_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[85,971],{

/***/ "+2AQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_SELLER_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellerInfoReducer; });
var GET_SELLER_INFOS = 'GET_SELLER_INFOS';
var initialState = {
  email: null,
  salesmanID: ''
};
var sellerInfoReducer = function sellerInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_SELLER_INFOS:
      {
        var sellerInfo = action.payload.sellerInfo;
        return {
          email: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.email) || state.email,
          salesmanID: (sellerInfo === null || sellerInfo === void 0 ? void 0 : sellerInfo.salesmanID) || state.salesmanID
        };
      }

    default:
      return state;
  }
};

/***/ }),

/***/ "+2Ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMAINING_STOCK_LIMIT; });
var REMAINING_STOCK_LIMIT = 10;

/***/ }),

/***/ "+DnP":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("W0vE"),
    baseFilter = __webpack_require__("sjzV"),
    baseIteratee = __webpack_require__("S3pA"),
    isArray = __webpack_require__("wxYD");

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ "+LXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COOKIE_PREFERENCES_STATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COOKIE_PREFERENCES_PERSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COOKIE_PREFERENCES_MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COOKIE_PREFERENCES_LAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COOKIE_WARNING_LOCALSTORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COOKIES_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COOKIE_PREFERENCES_DIDOMI_CONSENT; });
var COOKIE_PREFERENCES_STATS = 'statsCookie';
var COOKIE_PREFERENCES_PERSO = 'persoCookie';
var COOKIE_PREFERENCES_MEDIA = 'mediaCookie';
var COOKIE_PREFERENCES_LAYER = 'cookiePreferences';
var COOKIE_WARNING_LOCALSTORAGE_KEY = 'cookieBanner';
var COOKIES_ARRAY = [COOKIE_PREFERENCES_STATS, COOKIE_PREFERENCES_PERSO, COOKIE_PREFERENCES_MEDIA];
var COOKIE_PREFERENCES_DIDOMI_CONSENT = 'didomiVendorsConsent';

/***/ }),

/***/ "+M7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQuickDashboardQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOptionByIdQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFutureBookingsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentBookingsQuery; });
/* unused harmony export sendRequestPickYourRoomResortOnly */
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("L7OA");
/* harmony import */ var _queries_account_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QRI5");



 // QUICKDASHBOARD

var getQuickDashboardQueries = function getQuickDashboardQueries(bookingId, appContext) {
  return "\n    query {\n      customerBooking(id: \"".concat(bookingId, "\") {\n        ...booking\n      }\n    }\n    ").concat(Object(_queries_account_queries__WEBPACK_IMPORTED_MODULE_3__[/* getStayTeaserBookingFragment */ "o"])(appContext, {
    withUpsells: true
  }), "\n    ");
}; // DASHBOARD

var getOptionByIdQuery = function getOptionByIdQuery(bookingId, appContext) {
  return "query {\n  customerBooking(id: \"".concat(bookingId, "\") {\n    ...booking\n  }\n}\n").concat(Object(_queries_account_queries__WEBPACK_IMPORTED_MODULE_3__[/* getStayTeaserBookingFragment */ "o"])(appContext, {
    withUpsells: false
  }), "\n");
};

var getOptionFilter = function getOptionFilter(appContext) {
  var base = ['"OPTION"'];
  return Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_2__[/* isFeatureFlipped */ "a"])(appContext)('memberSpace.enableOptionRenewal') ? [].concat(base, ['"EXPIRED"']) : base;
};

var getFutureBookingsQuery = function getFutureBookingsQuery(appContext) {
  return "query { \n    customers(byPassGetCustomer: true) {\n      futureTrips {\n        count\n        trips(status: [\"VALIDATED\"]) {\n          data {\n            ...booking\n          }\n        }\n        options: trips(status: [".concat(getOptionFilter(appContext).join(','), "]){\n          data {\n            ...booking\n          }\n        }\n      }\n    }\n  }\n  ").concat(Object(_queries_account_queries__WEBPACK_IMPORTED_MODULE_3__[/* getStayTeaserBookingFragment */ "o"])(appContext, {
    withUpsells: true
  }), "\n  ");
};
var getCurrentBookingsQuery = function getCurrentBookingsQuery(appContext) {
  return "query { \n    customers(byPassGetCustomer: true) {\n      currentTrips {\n        count\n        trips {\n          data {\n            ...booking\n          }\n        }\n      }\n    }\n  }\n  ".concat(Object(_queries_account_queries__WEBPACK_IMPORTED_MODULE_3__[/* getStayTeaserBookingFragment */ "o"])(appContext, {
    withUpsells: false
  }), "\n  ");
};
var sendRequestPickYourRoomResortOnly = function sendRequestPickYourRoomResortOnly(_ref) {
  var bookingId = _ref.bookingId,
      comment = _ref.comment,
      criteria = _ref.criteria;
  return "mutation {\n    sendRequestPickYourRoomResortOnly(bookingId: \"".concat(bookingId, "\", criteria: \"").concat(criteria, "\", comment:\"").concat(comment, "\")\n  }");
};

/***/ }),

/***/ "+n+S":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("0Ocv"),
    isIterateeCall = __webpack_require__("R5u7"),
    toInteger = __webpack_require__("m2YG");

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),

/***/ "+pJz":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "+xJO":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var fails = __webpack_require__("fhLv");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "/+ub":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var fails = __webpack_require__("fhLv");
var createElement = __webpack_require__("a4SZ");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "/1vS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return popinTypes; });
var popinTypes = {
  VIEW: 'view',
  OUTSIDE_FACILITIES: 'outsideFacilities',
  ROOM_TYPE: 'roomType'
};

/***/ }),

/***/ "/ExG":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var isCallable = __webpack_require__("ANQd");
var store = __webpack_require__("l6h7");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "/GgU":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var toObject = __webpack_require__("A+R+");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "/yCi":
/***/ (function(module, exports, __webpack_require__) {

var createMathOperation = __webpack_require__("qqpj");

/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

module.exports = add;


/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* unused harmony export SEARCH_CRITERIA_TRANSPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAdditionalTransports; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("NLwV");







var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';

function _runAdditionalTransportsQuery(_ref) {
  var proposalId = _ref.proposalId,
      appContext = _ref.appContext,
      searchCriterias = _ref.searchCriterias;
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\" ").concat(searchCriterias ? ", searchCriteria: ".concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_6__[/* graphqlify */ "d"])(searchCriterias)) : '', ") {\n        id\n        price {\n          ...priceDetails\n        }\n        totalDifferentialPrice {\n          ...priceDetails\n        }\n        inbound {\n          ...transportsDetails\n        }\n        outbound {\n          ...transportsDetails\n        }\n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_2__[/* getPriceDetailFragment */ "h"])(appContext.locale), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "Nc"]
  });
}

function fetchAdditionalTransports(_ref2) {
  var proposal = _ref2.proposal,
      transportSearchCriteria = _ref2.transportSearchCriteria,
      appContext = _ref2.appContext;
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    var defaultTransport = proposal.transports;
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext: appContext,
      searchCriterias: transportSearchCriteria
    }).then(function (_ref3) {
      var additionalTransports = _ref3.additionalTransports;
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports,
        selectedTransport: defaultTransport
      }));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}



/***/ }),

/***/ "06Jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ additionalAccommodations_action_fetchBookingMoreAccommodations; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CLEAR_ADDITIONAL_ACCOMMODATIONS; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ FETCH_ADDITIONAL_ACCOMMODATIONS; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ TOGGLE_ACCOMMODATIONS_FILTER; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ UPDATE_FILTERED_ACCOMMODATIONS_RESULTS; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ TOGGLE_EXTRA_FEATURES; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ TOGGLE_PMR_CHECKBOX; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ clearAdditionalAccommodations; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ fetchAdditionalAccommodations; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getAlternativeFilteredAccommodations; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ toggleAdditionalAccommodationFilter; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ unselectAdditionalAccommodationsFilterCategory; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ toggleAdditionalAccommodationReducedMobilityFilter; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ togglePMRChecbox; });

// UNUSED EXPORTS: SET_FILTERED_ADDITIONAL_ACCOMMODATIONS

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/find.js
var find = __webpack_require__("6R5o");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/redux-optimist-promise/build/index.js
var build = __webpack_require__("b0q8");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: /opt/webapp/node_modules/stringify-object/index.js
var stringify_object = __webpack_require__("pPFN");
var stringify_object_default = /*#__PURE__*/__webpack_require__.n(stringify_object);

// CONCATENATED MODULE: ./src/client/components/utils/booking/bookingAccommodationsMore.queries.js



var bookingAccommodationsMore_queries_getBookingAccommodationsSearch = function getBookingAccommodationsSearch(appContext, id, options) {
  var body = [{
    attendees: options.attendees
  }];
  return "query {\n  bookingAdditionalAccommodations(bookingId: \"".concat(id, "\", body: ").concat(stringify_object_default()(body, {
    singleQuotes: false
  }), "\n  ) {\n    totalDifferentialPrice(selectedRate: \"").concat(options.selectedRate, "\") {\n      ...priceDetails\n      currency\n    }\n    differentialPriceByNight(\n      nightsNumber: ").concat(options.duration, ", \n      selectedRate: \"").concat(options.selectedRate, "\"\n    ) {\n      formattedValue(precision: 0)\n      value\n    }\n    isUpgradableOnline\n    accommodations {\n      attendeesDistribution {\n        attendees {\n          birthdate\n          customerId\n          id\n          type\n        }\n        id\n        quantity\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      categories {\n        id\n        label\n      }\n      category\n      categoryId\n      comfortType\n      connectingRoom\n      description\n      equipments {\n        id\n        label\n      }\n      exclusiveCollection\n      floorPlans\n      id\n      label\n\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      minCapacity\n      occupancies {\n        baby_count\n      }\n      occupation\n      outsideFacilities {\n        id\n        label\n      }\n      quantity\n      reducedMobilityAccess\n      roomType\n      services {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      surface\n      view {\n        id\n        label\n      }\n    }\n    id\n    remainingStock\n  }\n}\n").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(appContext === null || appContext === void 0 ? void 0 : appContext.locale), "\n");
};
// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js
















var CLEAR_ADDITIONAL_ACCOMMODATIONS = 'CLEAR_ADDITIONAL_ACCOMMODATIONS';
var GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT = 'GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT';
var FETCH_ADDITIONAL_ACCOMMODATIONS = 'FETCH_ADDITIONAL_ACCOMMODATIONS';
var CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS = 'UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS';
var SET_FILTERED_ADDITIONAL_ACCOMMODATIONS = 'SET_FILTERED_ADDITIONAL_ACCOMMODATIONS';
var TOGGLE_ACCOMMODATIONS_FILTER = 'TOGGLE_ACCOMMODATIONS_FILTER';
var UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY';
var UPDATE_FILTERED_ACCOMMODATIONS_RESULTS = 'UPDATE_FILTERED_ACCOMMODATIONS_RESULTS';
var TOGGLE_EXTRA_FEATURES = 'TOGGLE_EXTRA_FEATURES';
var TOGGLE_PMR_CHECKBOX = 'TOGGLE_PMR_CHECKBOX';

function _getSelectedProposal(state) {
  if (!state) {
    return null;
  }

  var proposals = Object(booking_selector["t" /* getProposals */])(state) || [];
  var resort = Object(booking_selector["j" /* getCurrentResort */])(state);
  var selectedProposal = find_default()(proposals, {
    id: Object(booking_selector["v" /* getSelectedProposalId */])(state)
  }) || Object(proposalUtils["d" /* getDefaultProposal */])(proposals, resort);
  return selectedProposal;
}

function _createAdditionalAccommodationsFilters(_ref) {
  var getState = _ref.getState,
      i18n = _ref.i18n,
      product = _ref.product,
      proposal = _ref.proposal,
      shouldPreselectFilters = _ref.shouldPreselectFilters;
  return Object(createAction["b" /* default */])(CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    i18n: i18n,
    product: product,
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    selectedProposal: proposal,
    shouldPreselectFilters: shouldPreselectFilters
  });
}

function _updateAdditionalAccommodationsFilters(isPmrChecked, getState) {
  return Object(createAction["b" /* default */])(UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(booking_selector["c" /* getAdditionalAccommodationsFilters */])(getState()),
    reducedMobilityVisibility: isPmrChecked !== null && isPmrChecked !== void 0 ? isPmrChecked : Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState())
  });
}

function _toggleFilter(filter, getState) {
  return Object(createAction["b" /* default */])(TOGGLE_ACCOMMODATIONS_FILTER, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    filter: filter
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(createAction["b" /* default */])(UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState()),
    category: category
  });
}

function _updateFilterAccommodations(getState) {
  return Object(createAction["b" /* default */])(UPDATE_FILTERED_ACCOMMODATIONS_RESULTS, {
    additionalAccommodations: Object(booking_selector["a" /* getAdditionalAccommodations */])(getState()),
    selectedProposal: _getSelectedProposal(getState()),
    filters: Object(booking_selector["c" /* getAdditionalAccommodationsFilters */])(getState()),
    reducedMobilityVisibility: Object(booking_selector["d" /* getAdditionalAccommodationsPmrChecked */])(getState())
  });
}

function _runAdditionalAccommodationsQuery(_ref2) {
  var proposalId = _ref2.proposalId,
      appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$selectedRate = _ref2.selectedRate,
      selectedRate = _ref2$selectedRate === void 0 ? '' : _ref2$selectedRate;
  var query = "\n    {\n      additionalAccommodations(proposalId: \"".concat(proposalId, "\") {\n        id\n        isUpgradableOnline\n        totalDifferentialPrice(selectedRate: \"").concat(selectedRate, "\") {\n          ...priceDetails\n        }\n        differentialPriceByNight(nightsNumber: ").concat(duration, ", selectedRate: \"").concat(selectedRate, "\") {\n          formattedValue(precision: 0)\n          value\n        }\n        remainingStock\n        accommodations {\n          id\n          categories { id label }\n          category\n          categoryId\n          comfortType\n          exclusiveCollection\n          connectingRoom\n          floorPlans\n          description\n          label\n          maxCapacity\n          roomType\n          media {\n            photos {\n              url\n            }\n          }\n          minCapacity\n          occupation\n          quantity\n          occupancies {\n            baby_count\n          }\n          outsideFacilities {\n            id\n            label\n          }\n          bathroomEquipments {\n            id\n            label\n          }\n          equipments {\n            id\n            label\n          }\n          services { id label }\n          strengths { id label }\n          surface\n          view { id label }\n          reducedMobilityAccess\n          attendeesDistribution {\n            id\n            quantity\n            attendees {\n              id\n              type\n              birthdate\n              customerId\n            }\n          }\n        }\n      }\n      config {\n        filters {\n          configuration {\n            categoryTitle\n            simpleRoom\n            simpleRooms\n            separatedRooms\n            separatedRooms3\n          }\n          comfort {\n            categoryTitle\n          }\n          extraFeatures {\n            categoryTitle\n          }\n          reducedMobility\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(get_default()(appContext, 'locale')), "\n  ");
  return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
    requestName: requestDictionary["Mc" /* PROPOSAL_GET_ADDITIONAL_ACCOMMODATIONS */]
  });
}

function clearAdditionalAccommodations() {
  return Object(createAction["b" /* default */])(CLEAR_ADDITIONAL_ACCOMMODATIONS);
}

function getAvailableFilteredAccommodationsByComfort(_ref3) {
  var additionalAccommodations = _ref3.additionalAccommodations;
  return Object(createAction["b" /* default */])(GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT, {
    additionalAccommodations: additionalAccommodations
  });
}

function getAlternativeFilteredAccommodations(_ref4) {
  var proposal = _ref4.proposal,
      appContext = _ref4.appContext;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate
    }).then(function (_ref5) {
      var additionalAccommodations = _ref5.additionalAccommodations;
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(getAvailableFilteredAccommodationsByComfort({
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT)));
    })["catch"](function (error) {
      logger_default.a.error('error', error);
    });
  };
}

function fetchAdditionalAccommodations(_ref6) {
  var appContext = _ref6.appContext,
      product = _ref6.product,
      proposal = _ref6.proposal,
      _ref6$roomsArrangemen = _ref6.roomsArrangement,
      roomsArrangement = _ref6$roomsArrangemen === void 0 ? [] : _ref6$roomsArrangemen,
      _ref6$shouldPreselect = _ref6.shouldPreselectFilters,
      shouldPreselectFilters = _ref6$shouldPreselect === void 0 ? true : _ref6$shouldPreselect;
  var id = proposal.id,
      duration = proposal.duration,
      selectedRate = proposal.price.selectedRate;
  return function (dispatch, getState) {
    dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
    return _runAdditionalAccommodationsQuery({
      proposalId: id,
      appContext: appContext,
      duration: duration,
      selectedRate: selectedRate,
      roomsArrangement: roomsArrangement
    }).then(function (_ref7) {
      var additionalAccommodations = _ref7.additionalAccommodations,
          i18n = _ref7.config;
      dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
        additionalAccommodations: additionalAccommodations
      }));
      dispatch(_createAdditionalAccommodationsFilters({
        getState: getState,
        i18n: i18n,
        product: product,
        proposal: proposal,
        shouldPreselectFilters: shouldPreselectFilters
      }));
      dispatch(_updateFilterAccommodations(getState));
    })["catch"](function (error) {
      dispatch(Object(createAction["b" /* default */])(Object(build["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), error));
    });
  };
}

function toggleAdditionalAccommodationFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function unselectAdditionalAccommodationsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilterAccommodations(getState));
  };
}

function togglePMRChecbox(isChecked, filterValues) {
  return function (dispatch, getState) {
    dispatch(Object(createAction["b" /* default */])(TOGGLE_PMR_CHECKBOX, {
      isChecked: isChecked,
      filterValues: filterValues
    }));
    dispatch(_updateAdditionalAccommodationsFilters(isChecked, getState));
  };
}

function toggleAdditionalAccommodationReducedMobilityFilter(accommodationsSets, visibility) {
  return function (dispatch) {
    Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
      additionalAccommodations: accommodationsSets
    });
    dispatch(Object(createAction["b" /* default */])(TOGGLE_EXTRA_FEATURES, {
      accommodationsSets: accommodationsSets,
      reducedMobilityVisibility: visibility
    }));
  };
}

var additionalAccommodations_action_runMoreAccommodationsQuery = function _runMoreAccommodationsQuery(_ref8) {
  var appContext = _ref8.appContext,
      _ref8$attendees = _ref8.attendees,
      attendees = _ref8$attendees === void 0 ? [] : _ref8$attendees,
      bookingId = _ref8.bookingId,
      duration = _ref8.duration,
      _ref8$selectedRate = _ref8.selectedRate,
      selectedRate = _ref8$selectedRate === void 0 ? '' : _ref8$selectedRate;
  var query = bookingAccommodationsMore_queries_getBookingAccommodationsSearch(appContext, bookingId, {
    attendees: attendees,
    duration: duration,
    selectedRate: selectedRate
  });
  return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
    requestName: requestDictionary["P" /* CUSTOMER_BOOKING_GET_MORE_ACCOMMODATIONS_DATA */],
    cacheFront: {
      key: "".concat(requestDictionary["P" /* CUSTOMER_BOOKING_GET_MORE_ACCOMMODATIONS_DATA */], "_").concat(bookingId)
    }
  });
};

var isNotSelected = function isNotSelected(set, selectedAccommodation) {
  return set.accommodations[0].id !== selectedAccommodation.id && set.totalDifferentialPrice.value !== selectedAccommodation.differentialPrice.amount;
};

var additionalAccommodations_action_fetchBookingMoreAccommodations = function fetchBookingMoreAccommodations(args) {
  var appContext = args.appContext,
      attendees = args.attendees,
      bookingId = args.bookingId,
      duration = args.duration,
      _args$ignoreReducedMo = args.ignoreReducedMobility,
      ignoreReducedMobility = _args$ignoreReducedMo === void 0 ? false : _args$ignoreReducedMo,
      product = args.product,
      _args$selectedAccommo = args.selectedAccommodation,
      selectedAccommodation = _args$selectedAccommo === void 0 ? {} : _args$selectedAccommo,
      _args$selectedRate = args.selectedRate,
      selectedRate = _args$selectedRate === void 0 ? '' : _args$selectedRate,
      _args$shouldPreselect = args.shouldPreselectFilters,
      shouldPreselectFilters = _args$shouldPreselect === void 0 ? false : _args$shouldPreselect;
  return /*#__PURE__*/function () {
    var _ref9 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch, getState) {
      var _yield$_runMoreAccomm, bookingAdditionalAccommodations;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(Object(createAction["b" /* default */])(FETCH_ADDITIONAL_ACCOMMODATIONS));
              _context.prev = 1;
              _context.next = 4;
              return additionalAccommodations_action_runMoreAccommodationsQuery({
                appContext: appContext,
                attendees: attendees,
                bookingId: bookingId,
                duration: duration,
                selectedRate: selectedRate
              });

            case 4:
              _yield$_runMoreAccomm = _context.sent;
              bookingAdditionalAccommodations = _yield$_runMoreAccomm.bookingAdditionalAccommodations;
              dispatch(Object(createAction["b" /* default */])(Object(build["resolve"])(FETCH_ADDITIONAL_ACCOMMODATIONS), {
                additionalAccommodations: bookingAdditionalAccommodations.filter(function (set) {
                  return set.remainingStock > 0 && set.totalDifferentialPrice.value > 0 && // only more expensive accommodation
                  Boolean(set.accommodations.length) && isNotSelected(set, selectedAccommodation) && (ignoreReducedMobility ? !set.accommodations.some(function (_ref10) {
                    var reducedMobilityAccess = _ref10.reducedMobilityAccess;
                    return Boolean(reducedMobilityAccess);
                  }) : true);
                })
              }));
              dispatch(_createAdditionalAccommodationsFilters({
                getState: getState,
                i18n: {},
                product: product,
                proposal: {},
                shouldPreselectFilters: shouldPreselectFilters
              }));
              dispatch(_updateFilterAccommodations(getState));
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              dispatch(Object(createAction["b" /* default */])(Object(build["reject"])(FETCH_ADDITIONAL_ACCOMMODATIONS), _context.t0));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function (_x, _x2) {
      return _ref9.apply(this, arguments);
    };
  }();
};


/***/ }),

/***/ "0D0S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setConfig = setConfig;
exports.default = void 0;
var runtimeConfig;

var _default = function _default() {
  return runtimeConfig;
};

exports.default = _default;

function setConfig(configValue) {
  runtimeConfig = configValue;
}

/***/ }),

/***/ "0OJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_TICKET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE_TICKET_REQUEST_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PORT_TAXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOURISTIC_TAXES; });
var PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
var PRICE_TICKET_REQUEST_ABORT = 'PRICE_TICKET_REQUEST_ABORT';
var PORT_TAXES = 'PORT_TAXES';
var TOURISTIC_TAXES = 'TOURISTIC_TAXES';

/***/ }),

/***/ "0fIf":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var lastIndexOf = __webpack_require__("QsAM");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "0x7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Yd/I");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("1JJ2");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qBqs");
/* harmony import */ var _portal_Portal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3uBn");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qqKu");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */










var Toast = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_2__["forwardRef"])(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE_WAVE : _ref$color,
      icon = _ref.icon,
      _ref$isFixed = _ref.isFixed,
      isFixed = _ref$isFixed === void 0 ? false : _ref$isFixed,
      label = _ref.label,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? _portal_Portal_constants__WEBPACK_IMPORTED_MODULE_6__[/* BEFORE_APP */ "c"] : _ref$portalName,
      visible = _ref.visible,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "color", "icon", "isFixed", "label", "onClose", "portalName", "visible"]);

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  return __jsx(_portal_Portal__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"], {
    name: portalName
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('end-0 top-0 isolate z-8 overflow-x-hidden py-20', {
      absolute: !isFixed,
      fixed: isFixed,
      'pointer-events-none': !visible,
      'px-20': visible
    }, className)
  }, __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    "aria-hidden": !visible,
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('transform transition-all duration-250 ease-in', {
      'pointer-events-auto ltr:translate-x-full rtl:-translate-x-full': !visible,
      'translate-x-0': visible
    })
  }), __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('flex rounded-12 bg-white font-bold', "text-".concat(color), {
      'shadow-md': visible
    }),
    "data-testid": "Toast",
    ref: ref
  }, __jsx("div", {
    className: "flex flex-1 items-center gap-5 p-10"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
    className: "shrink-0",
    name: icon,
    width: "1.875rem"
  }), label && __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_11__[/* Text */ "a"], {
    className: "flex-1",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_7__[/* t */ "h"])(label)
  }), children), __jsx("button", {
    "aria-disabled": !visible,
    className: "shrink-0 border-s-1 border-lightGrey p-10 text-black transition-colors duration-250 ease-in hocus:text-black-active",
    onClick: onClose,
    tabIndex: visible ? 0 : -1,
    type: "button"
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CROSS,
    width: "0.625rem"
  }))))));
});

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ZHK4");
module.exports = __webpack_require__("7xIC");


/***/ }),

/***/ "15pl":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "1Ll7":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('get', __webpack_require__("2srY"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "1P7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFormattedLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCursorClass; });
function getFormattedLabel() {
  var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!placeholder) {
    return '';
  }

  return isRequired ? "".concat(placeholder, "*") : placeholder;
}
function getCursorClass(_ref) {
  var hasPointer = _ref.hasPointer,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly;

  if (isDisabled) {
    return 'cursor-not-allowed';
  }

  if (isReadOnly) {
    return 'cursor-default';
  }

  if (isLoading) {
    return 'cursor-wait';
  }

  return hasPointer ? 'cursor-pointer' : '';
}

/***/ }),

/***/ "1TCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/app.js
var app = __webpack_require__("Khd+");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ToastContext.js
var ToastContext = __webpack_require__("waz2");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/memoize.js
var memoize = __webpack_require__("pFSi");
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);

// CONCATENATED MODULE: ./src/client/components/utils/responsive/Events.constants.js
var APP_EVENTS = {
  MOUNTING: 'cm_app_mounting',
  MOUNTED: 'cm_app_mounted'
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.helper.js
var Responsive_helper = __webpack_require__("GRjW");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/Responsive.listener.js



var PASSIVE = {
  passive: true
};
var componentsList = [];
var hasListener = false;

function shouldBreakpointChange(component, currentBreakpoint) {
  component.setState(function (state) {
    if (state.currentBreakpoint === currentBreakpoint) {
      return null;
    }

    return {
      currentBreakpoint: currentBreakpoint
    };
  });
}

function listener() {
  var currentBreakpoint = Object(Responsive_helper["a" /* getCurrentBreakpoint */])();
  componentsList.map(function (component) {
    return shouldBreakpointChange(component, currentBreakpoint);
  });
}

function subscribe(component) {
  componentsList.push(component);

  if (!hasListener) {
    hasListener = true;
    window.addEventListener('resize', listener, PASSIVE);
  }
}

function unsubscribe(component) {
  componentsList = componentsList.filter(function (item) {
    return item !== component;
  });

  if (!componentsList.length && hasListener) {
    hasListener = false;
    window.removeEventListener('resize', listener, PASSIVE);
  }
}


// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/getCurrentResponsive.js
var getCurrentResponsive = __webpack_require__("ZCNJ");

// CONCATENATED MODULE: ./src/client/components/utils/responsive/ResponsiveLayout.jsx









var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






 // prevent rerender of all component using ResponsiveContext when the breakpoint doesn't change

var memoizedGetCurrentResponsive = memoize_default()(getCurrentResponsive["a" /* default */]);

function sendEvent(name) {
  var event;

  if (typeof Event === 'function') {
    event = new Event(name);
  } else {
    event = document.createEvent('Event');
    event.initEvent(name, true, true);
  }

  document.dispatchEvent(event);
}

var ResponsiveLayout_ResponsiveLayout = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(ResponsiveLayout, _React$Component);

  var _super = _createSuper(ResponsiveLayout);

  function ResponsiveLayout(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ResponsiveLayout);

    _this = _super.call(this, props);

    if ( true && !window.cmAppMounted) {
      sendEvent(APP_EVENTS.MOUNTING);
    }

    _this.state = {
      currentBreakpoint: Object(Responsive_helper["a" /* getCurrentBreakpoint */])(props.device),
      isAppMounted: false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(ResponsiveLayout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      subscribe(this);
      this.setState({
        currentBreakpoint: Object(Responsive_helper["a" /* getCurrentBreakpoint */])(this.props.device),
        isAppMounted: true
      });

      if (!window.cmAppMounted) {
        // Dispatch the info that the app is mounted
        window.cmAppMounted = true;
        sendEvent(APP_EVENTS.MOUNTED);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      unsubscribe(this);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          currentBreakpoint = _this$state.currentBreakpoint,
          isAppMounted = _this$state.isAppMounted;
      var value = memoizedGetCurrentResponsive({
        currentBreakpoint: currentBreakpoint,
        isAppMounted: isAppMounted
      });
      return __jsx(ResponsiveContext["a" /* ResponsiveContext */].Provider, {
        value: value
      }, children);
    }
  }]);

  return ResponsiveLayout;
}(react_default.a.Component);
// CONCATENATED MODULE: ./src/client/context/DepartureCitiesContext.js

/* harmony default export */ var DepartureCitiesContext = (/*#__PURE__*/Object(react["createContext"])({
  departureCities: [],
  setDepartureCities: function setDepartureCities() {}
}));
// CONCATENATED MODULE: ./src/client/context/DepartureCitiesProvider.jsx











var DepartureCitiesProvider_jsx = react_default.a.createElement;

function DepartureCitiesProvider_createSuper(Derived) { var hasNativeReflectConstruct = DepartureCitiesProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function DepartureCitiesProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var DepartureCitiesProvider_DepartureCitiesProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(DepartureCitiesProvider, _Component);

  var _super = DepartureCitiesProvider_createSuper(DepartureCitiesProvider);

  function DepartureCitiesProvider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, DepartureCitiesProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      departureCities: [],
      setDepartureCities: function setDepartureCities(departureCities) {
        _this.setState({
          departureCities: departureCities
        });
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(DepartureCitiesProvider, [{
    key: "render",
    value: function render() {
      return DepartureCitiesProvider_jsx(DepartureCitiesContext.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return DepartureCitiesProvider;
}(react["Component"]);


// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__("Qavd");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// CONCATENATED MODULE: ./src/client/context/resortList.query.js
var resortOpeningDates = function resortOpeningDates() {
  return "\n  openingDates {\n    opening\n    closing\n  }\n";
};

var getAllResorts = function getAllResorts() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$withOpeningDates = _ref.withOpeningDates,
      withOpeningDates = _ref$withOpeningDates === void 0 ? false : _ref$withOpeningDates;

  return "\n  resortList: resorts(productTypes: [VILLAGE, JOYVIEW, VILLA]) {\n    badgeIcon\n    color\n    comfort\n    comfortLabel\n    destination {\n      area\n      country\n    }\n    hasECSpace\n    id\n    isExplicitEC\n    openingStatus\n    isJoyview\n    isUrbanOasis\n    name\n    offsetSell\n    seasonTrad\n    type\n    ".concat(withOpeningDates ? resortOpeningDates() : '', "\n  }\n");
};
// CONCATENATED MODULE: ./src/client/context/ResortListContext.js

var ResortListContext = /*#__PURE__*/Object(react["createContext"])({
  resortList: [],
  setResortList: function setResortList() {}
});
var ResortListContext_useResortList = function useResortList() {
  var context = Object(react["useContext"])(ResortListContext);

  if (context === undefined) {
    throw new Error('useResortList must be used within a ResortListContext.Provider');
  }

  Object(react["useEffect"])(function () {
    context.setResortList();
  }, []);
  return context.resortList;
};
// CONCATENATED MODULE: ./src/client/context/ResortListProvider.jsx



var ResortListProvider_jsx = react_default.a.createElement;





var ResortListProvider_ResortListProvider = function ResortListProvider(_ref) {
  var children = _ref.children;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useState = Object(react["useState"])(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = Object(react["useState"])([]),
      resortList = _useState2[0],
      updateResortList = _useState2[1];

  var setResortList = function setResortList() {
    if (resortList.length === 0 && !isLoading) {
      setIsLoading(true);
      graphqlClient["a" /* default */].runQuery("{".concat(getAllResorts({
        withOpeningDates: true
      }), "}"), appContext).then(function (res) {
        return updateResortList(res.resortList);
      }).finally(function () {
        return setIsLoading(false);
      });
    }
  };

  var value = Object(react["useMemo"])(function () {
    return {
      resortList: resortList,
      setResortList: setResortList
    };
  }, [resortList]);
  return ResortListProvider_jsx(ResortListContext.Provider, {
    value: value
  }, children);
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/partition.js
var partition = __webpack_require__("Zl10");
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/differenceWith.js
var differenceWith = __webpack_require__("HvGN");
var differenceWith_default = /*#__PURE__*/__webpack_require__.n(differenceWith);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/difference.js
var difference = __webpack_require__("lKOy");
var difference_default = /*#__PURE__*/__webpack_require__.n(difference);

// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/hooks/use-authentication/useAuthentication.js
var useAuthentication = __webpack_require__("Iev9");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/components/widgets/price-remote/price-remote-favorite/favorite.utils.js
var favorite_utils = __webpack_require__("KE+3");

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingSearch.queries.js
var bookingSearch_queries = __webpack_require__("tUpW");

// EXTERNAL MODULE: ./src/client/context/FavoriteProductListContext.js
var FavoriteProductListContext = __webpack_require__("XGb2");

// CONCATENATED MODULE: ./src/client/context/FavoriteProductListProvider.jsx






















var FavoriteProductListProvider_jsx = react_default.a.createElement;


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var FavoriteProductListProvider_FavoriteProductListProvider = function FavoriteProductListProvider(_ref) {
  var children = _ref.children;

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isLogged = _useAuthentication.isLogged;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var localStorageFavoritesName = isLogged ? constants["A" /* SHOPPING_REMOTE_FAVORITE_PRODUCTS */] : constants["w" /* SHOPPING_FAVORITE_PRODUCTS */];
  var localFavoriteProductsList = Object(local_storage_api["a" /* getFromLocalStorage */])(localStorageFavoritesName) || [];

  var _useState = Object(react["useState"])({
    favoriteProductList: localFavoriteProductsList,
    showcaseLatestFavorite: false,
    showAllFavorite: false,
    hasTooManyFavorites: localFavoriteProductsList.length >= constants["x" /* SHOPPING_FAVORITE_PRODUCTS_NUMBER_MAX */]
  }),
      favoriteProductsState = _useState[0],
      setFavoriteProductsState = _useState[1];

  var _useState2 = Object(react["useState"])(true),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = Object(react["useState"])(null),
      travelPlan = _useState3[0],
      setTravelPlan = _useState3[1];

  var setHasTooManyFavorites = function setHasTooManyFavorites(hasTooManyFavorites) {
    return setFavoriteProductsState(_objectSpread(_objectSpread({}, favoriteProductsState), {}, {
      hasTooManyFavorites: hasTooManyFavorites
    }));
  };

  var setFavoriteProductList = function setFavoriteProductList(favoriteProductList, showcaseLatestFavorite, showAllFavorite) {
    //Update the list of favorites in localStorage or delete it if there are no elements
    favoriteProductList.length ? Object(local_storage_api["c" /* setInLocalStorage */])(localStorageFavoritesName, favoriteProductList) : Object(local_storage_api["b" /* remove */])(localStorageFavoritesName);
    setFavoriteProductsState(_objectSpread(_objectSpread({}, favoriteProductsState), {}, {
      favoriteProductList: favoriteProductList,
      showcaseLatestFavorite: showcaseLatestFavorite,
      showAllFavorite: showAllFavorite,
      hasTooManyFavorites: favoriteProductList.length >= constants["x" /* SHOPPING_FAVORITE_PRODUCTS_NUMBER_MAX */]
    }));
  };

  var addTravelPlan = function addTravelPlan(proposal, product) {
    var _proposal$attendees, _proposal$attendees$a, _proposal$attendees2, _proposal$transports, _proposal$transports$, _proposal$transports$2, _proposal$transports$3, _proposal$transports$4;

    setTravelPlan(Object(favorite_utils["f" /* mapSearchEntity */])({
      adults: (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$a = _proposal$attendees.adults) === null || _proposal$attendees$a === void 0 ? void 0 : _proposal$attendees$a.length,
      birthdates: (((_proposal$attendees2 = proposal.attendees) === null || _proposal$attendees2 === void 0 ? void 0 : _proposal$attendees2.children) || []).map(function (_ref2) {
        var birthdate = _ref2.birthdate;
        return birthdate;
      }),
      returnDate: proposal.departureDate,
      departureDate: proposal.arrivalDate,
      departureCity: ((_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : (_proposal$transports$ = _proposal$transports.inbound) === null || _proposal$transports$ === void 0 ? void 0 : (_proposal$transports$2 = _proposal$transports$.travelSections) === null || _proposal$transports$2 === void 0 ? void 0 : (_proposal$transports$3 = _proposal$transports$2[0]) === null || _proposal$transports$3 === void 0 ? void 0 : (_proposal$transports$4 = _proposal$transports$3.departure) === null || _proposal$transports$4 === void 0 ? void 0 : _proposal$transports$4.cityId) || 'NO',
      price: proposal.price,
      reference: proposal.id,
      resort: product
    }));
  };

  var syncLocalAndRemoteFavorites = /*#__PURE__*/function () {
    var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(remoteBookmarks, localBookmarks, searches) {
      var _bookmarks;

      var bookmarksToSync, bookmarks, favoriteProductList;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              bookmarksToSync = differenceWith_default()(localBookmarks || [], [].concat(Object(toConsumableArray["a" /* default */])(remoteBookmarks), Object(toConsumableArray["a" /* default */])(searches)), function (item1, item2) {
                return item1.adultsNumber === item2.adultsNumber && item1.departureDate === item2.departureDate && item1.duration === item2.duration && item1.departureCity === item2.departureCity && item1.kids.length === item2.kids.length && item1.product.id === item2.product.id;
              });
              _context2.next = 3;
              return Promise.all(bookmarksToSync.map( /*#__PURE__*/function () {
                var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(bookmark) {
                  return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          return _context.abrupt("return", Object(favorite_utils["a" /* addBookmarkMutation */])(bookmark, appContext));

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 3:
              bookmarks = _context2.sent;

              if (bookmarksToSync === null || bookmarksToSync === void 0 ? void 0 : bookmarksToSync.length) {
                Object(local_storage_api["c" /* setInLocalStorage */])(constants["w" /* SHOPPING_FAVORITE_PRODUCTS */], difference_default()(localBookmarks, bookmarksToSync));
              } //Update the list of favorites with products received from ADD resource or from GET resource


              favoriteProductList = bookmarks[bookmarks.length - 1] ? (((_bookmarks = bookmarks[bookmarks.length - 1]) === null || _bookmarks === void 0 ? void 0 : _bookmarks.addBookmark) || []).map(function (b) {
                return Object(favorite_utils["e" /* mapBookmarkEntity */])(b);
              }) : remoteBookmarks;
              setFavoriteProductList([].concat(Object(toConsumableArray["a" /* default */])(favoriteProductList), Object(toConsumableArray["a" /* default */])(searches)), false, false);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function syncLocalAndRemoteFavorites(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var value = Object(react["useMemo"])(function () {
    return {
      favoriteProductsState: favoriteProductsState,
      loading: loading,
      addTravelPlan: addTravelPlan,
      setHasTooManyFavorites: setHasTooManyFavorites,
      setFavoriteProductList: setFavoriteProductList
    };
  }, [favoriteProductsState, loading]);

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    // $FlowFixMe
    query: "query { \n      bookmarks {\n        ".concat(Object(favorite_utils["d" /* getBookmarksQuery */])(appContext), "\n      }\n    }"),
    queryOptions: {
      requestName: requestDictionary["m" /* CUSTOMER_ACCOUNT_GET_BOOKMARKS */]
    },
    cache: false,
    ignore: !isLogged,
    map: function map(_ref5) {
      var bookmarks = _ref5.bookmarks;
      return bookmarks;
    }
  }),
      bookmarksLoading = _useGQL.isLoading,
      bookmarksData = _useGQL.data;

  var _useGQL2 = Object(useGQL["a" /* useGQL */])({
    query: Object(bookingSearch_queries["f" /* getUserSearchesQuery */])(appContext.locale),
    queryOptions: {
      requestName: requestDictionary["C" /* CUSTOMER_ACCOUNT_GET_SEARCHES */]
    },
    cache: false,
    ignore: !isLogged,
    map: function map(_ref6) {
      var userSearches = _ref6.userSearches;
      return userSearches;
    }
  }),
      searchesLoading = _useGQL2.isLoading,
      searchesData = _useGQL2.data;

  Object(react["useEffect"])(function () {
    setLoading(bookmarksLoading || searchesLoading);
  }, [bookmarksLoading, searchesLoading]);
  Object(react["useEffect"])(function () {
    var bookmarks = [];

    if (!!bookmarksData && !!searchesData) {
      bookmarks = bookmarksData.map(function (b) {
        return Object(favorite_utils["e" /* mapBookmarkEntity */])(b);
      });

      var _partition2 = partition_default()(favoriteProductsState.favoriteProductList.filter(function (_ref7) {
        var origin = _ref7.origin;
        return origin === 'BOOKMARK';
      }), function (item) {
        return item.adultsNumber === (travelPlan === null || travelPlan === void 0 ? void 0 : travelPlan.adultsNumber) && item.departureDate === (travelPlan === null || travelPlan === void 0 ? void 0 : travelPlan.departureDate) && item.duration === (travelPlan === null || travelPlan === void 0 ? void 0 : travelPlan.duration) && item.departureCity === (travelPlan === null || travelPlan === void 0 ? void 0 : travelPlan.departureCity) && item.kids.length === (travelPlan === null || travelPlan === void 0 ? void 0 : travelPlan.kids.length) && item.product.id === (travelPlan === null || travelPlan === void 0 ? void 0 : travelPlan.product.id);
      }),
          _partition3 = Object(slicedToArray["a" /* default */])(_partition2, 2),
          bookmarksToDelete = _partition3[0],
          filteredBookmarks = _partition3[1];

      bookmarksToDelete.forEach(function (_ref8) {
        var id = _ref8.id;
        return Object(favorite_utils["b" /* deleteBookmarkMutation */])(id, appContext);
      });
      var searches = (searchesData || []).map(function (b) {
        return Object(favorite_utils["f" /* mapSearchEntity */])(b);
      });
      syncLocalAndRemoteFavorites(travelPlan ? filteredBookmarks : bookmarks, Object(local_storage_api["a" /* getFromLocalStorage */])(constants["w" /* SHOPPING_FAVORITE_PRODUCTS */]), travelPlan ? [].concat(Object(toConsumableArray["a" /* default */])(searches), [travelPlan]) : searches);
    }
  }, [JSON.stringify(bookmarksData), JSON.stringify(searchesData), travelPlan]);
  return FavoriteProductListProvider_jsx(FavoriteProductListContext["a" /* FavoriteProductListContext */].Provider, {
    value: value
  }, children);
};

/* harmony default export */ var context_FavoriteProductListProvider = (FavoriteProductListProvider_FavoriteProductListProvider);
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isObject.js
var isObject = __webpack_require__("tQYX");
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/client/context/ABTestContext.js
var ABTestContext = __webpack_require__("hfZn");

// CONCATENATED MODULE: ./src/client/context/ABTestProvider.jsx































var ABTestProvider_jsx = react_default.a.createElement;

function ABTestProvider_createSuper(Derived) { var hasNativeReflectConstruct = ABTestProvider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ABTestProvider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ABTestProvider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ABTestProvider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ABTestProvider_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ABTestProvider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-console */

/* eslint-disable import/no-default-export */

/* eslint-env browser */



var ABTEST_PREFIX = 'testAB.';
var ABTEST_EVENT = 'testAB';
var env = "production";
var ABTestProvider_useMockABTasty = function useMockABTasty() {
  Object(react["useEffect"])(function () {
    // Skip mock in test environment to prevent Jest hanging
    if (env === 'test') {
      return;
    } // Only run mock in localhost development environment


    var isLocalhost =  true && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

    if (env !== 'development' || !isLocalhost) {
      return;
    } // expose the functions to the window object (only in localhost development)


    if ( true && env === 'development') {
      window.CM_AB_UTILS = {
        // turn on the mock
        enableMock: function enableMock() {
          localStorage.setItem('CM_ENABLE_AB_MOCK', 'true');
          console.info('CM_AB: Mock enabled - refresh page to apply');
        },
        // turn off the mock
        disableMock: function disableMock() {
          localStorage.removeItem('CM_ENABLE_AB_MOCK'); // Remove flag to disable (default)

          console.info('CM_AB: Mock disabled (default) - refresh page to apply');
        },
        // Force a specific value
        forceValue: function forceValue(testId, value) {
          if (window.forceABTestUpdate) {
            window.forceABTestUpdate(Object(defineProperty["a" /* default */])({}, testId, value));
            console.info("CM_AB: Forced ".concat(testId, " to \"").concat(value, "\""));
          }
        },
        // check current state
        getStatus: function getStatus() {
          var mockEnabled = localStorage.getItem('CM_ENABLE_AB_MOCK') === 'true'; // Default: false

          var sessionValue = sessionStorage.getItem('testAB.ab-test-activities');
          return {
            mockEnabled: mockEnabled,
            sessionValue: sessionValue,
            hasABTasty: !!window.ABTasty,
            hasForceUpdate: !!window.forceABTestUpdate,
            hasBookingEngineUpdate: !!window.forceBookingEngineUpdate
          };
        }
      };
      console.info('CM_AB: Utilities available on window.CM_AB_UTILS (localhost only)');
    } // Mock ABTasty disabled by default - developers can enable it for testing


    var enableMock = localStorage.getItem('CM_ENABLE_AB_MOCK') === 'true'; // Default: false

    if (!enableMock) {
      console.info('CM_AB: Mock ABTasty disabled by default - use window.CM_AB_UTILS.enableMock() to activate');
      return;
    }

    if ( true && (!window.ABTasty || typeof window.ABTasty.getTestsOnPage !== 'function')) {
      var mockDelay = 500; // 500 msecondes to simulate the delay

      console.info("CM_AB: Mocking with ".concat(mockDelay, "ms delay - starting with '0'")); // initialize the mock with '0' (no test active)

      window.ABTasty = window.ABTasty || {};

      window.ABTasty.getTestsOnPage = function () {
        return {
          1460669: {
            name: 'TEST - FR - Activities step - delete step',
            variationID: 1816698,
            variationName: 'Variation 1'
          }
        };
      }; // set the session storage with '0' (no test active)


      if ( true && window.sessionStorage) {
        window.sessionStorage.setItem('testAB.ab-test-activities', '0');
        console.info('CM_AB: Session storage initialized with "0"');
      } // Dispatch the official AB Tasty event to trigger the flow


      window.dispatchEvent(new Event('abtasty_tagContentExecuted'));
      console.info('CM_AB: Initial abtasty_tagContentExecuted event dispatched'); // force the state ABTestProvider with '0' (no test active)

      if (window.forceABTestUpdate) {
        window.forceABTestUpdate({
          'ab-test-activities': '0'
        });
        console.info('CM_AB: Provider state updated with "0"');
      } // after the delay, switch to '1' (test active)


      var timeoutId = setTimeout(function () {
        console.info('CM_AB: Delay completed, switching to "1"'); // update the session storage with '1' (test active)

        if ( true && window.sessionStorage) {
          window.sessionStorage.setItem('testAB.ab-test-activities', '1');
          console.info('CM_AB: Session storage updated to "1"');
        } // Dispatch the official AB Tasty event to trigger the flow with new data


        window.dispatchEvent(new Event('abtasty_tagContentExecuted'));
        console.info('CM_AB: abtasty_tagContentExecuted event dispatched with new data'); // force the state ABTestProvider with '1' (test active)

        if (window.forceABTestUpdate) {
          window.forceABTestUpdate({
            'ab-test-activities': '1'
          });
          console.info('CM_AB: Provider state updated with "1"');
        } // force the BookingEngine update


        if (window.forceBookingEngineUpdate) {
          console.info('CM_AB: Calling forceBookingEngineUpdate');
          window.forceBookingEngineUpdate();
        }
      }, mockDelay);
      return function () {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      };
    }
  }, []);
};

var ABTestProvider_isValidValues = function isValidValues(src, values) {
  return isObject_default()(values) && !isEmpty_default()(values) && !Object.entries(values).every(function (_ref) {
    var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return src[key] === value;
  });
}; // Session-storage fallback


var ABTestProvider_fetchABTestData = function fetchABTestData() {
  return Object(sessionStorageApi["a" /* getEntries */])().filter(function (_ref3) {
    var _ref4 = Object(slicedToArray["a" /* default */])(_ref3, 1),
        key = _ref4[0];

    return key.startsWith(ABTEST_PREFIX);
  }).reduce(function (acc, _ref5) {
    var _ref6 = Object(slicedToArray["a" /* default */])(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return ABTestProvider_objectSpread(ABTestProvider_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, key.replace(ABTEST_PREFIX, ''), value.toString()));
  }, {});
}; // REAL AB Tasty configs


var AB_TESTS_CONFIG = [{
  testId: 1460669,
  contextKey: 'ab-test-activities',
  activeVariationIds: [1816698],
  description: 'TEST - FR - Activities step - delete step'
}, {
  testId: 1477415,
  contextKey: 'ab-test-activities-uk',
  activeVariationIds: [1838508],
  description: 'TEST - UK - Activities step - delete step'
}, {
  testId: 1477417,
  contextKey: 'ab-test-activities-br',
  activeVariationIds: [1838510],
  description: 'TEST - BR - Activities step - delete step'
}, {
  testId: 1477416,
  contextKey: 'ab-test-activities-ca',
  activeVariationIds: [1838509],
  description: 'TEST - CA - Activities step - delete step'
}, {
  testId: 1477418,
  contextKey: 'ab-test-activities-jp',
  activeVariationIds: [1838511],
  description: 'TEST - JP - Activities step - delete step'
}];

var fetchABTastyData = function fetchABTastyData() {
  console.info('CM_AB: fetchABTastyData called');

  try {
    if ( true && window.ABTasty && typeof window.ABTasty.getTestsOnPage === 'function') {
      var tests = window.ABTasty.getTestsOnPage();
      console.info('CM_AB: ABTasty.getTestsOnPage() returned:', tests);
      var abTastyData = {};
      AB_TESTS_CONFIG.forEach(function (_ref7) {
        var testId = _ref7.testId,
            contextKey = _ref7.contextKey,
            activeVariationIds = _ref7.activeVariationIds;
        var test = tests[testId];

        if (test) {
          var isActive = activeVariationIds.includes(test.variationID);
          var value = isActive ? '1' : '0';
          abTastyData[contextKey] = value;
          console.info("CM_AB: Test ".concat(testId, " (").concat(contextKey, "):"), {
            test: test,
            variationID: test.variationID,
            activeVariationIds: activeVariationIds,
            isActive: isActive,
            value: value
          });
        } else {
          abTastyData[contextKey] = '0';
          console.info("CM_AB: Test ".concat(testId, " (").concat(contextKey, ") not found, defaulting to \"0\""));
        }
      });
      console.info('CM_AB: Final abTastyData:', abTastyData);
      return abTastyData;
    }

    console.info('CM_AB: ABTasty not available or getTestsOnPage not a function');
  } catch (error) {
    console.warn('CM_AB: Error fetching ABTasty data', error);
  } // Default fallback


  var fallbackData = AB_TESTS_CONFIG.reduce(function (acc, _ref8) {
    var contextKey = _ref8.contextKey;
    acc[contextKey] = '0';
    return acc;
  }, {});
  console.info('CM_AB: Using fallback data:', fallbackData);
  return fallbackData;
}; // Helper function to get fallback data


var getFallbackData = function getFallbackData() {
  return AB_TESTS_CONFIG.reduce(function (acc, _ref9) {
    var contextKey = _ref9.contextKey;
    acc[contextKey] = '0';
    return acc;
  }, {});
};

var ABTestProvider_ABTestProvider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ABTestProvider, _Component);

  var _super = ABTestProvider_createSuper(ABTestProvider);

  function ABTestProvider(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ABTestProvider);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "updateABTastyData", function () {
      var _window$ABTasty, _window$ABTasty$getTe, _window$ABTasty2;

      console.info('CM_AB: updateABTastyData called');
      var abTastyData = fetchABTastyData();
      console.info('CM_AB: fetchABTastyData result:', abTastyData); // Check if we have real ABTasty data (not just sessionStorage fallback)

      var abTastyTests =  true && ((_window$ABTasty = window.ABTasty) === null || _window$ABTasty === void 0 ? void 0 : (_window$ABTasty$getTe = _window$ABTasty.getTestsOnPage) === null || _window$ABTasty$getTe === void 0 ? void 0 : _window$ABTasty$getTe.call(_window$ABTasty));
      var hasRealABTastyData = !isEmpty_default()(abTastyData) && true && window.ABTasty && typeof window.ABTasty.getTestsOnPage === 'function' && !isEmpty_default()(abTastyTests);
      console.info('CM_AB: Data validation:', {
        abTastyData: abTastyData,
        abTastyTests: abTastyTests,
        hasRealABTastyData: hasRealABTastyData,
        currentState: _this.state.abTastyData,
        eventState:  true && ((_window$ABTasty2 = window.ABTasty) === null || _window$ABTasty2 === void 0 ? void 0 : _window$ABTasty2.eventState)
      });
      var finalData = null;

      if (hasRealABTastyData) {
        console.info('CM_AB: Real ABTasty data found');
        finalData = abTastyData;

        if (ABTestProvider_isValidValues(_this.state.abTastyData, abTastyData)) {
          console.info('CM_AB: Updating state with new ABTasty data');

          _this.setState({
            abTastyData: abTastyData
          });
        } else {
          console.info('CM_AB: ABTasty data unchanged, but still triggering event');
        } // Stop retrying if we have real data


        if (_this.abTastyRetryTimer) {
          console.info('CM_AB: Stopping retry timer');
          clearTimeout(_this.abTastyRetryTimer);
          _this.abTastyRetryTimer = null;
        }
      } else {
        console.info('CM_AB: No real ABTasty data yet, using fallback data immediately'); // Use fallback data immediately to avoid delaying the render

        finalData = getFallbackData();

        if (ABTestProvider_isValidValues(_this.state.abTastyData, finalData)) {
          console.info('CM_AB: Setting fallback data immediately');

          _this.setState({
            abTastyData: finalData
          });
        } // Start retries in background (max 3 retries)


        if (!_this.abTastyRetryTimer && !_this.abTastyRetryCount) {
          _this.abTastyRetryCount = 1;
          console.info('CM_AB: Starting background retry mechanism (attempt 1/3)');
          _this.abTastyRetryTimer = setTimeout(function () {
            _this.abTastyRetryTimer = null;

            _this.updateABTastyData();
          }, 1000);
        } else if (_this.abTastyRetryCount && _this.abTastyRetryCount < 3) {
          _this.abTastyRetryCount++;
          console.info("CM_AB: Background retry attempt ".concat(_this.abTastyRetryCount, "/3"));
          _this.abTastyRetryTimer = setTimeout(function () {
            _this.abTastyRetryTimer = null;

            _this.updateABTastyData();
          }, 1000);
        } else {
          console.info('CM_AB: Max retries reached, keeping fallback data');
        }
      } // ALWAYS trigger event for BookingEngine if we have data


      if (finalData && typeof document !== 'undefined') {
        document.dispatchEvent(new CustomEvent('abTastyDataUpdated', {
          detail: finalData
        }));
        console.info('CM_AB: abTastyDataUpdated event dispatched with data:', finalData);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleEvent", function (e) {
      if (ABTestProvider_isValidValues(_this.state, e.values)) {
        _this.setState(function (prev) {
          return ABTestProvider_objectSpread(ABTestProvider_objectSpread({}, prev), e.values);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleABTastyReady", function (event) {
      var _window$ABTasty3;

      console.info('CM_AB: ABTasty ready event received:', {
        eventType: event.type,
        timestamp: new Date().toISOString(),
        abTastyExists:  true && !!window.ABTasty,
        getTestsOnPage:  true && typeof ((_window$ABTasty3 = window.ABTasty) === null || _window$ABTasty3 === void 0 ? void 0 : _window$ABTasty3.getTestsOnPage)
      }); // ABTasty is now ready, fetch the data

      _this.updateABTastyData();
    });

    var sessionData = ABTestProvider_fetchABTestData();
    var fallbackData = getFallbackData();
    _this.state = ABTestProvider_objectSpread(ABTestProvider_objectSpread({}, sessionData), {}, {
      abTastyData: fallbackData // Initialize with fallback data immediately

    });
    return _this;
  }

  Object(createClass["a" /* default */])(ABTestProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _window$ABTasty4,
          _window$ABTasty5,
          _window$ABTasty5$even,
          _window$ABTasty5$even2,
          _window$ABTasty6,
          _window$ABTasty7,
          _window$ABTasty7$even,
          _window$ABTasty7$even2,
          _this2 = this;

      document.addEventListener(ABTEST_EVENT, this.handleEvent, false); // Use official AB Tasty event

      window.addEventListener('abtasty_tagContentExecuted', this.handleABTastyReady, false); // Also keep the custom event as fallback

      document.addEventListener('cm_app_mounted', this.handleABTastyReady, false);
      console.info('CM_AB: ABTestProvider mounted, listening for events');
      console.info('CM_AB: Environment:', {
        NODE_ENV: "production",
        hostname: true ? window.location.hostname : undefined,
        isLocalhost:  true && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
      });
      console.info('CM_AB: ABTasty status:', {
        exists:  true && !!window.ABTasty,
        eventState:  true && ((_window$ABTasty4 = window.ABTasty) === null || _window$ABTasty4 === void 0 ? void 0 : _window$ABTasty4.eventState),
        tagContentExecuted:  true && ((_window$ABTasty5 = window.ABTasty) === null || _window$ABTasty5 === void 0 ? void 0 : (_window$ABTasty5$even = _window$ABTasty5.eventState) === null || _window$ABTasty5$even === void 0 ? void 0 : (_window$ABTasty5$even2 = _window$ABTasty5$even.tagContentExecuted) === null || _window$ABTasty5$even2 === void 0 ? void 0 : _window$ABTasty5$even2.status),
        getTestsOnPage:  true && typeof ((_window$ABTasty6 = window.ABTasty) === null || _window$ABTasty6 === void 0 ? void 0 : _window$ABTasty6.getTestsOnPage)
      }); // Check if AB Tasty is already ready (handles timing issue)

      if ( true && ((_window$ABTasty7 = window.ABTasty) === null || _window$ABTasty7 === void 0 ? void 0 : (_window$ABTasty7$even = _window$ABTasty7.eventState) === null || _window$ABTasty7$even === void 0 ? void 0 : (_window$ABTasty7$even2 = _window$ABTasty7$even.tagContentExecuted) === null || _window$ABTasty7$even2 === void 0 ? void 0 : _window$ABTasty7$even2.status) === 'complete') {
        console.info('CM_AB: ABTasty already ready, fetching data immediately');
        this.updateABTastyData();
      } else if ( true && window.ABTasty && typeof window.ABTasty.getTestsOnPage === 'function') {
        // Alternative check: if ABTasty exists and has getTestsOnPage, try to fetch
        console.info('CM_AB: ABTasty exists but event not fired, attempting to fetch data');
        this.updateABTastyData();
      } // Exposer la fonction de mise à jour pour les tests


      if (true) {
        window.forceABTestUpdate = function (data) {
          console.info('CM_AB: forceABTestUpdate called with:', data);

          _this2.setState({
            abTastyData: data
          });
        }; // Add debugging utilities for real environments


        window.CM_AB_DEBUG = {
          checkABTasty: function checkABTasty() {
            var _window$ABTasty8, _window$ABTasty9, _window$ABTasty10, _window$ABTasty10$get, _window$ABTasty11, _window$ABTasty11$eve;

            console.info('CM_AB: ABTasty Debug Info:', {
              exists: !!window.ABTasty,
              eventState: (_window$ABTasty8 = window.ABTasty) === null || _window$ABTasty8 === void 0 ? void 0 : _window$ABTasty8.eventState,
              getTestsOnPage: typeof ((_window$ABTasty9 = window.ABTasty) === null || _window$ABTasty9 === void 0 ? void 0 : _window$ABTasty9.getTestsOnPage),
              tests: (_window$ABTasty10 = window.ABTasty) === null || _window$ABTasty10 === void 0 ? void 0 : (_window$ABTasty10$get = _window$ABTasty10.getTestsOnPage) === null || _window$ABTasty10$get === void 0 ? void 0 : _window$ABTasty10$get.call(_window$ABTasty10),
              tagContentExecuted: (_window$ABTasty11 = window.ABTasty) === null || _window$ABTasty11 === void 0 ? void 0 : (_window$ABTasty11$eve = _window$ABTasty11.eventState) === null || _window$ABTasty11$eve === void 0 ? void 0 : _window$ABTasty11$eve.tagContentExecuted
            });
          },
          triggerEvent: function triggerEvent() {
            console.info('CM_AB: Manually triggering abtasty_tagContentExecuted event');
            window.dispatchEvent(new Event('abtasty_tagContentExecuted'));
          },
          checkState: function checkState() {
            console.info('CM_AB: Current Provider State:', _this2.state);
          },
          forceUpdate: function forceUpdate() {
            console.info('CM_AB: Manually calling updateABTastyData');

            _this2.updateABTastyData();
          }
        };
      } // Trigger event immediately for BookingEngine to avoid render delay


      if (typeof document !== 'undefined') {
        document.dispatchEvent(new CustomEvent('abTastyDataUpdated', {
          detail: this.state.abTastyData // Use state data (already has fallback)

        }));
        console.info('CM_AB: Immediate abTastyDataUpdated event dispatched');
      } // Initial fetch of ABTasty data


      this.updateABTastyData();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener(ABTEST_EVENT, this.handleEvent, false);
      document.removeEventListener('cm_app_mounted', this.handleABTastyReady, false); // Cleanup retry timer

      if (this.abTastyRetryTimer) {
        clearTimeout(this.abTastyRetryTimer);
        this.abTastyRetryTimer = null;
      } // Cleanup forceABTestUpdate


      if ( true && window.forceABTestUpdate) {
        delete window.forceABTestUpdate;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return ABTestProvider_jsx(ABTestContext["a" /* ABTestContext */].Provider, {
        value: this.state
      }, this.props.children ? react["Children"].only(this.props.children) : null);
    }
  }]);

  return ABTestProvider;
}(react["Component"]);


// EXTERNAL MODULE: ./src/client/context/OptinsProvider.js
var OptinsProvider = __webpack_require__("H8tl");

// CONCATENATED MODULE: ./src/client/app/AppProviders.jsx
var AppProviders_jsx = react_default.a.createElement;











var AppProviders_AppProviders = function AppProviders(_ref) {
  var children = _ref.children,
      appContext = _ref.appContext,
      pageContext = _ref.pageContext,
      reduxStore = _ref.reduxStore,
      toastRef = _ref.toastRef;
  var toastValue = Object(react["useMemo"])(function () {
    return {
      ref: toastRef
    };
  }, [toastRef]); // Mock ABTasty for testing purposes in local development

  ABTestProvider_useMockABTasty();
  return AppProviders_jsx(ReactAppContext["b" /* B2CAppContextProvider */], {
    appContext: appContext
  }, AppProviders_jsx(PageContext["a" /* PageContextProvider */], {
    pageContext: pageContext
  }, AppProviders_jsx(es["a" /* Provider */], {
    store: reduxStore
  }, AppProviders_jsx(ABTestProvider_ABTestProvider, null, AppProviders_jsx(ResponsiveLayout_ResponsiveLayout, {
    userAgent: appContext.userAgent,
    device: appContext.device
  }, AppProviders_jsx(DepartureCitiesProvider_DepartureCitiesProvider, null, AppProviders_jsx(ResortListProvider_ResortListProvider, null, AppProviders_jsx(context_FavoriteProductListProvider, null, AppProviders_jsx(ToastContext["a" /* ToastContext */].Provider, {
    value: toastValue
  }, AppProviders_jsx(OptinsProvider["b" /* OptinsProvider */], null, children))))))))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToHash.js
var scrollToHash = __webpack_require__("34at");

// EXTERNAL MODULE: ./src/hooks/use-previous/usePrevious.js
var usePrevious = __webpack_require__("AbLU");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/booking/entry-route/entryRoute.reducer.js
var entryRoute_reducer = __webpack_require__("m9Sl");

// CONCATENATED MODULE: ./src/client/store/booking/entry-route/entryroute.action.js


var entryroute_action_setEntryRoute = function setEntryRoute(payload) {
  return Object(createAction["b" /* default */])(entryRoute_reducer["a" /* SET_ENTRY_ROUTE */], payload);
};
var entryroute_action_unsetEntryRoute = function unsetEntryRoute() {
  return Object(createAction["b" /* default */])(entryRoute_reducer["b" /* UNSET_ENTRY_ROUTE */]);
};
// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// CONCATENATED MODULE: ./src/client/app/RouteChangeListener.jsx













var RouteChangeListener_RouteChangeListener = function RouteChangeListener() {
  var router = Object(next_router["useRouter"])();
  var hasNavigated = Object(react["useRef"])(false);
  var dispatch = Object(es["d" /* useDispatch */])();
  var uri = new URI_default.a(router.asPath);
  var pathname = uri.pathname();
  var previousPathname = Object(usePrevious["a" /* usePrevious */])(pathname);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var scrollUnderNav = !isDesktop;
  var isSeller = appContext.isSeller || // the pdf can be accessed by anybody but is only used by seller
  pathname.startsWith('/proposal-pdf');
  Object(react["useEffect"])(function () {
    if (isSeller) {
      var _router$query;

      if (((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.forceAuth) !== undefined) {
        return Object(redirectUtils["a" /* redirectToOidc */])(appContext);
      }
    }
  }, []);
  Object(react["useEffect"])(function () {
    if (uri.hash()) {
      Object(scrollToHash["a" /* goToHash */])(uri.hash(), scrollUnderNav);
    } else if (hasNavigated.current) {
      window.scrollTo(0, 0);
    }
  }, [pathname, uri.hash()]);
  Object(react["useEffect"])(function () {
    // $FlowFixMe
    var showLoader = function showLoader(nextUri, _ref) {
      var shallow = _ref.shallow;

      // on the booking engine there is no loader between pages, no loader also if it is the same path
      if (!shallow) {
        hasNavigated.current = true;
      }

      if (!shallow && !(nextUri.startsWith('/booking/') && previousPathname.startsWith('/booking/'))) {
        if (!nextUri.startsWith('/booking/') && !nextUri.startsWith('/option/')) {
          dispatch(entryroute_action_unsetEntryRoute());
        } // startLoading second arg it here to handle scroll correctly after navigation
        // see Components/widgets/loading/Loading.jsx


        dispatch(Object(globalLoader_action["d" /* startLoading */])('', true));
      }
    }; // $FlowFixMe


    var hideLoader = function hideLoader(nextUri, _ref2) {
      var shallow = _ref2.shallow;
      // By default next triggers routeChangeComplete even on the first app mount
      // However, in the BookingEngine we show a loader while the content loads
      var queryParams = URI_default.a.parseQuery(new URI_default.a(nextUri).query());
      dispatch({
        type: store_constants["m" /* SYNC_WITH_LOCATION */],
        payload: {
          location: {
            queryParams: queryParams
          }
        }
      });

      if (!shallow && hasNavigated.current && !(nextUri.startsWith('/booking/') && previousPathname.startsWith('/booking/'))) {
        dispatch(Object(globalLoader_action["c" /* endLoading */])());
      }
    }; // Show the loader before each page transition, hide after


    router.events.on('routeChangeStart', showLoader);
    router.events.on('routeChangeComplete', hideLoader);
    return function () {
      router.events.off('routeChangeStart', showLoader);
      router.events.off('routeChangeComplete', hideLoader);
    };
  }, []);
  return null;
};
// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/router/createRouterLocation.js











function createRouterLocation_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function createRouterLocation_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? createRouterLocation_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : createRouterLocation_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var createRouterLocation_createRouterLocation = function createRouterLocation(_ref) {
  var asPath = _ref.asPath,
      originalUrl = _ref.originalUrl,
      query = _ref.query,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? {} : _ref$params;
  var uri = new URI_default.a(asPath);
  var urlParams = {};
  var queryParams = {};
  /*
   * Due to a next-route implementation with a weird `.join('/')`
   * we need to check if the current query param has a slash as separator
   * and split it into an array.
   * cf: https://github.com/fridays/next-routes/issues/250
   */

  for (var queryParameter in query) {
    if (uri.hasSearch(queryParameter) && !params[queryParameter]) {
      queryParams[queryParameter] = query[queryParameter];
    } else {
      urlParams[queryParameter] = query[queryParameter];
    }
  }

  return {
    origin: true ? window.location.origin : undefined,
    pathname: uri.pathname(),
    hash: uri.hash(),
    urlParams: urlParams,
    queryParams: queryParams
  };
};
var createRouterLocation_updateShallowQueryParams = function updateShallowQueryParams(_ref2) {
  var location = _ref2.location,
      href = _ref2.href;

  if (!href) {
    return location;
  }

  var uri = Object(uriUtils["b" /* convertLocationToURI */])(location); // We cannot reconstruct the URL simply from href since the front-end doesn't know what routes can
  // be rewritten (/r/Bali/y is {urlParams: { dynamicPage: '/r/Bali/y }})

  var currentUri = new URI_default.a(href);
  var newQueryParams = location.queryParams;
  var queryParamsList = Object.keys(uri.query(true));
  var currentQueryParamsList = Object.keys(currentUri.query(true)); // delete query params which are no longer in the new uri

  for (var queryParamName in uri.query(true)) {
    if (!currentQueryParamsList.includes(queryParamName)) {
      delete newQueryParams[queryParamName];
    }
  } // add missing query params or update the current ones


  for (var _queryParamName in currentUri.query(true)) {
    if (!queryParamsList.includes(_queryParamName) || newQueryParams[_queryParamName] !== currentUri.query(true)[_queryParamName]) {
      newQueryParams[_queryParamName] = currentUri.query(true)[_queryParamName];
    }
  }

  return createRouterLocation_objectSpread(createRouterLocation_objectSpread({}, location), {}, {
    queryParams: newQueryParams
  });
};
// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// EXTERNAL MODULE: ./src/client/components/frameworks/toast/Toast.jsx
var Toast = __webpack_require__("0x7Y");

// CONCATENATED MODULE: ./src/client/components/frameworks/toast/Toast.container.jsx



var mapStateToProps = function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = state.toast || {},
      className = _ref.className,
      color = _ref.color,
      icon = _ref.icon,
      label = _ref.label,
      shouldDisplay = _ref.shouldDisplay,
      style = _ref.style;

  return {
    className: className,
    color: color,
    icon: icon,
    label: label,
    style: style,
    visible: shouldDisplay
  };
};
var mapDispatchToProps = {
  onClose: toast_actions["c" /* closeToast */]
};
var ToastContainer = Object(es["c" /* connect */])(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(Toast["a" /* Toast */]);
// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// CONCATENATED MODULE: ./src/client/components/layouts/head-info/HeadInfos.jsx
var HeadInfos_jsx = react_default.a.createElement;



var HeadInfos_HeadInfos = function HeadInfos() {
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  return HeadInfos_jsx(head_default.a, null, HeadInfos_jsx("title", {
    key: "title"
  }, pageContext.pageTitle), HeadInfos_jsx("meta", {
    key: "description",
    name: "description",
    content: pageContext.pageDescription || ''
  }), HeadInfos_jsx("link", {
    key: "canonical",
    rel: "canonical",
    href: pageContext.canonicalUrl
  }), HeadInfos_jsx("meta", {
    key: "viewport",
    name: "viewport",
    content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// CONCATENATED MODULE: ./src/client/store/user-info/hoc/UserInfo.jsx


var connector = Object(es["c" /* connect */])(function (state) {
  return {
    userInfo: Object(userInfo_selectors["a" /* userInfoSelector */])(state)
  };
});
function userInfoWrapper(ComponentToWrap) {
  return connector(ComponentToWrap);
}
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/components/frameworks/toaster-immersive/ToasterImmersive.jsx









var ToasterImmersive_jsx = react_default.a.createElement;

function ToasterImmersive_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ToasterImmersive_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ToasterImmersive_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ToasterImmersive_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var ToasterImmersive_ToasterImmersive = function ToasterImmersive(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref$color,
      iconName = _ref.iconName,
      onClick = _ref.onClick,
      onClose = _ref.onClose,
      subtitle = _ref.subtitle,
      text = _ref.text,
      title = _ref.title,
      url = _ref.url;

  var _useState = Object(react["useState"])(false),
      viewed = _useState[0],
      setViewed = _useState[1];

  Object(react["useEffect"])(function () {
    if (viewed) {
      onClose && onClose();
    }
  }, [viewed]);
  var TagName = url ? DynamicLink["a" /* default */] : 'div';
  var tagProps = url ? {
    url: url
  } : {};
  tagProps = ToasterImmersive_objectSpread(ToasterImmersive_objectSpread({}, tagProps), {}, {
    onClick: onClick
  });
  return ToasterImmersive_jsx("div", {
    className: "relative isolate flex gap-10 py-10 pe-20"
  }, ToasterImmersive_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-".concat(color),
    name: iconName,
    width: "1.25rem"
  }), ToasterImmersive_jsx(TagName, Object(esm_extends["a" /* default */])({}, tagProps, {
    className: "font-sans"
  }), title && ToasterImmersive_jsx("h3", {
    className: "text-16 text-".concat(color, " font-bold")
  }, title), !!subtitle && ToasterImmersive_jsx("p", {
    className: "m-0 font-brand text-24 leading-tight"
  }, subtitle), text && ToasterImmersive_jsx(Text["a" /* Text */], {
    text: text,
    theme: "text-sans-n1"
  })), ToasterImmersive_jsx("button", {
    className: "absolute end-0 top-0 leading-0",
    onClick: function onClick(e) {
      e.stopPropagation();
      onClose && onClose();
      setViewed(true);
    },
    type: "button"
  }, ToasterImmersive_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.75rem"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/crisis-alert/CrisisAlertLinkBanner.jsx

var CrisisAlertLinkBanner_jsx = react_default.a.createElement;





var CRISIS_ALERT_LOCALSTORAGE_KEY = 'dismissGlobalAlert';
var CrisisAlertLinkBanner_CrisisAlertLinkBanner = function CrisisAlertLinkBanner(_ref) {
  var alertDate = _ref.alertDate,
      linkLabel = _ref.linkLabel,
      linkUrl = _ref.linkUrl,
      _onClose = _ref.onClose,
      setIsVisible = _ref.setIsVisible,
      isSpread = _ref.isSpread;
  var shouldDisplay = !isEmpty_default()(alertDate) && !isEmpty_default()(linkLabel) && !(Object(local_storage_api["a" /* getFromLocalStorage */])(CRISIS_ALERT_LOCALSTORAGE_KEY) === alertDate);
  Object(react["useEffect"])(function () {
    setIsVisible && setIsVisible(shouldDisplay);
  }, [shouldDisplay]);
  return shouldDisplay ? CrisisAlertLinkBanner_jsx(ToasterImmersive_ToasterImmersive, {
    color: colors["a" /* COLORS */].ORANGE,
    iconName: icons["a" /* ICONS */].LIGHTBULB,
    onClose: function onClose() {
      Object(local_storage_api["c" /* setInLocalStorage */])(CRISIS_ALERT_LOCALSTORAGE_KEY, alertDate);
      _onClose && _onClose();
    },
    title: linkLabel,
    url: isSpread ? linkUrl : undefined
  }) : null;
};
// CONCATENATED MODULE: ./src/utils/tracking/dataScore.js



var dataScore_getDataScore = function getDataScore(_ref) {
  var resortId = _ref.resortId,
      departureDate = _ref.departureDate,
      appContext = _ref.appContext;
  var neolaneId = appContext.neolaneId,
      googleTrackingId = appContext.googleTrackingId;
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    query{\n      dataScore(\n      resortId: \"".concat(resortId || '', "\",\n      departureDate: \"").concat(departureDate || '', "\",\n      neolaneId: \"").concat(neolaneId || '', "\",\n      gaTrackingId: \"").concat(googleTrackingId || '', "\") {\n        leadScoring\n      }\n    }\n  "));
};


// EXTERNAL MODULE: ./src/client/store/lead-info/constants.js
var lead_info_constants = __webpack_require__("unIT");

// CONCATENATED MODULE: ./src/client/store/lead-info/leadInfos.action.js



var leadInfos_action_setDataScore = function setDataScore(score) {
  return Object(createAction["b" /* default */])(lead_info_constants["b" /* SET_DATA_SCORE */], {
    score: score
  });
};


// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// CONCATENATED MODULE: ./src/client/components/widgets/data-score/DataScore.jsx









function DataScore_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DataScore_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DataScore_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DataScore_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var pendingDataScoreTimeout = null;
/*
 * the following function is used to execute the fn arg on the last call only
 * the previous scheduled call to fn will be canceled at every new call
 * by clearing the setTimeout id stored in pendingDataScoreTimeout
 *
 */

var takeLast = function takeLast(fn) {
  clearTimeout(pendingDataScoreTimeout); // 5000ms is choosed arbitrarily

  pendingDataScoreTimeout = setTimeout(fn, 5000);
};

var DataScore_neolaneId = null;

var DataScore_DataScore = function DataScore() {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var selectedProposal = Object(es["e" /* useSelector */])(booking_selector["i" /* getCurrentProposal */]);
  var resort = Object(es["e" /* useSelector */])(booking_selector["j" /* getCurrentResort */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var dataScoreHasBeenFetched = !!Object(sessionStorageApi["b" /* getFromSessionStorage */])(lead_info_constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */]);
  Object(react["useEffect"])(function () {
    if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('enableLeadScoring') && isAppMounted && ( // neolaneId will change after user sign in
    !DataScore_neolaneId && appContext.neolaneId || !dataScoreHasBeenFetched && (appContext.neolaneId || appContext.googleTrackingId))) {
      DataScore_neolaneId = appContext.neolaneId;
      /*
           every calls to the lead scoring API is billed so we want to make
           sure there is only one call to be done when the app state is stabilized
         */

      takeLast(function () {
        dataScore_getDataScore(DataScore_objectSpread(DataScore_objectSpread(DataScore_objectSpread({}, selectedProposal ? {
          departureDate: selectedProposal.departureDate
        } : null), resort ? {
          resortId: resort.id
        } : null), {}, {
          appContext: appContext
        })).then(function (_ref) {
          var leadScoring = _ref.dataScore.leadScoring;
          var score = parseFloat(leadScoring);
          tracking_api["b" /* setDataLayer */](DataScore_objectSpread(DataScore_objectSpread({}, constants["m" /* GA_DEFAULT_PAYLOAD */]), {}, {
            event: 'leadScoring',
            leadScoring: score
          }), appContext, pageContext.pageId);
          dispatch(leadInfos_action_setDataScore(leadScoring));
          Object(sessionStorageApi["d" /* setInSessionStorage */])(lead_info_constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */], leadScoring);
        }).catch(function () {
          /* we don't do anything if the call fails */
        });
      });
    }
  }, [isAppMounted, appContext, selectedProposal]);
  return null;
};


// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/analytics/analyticsUtils.js
var analyticsUtils = __webpack_require__("kdyR");

// EXTERNAL MODULE: ./src/utils/api-status/constants.js
var api_status_constants = __webpack_require__("54uq");

// EXTERNAL MODULE: ./src/client/components/widgets/ftc/ftc.utils.js
var ftc_utils = __webpack_require__("1qr/");

// CONCATENATED MODULE: ./src/client/components/widgets/ftc-toaster/FTCToasterContainer.jsx




var FTCToasterContainer_jsx = react_default.a.createElement;
















var voucherQuery = "query {\n    vouchers {\n      type\n      items {\n        value\n        unit\n        currency\n        id\n        isExpired\n        originType\n        status\n      }\n    }\n }";
var FTCToasterContainer_FTCToasterContainer = function FTCToasterContainer(_ref) {
  var _onClose = _ref.onClose,
      setIsVisible = _ref.setIsVisible;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var track = Object(useTracking["a" /* useTracking */])();
  var PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;
  var isAllowedPage = [PAGE_TYPES.RESORT, PAGE_TYPES.CRUISE].includes(pageType);
  var displayFTC = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayFutureTravelCredit');
  var displayFTCToShopping = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('shopping.displayFutureTravelCredit');

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isLogged = _useAuthentication.isLogged;

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: voucherQuery,
    queryOptions: {
      requestName: requestDictionary["F" /* CUSTOMER_ACCOUNT_GET_VOUCHERS */]
    },
    cache: false,
    ignore: !isLogged || !isAllowedPage || !displayFTC
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  var creditNotesVouchers = data === null || data === void 0 ? void 0 : data.vouchers.find(function (_ref2) {
    var type = _ref2.type;
    return type === 'CREDIT_NOTE';
  });
  var creditNoteVoucher = creditNotesVouchers === null || creditNotesVouchers === void 0 ? void 0 : creditNotesVouchers.items.find(function (voucher) {
    return voucher.status === api_status_constants["b" /* API_AVAILABLE */] && voucher.originType.startsWith('<DOS=');
  });
  var hasCreditNoteVoucher = !!creditNoteVoucher;
  Object(react["useEffect"])(function () {
    if (hasCreditNoteVoucher) {
      track({
        actionGA: 'FTC',
        labelGA: 'displayAmountToaster'
      });
    }
  }, [hasCreditNoteVoucher]);
  var title = Object(i18n["h" /* t */])(hasCreditNoteVoucher ? 'resort.futureTravelCredit.specificTitle' : 'resort.futureTravelCredit.genericTitle');
  var text = Object(i18n["h" /* t */])(hasCreditNoteVoucher ? 'resort.futureTravelCredit.message' : 'resort.futureTravelCredit.genericDescription');
  var subtitle = creditNoteVoucher && Object(ftc_utils["a" /* formatVoucherValue */])(creditNoteVoucher, appContext.locale);
  var shouldSkipRendering = !isAppMounted || !isAllowedPage || !displayFTC || isLoading && isLogged || !isLoading && isLogged && !hasCreditNoteVoucher || !displayFTCToShopping && !isLogged || !Object(analyticsUtils["a" /* isAnalyticsEnabled */])();
  Object(react["useEffect"])(function () {
    setIsVisible && setIsVisible(!shouldSkipRendering);
  }, [shouldSkipRendering]);
  return !shouldSkipRendering && FTCToasterContainer_jsx(ToasterImmersive_ToasterImmersive, {
    title: title,
    text: text,
    subtitle: subtitle,
    iconName: icons["a" /* ICONS */].PROMO_CODE,
    onClose: function onClose() {
      _onClose && _onClose();
    }
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-favorite/PriceRemoteMaximumFavoriteToaster.jsx


var PriceRemoteMaximumFavoriteToaster_jsx = react_default.a.createElement;








var PriceRemoteMaximumFavoriteToaster_PriceRemoteMaximumFavoriteToaster = function PriceRemoteMaximumFavoriteToaster(_ref) {
  var setIsVisible = _ref.setIsVisible;

  var _useContext = Object(react["useContext"])(FavoriteProductListContext["a" /* FavoriteProductListContext */]),
      _useContext$favoriteP = _useContext.favoriteProductsState,
      favoriteProductList = _useContext$favoriteP.favoriteProductList,
      hasTooManyFavorites = _useContext$favoriteP.hasTooManyFavorites,
      setFavoriteProductList = _useContext.setFavoriteProductList,
      setHasTooManyFavorites = _useContext.setHasTooManyFavorites;

  var _useAuthentication = Object(useAuthentication["a" /* useAuthentication */])(),
      isLogged = _useAuthentication.isLogged,
      isQuickLogged = _useAuthentication.isQuickLogged;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;
  var isAllowedPage = [PAGE_TYPES.RESORT].includes(pageType);
  var displayToaster = !isLogged && !isQuickLogged && hasTooManyFavorites && isAllowedPage;
  Object(react["useEffect"])(function () {
    setIsVisible === null || setIsVisible === void 0 ? void 0 : setIsVisible(displayToaster);
  }, [displayToaster]);
  return displayToaster && PriceRemoteMaximumFavoriteToaster_jsx(ToasterImmersive_ToasterImmersive, {
    text: Object(i18n["h" /* t */])('common.favoriteOption.favoriteTooltip.editFavorite'),
    title: Object(i18n["h" /* t */])('common.favoriteOption.favoriteTooltip.maximumLabel'),
    iconName: icons["a" /* ICONS */].WARNING,
    onClick: function onClick() {
      setFavoriteProductList(favoriteProductList, false, displayToaster);
      setIsVisible === null || setIsVisible === void 0 ? void 0 : setIsVisible(false);
    },
    onClose: function onClose() {
      setIsVisible === null || setIsVisible === void 0 ? void 0 : setIsVisible(false);
      setHasTooManyFavorites(false);
    }
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.tracking.js
var Navigation_tracking = __webpack_require__("4Grf");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.mapper.js









function mapSubItemsProps(parentLabel, items, index) {
  if (isEmpty_default()(items)) {
    return [];
  }

  return items.map(function (item, subIndex) {
    var dataLabel = "".concat(parentLabel, "_").concat(camelCase_default()(item.label));
    var subItemsProps = {
      id: "".concat(index).concat(subIndex),
      color: item.color || colors["a" /* COLORS */].BLACK,
      label: item.label,
      link: {
        url: item.url,
        trackingData: Object(Navigation_tracking["f" /* getNavigationSubItemLinkTrackingData */])({
          label: dataLabel,
          parentLabel: parentLabel.split('_')[0]
        })
      },
      seeMoreLabel: item.seeMoreLabel || ''
    };

    if (!isEmpty_default()(item.imageUrl)) {
      subItemsProps.thumbnail = {
        imageUrl: item.imageUrl
      };
    }

    if (!isEmpty_default()(item.subItems)) {
      subItemsProps.subItems = mapSubItemsProps(dataLabel, item.subItems, "".concat(index).concat(subIndex));
    }

    return subItemsProps;
  });
}

var Navigation_mapper_buildNavigationMenuItems = function buildNavigationMenuItems(menus) {
  if (!menus || !menus.length) {
    return [];
  }

  return menus.map(function (menu, index) {
    return {
      color: menu.color || colors["a" /* COLORS */].BLACK,
      id: "".concat(index),
      label: menu.label,
      link: {
        url: menu.url,
        trackingData: Object(Navigation_tracking["d" /* getNavigationItemLinkTrackingData */])(camelCase_default()(menu.label))
      },
      isList: menu.type === 'subItemsList',
      subItems: mapSubItemsProps(camelCase_default()(menu.label), menu.items, index)
    };
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-stickynode/dist/Sticky.js
var Sticky = __webpack_require__("Phb7");
var Sticky_default = /*#__PURE__*/__webpack_require__.n(Sticky);

// EXTERNAL MODULE: ./src/client/components/utils/layers/stopScroll.js
var stopScroll = __webpack_require__("qVkC");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// CONCATENATED MODULE: ./src/client/components/utils/languages/SwitchLanguageModel.js






var SwitchLanguageModel_jsx = react["createElement"];


function getUrl(locale) {
  return '/?locale=' + locale;
}

function SwitchLanguageModel_getLocales(localesConfig) {
  return Object.keys(localesConfig);
}

function getSwitchLocale(localesConfig, currentLocale) {
  return SwitchLanguageModel_getLocales(localesConfig).filter(function (locale) {
    return locale !== currentLocale;
  })[0];
}

var SwitchLanguageModel_SwitchLanguage = /*#__PURE__*/function () {
  function SwitchLanguage(availableLocalesConfig, currentLocale) {
    Object(classCallCheck["a" /* default */])(this, SwitchLanguage);

    Object(defineProperty["a" /* default */])(this, "localesConfig", void 0);

    Object(defineProperty["a" /* default */])(this, "currentLocale", void 0);

    this.localesConfig = availableLocalesConfig;
    this.currentLocale = currentLocale;
  }

  Object(createClass["a" /* default */])(SwitchLanguage, [{
    key: "getAvailableLocales",
    value: function getAvailableLocales() {
      return this.localesConfig;
    }
  }, {
    key: "getCurrentLocaleLabel",
    value: function getCurrentLocaleLabel() {
      return this.localesConfig[this.currentLocale].label;
    }
  }, {
    key: "getSwitchLocaleLabel",
    value: function getSwitchLocaleLabel() {
      return this.localesConfig[getSwitchLocale(this.localesConfig, this.currentLocale)].label;
    }
  }, {
    key: "getLabelWithUrls",
    value: function getLabelWithUrls() {
      var _this = this;

      return Object.keys(this.localesConfig).map(function (locale) {
        return {
          label: _this.localesConfig[locale].label,
          countryCode: _this.localesConfig[locale].PAYS,
          langCode: _this.localesConfig[locale].LANG,
          languageNativeName: _this.localesConfig[locale].languageNativeName,
          moment: _this.localesConfig[locale].moment,
          locale: locale,
          url: getUrl(locale)
        };
      });
    }
  }, {
    key: "getSwitchUrl",
    value: function getSwitchUrl() {
      return getUrl(getSwitchLocale(this.localesConfig, this.currentLocale));
    }
  }, {
    key: "isMultiLanguage",
    value: function isMultiLanguage() {
      return SwitchLanguageModel_getLocales(this.localesConfig).length > 1;
    }
    /* todo: es6 : make this class iterable */

  }, {
    key: "map",
    value: function map(mapper) {
      var _this2 = this;

      var mapping = function mapping() {
        return _this2.getLabelWithUrls().map(mapper);
      };

      return this.or(mapping.bind(this));
    }
  }, {
    key: "or",
    value: function or(callback) {
      return this.isMultiLanguage() ? callback() : SwitchLanguageModel_jsx("noscript", null);
    }
  }]);

  return SwitchLanguage;
}();

/* harmony default export */ var SwitchLanguageModel = (SwitchLanguageModel_SwitchLanguage);
// CONCATENATED MODULE: ./src/client/components/widgets/languages/Languages.themes.js
var themes = {
  inline: {
    thRoot: 'inline-flex items-center justify-around whitespace-nowrap',
    thItemFirst: 'border-l-0 border-grey capitalize flex-1 text-center text-black',
    thItem: 'border-l-1 border-grey capitalize flex-1 text-center text-black',
    thItemCurrent: 'font-bold text-black',
    thLink: 'inline-block py-5 px-10 hocus:underline whitespace-nowrap'
  },
  column: {
    thRoot: '',
    thItemFirst: 'border-t-0 border-grey capitalize text-center text-black',
    thItem: 'border-t-1 border-grey capitalize text-center text-black',
    thItemCurrent: 'font-bold text-black',
    thLink: 'block p-10 hocus:underline whitespace-nowrap'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/languages/Languages.jsx










var Languages_jsx = react_default.a.createElement;








var Languages_Languages = function Languages(_ref) {
  var className = _ref.className,
      _ref$currentLocale = _ref.currentLocale,
      currentLocale = _ref$currentLocale === void 0 ? '' : _ref$currentLocale,
      _ref$defaultLocale = _ref.defaultLocale,
      defaultLocale = _ref$defaultLocale === void 0 ? '' : _ref$defaultLocale,
      getTrackingData = _ref.getTrackingData,
      isActive = _ref.isActive,
      locales = _ref.locales,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'inline' : _ref$theme;
  var track = Object(useTracking["a" /* useTracking */])();

  var _useRouter = Object(next_router["useRouter"])(),
      asPath = _useRouter.asPath;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      switchLang = _usePageContext.switchLang;

  if (isEmpty_default()(locales)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thItem = _themes$theme.thItem,
      thItemCurrent = _themes$theme.thItemCurrent,
      thItemFirst = _themes$theme.thItemFirst,
      thLink = _themes$theme.thLink,
      thRoot = _themes$theme.thRoot;
  var languages = new SwitchLanguageModel(locales, currentLocale);
  var currentUri = new URI_default.a(asPath);
  return Languages_jsx("ul", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, languages.map(function () {
    var _switchLang$find;

    var localeInfos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var idx = arguments.length > 1 ? arguments[1] : undefined;
    var switchLangUri = switchLang === null || switchLang === void 0 ? void 0 : (_switchLang$find = switchLang.find(function (_ref2) {
      var hrefLangLocale = _ref2.locale;
      return localeInfos.locale === hrefLangLocale;
    })) === null || _switchLang$find === void 0 ? void 0 : _switchLang$find.url;
    var isCurrentLocale = currentLocale === localeInfos.locale;
    var isDefaultLocale = defaultLocale === localeInfos.locale;
    var langUrl;

    if (!isCurrentLocale && switchLangUri) {
      var langUri = currentUri.clone().pathname(switchLangUri).setQuery({
        locale: undefined
      });

      if (!isDefaultLocale) {
        langUri.setQuery({
          locale: localeInfos.locale
        });
      }

      langUrl = langUri.toString();
    } else if (!isCurrentLocale && !switchLangUri) {
      langUrl = isDefaultLocale ? '/' : localeInfos.url;
    }

    var label = localeInfos.moment ? localeInfos.moment.slice(0, 2) : localeInfos.label;
    var TagName = isCurrentLocale ? 'div' : 'a';
    return Languages_jsx("li", {
      key: "".concat(localeInfos.locale, "-").concat(localeInfos.countryCode, "-").concat(localeInfos.langCode),
      className: Object(classnames_utils["a" /* classnames */])(idx === 0 ? thItemFirst : thItem, Object(defineProperty["a" /* default */])({}, "".concat(thItemCurrent), isCurrentLocale))
    }, Languages_jsx(TagName, {
      "aria-current": isCurrentLocale,
      "aria-label": "".concat(label, " ").concat(localeInfos.languageNativeName),
      className: Object(classnames_utils["a" /* classnames */])(thLink),
      "data-testid": "Languages-link",
      href: langUrl,
      lang: localeInfos.moment,
      onClick: function onClick() {
        if (!isCurrentLocale && getTrackingData) {
          track(getTrackingData(localeInfos.url.replace('/?locale=', '')));
        }
      },
      tabIndex: isActive ? 0 : -1
    }, localeInfos.label));
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/hooks/use-autocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__("aUQU");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__("TYRa");
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.utils.js
var FacetSearch_utils = __webpack_require__("hPQF");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackSearchResults.js
var useTrackSearchResults = __webpack_require__("NrqW");

// EXTERNAL MODULE: ./src/client/store/faceting/faceting.selector.js + 1 modules
var faceting_selector = __webpack_require__("vIa8");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchQuery.jsx




var GlobalSearchQuery_jsx = react_default.a.createElement;


















var redirection = 'redirection_suggestedRequest';
var GlobalSearchQuery_ReferencedSearchQuery = function ReferencedSearchQuery(props) {
  var autocompleteQuery = props.autocompleteQuery,
      clearGlobalSearch = props.clearGlobalSearch,
      facetingSuggestedRequests = props.facetingSuggestedRequests,
      onChangeQuery = props.onChangeQuery,
      searchInputRef = props.searchInputRef;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isSeller = _useAppContext.isSeller;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["m" /* getKidsValidationState */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'layer'
  });
  var containerPadding = isDesktop ? {
    paddingLeft: '15%',
    paddingRight: '15%'
  } : {};
  var hasSuggestRequests = !!facetingSuggestedRequests.items.length;
  return GlobalSearchQuery_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('bg-white px-15', {
      relative: !autocompleteQuery
    }),
    style: containerPadding
  }, GlobalSearchQuery_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('m-auto w-full max-w-site-medium pt-30 md:pb-20', {
      'pb-30': autocompleteQuery,
      'pb-50 md:pb-50': !hasSuggestRequests && !autocompleteQuery
    })
  }, GlobalSearchQuery_jsx("label", {
    className: "mb-10 block px-20 font-brand text-24",
    htmlFor: "global-search-query-input"
  }, upperFirst_default()(Object(i18n["h" /* t */])('faceting.autocomplete.enterYourSearch'))), GlobalSearchQuery_jsx("div", {
    className: "flex h-[66px] overflow-hidden rounded-pill border-1 border-lightSand p-10"
  }, GlobalSearchQuery_jsx("input", {
    className: Object(classnames_utils["a" /* classnames */])('h-full flex-1 cursor-pointer px-10 text-14 font-bold leading-normal', {
      'text-mediumGrey': !autocompleteQuery,
      'text-black': autocompleteQuery
    }),
    "data-testid": "global-search-input",
    id: "global-search-query-input",
    onChange: onChangeQuery,
    placeholder: Object(i18n["h" /* t */])('faceting.searchTitle'),
    ref: searchInputRef,
    type: "search",
    value: autocompleteQuery
  }), GlobalSearchQuery_jsx(Button["a" /* Button */], {
    className: "w-46 min-w-46 flex-none rounded-pill leading-0 lg:justify-center",
    "data-testid": "global-search-search-button",
    isExternalLink: false,
    isSquare: true,
    onClick: function onClick() {
      var query = {
        label: autocompleteQuery
      };
      Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
        criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
        router: router,
        searchCriteria: {
          query: query,
          departureCity: departureCity,
          departureDate: departureDate,
          duration: duration,
          keywords: '',
          kids: kids,
          kidsValidationState: kidsValidationState
        },
        searchPageRouteName: 'search'
      });
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(query));
      clearGlobalSearch();
      track({
        actionGA: 'search',
        categoryGA: 'layer',
        labelGA: 'validate',
        searchReferrer: 'layer'
      });
    },
    url: autocompleteQuery ? "/s?search=".concat(autocompleteQuery) : '/s'
  }, GlobalSearchQuery_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.5rem"
  })))), !isSeller && hasSuggestRequests && !autocompleteQuery && GlobalSearchQuery_jsx("div", {
    className: "m-auto w-full max-w-site-medium py-25 pb-40 md:pt-0"
  }, GlobalSearchQuery_jsx("div", {
    className: "font-sans text-14"
  }, facetingSuggestedRequests.title), GlobalSearchQuery_jsx("div", {
    className: "flex flex-wrap md:justify-between"
  }, facetingSuggestedRequests.items.map(function (_ref) {
    var suggestLabel = _ref.label,
        suggestUrl = _ref.url;
    return GlobalSearchQuery_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('w-1/2 pe-20 pt-10 md:w-auto md:pt-0'),
      key: suggestLabel
    }, GlobalSearchQuery_jsx("div", {
      className: "w-full truncate pt-10 font-sans text-14 font-bold"
    }, GlobalSearchQuery_jsx(DynamicLink["a" /* default */], {
      className: "font-bold text-sienna underline transition-color hocus:text-sienna-active",
      onClick: function onClick() {
        var isSearchUrl = suggestUrl.startsWith('/s');
        track({
          actionGA: 'search',
          categoryGA: 'layer',
          internalSearchEngineNbResults: isSearchUrl ? '' : redirection,
          labelGA: 'suggestedRequest',
          searchReferrer: 'layer',
          searchRequestType: 'Autocomplete',
          searchTerms: suggestLabel
        });

        if (!isSearchUrl) {
          trackSearchResults({
            internalSearchEngineNbResults: redirection,
            searchRequestType: 'Autocomplete',
            searchResorts: [],
            searchTerms: suggestLabel
          });
        }

        clearGlobalSearch();
      },
      url: suggestUrl
    }, suggestLabel)));
  }))));
};
var SearchQuery = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return GlobalSearchQuery_jsx(GlobalSearchQuery_ReferencedSearchQuery, Object(esm_extends["a" /* default */])({}, props, {
    searchInputRef: ref
  }));
});
// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackQueryChange.js
var useTrackQueryChange = __webpack_require__("kWbI");

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 1 modules
var Grid = __webpack_require__("uLWw");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 5 modules
var Product = __webpack_require__("XTOr");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestionsGrid.jsx




var GlobalSearchSuggestionsGrid_jsx = react_default.a.createElement;




var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var MAX_GRID_SUGGESTIONS = 4;
var GlobalSearchSuggestionsGrid_GlobalSearchSuggestionsGrid = function GlobalSearchSuggestionsGrid(props) {
  var isDesktop = props.isDesktop;
  var products = props.blockSuggestions.slice(0, MAX_GRID_SUGGESTIONS).map(function (_ref) {
    var image = _ref.image,
        label = _ref.label,
        link = _ref.link,
        productId = _ref.productId,
        productType = _ref.productType,
        subLabel1 = _ref.subLabel1,
        subLabel2 = _ref.subLabel2;
    return {
      header: {
        heading: {
          subtitle: productType === PRODUCT_TYPES.RESORT ? subLabel1 : subLabel2,
          title: label
        }
      },
      id: productId,
      thumbnail: {
        pictures: [{
          altMsg: label,
          src: image
        }]
      },
      type: productType,
      url: link
    };
  });
  var grid = {
    desktop: 3,
    mobile: 1,
    phablet: 2,
    tablet: 3
  };
  return products.length > 0 && GlobalSearchSuggestionsGrid_jsx(Grid["a" /* default */], {
    display: grid,
    grid: grid,
    hasSeeMore: false,
    totalNumberToDisplay: MAX_GRID_SUGGESTIONS
  }, products.map(function (product) {
    return GlobalSearchSuggestionsGrid_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      key: product.id
    }, product, {
      onClick: function onClick() {
        var query = {
          label: product.header.heading.title,
          type: 'resort'
        };
        props.onClick(query);
      },
      isCompact: !isDesktop
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestionsList.jsx
var GlobalSearchSuggestionsList = __webpack_require__("RWDY");

// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearchSuggestions.jsx

















var GlobalSearchSuggestions_jsx = react_default.a.createElement;

function GlobalSearchSuggestions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GlobalSearchSuggestions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GlobalSearchSuggestions_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GlobalSearchSuggestions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var SuggestionsBlockTitle = function SuggestionsBlockTitle(_ref) {
  var title = _ref.title;
  return GlobalSearchSuggestions_jsx("div", {
    className: "mb-20 mt-15 text-16 font-bold leading-tight text-sienna lg:mb-10"
  }, title);
};

var GlobalSearchSuggestions_SearchSuggestions = function SearchSuggestions(props) {
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["m" /* getKidsValidationState */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  var track = Object(useTracking["a" /* useTracking */])();
  var locale = router.query.locale;
  var suggestionsBlocks = [{
    id: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].COUNTRY,
    types: [GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].AREA, GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].COUNTRY],
    title: Object(i18n["h" /* t */])('faceting.autocomplete.destinationsTitle'),
    linkLabel: Object(i18n["h" /* t */])('faceting.autocomplete.moreDestinationsLabel'),
    linkURL: Object(i18n["h" /* t */])('faceting.autocomplete.moreDestinationsURL'),
    width: isDesktop ? 'w-1/5' : 'w-full',
    order: isDesktop ? 1 : 2
  }, {
    id: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY,
    types: [GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY],
    type: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY,
    title: Object(i18n["h" /* t */])('faceting.autocomplete.activitiesTitle'),
    linkLabel: Object(i18n["h" /* t */])('faceting.autocomplete.moreActivitiesLabel'),
    linkURL: Object(i18n["h" /* t */])('faceting.autocomplete.moreActivitiesURL'),
    width: isDesktop ? 'w-1/5' : 'w-full',
    order: isDesktop ? 2 : 3
  }, {
    id: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT,
    types: [GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT],
    title: Object(i18n["h" /* t */])('faceting.autocomplete.productsTitle'),
    linkLabel: Object(i18n["h" /* t */])('faceting.autocomplete.moreProductsLabel'),
    linkURL: '/s',
    width: isDesktop ? 'w-3/5' : 'w-full',
    order: isDesktop ? 3 : 1
  }, {
    id: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO,
    types: [GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO],
    title: Object(i18n["h" /* t */])('faceting.autocomplete.editorialTitle'),
    linkLabel: Object(i18n["h" /* t */])('faceting.autocomplete.seeMoreArticlesLabel'),
    linkURL: Object(i18n["h" /* t */])('faceting.autocomplete.seeMoreArticlesLink'),
    width: isDesktop ? 'w-2/5' : 'w-full',
    order: 4
  }];
  var trackingPayload = {
    categoryGA: 'layer',
    searchReferrer: 'layer'
  };
  return GlobalSearchSuggestions_jsx("div", {
    id: "search-suggestions",
    className: "m-auto flex max-w-site-medium flex-wrap border-0 border-lightGrey lg:border-t-1"
  }, suggestionsBlocks.map(function (block) {
    var blockSuggestions = props.autocompleteResults.filter(function (result) {
      return !!result.label && block.types.includes(result.type);
    });
    var SuggestionsBlock = block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT ? GlobalSearchSuggestionsGrid_GlobalSearchSuggestionsGrid : GlobalSearchSuggestionsList["a" /* GlobalSearchSuggestionsList */];
    var linkURL = block.linkURL;
    var blockLinkURL = locale && linkURL ? new URI_default.a(linkURL).addQuery({
      locale: locale
    }).toString() : linkURL;
    return props.autocompleteQuery.length === 0 || !isDesktop && isEmpty_default()(blockSuggestions) ? null : GlobalSearchSuggestions_jsx("div", {
      key: "search-suggestions-".concat(block.id),
      className: Object(classnames_utils["a" /* classnames */])(block.width, {
        'mb-20 border-t-1 border-grey': !isDesktop
      }),
      style: {
        order: block.order
      }
    }, block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].COUNTRY || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO && !isDesktop ? GlobalSearchSuggestions_jsx(SuggestionsBlockTitle, {
      title: block.title
    }) : GlobalSearchSuggestions_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('items-strech flex justify-between', {
        'w-5/6': block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO
      })
    }, GlobalSearchSuggestions_jsx(SuggestionsBlockTitle, {
      title: block.title
    }), (block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT && blockSuggestions.length > MAX_GRID_SUGGESTIONS || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO && blockLinkURL) && GlobalSearchSuggestions_jsx(DynamicLink["a" /* default */], {
      className: "mb-20 mt-15 text-12 font-bold leading-tight text-black underline lg:mb-10",
      isExternalLink: false,
      onClick: function onClick() {
        track(GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
          actionGA: 'search',
          labelGA: "viewMore_".concat(Object(utils["j" /* getSearchMappedTypeForLabelGA */])(block.id))
        }));

        if (block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO) {
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection_editorial',
            searchRequestType: 'Nocomplete',
            searchTerms: props.autocompleteQuery
          }, {
            label: '',
            type: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO
          });
        }

        props.clearGlobalSearch();
      },
      url: block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT ? "/s?search=".concat(props.autocompleteQuery) : blockLinkURL
    }, upperFirst_default()(block.linkLabel))), isEmpty_default()(blockSuggestions) ? GlobalSearchSuggestions_jsx("p", {
      className: "mb-25 mt-0 text-20 leading-tight text-grey"
    }, upperFirst_default()(Object(i18n["h" /* t */])('faceting.autocomplete.noResult'))) : GlobalSearchSuggestions_jsx(SuggestionsBlock, Object(esm_extends["a" /* default */])({}, props, {
      blockSuggestions: blockSuggestions,
      blockType: block.id,
      isDesktop: isDesktop,
      onClick: function onClick(query) {
        props.clearGlobalSearch();

        if (query.type === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].RESORT) {
          trackQueryChange(query, GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
            internalSearchEngineNbResults: 'redirection'
          }));
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection',
            searchRequestType: 'Autocomplete',
            searchTerms: query.label,
            searchResorts: []
          });
        } else if (query.type === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO) {
          trackQueryChange(query, GlobalSearchSuggestions_objectSpread(GlobalSearchSuggestions_objectSpread({}, trackingPayload), {}, {
            internalSearchEngineNbResults: 'redirection_editorial'
          }));
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection_editorial',
            searchRequestType: 'Autocomplete',
            searchTerms: query.label
          }, query);

          if (query.link) {
            var queryLink = dist["url"].normalizeUrl(query.link);
            var queryLinkWithLocale = locale ? new URI_default.a(queryLink).addQuery({
              locale: locale
            }).toString() : queryLink;
            router.push(queryLinkWithLocale);
          }
        } else {
          dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(query));
          trackQueryChange(query, trackingPayload);
          Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
            criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
            router: router,
            searchCriteria: {
              query: query,
              departureCity: departureCity,
              departureDate: departureDate,
              duration: duration,
              keywords: '',
              kids: kids,
              kidsValidationState: kidsValidationState
            },
            searchPageRouteName: 'search'
          });
        }
      }
    })), block.linkLabel && blockLinkURL && (block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].COUNTRY || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].ACTIVITY || block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO && !isDesktop) ? GlobalSearchSuggestions_jsx(DynamicLink["a" /* default */], {
      className: "text-12 font-bold text-black underline",
      isExternalLink: false,
      onClick: function onClick() {
        track({
          categoryGA: 'layer',
          actionGA: 'search',
          labelGA: "viewMore_".concat(block.id),
          searchReferrer: 'layer'
        });

        if (block.id === GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO) {
          trackSearchResults({
            internalSearchEngineNbResults: 'redirection_editorial',
            searchRequestType: 'Nocomplete',
            searchTerms: props.autocompleteQuery
          }, {
            label: '',
            type: GlobalSearchSuggestionsList["b" /* SUGGESTION_TYPES */].EDITO
          });
        }

        props.clearGlobalSearch();
      },
      url: blockLinkURL
    }, upperFirst_default()(block.linkLabel)) : null);
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/global-search/GlobalSearch.jsx

var GlobalSearch_jsx = react_default.a.createElement;



















function DesktopSearchContainer(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      offsetTop = _ref.offsetTop,
      closeButton = _ref.closeButton;
  return GlobalSearch_jsx("aside", {
    className: Object(classnames_utils["a" /* classnames */])('animation-duration-500 fixed inset-0 flex animate-fadeIn flex-col', {
      'invisible opacity-0': !isOpen
    }),
    style: {
      backgroundColor: 'rgba(1, 1, 1, 0.5)',
      top: "".concat(Navigation_constants["d" /* heights */].NAVIGATION_LARGE_HEIGHT + offsetTop, "px")
    }
  }, GlobalSearch_jsx("div", {
    className: "max-h-9/10 overflow-y-auto"
  }, children), GlobalSearch_jsx("div", {
    className: "relative z-1 flex w-full translate-y-1/2 transform justify-center"
  }, closeButton));
}

var onScroll = throttle_default()(function () {
  Object(lib["forceCheck"])();
}, 250);

function MobileSearchContainer(_ref2) {
  var children = _ref2.children,
      isOpen = _ref2.isOpen,
      offsetTop = _ref2.offsetTop,
      closeButton = _ref2.closeButton;
  return GlobalSearch_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('fixed inset-x-0 bottom-0 -z-1 w-full transform', {
      'translate-y-0': isOpen,
      '-translate-y-full': !isOpen
    }),
    onScroll: onScroll,
    style: {
      top: Navigation_constants["d" /* heights */].NAVIGATION_NARROW_HEIGHT + offsetTop,
      backgroundColor: isOpen ? 'rgba(1, 1, 1, 0.5)' : 'transparent',
      transition: 'transform linear 330ms'
    }
  }, GlobalSearch_jsx("div", {
    className: "scroll-y max-h-9/10"
  }, isOpen ? children : null), GlobalSearch_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative z-1 flex w-full translate-y-1/2 transform justify-center opacity-0 transition-opacity duration-250 ease-in', {
      'opacity-100': isOpen
    })
  }, closeButton));
}

var GlobalSearch_GlobalSearch = function GlobalSearch(_ref3) {
  var className = _ref3.className,
      facetingSuggestedRequests = _ref3.facetingSuggestedRequests,
      isOpen = _ref3.isOpen,
      offsetTop = _ref3.offsetTop,
      toggleOpen = _ref3.toggleOpen;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useAutocomplete = Object(useAutocomplete["a" /* useAutocomplete */])(),
      autocompleteQuery = _useAutocomplete.autocompleteQuery,
      setAutocompleteQuery = _useAutocomplete.setAutocompleteQuery,
      autocompleteResults = _useAutocomplete.autocompleteResults,
      setAutocompleteResults = _useAutocomplete.setAutocompleteResults;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'header_search',
    categoryGA: 'headerMenu'
  }); // This effect is used to focus the search query input element when the GlobalSearch is opened
  // Use timer to wait for css transition

  var searchInput = /*#__PURE__*/Object(react["createRef"])();
  Object(react["useEffect"])(function () {
    var timer = null;

    if (isOpen && searchInput.current) {
      var _facetingSuggestedReq;

      if (!appContext.isSeller && !autocompleteQuery && !!(facetingSuggestedRequests === null || facetingSuggestedRequests === void 0 ? void 0 : (_facetingSuggestedReq = facetingSuggestedRequests.items) === null || _facetingSuggestedReq === void 0 ? void 0 : _facetingSuggestedReq.length)) {
        track({
          actionGA: 'search',
          categoryGA: 'layer',
          labelGA: 'requestsDisplay'
        });
      }

      var input = searchInput.current;
      timer = setTimeout(function () {
        input.focus();
      }, 500);
    }

    return function () {
      clearTimeout(timer);
    };
  }, [isOpen]);
  var toggleGlobalSearch = Object(react["useCallback"])(function () {
    setAutocompleteQuery('');
    setAutocompleteResults([]);
    toggleOpen();
  }, [toggleOpen]);

  var onChangeQuery = function onChangeQuery(e) {
    var value = e.currentTarget.value;
    setAutocompleteQuery(value);
  };

  var GLOBAL_SEARCH_ENABLED = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.globalSearchEnabled');

  var searchComponent = GlobalSearch_jsx(react["Fragment"], null, GlobalSearch_jsx(SearchQuery, {
    autocompleteQuery: autocompleteQuery,
    clearGlobalSearch: toggleGlobalSearch,
    facetingSuggestedRequests: facetingSuggestedRequests,
    onChangeQuery: onChangeQuery,
    ref: searchInput
  }), GlobalSearch_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('animation-duration-500 w-full animate-slideInTop bg-white px-15', {
      'overflow-y-auto': isDesktop,
      'invisible h-0 opacity-0': autocompleteQuery.length === 0
    }),
    "data-testid": "search-suggestions-container",
    style: isDesktop ? {
      paddingLeft: '15%',
      paddingRight: '15%'
    } : {}
  }, GlobalSearch_jsx(GlobalSearchSuggestions_SearchSuggestions, {
    autocompleteQuery: autocompleteQuery,
    autocompleteResults: autocompleteResults,
    clearGlobalSearch: toggleGlobalSearch
  })));

  var searchLinkLabel = Object(i18n["h" /* t */])('faceting.searchLinkLabel');

  var closeButton = GlobalSearch_jsx(Button["a" /* Button */], {
    className: "absolute bottom-0 left-1/2 size-50 -translate-x-1/2 translate-y-1/2 transform rounded-full leading-0 shadow-subtle lg:size-48 lg:justify-center",
    color: colors["a" /* COLORS */].DARK_GREY,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].WHITE,
    "data-testid": "global-search-close-button",
    isSquare: true,
    onClick: function onClick() {
      toggleGlobalSearch();
      track({
        labelGA: 'close'
      });
    }
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: ".75rem"
  }));

  return GLOBAL_SEARCH_ENABLED ? GlobalSearch_jsx(react["Fragment"], null, GlobalSearch_jsx("button", {
    "aria-expanded": isOpen,
    "aria-label": "Search",
    "aria-pressed": isOpen,
    "data-testid": "global-search-button",
    onClick: function onClick() {
      toggleGlobalSearch();
      track({
        labelGA: isOpen ? 'close' : 'open'
      });
    },
    title: searchLinkLabel,
    type: "button",
    url: routeBuilder["a" /* buildUrl */]('search')
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.5rem"
  }), GlobalSearch_jsx("span", {
    className: "sr-only"
  }, searchLinkLabel)), isDesktop ? GlobalSearch_jsx(DesktopSearchContainer, {
    isOpen: isOpen,
    offsetTop: offsetTop,
    closeButton: closeButton
  }, searchComponent) : GlobalSearch_jsx(MobileSearchContainer, {
    isOpen: isOpen,
    offsetTop: offsetTop,
    closeButton: closeButton
  }, searchComponent)) : GlobalSearch_jsx(DynamicLink["a" /* default */], {
    className: className,
    "data-testid": "global-search-link",
    onClick: function onClick() {
      track();
    },
    title: searchLinkLabel,
    url: routeBuilder["a" /* buildUrl */]('search')
  }, GlobalSearch_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS,
    width: "1.5rem"
  }), GlobalSearch_jsx("span", {
    className: "sr-only"
  }, searchLinkLabel));
};
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/member-access/member-access-button/NavigationMemberAccessButton.jsx
var NavigationMemberAccessButton_jsx = react_default.a.createElement;








var NavigationMemberAccessButton_NavigationMemberAccessButton = function NavigationMemberAccessButton(_ref) {
  var className = _ref.className,
      isActive = _ref.isActive,
      isAuthenticated = _ref.isAuthenticated,
      isQuickLoggedIn = _ref.isQuickLoggedIn,
      _onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1.5 : _ref$size,
      title = _ref.title;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  if (Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('memberSpace.hideConnectionButton')) {
    return null;
  }

  var isAnimationEnable = !Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('memberSpace.disableConnectionAnimation') && !isAuthenticated;
  return NavigationMemberAccessButton_jsx("button", {
    "aria-expanded": isActive,
    className: className,
    onClick: function onClick() {
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();

      if (!isActive) {
        trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
          detail_click: 'my_account'
        });
      }
    },
    title: title,
    type: "button"
  }, NavigationMemberAccessButton_jsx("span", {
    className: "relative flex",
    "data-testid": "user-icon"
  }, !!title && NavigationMemberAccessButton_jsx("span", {
    className: "sr-only"
  }, title), NavigationMemberAccessButton_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PEOPLE,
    width: "".concat(size, "rem")
  }), (isAuthenticated || isQuickLoggedIn) && NavigationMemberAccessButton_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('absolute right-[-0.3125rem] top-[-0.5625rem] flex size-12 items-center justify-center rounded-full leading-0', {
      'bg-green': isAuthenticated
    })
  }, NavigationMemberAccessButton_jsx(Icon["a" /* Icon */], {
    className: "text-white",
    name: icons["a" /* ICONS */].CHECK,
    width: "0.5rem"
  })), isAnimationEnable && NavigationMemberAccessButton_jsx("span", {
    className: "absolute animate-hello",
    style: {
      top: "".concat(size * 0.153, "rem"),
      left: "".concat(-size * 0.38, "rem"),
      width: "".concat(size * 0.6, "rem"),
      height: "".concat(size * 0.6, "rem"),
      border: "solid ".concat(size * 0.08, "rem black"),
      borderRadius: '0 0 50% 80%',
      borderColor: 'transparent transparent currentColor transparent',
      transformOrigin: 'bottom right'
    }
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-favorite/ProductFavorite.jsx
var ProductFavorite = __webpack_require__("fWEd");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/favorite/NavigationFavoriteButton.jsx

var NavigationFavoriteButton_jsx = react_default.a.createElement;





var NavigationFavoriteButton_NavigationFavoriteButton = function NavigationFavoriteButton(_ref) {
  var favoriteProductListLength = _ref.favoriteProductListLength,
      isActive = _ref.isActive,
      triggerOnHover = _ref.triggerOnHover,
      onClick = _ref.onClick;
  var track = Object(useTracking["a" /* useTracking */])({});

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageId = _usePageContext.pageId;

  var handleClick = function handleClick() {
    onClick();
    track({
      actionGA: 'header_favorites',
      labelGA: !isActive ? 'openFavorites' : 'closeFavorites',
      categoryGA: 'headerMenu',
      pageName: pageId
    });
  };

  return NavigationFavoriteButton_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('navigation-arrow navigation-arrow--overlap relative me-10 flex px-10 text-black hocus:text-black-active lg:me-0', {
      'navigation-arrow-active': isActive
    })
  }, NavigationFavoriteButton_jsx(ProductFavorite["a" /* ProductFavorite */], Object(esm_extends["a" /* default */])({
    "data-testid": "CTA-see-favorite",
    total: favoriteProductListLength
  }, triggerOnHover ? {
    onMouseEnter: handleClick
  } : {
    onClick: handleClick
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeBackPanel.jsx
var NavigationLargeBackPanel_jsx = react_default.a.createElement;

var NavigationLargeBackPanel = function NavigationLargeBackPanel(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height;
  return NavigationLargeBackPanel_jsx("div", {
    className: "pointer-events-none absolute inset-x-0 top-full z-0"
  }, NavigationLargeBackPanel_jsx("div", {
    className: "rounded-b pointer-events-none mx-auto my-0 h-0 max-h-nav-large-sub w-full max-w-site overflow-hidden bg-white shadow transition-heights duration-250 ease-in",
    style: {
      height: "".concat(String(height), "px")
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeElement.jsx
var NavigationLargeElement_jsx = react_default.a.createElement;


var NavigationLargeElement_NavigationLargeElement = function NavigationLargeElement(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      id = _ref.id,
      onClose = _ref.onClose,
      style = _ref.style;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeElement_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('absolute end-0 top-full -mt-5 max-h-nav-large-sub overflow-y-auto bg-white p-15', className),
    id: id,
    style: style
  }, closeLabel && NavigationLargeElement_jsx("button", {
    className: "sr-only float-right mb-10 px-5 text-12 text-black focus:not-sr-only",
    onClick: onClose,
    type: "button"
  }, closeLabel), children);
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/panels/NavigationLargeSidebar.jsx
var NavigationLargeSidebar_jsx = react_default.a.createElement;



var NavigationLargeSidebar_NavigationLargeSidebar = function NavigationLargeSidebar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      headerLabel = _ref.headerLabel,
      id = _ref.id,
      isVisible = _ref.isVisible,
      onClose = _ref.onClose,
      style = _ref.style;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeSidebar_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('transition-transform fixed end-0 top-0 z-1 h-screen transform bg-white duration-500 ease-out', {
      'translate-x-0': isVisible,
      'ltr:translate-x-full rtl:-translate-x-full': !isVisible
    }, className),
    id: id,
    style: style,
    onMouseLeave: onClose
  }, NavigationLargeSidebar_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex h-full transform flex-col transition-opacity delay-200 duration-500 ease-out', {
      'opacity-0': !isVisible
    })
  }, NavigationLargeSidebar_jsx("div", {
    className: "flex h-60 shrink-0 px-30",
    style: {
      height: Navigation_constants["d" /* heights */].NAVIGATION_LARGE_HEIGHT
    }
  }, headerLabel), NavigationLargeSidebar_jsx("div", {
    className: "scroll-y h-full px-30"
  }, children)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/first-level-item/NavigationLargeFirstLevelItem.jsx


var NavigationLargeFirstLevelItem_jsx = react_default.a.createElement;




var NavigationLargeFirstLevelItem_NavigationLargeFirstLevelItem = function NavigationLargeFirstLevelItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      hasSubItems = _ref.hasSubItems,
      isActive = _ref.isActive,
      link = _ref.link;
  var track = Object(useTracking["a" /* useTracking */])();

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationLargeFirstLevelItem_jsx(DynamicLink["a" /* default */], {
    "aria-haspopup": hasSubItems,
    className: Object(classnames_utils["a" /* classnames */])('cursor-pointer flex font-sans font-bold items-center px-10 relative hocus:text-black-active transition-color duration-250 ease-in text-10 lg:text-12', "text-".concat(color), Object(defineProperty["a" /* default */])({}, "hocus:text-".concat(color, "-active"), !!color), {
      'navigation-arrow': hasSubItems
    }, {
      'navigation-arrow-active': isActive && hasSubItems
    }, className),
    "data-testid": "NavigationLarge-item-link",
    onClick: function onClick() {
      return (link === null || link === void 0 ? void 0 : link.trackingData) && track(link.trackingData);
    },
    url: link.url
  }, children);
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/large/NavigationLarge.jsx










var NavigationLarge_jsx = react_default.a.createElement;

/* eslint-env browser */



























var NavigationMemberAccess = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "uXT4")).then(function (x) {
    return x.NavigationMemberAccess;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("uXT4")];
    },
    modules: ["../member-access/NavigationMemberAccess"]
  }
});
var NavigationFavorite = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 44).then(__webpack_require__.bind(null, "+uRY")).then(function (x) {
    return x.NavigationFavorite;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("+uRY")];
    },
    modules: ["../favorite/NavigationFavorite"]
  }
});
var NavigationLargePanel = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 968).then(__webpack_require__.bind(null, "x5wo")).then(function (x) {
    return x.NavigationLargePanel;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("x5wo")];
    },
    modules: ["./panels/NavigationLargePanel"]
  }
});
var NavigationLargeSubNav = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 969).then(__webpack_require__.bind(null, "5Rjz")).then(function (x) {
    return x.NavigationLargeSubNav;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("5Rjz")];
    },
    modules: ["./subnavs/NavigationLargeSubNav"]
  }
});
var NavigationLargeSubNavList = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 970).then(__webpack_require__.bind(null, "h6Iw")).then(function (x) {
    return x.NavigationLargeSubNavList;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Iw")];
    },
    modules: ["./subnavs/NavigationLargeSubNavList"]
  }
});
var NavigationContact = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "AY+A")).then(function (x) {
    return x.NavigationContact;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("AY+A")];
    },
    modules: ["../contact/NavigationContact"]
  }
});
var POPHOVER_IN_DELAY = 300;
var POPHOVER_OUT_DELAY = 500;
var NavigationLarge_NavigationLarge = function NavigationLarge(props) {
  var backToB2CWebsiteLabel = props.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = props.backToB2CWebsiteLink,
      contact = props.contact,
      facetingSuggestedRequests = props.facetingSuggestedRequests,
      _props$id = props.id,
      id = _props$id === void 0 ? 'Navigation' : _props$id,
      isBookingEnginePage = props.isBookingEnginePage,
      isMicePage = props.isMicePage,
      items = props.items,
      _props$language = props.language,
      language = _props$language === void 0 ? {} : _props$language,
      logo = props.logo,
      MICELogoRedirectionLink = props.MICELogoRedirectionLink,
      promoBannerRef = props.promoBannerRef,
      userInfo = props.userInfo,
      hideUndecidedPathFeature = props.hideUndecidedPathFeature;
  var track = Object(useTracking["a" /* useTracking */])();

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageId = _usePageContext.pageId;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isGsa = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa');

  var _ref = userInfo || {},
      isLoggedIn = _ref.isLoggedIn,
      isQuickLoggedIn = _ref.isQuickLoggedIn;

  var _useState = Object(react["useState"])(null),
      activeElement = _useState[0],
      setActiveElement = _useState[1];

  var _useState2 = Object(react["useState"])(-1),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var _useState3 = Object(react["useState"])(0),
      height = _useState3[0],
      setHeight = _useState3[1];

  var navigationNode = Object(react["useRef"])(null);
  var itemsRef = Object(react["useRef"])([]);

  var _useContext = Object(react["useContext"])(FavoriteProductListContext["a" /* FavoriteProductListContext */]),
      _useContext$favoriteP = _useContext.favoriteProductsState,
      favoriteProductList = _useContext$favoriteP.favoriteProductList,
      showcaseLatestFavorite = _useContext$favoriteP.showcaseLatestFavorite,
      showAllFavorite = _useContext$favoriteP.showAllFavorite,
      setFavoriteProductList = _useContext.setFavoriteProductList;

  var hoverInTimeout = Object(react["useRef"])(null);
  var hoverOutTimeout = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    return function () {
      clearTimeout(hoverOutTimeout.current);
      clearTimeout(hoverInTimeout.current);
    };
  }, []);
  Object(react["useEffect"])(function () {
    itemsRef.current = itemsRef.current.slice(0, props.items.length);
  }, [items]);

  var toggleElement = function toggleElement(element) {
    return function () {
      setActiveElement(element === activeElement ? null : element);
      setActiveIndex(-1);
      setHeight(0);
    };
  };

  Object(react["useEffect"])(function () {
    if (showcaseLatestFavorite) {
      toggleElement(Navigation_constants["c" /* elements */].NEW_FAVORITE)();
      setFavoriteProductList(favoriteProductList, false, false);
    }
  }, [showcaseLatestFavorite]);
  Object(react["useEffect"])(function () {
    if (showAllFavorite) {
      toggleElement(Navigation_constants["c" /* elements */].FAVORITE)();
      setFavoriteProductList(favoriteProductList, false, false);
    }
  }, [showAllFavorite]);

  var onClickOutside = function onClickOutside() {
    if (activeElement) {
      setActiveElement(null);
    }
  };

  var onFavoriteButtonClick = function onFavoriteButtonClick() {
    if (favoriteProductList.length > 0 && activeElement !== Navigation_constants["c" /* elements */].NO_FAVORITES && activeElement !== Navigation_constants["c" /* elements */].NEW_FAVORITE) {
      toggleElement(Navigation_constants["c" /* elements */].FAVORITE)();
    } else if (favoriteProductList.length === 0) {
      toggleElement(Navigation_constants["c" /* elements */].NO_FAVORITES)();
    } else {
      setActiveElement(null);
    }
  };

  var setSubnav = function setSubnav(index, isFocus) {
    var subNavHeight = 0;

    if (true) {
      // $FlowFixMe
      subNavHeight = itemsRef[index] ? itemsRef[index].clientHeight : 0;
    }

    clearTimeout(hoverOutTimeout.current);
    hoverInTimeout.current = setTimeout(function () {
      setActiveElement(null);
      setActiveIndex(index);
      setHeight(subNavHeight);
    }, isFocus ? 0 : POPHOVER_IN_DELAY);
  };

  var resetSubnav = function resetSubnav(isFocus) {
    clearTimeout(hoverInTimeout.current);
    hoverOutTimeout.current = setTimeout(function () {
      setActiveIndex(-1);
      setHeight(0);
    }, isFocus ? 0 : POPHOVER_OUT_DELAY);
  };

  var iconButtonClassNames = 'cursor-pointer flex items-center px-10 relative text-black hocus:text-black-active';
  var offsetTop = promoBannerRef && promoBannerRef.current ? promoBannerRef.current.offsetHeight - Object(stopScroll["a" /* getTopScrollValue */])(document) : 0 - ((navigationNode === null || navigationNode === void 0 ? void 0 : navigationNode.current) ? Object(stopScroll["a" /* getTopScrollValue */])(document) : 0);
  var isGlobalSearchActiveElement = activeElement === Navigation_constants["c" /* elements */].SEARCH;
  var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);

  var getLogoTitle = function getLogoTitle() {
    if (isMicePage) {
      return 'Club Med meetings and events page';
    }

    if (isGsa) {
      return Object(i18n["h" /* t */])('account.authentication.yourAccount.title');
    }

    return 'Club Med Homepage';
  };

  var getLogoUrl = function getLogoUrl() {
    if (isMicePage) {
      return MICELogoRedirectionLink;
    }

    if (isGsa) {
      return '/account';
    }

    return '/';
  };

  return NavigationLarge_jsx(Sticky_default.a, {
    enabled: activeElement === Navigation_constants["c" /* elements */].NEW_FAVORITE && !isGlobalSearchActiveElement,
    innerZ: 7,
    activeClass: "animate-slideInTop animation-duration-500"
  }, NavigationLarge_jsx(ClickOutside["a" /* ClickOutside */], {
    onClick: onClickOutside
  }, NavigationLarge_jsx("nav", {
    "aria-label": "ClubMed main navigation",
    className: Object(classnames_utils["a" /* classnames */])("".concat(Navigation_constants["a" /* NAVIGATION_OFFSET_SELECTOR */], " absolute inset-x-0 top-0 z-main-navigation hidden bg-white lg:block")),
    id: id,
    role: "navigation"
  }, NavigationLarge_jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: isGlobalSearchActiveElement
  }, NavigationLarge_jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: isGlobalSearchActiveElement
  }, NavigationLarge_jsx(NavigationLargeBackPanel, {
    height: height
  }), NavigationLarge_jsx("div", {
    className: "flex h-60 items-stretch justify-between border-b-1 border-grey px-20",
    ref: navigationNode,
    style: {
      height: Navigation_constants["d" /* heights */].NAVIGATION_LARGE_HEIGHT
    }
  }, NavigationLarge_jsx(DynamicLink["a" /* default */], {
    className: "flex shrink-0 cursor-pointer items-center px-20 text-ultramarine hocus:text-ultramarine-active",
    "data-testid": "NavigationLarge-logo",
    onFocus: function onFocus() {
      resetSubnav(true);
      track(Navigation_tracking["b" /* NAVIGATION_TRACKING_LOGO_BUTTON */]);
    },
    queryParamsToIgnore: ['selectedProposalId', 'proposalIds', 'optionIds'],
    title: getLogoTitle(),
    url: getLogoUrl()
  }, NavigationLarge_jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])({
      '-mt-5': !isMicePage,
      'mt-5': isMicePage
    }),
    name: isMicePage ? icons["a" /* ICONS */].CLUBMED_MEETINGS : icons["a" /* ICONS */].CLUBMED,
    isNotSquare: true,
    width: isMicePage ? '5rem' : '10rem'
  }), NavigationLarge_jsx("span", {
    className: "sr-only"
  }, getLogoTitle())), NavigationLarge_jsx("ul", {
    className: "mx-auto flex",
    style: {
      flex: '0 1 auto'
    }
  }, items.map(function (item, index) {
    var subItems = item.subItems || [];
    var hasSubItems = !!subItems.length;
    var isList = item.isList,
        label = item.label;
    var isActive = index === activeIndex;
    return !!label && NavigationLarge_jsx("li", {
      className: "flex items-stretch",
      "data-testid": "NavigationLarge-item",
      key: label,
      onBlur: function onBlur() {
        resetSubnav(true);
      },
      onFocus: function onFocus() {
        setSubnav(index, true);
      },
      onMouseEnter: function onMouseEnter() {
        setSubnav(index);
      },
      onMouseLeave: resetSubnav
    }, NavigationLarge_jsx(NavigationLargeFirstLevelItem_NavigationLargeFirstLevelItem, {
      color: item.color,
      hasSubItems: hasSubItems,
      isActive: isActive,
      link: item.link
    }, label), hasSubItems && NavigationLarge_jsx(NavigationLargePanel, {
      isActive: isActive // $FlowFixMe
      ,
      ref: function ref(elem) {
        return itemsRef.current[index] = elem;
      }
    }, isList ? NavigationLarge_jsx(NavigationLargeSubNavList, {
      parentLabel: label,
      subItems: subItems
    }) : NavigationLarge_jsx(NavigationLargeSubNav, {
      subItems: subItems
    })));
  })), (logo === null || logo === void 0 ? void 0 : logo.imageUrl) && NavigationLarge_jsx(DynamicLink["a" /* default */], {
    className: "flex h-full max-w-100 cursor-pointer items-center py-5",
    onClick: function onClick() {
      return track({
        actionGA: 'header_reinsuranceLogo',
        categoryGA: 'headerMenu',
        labelGA: 'reinsuranceLogo'
      });
    },
    url: logo.link
  }, NavigationLarge_jsx("img", {
    alt: "",
    className: "max-h-full w-full",
    src: logo.imageUrl
  })), NavigationLarge_jsx("div", {
    className: "relative flex shrink-0"
  }, !isEmpty_default()(contact) && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx("button", {
    "aria-expanded": activeElement === Navigation_constants["c" /* elements */].CONTACT,
    "data-testid": "NavigationLarge-contact-button",
    className: Object(classnames_utils["a" /* classnames */])(iconButtonClassNames, 'navigation-arrow navigation-arrow--overlap text-[0.8125rem]', {
      'navigation-arrow-active text-black': activeElement === Navigation_constants["c" /* elements */].CONTACT
    }),
    onClick: function onClick() {
      hasContactDetails && toggleElement(Navigation_constants["c" /* elements */].CONTACT)();

      if (activeElement !== Navigation_constants["c" /* elements */].CONTACT && hasContactDetails) {
        track(Navigation_tracking["a" /* NAVIGATION_TRACKING_CONTACT_BUTTON */]);
      }
    },
    title: contact.title,
    type: "button"
  }, NavigationLarge_jsx(Icon["a" /* Icon */], {
    className: "me-5 text-black",
    name: icons["a" /* ICONS */].PHONE,
    hasRtl: true,
    width: "1.5rem"
  }), NavigationLarge_jsx("span", {
    className: "sr-only"
  }, contact.title, "\xA0"), NavigationLarge_jsx("span", {
    className: "whitespace-nowrap font-bold text-black",
    dir: "ltr"
  }, contact.phoneNumber)), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
    className: "w-300 rounded-12 p-20 shadow-md",
    onClose: function onClose() {
      toggleElement(Navigation_constants["c" /* elements */].CONTACT)();
    }
  }, activeElement === Navigation_constants["c" /* elements */].CONTACT ? NavigationLarge_jsx(NavigationContact, {
    contact: contact,
    isBookingEnginePage: isBookingEnginePage
  }) : null)), isMicePage && NavigationLarge_jsx(DynamicLink["a" /* default */], {
    className: "relative flex cursor-pointer items-center px-15 text-14 font-bold leading-tight text-black underline hocus:text-black-active",
    onClick: function onClick() {
      return track({
        actionGA: 'header_backToB2C',
        categoryGA: 'headerMenu',
        labelGA: 'backToB2C'
      });
    },
    url: backToB2CWebsiteLink
  }, backToB2CWebsiteLabel), !isMicePage && NavigationLarge_jsx(react["Fragment"], null, !isGsa && NavigationLarge_jsx(GlobalSearch_GlobalSearch, {
    className: "relative flex cursor-pointer items-center px-10 text-black hocus:text-black-active",
    facetingSuggestedRequests: facetingSuggestedRequests,
    isOpen: isGlobalSearchActiveElement,
    offsetTop: offsetTop,
    toggleOpen: toggleElement(Navigation_constants["c" /* elements */].SEARCH)
  }), NavigationLarge_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
    className: Object(classnames_utils["a" /* classnames */])(iconButtonClassNames, 'navigation-arrow navigation-arrow--overlap', {
      'navigation-arrow-active': activeElement === Navigation_constants["c" /* elements */].LOGIN
    }),
    isActive: activeElement === Navigation_constants["c" /* elements */].LOGIN,
    isAuthenticated: isLoggedIn,
    isQuickLoggedIn: isQuickLoggedIn,
    onClick: function onClick() {
      toggleElement(Navigation_constants["c" /* elements */].LOGIN)();
    },
    title: Object(i18n["h" /* t */])('account.authentication.yourAccount.title')
  }), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
    className: Object(classnames_utils["a" /* classnames */])('rounded-12 shadow-md', {
      'px-20 py-30': !isLoggedIn && !isQuickLoggedIn,
      'w-[18.125rem]': isLoggedIn || isQuickLoggedIn
    }),
    onClose: function onClose() {
      toggleElement(Navigation_constants["c" /* elements */].LOGIN)();
    }
  }, activeElement === Navigation_constants["c" /* elements */].LOGIN ? NavigationLarge_jsx(NavigationMemberAccess, {
    userInfo: userInfo
  }) : null), !hideUndecidedPathFeature && NavigationLarge_jsx(react["Fragment"], null, !isGsa && NavigationLarge_jsx(NavigationFavoriteButton_NavigationFavoriteButton, {
    onClick: onFavoriteButtonClick,
    triggerOnHover: favoriteProductList.length > 0 && activeElement !== Navigation_constants["c" /* elements */].NO_FAVORITES && activeElement !== Navigation_constants["c" /* elements */].NEW_FAVORITE,
    isActive: activeElement === Navigation_constants["c" /* elements */].NO_FAVORITES || activeElement === Navigation_constants["c" /* elements */].NEW_FAVORITE,
    favoriteProductListLength: favoriteProductList.length
  }), NavigationLarge_jsx(NavigationLargeSidebar_NavigationLargeSidebar, {
    className: "flex flex-col shadow-md",
    isVisible: activeElement === Navigation_constants["c" /* elements */].FAVORITE,
    headerLabel: NavigationLarge_jsx("div", {
      className: "flex w-full items-center justify-between"
    }, NavigationLarge_jsx("div", null, Object(i18n["h" /* t */])('common.favoriteOption.allMyFavorites.title')), NavigationLarge_jsx(NavigationFavoriteButton_NavigationFavoriteButton, {
      onClick: function onClick() {
        setActiveElement(null);
      },
      isActive: false,
      favoriteProductListLength: favoriteProductList.length
    })),
    style: {
      maxWidth: '425px'
    },
    onClose: function onClose() {
      setActiveElement(null);
      track({
        actionGA: 'header_favorites',
        labelGA: 'closeFavorites',
        categoryGA: 'headerMenu',
        pageName: pageId
      });
    }
  }, NavigationLarge_jsx(NavigationFavorite, {
    onClose: function onClose() {
      setActiveElement(null);
      track({
        actionGA: 'header_favorites',
        labelGA: 'closeFavorites',
        categoryGA: 'headerMenu',
        pageName: pageId
      });
    }
  }))), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
    className: "rounded-12 shadow-md",
    onClose: function onClose() {
      setActiveElement(null);
    }
  }, activeElement === Navigation_constants["c" /* elements */].NO_FAVORITES || activeElement === Navigation_constants["c" /* elements */].NEW_FAVORITE ? NavigationLarge_jsx(NavigationFavorite, {
    onButtonClick: function onButtonClick(e) {
      var _e$stopPropagation;

      e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e);
      setActiveElement(Navigation_constants["c" /* elements */].FAVORITE);
    },
    onClose: function onClose() {
      setActiveElement(null);
      track({
        actionGA: 'header_favorites',
        labelGA: 'closeFavorites',
        categoryGA: 'headerMenu',
        pageName: pageId
      });
    },
    showcaseLatest: activeElement === Navigation_constants["c" /* elements */].NEW_FAVORITE
  }) : null)), Object.keys((language === null || language === void 0 ? void 0 : language.locales) || {}).length > 1 && NavigationLarge_jsx(react["Fragment"], null, NavigationLarge_jsx("button", {
    "aria-expanded": activeElement === Navigation_constants["c" /* elements */].LANGUAGES,
    className: Object(classnames_utils["a" /* classnames */])(iconButtonClassNames, 'navigation-arrow navigation-arrow--overlap min-w-56 text-center text-12 uppercase', {
      'navigation-arrow-active': activeElement === Navigation_constants["c" /* elements */].LANGUAGES
    }),
    "data-testid": "NavigationLarge-language-button",
    onClick: function onClick() {
      toggleElement(Navigation_constants["c" /* elements */].LANGUAGES)();
    },
    title: "languages",
    type: "button"
  }, NavigationLarge_jsx("span", {
    className: "flex items-center gap-5"
  }, language.locales[language.currentLocale].label, NavigationLarge_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    rotation: activeElement === Navigation_constants["c" /* elements */].LANGUAGES ? 180 : 0,
    width: ".75rem"
  }))), NavigationLarge_jsx(NavigationLargeElement_NavigationLargeElement, {
    className: "px-5 py-0",
    onClose: function onClose() {
      toggleElement(Navigation_constants["c" /* elements */].LANGUAGES)();
    }
  }, activeElement === Navigation_constants["c" /* elements */].LANGUAGES && NavigationLarge_jsx(Languages_Languages, Object(esm_extends["a" /* default */])({}, language, {
    currentLocale: language.currentLocale,
    getTrackingData: Navigation_tracking["e" /* getNavigationLanguagesButtonTrackingData */],
    isActive: activeElement === Navigation_constants["c" /* elements */].LANGUAGES,
    locales: language.locales,
    theme: "column"
  })))))))))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("Ee2X");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/NavigationSticky.jsx












var NavigationSticky_jsx = react_default.a.createElement;

function NavigationSticky_createSuper(Derived) { var hasNativeReflectConstruct = NavigationSticky_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationSticky_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





function stickyNav(WrappedComponent) {
  var _temp;

  return _temp = /*#__PURE__*/function (_Component) {
    Object(inherits["a" /* default */])(NavigationSticky, _Component);

    var _super = NavigationSticky_createSuper(NavigationSticky);

    function NavigationSticky(props) {
      var _this;

      Object(classCallCheck["a" /* default */])(this, NavigationSticky);

      _this = _super.call(this, props);

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onLock", function () {
        var isLocked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _this.setState({
          isLocked: isLocked
        });
      });

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleScroll", throttle_default()(function () {
        var _this$state = _this.state,
            lastY = _this$state.lastY,
            isLocked = _this$state.isLocked;

        if (!isLocked) {
          var posY = Math.max(window.pageYOffset, 0);
          var stickyStart = Navigation_constants["d" /* heights */].NAVIGATION_NARROW_HEIGHT;
          var scrolledDown = posY > lastY;

          _this.setState(function () {
            return {
              isHidden: scrolledDown && posY > stickyStart,
              lastY: posY
            };
          });
        }
      }, 200));

      Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onStateChange", function (status) {
        _this.setState(function () {
          return {
            isSticky: status.status !== Sticky_default.a.STATUS_ORIGINAL
          };
        });
      });

      _this.state = {
        isHidden: false,
        isLocked: false,
        isSticky: false,
        lastY: 0
      };
      return _this;
    }

    Object(createClass["a" /* default */])(NavigationSticky, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('scroll', this.handleScroll, false);
        this.handleScroll();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll, false);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state2 = this.state,
            isHidden = _this$state2.isHidden,
            isLocked = _this$state2.isLocked,
            isSticky = _this$state2.isSticky,
            lastY = _this$state2.lastY;
        return NavigationSticky_jsx(Sticky_default.a, {
          enabled: lastY !== 0,
          enableTransforms: false,
          innerClass: Object(classnames_utils["a" /* classnames */])('w-full', {
            'transform -translate-y-full': isSticky && isHidden && !isLocked
          }),
          innerZ: isLocked ? 7 : 5,
          onStateChange: this.onStateChange
        }, NavigationSticky_jsx(WrappedComponent, Object(esm_extends["a" /* default */])({}, this.props, {
          onLock: this.onLock
        })));
      }
    }]);

    return NavigationSticky;
  }(react["Component"]), _temp;
}
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SideNavigationItem.jsx

var SideNavigationItem_jsx = react_default.a.createElement;






var SideNavigationItem_SideNavigationItem = function SideNavigationItem(_ref) {
  var color = _ref.color,
      hasFocus = _ref.hasFocus,
      isRoot = _ref.isRoot,
      label = _ref.label,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      nextPanel = _ref.nextPanel,
      onClick = _ref.onClick,
      setActiveItem = _ref.setActiveItem,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var track = Object(useTracking["a" /* useTracking */])();
  var buttonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (hasFocus && buttonRef && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [hasFocus]);

  var handleClick = function handleClick() {
    onClick(nextPanel);
    setActiveItem();
    (link === null || link === void 0 ? void 0 : link.trackingData) && track(link.trackingData);
  };

  var content = SideNavigationItem_jsx(react["Fragment"], {
    key: label
  }, SideNavigationItem_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])("text-".concat(color), 'font-sans text-16 font-bold', {
      uppercase: isRoot
    })
  }, label), SideNavigationItem_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: "0.625rem"
  }));

  return (link === null || link === void 0 ? void 0 : link.url) ? SideNavigationItem_jsx(DynamicLink["a" /* default */], {
    className: "flex h-full w-full cursor-pointer items-center justify-between py-15",
    "data-testid": "SideNavigationItem-subitem-link",
    onClick: handleClick,
    tabIndex: tabIndex,
    target: link.target,
    url: link.url
  }, content) : SideNavigationItem_jsx("button", {
    className: "w-full",
    "data-testid": "SideNavigationItem-subitem-button",
    onClick: handleClick,
    ref: buttonRef,
    tabIndex: tabIndex,
    type: "button"
  }, SideNavigationItem_jsx("span", {
    className: "flex h-full w-full items-center justify-between py-15"
  }, content));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SideNavigation.jsx









var SideNavigation_jsx = react_default.a.createElement;










var SideNavigation_SideNavigation = function SideNavigation(_ref) {
  var backButtonLabel = _ref.backButtonLabel,
      backToB2CWebsiteLabel = _ref.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = _ref.backToB2CWebsiteLink,
      closeMenu = _ref.closeMenu,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'SideNavigation' : _ref$id,
      isActive = _ref.isActive,
      isHidden = _ref.isHidden,
      isMicePage = _ref.isMicePage,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      label = _ref.label,
      language = _ref.language,
      logo = _ref.logo,
      navBack = _ref.navBack,
      navForward = _ref.navForward,
      parent = _ref.parent,
      parentLabel = _ref.parentLabel,
      parentLink = _ref.parentLink,
      style = _ref.style;

  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      _setActiveItem = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])();
  var backButtonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (!isHidden && backButtonRef && backButtonRef.current) {
      backButtonRef.current.focus();
    }

    if (isHidden) {
      _setActiveItem(-1);
    }
  }, [isHidden]);
  var classNames = {
    'ltr:-translate-x-full rtl:translate-x-full': isHidden,
    'translate-x-0': !isHidden
  };
  var hasParentLink = parentLink && parentLink.url;
  var navItems = items.map(function (item, idx) {
    var itemProps = {
      color: item.color,
      isRoot: isEmpty_default()(parent),
      label: item.label,
      link: {},
      nextPanel: '',
      onClick: navForward,
      setActiveItem: function setActiveItem() {
        _setActiveItem(idx);
      },
      tabIndex: isActive ? 0 : -1
    };
    var subItems = item.subItems || [];
    var itemId = "".concat(item.label.replace(/ /g, '-').toLowerCase()).concat(item.id);

    if (subItems.length) {
      itemProps.nextPanel = itemId;
    } else {
      itemProps.link = get_default()(item, 'link');
    }

    return SideNavigation_jsx("li", {
      key: itemId
    }, SideNavigation_jsx(SideNavigationItem_SideNavigationItem, Object(esm_extends["a" /* default */])({}, itemProps, {
      hasFocus: isActive && activeItem === idx
    })));
  });
  var TagName = hasParentLink ? DynamicLink["a" /* default */] : 'div';
  var subProps = hasParentLink ? {
    target: parentLink === null || parentLink === void 0 ? void 0 : parentLink.target,
    url: parentLink === null || parentLink === void 0 ? void 0 : parentLink.url
  } : null;
  return SideNavigation_jsx("div", {
    "aria-hidden": isHidden,
    className: Object(classnames_utils["a" /* classnames */])('fixed bottom-0 start-0 w-full transform bg-white', classNames),
    id: id,
    style: style
  }, SideNavigation_jsx("div", {
    className: "h-full overflow-y-scroll bg-white p-15"
  }, !!parent && !!label && SideNavigation_jsx("div", {
    className: "flex justify-between"
  }, SideNavigation_jsx("button", {
    className: "-ms-10 flex items-center p-10 text-14 font-bold",
    "data-testid": "SideNavigation-back",
    onClick: navBack ? function () {
      return navBack();
    } : null,
    ref: backButtonRef,
    tabIndex: isActive ? 0 : -1,
    type: "button"
  }, SideNavigation_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_LEFT,
    width: "0.8125rem"
  }), !!backButtonLabel && SideNavigation_jsx("span", {
    className: "sr-only",
    "data-testid": "SideNavigation-back-label"
  }, Object(dist["messageFormat"])(backButtonLabel).format({
    item: parentLabel
  }))), SideNavigation_jsx(TagName, Object(esm_extends["a" /* default */])({}, subProps, {
    className: "block py-10 text-16 font-bold uppercase text-black",
    "data-testid": "SideNavigation-item-link",
    onClick: function onClick() {
      closeMenu();
      (parentLink === null || parentLink === void 0 ? void 0 : parentLink.trackingData) && track(parentLink.trackingData);
    },
    tabIndex: isActive ? 0 : -1
  }), label)), SideNavigation_jsx("ul", null, !isEmpty_default()(items) && navItems), !parent && isMicePage && backToB2CWebsiteLabel && SideNavigation_jsx(DynamicLink["a" /* default */], {
    className: "relative block cursor-pointer py-15 text-16 font-bold leading-tight text-black underline hocus:text-black-active",
    onClick: function onClick() {
      closeMenu();
      track({
        actionGA: 'header_backToB2C',
        categoryGA: 'headerMenu',
        labelGA: 'backToB2C'
      });
    },
    url: backToB2CWebsiteLink
  }, backToB2CWebsiteLabel), !parent && language && Object.keys(get_default()(language, 'locales', {})).length > 1 && SideNavigation_jsx("div", {
    className: "overflow-x-auto border-b-1 border-t-1 border-grey"
  }, SideNavigation_jsx(Languages_Languages, Object(esm_extends["a" /* default */])({}, language, {
    className: "min-w-full py-15",
    getTrackingData: Navigation_tracking["e" /* getNavigationLanguagesButtonTrackingData */],
    isActive: isActive
  }))), !parent && (logo === null || logo === void 0 ? void 0 : logo.imageUrl) && SideNavigation_jsx(DynamicLink["a" /* default */], {
    className: "block cursor-pointer py-5",
    onClick: function onClick() {
      closeMenu();
      track({
        actionGA: 'header_reinsuranceLogo',
        categoryGA: 'headerMenu',
        labelGA: 'reinsuranceLogo'
      });
    },
    url: logo.link
  }, SideNavigation_jsx("img", {
    alt: "",
    className: "max-h-80 max-w-2/5",
    src: logo.imageUrl
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/SubItems.jsx









var SubItems_jsx = react_default.a.createElement;



var SubItems_SubItems = function SubItems(props) {
  var backButtonLabel = props.backButtonLabel,
      backButtonMainNavLabel = props.backButtonMainNavLabel,
      closeMenu = props.closeMenu,
      items = props.items,
      language = props.language,
      navBack = props.navBack,
      navForward = props.navForward,
      panelStyles = props.panelStyles,
      parentId = props.parentId,
      parentLabel = props.parentLabel,
      sideNavigationPanels = props.sideNavigationPanels;
  return items.filter(function (item) {
    return item.subItems && item.subItems.length;
  }).map(function (_ref) {
    var id = _ref.id,
        label = _ref.label,
        link = _ref.link,
        subItems = _ref.subItems;
    var itemId = "".concat(label.replace(/ /g, '-').toLowerCase()).concat(id);
    var panelProps = {
      backButtonLabel: parentId === Navigation_constants["b" /* ROOT_ID */] ? backButtonMainNavLabel : backButtonLabel,
      id: itemId,
      isActive: !!sideNavigationPanels.length && sideNavigationPanels[sideNavigationPanels.length - 1] === itemId,
      isHidden: !sideNavigationPanels.includes(itemId),
      items: subItems,
      label: label,
      language: language,
      navBack: navBack,
      navForward: navForward,
      closeMenu: closeMenu,
      parent: parentId,
      parentLabel: parentLabel,
      parentLink: link,
      style: panelStyles
    };
    return [SubItems_jsx(SideNavigation_SideNavigation, Object(esm_extends["a" /* default */])({
      key: label
    }, panelProps)), SubItems_jsx(SubItems, Object(esm_extends["a" /* default */])({
      key: itemId
    }, props, {
      parentId: itemId,
      parentLabel: label,
      items: subItems
    }))];
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/NavigationNarrowElementPanel.jsx
var NavigationNarrowElementPanel_jsx = react_default.a.createElement;


var NavigationNarrowElementPanel_NavigationNarrowElementPanel = function NavigationNarrowElementPanel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      style = _ref.style;

  if (!react["Children"].count(children)) {
    return null;
  }

  return NavigationNarrowElementPanel_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(className || 'bg-white bottom-0 fixed p-15 end-0 duration-250 ease-in transform w-full', {
      'transform translate-x-0': isActive,
      'transform ltr:translate-x-full rtl:-translate-x-full': !isActive
    }),
    style: style
  }, children);
};
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/narrow/NavigationNarrow.jsx










var NavigationNarrow_jsx = react_default.a.createElement;























var NavigationNarrow_NavigationContact = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "AY+A")).then(function (x) {
    return x.NavigationContact;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("AY+A")];
    },
    modules: ["../contact/NavigationContact"]
  }
});
var NavigationNarrow_NavigationMemberAccess = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "uXT4")).then(function (x) {
    return x.NavigationMemberAccess;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("uXT4")];
    },
    modules: ["../member-access/NavigationMemberAccess"]
  }
});
var NavigationNarrow_NavigationFavorite = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 44).then(__webpack_require__.bind(null, "+uRY")).then(function (x) {
    return x.NavigationFavorite;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("+uRY")];
    },
    modules: ["../favorite/NavigationFavorite"]
  }
});
var NavigationNarrow_NavigationNarrow = function NavigationNarrow(props) {
  var _navBarRef$current;

  var _props$backButtonLabe = props.backButtonLabel,
      backButtonLabel = _props$backButtonLabe === void 0 ? '' : _props$backButtonLabe,
      backButtonMainNavLabel = props.backButtonMainNavLabel,
      backToB2CWebsiteLabel = props.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = props.backToB2CWebsiteLink,
      closeMainNavLabel = props.closeMainNavLabel,
      _props$contact = props.contact,
      contact = _props$contact === void 0 ? {} : _props$contact,
      facetingSuggestedRequests = props.facetingSuggestedRequests,
      _props$id = props.id,
      id = _props$id === void 0 ? 'Navigation' : _props$id,
      isMicePage = props.isMicePage,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      language = props.language,
      logo = props.logo,
      onLock = props.onLock,
      openMainNavLabel = props.openMainNavLabel,
      userInfo = props.userInfo,
      MICELogoRedirectionLink = props.MICELogoRedirectionLink,
      hideUndecidedPathFeature = props.hideUndecidedPathFeature;
  var track = Object(useTracking["a" /* useTracking */])();
  var navBarRef = Object(react["useRef"])();

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageId = _usePageContext.pageId;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isGsa = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa');

  var _useContext = Object(react["useContext"])(FavoriteProductListContext["a" /* FavoriteProductListContext */]),
      _useContext$favoriteP = _useContext.favoriteProductsState,
      favoriteProductList = _useContext$favoriteP.favoriteProductList,
      showcaseLatestFavorite = _useContext$favoriteP.showcaseLatestFavorite,
      showAllFavorite = _useContext$favoriteP.showAllFavorite,
      setFavoriteProductList = _useContext.setFavoriteProductList;

  var _useState = Object(react["useState"])(null),
      activeElement = _useState[0],
      setActiveElement = _useState[1];

  var _useState2 = Object(react["useState"])([]),
      sideNavigationPanels = _useState2[0],
      setSideNavigationPanels = _useState2[1];

  var toggleElement = function toggleElement(element) {
    return function () {
      setActiveElement(element === activeElement ? null : element);
      setSideNavigationPanels([]);
      onLock(!!element);
    };
  };

  var resetNav = function resetNav() {
    setActiveElement(null);
    setSideNavigationPanels([]);
    onLock(false);
  };

  var navBack = function navBack() {
    setSideNavigationPanels(sideNavigationPanels.splice(0, sideNavigationPanels.length - 1));
  };

  var navForward = function navForward(nextPanel) {
    nextPanel && !sideNavigationPanels.includes(nextPanel) ? setSideNavigationPanels([].concat(Object(toConsumableArray["a" /* default */])(sideNavigationPanels), [nextPanel])) : toggleElement(Navigation_constants["c" /* elements */].MENU)();
  };

  var closeMenu = function closeMenu() {
    toggleElement(Navigation_constants["c" /* elements */].MENU)();
  };

  var closeMemberPanel = function closeMemberPanel() {
    toggleElement(Navigation_constants["c" /* elements */].LOGIN)();
  };

  var offsetTop = (navBarRef === null || navBarRef === void 0 ? void 0 : (_navBarRef$current = navBarRef.current) === null || _navBarRef$current === void 0 ? void 0 : _navBarRef$current.getBoundingClientRect().top) || 0;
  var panelStyles = {
    maxWidth: '31rem',
    top: Navigation_constants["d" /* heights */].NAVIGATION_NARROW_HEIGHT + offsetTop,
    transition: 'transform linear 330ms'
  };
  var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.phoneNumber) || (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);
  Object(react["useEffect"])(function () {
    if (showAllFavorite) {
      toggleElement(Navigation_constants["c" /* elements */].FAVORITE)();
    }
  }, [showAllFavorite]);
  Object(react["useEffect"])(function () {
    if (showcaseLatestFavorite) {
      toggleElement(Navigation_constants["c" /* elements */].NEW_FAVORITE)();
      setFavoriteProductList(favoriteProductList, false, false);
    }
  }, [showcaseLatestFavorite]);

  var onFavoriteButtonClick = function onFavoriteButtonClick() {
    if (favoriteProductList.length > 0 && (activeElement !== Navigation_constants["c" /* elements */].NO_FAVORITES || activeElement !== Navigation_constants["c" /* elements */].NEW_FAVORITE)) {
      toggleElement(Navigation_constants["c" /* elements */].FAVORITE)();
    } else {
      toggleElement(Navigation_constants["c" /* elements */].NO_FAVORITES)();
    }
  };

  var getLogoTitle = function getLogoTitle() {
    if (isMicePage) {
      return 'Club Med meetings and events page';
    }

    if (isGsa) {
      return Object(i18n["h" /* t */])('account.authentication.yourAccount.title');
    }

    return 'Club Med Homepage';
  };

  var getLogoUrl = function getLogoUrl() {
    if (isMicePage) {
      return MICELogoRedirectionLink;
    }

    if (isGsa) {
      return '/account';
    }

    return '/';
  };

  return NavigationNarrow_jsx("nav", {
    className: Object(classnames_utils["a" /* classnames */])('w-full bg-white lg:hidden', Navigation_constants["a" /* NAVIGATION_OFFSET_SELECTOR */]),
    id: id,
    role: "navigation"
  }, NavigationNarrow_jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: !!activeElement
  }, NavigationNarrow_jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: !!activeElement
  }, NavigationNarrow_jsx("div", {
    className: "flex h-50 flex-nowrap border-b-1",
    style: {
      height: Navigation_constants["d" /* heights */].NAVIGATION_NARROW_HEIGHT
    },
    ref: navBarRef
  }, !isGsa && NavigationNarrow_jsx("div", {
    className: "flex h-full items-center border-e-1 border-grey"
  }, NavigationNarrow_jsx("button", {
    className: "h-full p-15 text-black",
    id: "NavigationNarrow-toggleSideNav-button",
    "data-testid": "NavigationNarrow-toggleSideNav-button",
    onClick: toggleElement(Navigation_constants["c" /* elements */].MENU),
    type: "button"
  }, NavigationNarrow_jsx("span", {
    className: "sr-only"
  }, activeElement === Navigation_constants["c" /* elements */].MENU ? closeMainNavLabel : openMainNavLabel), NavigationNarrow_jsx("div", {
    className: "hamburger"
  }, NavigationNarrow_jsx("span", {
    className: Object(classnames_utils["a" /* classnames */])('hamburger-span', {
      'hamburger-span-active': activeElement === Navigation_constants["c" /* elements */].MENU
    })
  })))), NavigationNarrow_jsx(SideNavigation_SideNavigation, {
    backToB2CWebsiteLink: backToB2CWebsiteLink,
    backToB2CWebsiteLabel: backToB2CWebsiteLabel,
    closeMenu: closeMenu,
    id: Navigation_constants["b" /* ROOT_ID */],
    isActive: activeElement === Navigation_constants["c" /* elements */].MENU && !sideNavigationPanels.length,
    isHidden: activeElement !== Navigation_constants["c" /* elements */].MENU,
    isMicePage: isMicePage,
    items: items,
    logo: logo,
    language: language,
    navBack: navBack,
    navForward: navForward,
    style: panelStyles
  }), NavigationNarrow_jsx(SubItems_SubItems, {
    backButtonLabel: backButtonLabel,
    backButtonMainNavLabel: backButtonMainNavLabel,
    closeMenu: closeMenu,
    items: items,
    language: language,
    navBack: navBack,
    navForward: navForward,
    panelStyles: panelStyles,
    parentId: Navigation_constants["b" /* ROOT_ID */],
    sideNavigationPanels: sideNavigationPanels
  }), NavigationNarrow_jsx("div", {
    className: "flex-1 px-10"
  }, NavigationNarrow_jsx(DynamicLink["a" /* default */], {
    className: "flex h-50 items-center",
    "data-testid": "NavigationNarrow-logo-link",
    onClick: function onClick() {
      resetNav();
      track(Navigation_tracking["b" /* NAVIGATION_TRACKING_LOGO_BUTTON */]);
    },
    style: {
      height: Navigation_constants["d" /* heights */].NAVIGATION_NARROW_HEIGHT
    },
    title: getLogoTitle(),
    url: getLogoUrl()
  }, NavigationNarrow_jsx(Icon["a" /* Icon */], {
    className: Object(classnames_utils["a" /* classnames */])({
      'mt-5 text-ultramarine': isMicePage
    }),
    isNotSquare: true,
    name: isMicePage ? icons["a" /* ICONS */].CLUBMED_MEETINGS : icons["a" /* ICONS */].CLUBMED,
    width: isMicePage ? '3rem' : '6rem'
  }), NavigationNarrow_jsx("span", {
    className: "sr-only"
  }, isMicePage ? 'Club Med meetings and events page' : 'Club Med Homepage'))), NavigationNarrow_jsx("div", {
    className: "flex"
  }, !isMicePage && !isGsa && NavigationNarrow_jsx(GlobalSearch_GlobalSearch, {
    className: Object(classnames_utils["a" /* classnames */])('navigation-arrow relative flex items-center px-10', {
      'text-black': activeElement !== Navigation_constants["c" /* elements */].SEARCH,
      'navigation-arrow-active text-black-active': activeElement === Navigation_constants["c" /* elements */].SEARCH
    }),
    facetingSuggestedRequests: facetingSuggestedRequests,
    isOpen: activeElement === Navigation_constants["c" /* elements */].SEARCH,
    offsetTop: offsetTop,
    toggleOpen: toggleElement(Navigation_constants["c" /* elements */].SEARCH)
  }), !isEmpty_default()(contact) && NavigationNarrow_jsx(react["Fragment"], null, NavigationNarrow_jsx("button", {
    "aria-expanded": activeElement === Navigation_constants["c" /* elements */].CONTACT,
    className: Object(classnames_utils["a" /* classnames */])('navigation-arrow relative flex items-center px-10', {
      'text-black': activeElement !== Navigation_constants["c" /* elements */].CONTACT,
      'navigation-arrow-active text-black-active': activeElement === Navigation_constants["c" /* elements */].CONTACT
    }),
    "data-testid": "NavigationNarrow-contact-button",
    onClick: function onClick() {
      hasContactDetails && toggleElement(Navigation_constants["c" /* elements */].CONTACT)();

      if (activeElement !== Navigation_constants["c" /* elements */].CONTACT && hasContactDetails) {
        track(Navigation_tracking["a" /* NAVIGATION_TRACKING_CONTACT_BUTTON */]);
      }
    },
    title: contact.title,
    type: "button"
  }, NavigationNarrow_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].PHONE,
    width: "1.5rem"
  }), NavigationNarrow_jsx("span", {
    className: "sr-only"
  }, contact.title)), NavigationNarrow_jsx(NavigationNarrowElementPanel_NavigationNarrowElementPanel, {
    isActive: activeElement === Navigation_constants["c" /* elements */].CONTACT,
    style: panelStyles
  }, activeElement === Navigation_constants["c" /* elements */].CONTACT && NavigationNarrow_jsx(NavigationNarrow_NavigationContact, {
    contact: contact,
    hasTel: true
  }))), !isMicePage && NavigationNarrow_jsx(react["Fragment"], null, NavigationNarrow_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
    className: Object(classnames_utils["a" /* classnames */])('navigation-arrow relative flex items-center px-10', {
      'text-black': activeElement !== Navigation_constants["c" /* elements */].LOGIN,
      'navigation-arrow-active text-black-active': activeElement === Navigation_constants["c" /* elements */].LOGIN
    }),
    "data-testid": "NavigationMember-access-button",
    isActive: activeElement === Navigation_constants["c" /* elements */].LOGIN,
    isAuthenticated: userInfo && userInfo.isLoggedIn,
    isQuickLoggedIn: userInfo && userInfo.isQuickLoggedIn,
    onClick: toggleElement(Navigation_constants["c" /* elements */].LOGIN),
    title: Object(i18n["h" /* t */])('account.authentication.yourAccount.title')
  }), NavigationNarrow_jsx(NavigationNarrowElementPanel_NavigationNarrowElementPanel, {
    className: "fixed bottom-0 end-0 w-9/10 overflow-y-auto bg-white p-20",
    isActive: activeElement === Navigation_constants["c" /* elements */].LOGIN,
    style: panelStyles
  }, activeElement === Navigation_constants["c" /* elements */].LOGIN && NavigationNarrow_jsx(NavigationNarrow_NavigationMemberAccess, {
    closeMemberPanel: closeMemberPanel,
    userInfo: userInfo
  })), !hideUndecidedPathFeature && !isGsa && NavigationNarrow_jsx(NavigationFavoriteButton_NavigationFavoriteButton, {
    onClick: onFavoriteButtonClick,
    isActive: activeElement === Navigation_constants["c" /* elements */].NO_FAVORITES || activeElement === Navigation_constants["c" /* elements */].NEW_FAVORITE,
    favoriteProductListLength: favoriteProductList.length
  }), !hideUndecidedPathFeature && (favoriteProductList.length > 0 && activeElement === Navigation_constants["c" /* elements */].FAVORITE ? NavigationNarrow_jsx(NavigationNarrowElementPanel_NavigationNarrowElementPanel, {
    className: "fixed bottom-0 end-0 w-full max-w-none overflow-y-auto overflow-x-hidden bg-white p-20",
    isActive: activeElement === Navigation_constants["c" /* elements */].FAVORITE,
    style: panelStyles
  }, NavigationNarrow_jsx(NavigationNarrow_NavigationFavorite, {
    onClose: function onClose() {
      toggleElement(null)();
      track({
        actionGA: 'header_favorites',
        labelGA: 'closeFavorites',
        categoryGA: 'headerMenu',
        pageName: pageId
      });
    }
  })) : NavigationNarrow_jsx(NavigationNarrowElementPanel_NavigationNarrowElementPanel, {
    className: Object(classnames_utils["a" /* classnames */])('fixed inset-x-0 z-1 max-w-none translate-x-0 transform overflow-y-auto overflow-x-hidden rounded-2 bg-white px-20 py-15 shadow duration-250 ease-in', {
      'mx-10': activeElement === Navigation_constants["c" /* elements */].NO_FAVORITES || activeElement === Navigation_constants["c" /* elements */].NEW_FAVORITE
    }),
    isActive: activeElement === Navigation_constants["c" /* elements */].NO_FAVORITES || activeElement === Navigation_constants["c" /* elements */].NEW_FAVORITE,
    style: panelStyles
  }, NavigationNarrow_jsx(NavigationNarrow_NavigationFavorite, {
    onButtonClick: function onButtonClick(e) {
      e.stopPropagation();
      toggleElement(Navigation_constants["c" /* elements */].FAVORITE)();
    },
    onClose: function onClose() {
      toggleElement(null)();
      track({
        actionGA: 'header_favorites',
        labelGA: 'closeFavorites',
        categoryGA: 'headerMenu',
        pageName: pageId
      });
    },
    showcaseLatest: activeElement === Navigation_constants["c" /* elements */].NEW_FAVORITE
  })))))))));
};
var StickyNavigationNarrow = stickyNav(NavigationNarrow_NavigationNarrow);
// CONCATENATED MODULE: ./src/client/components/widgets/navigation/Navigation.jsx

var Navigation_jsx = react_default.a.createElement;










var Navigation_Navigation = function Navigation(_ref) {
  var facetingSuggestedRequests = _ref.facetingSuggestedRequests,
      id = _ref.id,
      language = _ref.language,
      navigation = _ref.navigation,
      promoBannerRef = _ref.promoBannerRef,
      userInfo = _ref.userInfo;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var backButtonLabel = navigation.backButtonLabel,
      backButtonMainNavLabel = navigation.backButtonMainNavLabel,
      backToB2CWebsiteLabel = navigation.backToB2CWebsiteLabel,
      backToB2CWebsiteLink = navigation.backToB2CWebsiteLink,
      closeMainNavLabel = navigation.closeMainNavLabel,
      contact = navigation.contact,
      contactMICE = navigation.contactMICE,
      logo = navigation.logo,
      menus = navigation.menus,
      menusMICE = navigation.menusMICE,
      MICELogoRedirectionLink = navigation.MICELogoRedirectionLink,
      openMainNavLabel = navigation.openMainNavLabel;
  var isMicePage = dist["b2cPagesService"].isMicePage(pageType);
  var isClientSide = true;
  var isBookingEnginePage = pageType === constants["C" /* STATIC_PAGE_TYPES */].BE;
  var navigationProps = {
    backToB2CWebsiteLabel: backToB2CWebsiteLabel,
    backToB2CWebsiteLink: backToB2CWebsiteLink,
    contact: isMicePage ? contactMICE : contact,
    facetingSuggestedRequests: facetingSuggestedRequests,
    id: id,
    isBookingEnginePage: isBookingEnginePage,
    isMicePage: isMicePage,
    items: Navigation_mapper_buildNavigationMenuItems(isMicePage ? menusMICE : menus),
    logo: logo,
    language: language,
    promoBannerRef: promoBannerRef,
    userInfo: userInfo,
    hideUndecidedPathFeature: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('hideUndecidedPathFeature'),
    MICELogoRedirectionLink: MICELogoRedirectionLink
  };
  var shouldRenderDesktopNav = !isClientSide || isAppMounted && isDesktop;
  var shouldRenderMobileNav = !isClientSide || isAppMounted && !isDesktop;
  return Navigation_jsx(react["Fragment"], null, shouldRenderDesktopNav && Navigation_jsx(NavigationLarge_NavigationLarge, navigationProps), shouldRenderMobileNav && Navigation_jsx(StickyNavigationNarrow, Object(esm_extends["a" /* default */])({}, navigationProps, {
    backButtonLabel: backButtonLabel,
    backButtonMainNavLabel: backButtonMainNavLabel,
    closeMainNavLabel: closeMainNavLabel,
    openMainNavLabel: openMainNavLabel
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/pancakes/Pancakes.jsx










var Pancakes_jsx = react_default.a.createElement;

function Pancakes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Pancakes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Pancakes_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Pancakes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/click-events-have-key-events */






var HEIGHT = 110;
var Pancakes_Pancakes = function Pancakes(_ref) {
  var children = _ref.children;

  var _useState = Object(react["useState"])(false),
      shouldAppear = _useState[0],
      setShouldAppear = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isSpread = _useState2[0],
      setIsSpread = _useState2[1];

  var _useState3 = Object(react["useState"])(children.map(function (child, key) {
    return {
      child: child,
      shouldDisplay: false,
      key: key,
      isClosed: false
    };
  })),
      toasterItems = _useState3[0],
      setToasterItems = _useState3[1];

  var hasOnlyEverHadOneToaster = toasterItems.filter(function (_ref2) {
    var isClosed = _ref2.isClosed,
        shouldDisplay = _ref2.shouldDisplay;
    return !isClosed && shouldDisplay;
  }).length === 1;
  Object(react["useEffect"])(function () {
    var timeoutID = setTimeout(function () {
      setShouldAppear(true);
    }, 300);
    return function () {
      clearTimeout(timeoutID);
    };
  }, []);
  var filteredItems = toasterItems.filter(function (item) {
    return item.shouldDisplay && !item.isClosed;
  });
  var shouldDisplayAsSpread = isSpread && filteredItems.length > 1;
  var index = 0;

  var generateChild = function generateChild(_ref3) {
    var child = _ref3.child,
        key = _ref3.key;
    return /*#__PURE__*/react_default.a.cloneElement(child, {
      setIsVisible: function setIsVisible(isVisible) {
        setToasterItems(function (prevItems) {
          return prevItems.map(function (item) {
            if (item.key === key) {
              return Pancakes_objectSpread(Pancakes_objectSpread({}, item), {}, {
                shouldDisplay: isVisible
              });
            }

            return item;
          });
        });
      },
      onClose: function onClose() {
        setToasterItems(function (prevItems) {
          return prevItems.map(function (item) {
            if (item.key === key) {
              return Pancakes_objectSpread(Pancakes_objectSpread({}, item), {}, {
                shouldDisplay: false,
                isClosed: true
              });
            }

            return item;
          });
        });
      },
      isSpread: shouldDisplayAsSpread || filteredItems.length === 1
    });
  };

  return shouldAppear ? Pancakes_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('animation-duration-500 mt-navigation absolute inset-x-0 z-4 mx-10 me-10 max-w-full pt-10 sm:end-0 sm:start-auto sm:w-full md:max-w-400 lg:me-30 lg:pt-30 ltr:animate-slideInRight rtl:animate-slideInLeft'),
    style: {
      perspective: 1000,
      perspectiveOrigin: 'bottom'
    }
  }, filteredItems.length > 1 && Pancakes_jsx("button", {
    onClick: function onClick() {
      setIsSpread(!isSpread);
    },
    className: "transition-transform absolute end-0 h-30 cursor-pointer rounded-4 bg-white px-10 text-14 font-bold text-black shadow duration-250 ease-in",
    style: {
      transform: "translateY(".concat(shouldDisplayAsSpread ? 0 : '2.5rem', ")")
    },
    type: "button"
  }, Object(i18n["h" /* t */])('common.loadLess'), Pancakes_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: "0.625rem",
    className: "ms-10"
  })), toasterItems.filter(function (item) {
    return !item.isClosed;
  }).map(function (_ref4) {
    var child = _ref4.child,
        key = _ref4.key,
        shouldDisplay = _ref4.shouldDisplay;
    var shouldActAsButton = index === 0 && !isSpread; // using native buttons breaks stuff

    var content = generateChild({
      child: child,
      key: key,
      shouldDisplay: shouldDisplay
    });
    return Pancakes_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('transition-transform absolute mb-10 w-full rounded-12 bg-white p-10 shadow duration-250 ease-in', {
        'cursor-pointer': shouldActAsButton
      }, {
        hidden: !shouldDisplay
      }),
      style: {
        zIndex: children.length - index,
        transform: shouldDisplayAsSpread ? "translateY(".concat((HEIGHT + 10) * index + 40, "px") : "translateY(".concat(10 * index, "px) translateZ(").concat(-30 * index, "px)"),
        height: hasOnlyEverHadOneToaster ? 'auto' : "calc(".concat(HEIGHT, "rem / 16)"),
        willChange: 'transform'
      },
      tabIndex: shouldActAsButton ? index : -1,
      role: shouldActAsButton ? 'button' : 'presentation',
      onClick: shouldActAsButton ? function () {
        return setIsSpread(true);
      } : function () {},
      key: key
    }, content, shouldDisplay && index++ === 0 && filteredItems.length > 1 && Pancakes_jsx("span", {
      className: Object(classnames_utils["a" /* classnames */])('absolute bottom-[10px] text-12 text-mediumGrey transition-opacity duration-250 ease-in', {
        'opacity-0': isSpread
      })
    }, Pancakes_jsx(TemplateString["a" /* TemplateString */], {
      template: Object(i18n["h" /* t */])('common.moreNotifications'),
      values: {
        number: filteredItems.length - 1
      }
    })));
  })) : null;
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__("Cm4o");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// CONCATENATED MODULE: ./src/client/components/widgets/promotional-banner/promo-banner/PromoBanner.jsx











var PromoBanner_jsx = react_default.a.createElement;

function PromoBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PromoBanner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PromoBanner_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PromoBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var PromoBanner_PromoBanner = function PromoBanner(_ref) {
  var callToAction = _ref.callToAction,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      description = _ref.description,
      innerRef = _ref.innerRef,
      link = _ref.link,
      onClick = _ref.onClick,
      onClose = _ref.onClose,
      title = _ref.title;

  if (!title) {
    return null;
  }

  var hasLink = link === null || link === void 0 ? void 0 : link.url;
  var TagName = hasLink ? DynamicLink["a" /* default */] : 'div';
  var tagProps = hasLink ? PromoBanner_objectSpread(PromoBanner_objectSpread({}, link), {}, {
    onClick: onClick
  }) : {};
  return PromoBanner_jsx("aside", {
    "data-id": "PromoBanner",
    className: Object(classnames_utils["a" /* classnames */])('relative flex h-50 items-center px-20 text-14 text-sienna', className),
    ref: innerRef
  }, PromoBanner_jsx("div", {
    className: "pointer-events-none absolute inset-0 bg-current opacity-5"
  }), PromoBanner_jsx(TagName, Object(esm_extends["a" /* default */])({}, tagProps, {
    className: "flex w-full justify-center text-inherit"
  }), PromoBanner_jsx("div", {
    className: "max-w-20 grow"
  }), PromoBanner_jsx("div", {
    className: "truncate"
  }, PromoBanner_jsx("span", {
    "data-testid": "PromoBanner-title",
    className: "pe-10 font-bold"
  }, title), hasLink && PromoBanner_jsx(Icon["a" /* Icon */], {
    className: "me-10 sm:me-0 sm:hidden",
    hasRtl: true,
    name: icons["a" /* ICONS */].ARROW_RIGHT,
    width: ".7em"
  }), !!description && PromoBanner_jsx("span", {
    className: "hidden pe-10 md:inline",
    "data-testid": "PromoBanner-description"
  }, description)), hasLink && PromoBanner_jsx("span", {
    className: "hidden shrink-0 pe-10 underline transition-color duration-250 ease-in md:inline"
  }, callToAction)), PromoBanner_jsx("button", {
    className: "leading-0 text-inherit",
    onClick: onClose,
    type: "button"
  }, PromoBanner_jsx("span", {
    className: "sr-only"
  }, closeLabel), PromoBanner_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.75rem"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/promotional-banner/PromotionalBanner.jsx











var PromotionalBanner_jsx = react_default.a.createElement;






var DISABLE_PROMO_BANNER = 'disablePromotionalBanner';
var MOCK_ORIGIN = 'https://mock-origin.clubmed.fr';
var ONE_DAY = 1000 * 60 * 60 * 24;

function shouldBeDisabled() {
  var data = Object(local_storage_api["a" /* getFromLocalStorage */])(DISABLE_PROMO_BANNER);

  if (data == null) {
    return false;
  }

  return data === true;
}

var PromotionalBanner_PromotionalBanner = /*#__PURE__*/Object(react["forwardRef"])(function PromotionalBanner(_ref, ref) {
  var _ref$enabledPages = _ref.enabledPages,
      enabledPages = _ref$enabledPages === void 0 ? [] : _ref$enabledPages,
      _ref$disabledPages = _ref.disabledPages,
      disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages,
      title = _ref.title,
      description = _ref.description,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["enabledPages", "disabledPages", "title", "description"]);

  var _useRouter = Object(next_router["useRouter"])(),
      asPath = _useRouter.asPath;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageId = _usePageContext.pageId;

  var track = Object(useTracking["a" /* useTracking */])();

  var _URL = new URL(asPath, MOCK_ORIGIN),
      pathname = _URL.pathname;

  var pageMatch = function pageMatch(pages) {
    return pages.some(function (page) {
      return page && ( // testing pages that correspond to a resort/tour
      pageId === "resort-".concat(page.toUpperCase()) || pageId === "tour-".concat(page.toUpperCase()) || // pages that correspond to a url
      pathname === page || pathname.startsWith("".concat(page, "/")));
    });
  };

  var isPageEnabled = enabledPages.length === 0 || pageMatch(enabledPages);
  var isPageDisabled = disabledPages.length > 0 && pageMatch(disabledPages);
  var shouldBeDisplayed = !shouldBeDisabled() && isPageEnabled && !isPageDisabled;

  var _useState = Object(react["useState"])(shouldBeDisplayed),
      isDisplayed = _useState[0],
      setDisplay = _useState[1];

  Object(react["useEffect"])(function () {
    setDisplay(shouldBeDisplayed);
  }, [shouldBeDisplayed]);

  var onClose = function onClose() {
    setDisplay(false);
    Object(local_storage_api["c" /* setInLocalStorage */])(DISABLE_PROMO_BANNER, true, {
      ttl: ONE_DAY
    });
    track({
      event: 'eventGA',
      categoryGA: 'promoBanner',
      labelGA: title,
      actionGA: 'close',
      valueGA: '0',
      nonInteraction: '0'
    });
  };

  if (!title || !description || !isDisplayed) {
    return null;
  }

  return PromotionalBanner_jsx(PromoBanner_PromoBanner, Object(esm_extends["a" /* default */])({}, props, {
    description: description,
    innerRef: ref,
    onClick: function onClick() {
      return track({
        event: 'eventGA',
        categoryGA: 'promoBanner',
        labelGA: title,
        actionGA: 'click',
        valueGA: '0',
        nonInteraction: '0'
      });
    },
    onClose: onClose,
    title: title
  }));
});
// EXTERNAL MODULE: ./src/hooks/use-block-input-departure-date/useBlockInputDepartureDate.js
var useBlockInputDepartureDate = __webpack_require__("VQ9C");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.selector.js + 1 modules
var calendar_selector = __webpack_require__("05PS");

// CONCATENATED MODULE: ./src/client/components/widgets/resort-not-booking-toaster/ResortNotBookingToasterContainer.jsx


var ResortNotBookingToasterContainer_jsx = react_default.a.createElement;










var ResortNotBookingToasterContainer_ResortNotBookingToasterContainer = function ResortNotBookingToasterContainer(_ref) {
  var setIsVisible = _ref.setIsVisible;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType,
      pageId = _usePageContext.pageId;

  var calendarIsLoading = Object(es["e" /* useSelector */])(calendar_selector["e" /* getCalendarLoading */]);
  var PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;
  var isAllowedPage = [PAGE_TYPES.RESORT, PAGE_TYPES.CRUISE].includes(pageType);

  var _useBlockInputDepartu = Object(useBlockInputDepartureDate["a" /* useBlockInputDepartureDate */])(true),
      blockInputDepartureDate = _useBlockInputDepartu.blockInputDepartureDate;

  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);

  var _useState = Object(react["useState"])(!!departureDate),
      hasInitialDepartureDate = _useState[0],
      setHasInitialDepartureDate = _useState[1];

  var title = Object(i18n["h" /* t */])('priceRemote.errors.noAvailabilities');
  var displayToaster = hasInitialDepartureDate && isAllowedPage && blockInputDepartureDate && !calendarIsLoading;
  Object(react["useEffect"])(function () {
    setIsVisible && setIsVisible(displayToaster);
  }, [displayToaster]);
  Object(react["useEffect"])(function () {
    setHasInitialDepartureDate(!!departureDate);
  }, [pageId]);
  return displayToaster ? ResortNotBookingToasterContainer_jsx(ToasterImmersive_ToasterImmersive, {
    title: title,
    iconName: icons["a" /* ICONS */].WARNING,
    onClose: function onClose() {
      setIsVisible && setIsVisible(false);
    }
  }) : null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/navigation/contact/NavigationContact.jsx
var contact_NavigationContact = __webpack_require__("AY+A");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/member-access/NavigationMemberAccess.jsx + 6 modules
var member_access_NavigationMemberAccess = __webpack_require__("uXT4");

// CONCATENATED MODULE: ./src/client/components/widgets/confirmation-header/ConfirmationHeader.jsx



var ConfirmationHeader_jsx = react_default.a.createElement;

















var ConfirmationHeader_ConfirmationHeader = function ConfirmationHeader(_ref) {
  var contact = _ref.contact;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var _useState = Object(react["useState"])(false),
      contactPopUpVisible = _useState[0],
      setContactPopUpVisible = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      loginPopUpVisible = _useState2[0],
      setLoginPopUpVisible = _useState2[1];

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var hasContactDetails = (contact === null || contact === void 0 ? void 0 : contact.hours) || (contact === null || contact === void 0 ? void 0 : contact.description) || (contact === null || contact === void 0 ? void 0 : contact.toll) || (contact === null || contact === void 0 ? void 0 : contact.title);
  var connectedUserInfo = Object(es["e" /* useSelector */])(booking_selector["h" /* getConnectedUserInfoSelector */]);
  var isLoggedIn = connectedUserInfo.isLoggedIn,
      isQuickLoggedIn = connectedUserInfo.isQuickLoggedIn;
  var isBookingEnginePage = pageType === constants["C" /* STATIC_PAGE_TYPES */].BE;
  var iconButtonClassNames = 'cursor-pointer flex items-center px-15 relative hocus:text-black-active';
  return ConfirmationHeader_jsx("header", {
    className: "border-b-1 border-grey bg-white px-20 md:px-50",
    "data-testid": "booking-header",
    role: "navigation"
  }, ConfirmationHeader_jsx("div", {
    className: "relative isolate z-1 m-auto flex h-60 max-w-site justify-between gap-20"
  }, ConfirmationHeader_jsx(DynamicLink["a" /* default */], {
    className: "flex items-center gap-10 text-14 text-black hocus:text-black-active",
    onClick: function onClick() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
        detail_click: 'back_home'
      });
    },
    url: "/"
  }, ConfirmationHeader_jsx(Icon["a" /* Icon */], {
    dataTestid: "left-arrow-icon",
    name: icons["a" /* ICONS */].ARROW_TAIL_LEFT,
    width: "1.875rem"
  }), ConfirmationHeader_jsx("span", {
    className: "hidden sm:block"
  }, Object(i18n["h" /* t */])('booking.confirmation.goToHome'))), ConfirmationHeader_jsx(DynamicLink["a" /* default */], {
    className: "flex items-center justify-center",
    onClick: function onClick() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
        detail_click: 'logo'
      });
    },
    url: "/"
  }, ConfirmationHeader_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    dataTestid: "cm-logo",
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED,
    width: "6.25rem"
  })), ConfirmationHeader_jsx("div", {
    className: "relative flex gap-20"
  }, !isEmpty_default()(contact) && ConfirmationHeader_jsx(react["Fragment"], null, ConfirmationHeader_jsx("button", {
    "aria-expanded": Navigation_constants["c" /* elements */].CONTACT,
    className: Object(classnames_utils["a" /* classnames */])('navigation-arrow relative flex items-center', {
      'navigation-arrow-active': contactPopUpVisible
    }),
    "data-testid": "header-contact-button",
    onClick: function onClick() {
      hasContactDetails && setContactPopUpVisible(true);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_HEADER, {
        detail_click: 'call'
      });
    },
    title: contact.title,
    type: "button"
  }, ConfirmationHeader_jsx(Icon["a" /* Icon */], {
    className: "text-black",
    dataTestid: "phone-icon",
    hasRtl: true,
    name: icons["a" /* ICONS */].PHONE_LIGHT,
    width: "1.875rem"
  }), ConfirmationHeader_jsx("span", {
    className: "sr-only"
  }, contact.title)), contactPopUpVisible && ConfirmationHeader_jsx(ClickOutside["a" /* ClickOutside */], {
    className: "absolute right-0 top-[66px]",
    onClick: function onClick() {
      contactPopUpVisible && setContactPopUpVisible(false);
    }
  }, ConfirmationHeader_jsx(NavigationLargeElement_NavigationLargeElement, {
    className: "w-300 rounded-12 shadow-md",
    onClose: function onClose() {
      return setContactPopUpVisible(false);
    }
  }, ConfirmationHeader_jsx(contact_NavigationContact["NavigationContact"], {
    isBookingEnginePage: isBookingEnginePage,
    contact: contact
  })))), ConfirmationHeader_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('navigation-arrow relative flex items-center', {
      'navigation-arrow-active': loginPopUpVisible
    })
  }, ConfirmationHeader_jsx(NavigationMemberAccessButton_NavigationMemberAccessButton, {
    className: Object(classnames_utils["a" /* classnames */])(iconButtonClassNames),
    isActive: loginPopUpVisible,
    isAuthenticated: isLoggedIn,
    isQuickLoggedIn: isQuickLoggedIn,
    onClick: function onClick() {
      return setLoginPopUpVisible(true);
    },
    size: 1.875,
    title: Object(i18n["h" /* t */])('account.authentication.yourAccount.title')
  })), loginPopUpVisible && ConfirmationHeader_jsx(ClickOutside["a" /* ClickOutside */], {
    className: "absolute right-0 top-[66px]",
    onClick: function onClick() {
      loginPopUpVisible && setLoginPopUpVisible(false);
    }
  }, ConfirmationHeader_jsx(NavigationLargeElement_NavigationLargeElement, {
    className: Object(classnames_utils["a" /* classnames */])('w-[90vw] rounded-12 shadow-md md:w-640', {
      'w-[18.125rem] p-0': isLoggedIn || isQuickLoggedIn
    }),
    onClose: function onClose() {
      return setLoginPopUpVisible(false);
    }
  }, ConfirmationHeader_jsx(member_access_NavigationMemberAccess["NavigationMemberAccess"], {
    userInfo: connectedUserInfo
  }))))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/booking-footer/BookingFooter.jsx + 2 modules
var BookingFooter = __webpack_require__("dATv");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/config.js
var next_config = __webpack_require__("LdtY");
var next_config_default = /*#__PURE__*/__webpack_require__.n(next_config);

// EXTERNAL MODULE: /opt/webapp/node_modules/prop-types/index.js
var prop_types = __webpack_require__("aWzz");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: /opt/webapp/node_modules/@didomi/react/es/index.js


var es_DidomiSDK = function DidomiSDK(_ref) {
  var _ref$apiKey = _ref.apiKey,
    apiKeyProp = _ref$apiKey === void 0 ? null : _ref$apiKey,
    _ref$iabVersion = _ref.iabVersion,
    iabVersion = _ref$iabVersion === void 0 ? 2 : _ref$iabVersion,
    _ref$noticeId = _ref.noticeId,
    noticeId = _ref$noticeId === void 0 ? null : _ref$noticeId,
    _ref$platform = _ref.platform,
    platform = _ref$platform === void 0 ? null : _ref$platform,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$gdprAppliesGloba = _ref.gdprAppliesGlobally,
    gdprAppliesGloballyProp = _ref$gdprAppliesGloba === void 0 ? true : _ref$gdprAppliesGloba,
    onReady = _ref.onReady,
    onConsentChanged = _ref.onConsentChanged,
    onNoticeShown = _ref.onNoticeShown,
    onNoticeHidden = _ref.onNoticeHidden,
    onNoticeBackdropclick = _ref.onNoticeBackdropclick,
    onNoticeClickAgree = _ref.onNoticeClickAgree,
    onNoticeClickMoreInfo = _ref.onNoticeClickMoreInfo,
    onPreferencesClickAgreeToAll = _ref.onPreferencesClickAgreeToAll,
    onPreferencesClickDisagreeToAll = _ref.onPreferencesClickDisagreeToAll,
    onPreferencesClickPurposeAgree = _ref.onPreferencesClickPurposeAgree,
    onPreferencesClickPurposeDisagree = _ref.onPreferencesClickPurposeDisagree,
    onPreferencesClickViewVendors = _ref.onPreferencesClickViewVendors,
    onPreferencesClickSaveChoices = _ref.onPreferencesClickSaveChoices,
    onPreferencesClickVendorAgree = _ref.onPreferencesClickVendorAgree,
    onPreferencesClickVendorDisagree = _ref.onPreferencesClickVendorDisagree,
    onPreferencesClickVendorSaveChoices = _ref.onPreferencesClickVendorSaveChoices,
    _ref$sdkPath = _ref.sdkPath,
    sdkPath = _ref$sdkPath === void 0 ? 'https://sdk.privacy-center.org/' : _ref$sdkPath,
    _ref$embedTCFStub = _ref.embedTCFStub,
    embedTCFStub = _ref$embedTCFStub === void 0 ? true : _ref$embedTCFStub;
  /**
   * Set all the Didomi event listeners from the props
   */
  var setEvents = function setEvents() {
    if (onReady) {
      window.didomiOnReady = window.didomiOnReady || [];
      window.didomiOnReady.push(onReady);
    }
    window.didomiEventListeners = window.didomiEventListeners || [];
    if (onConsentChanged) {
      window.didomiEventListeners.push({
        event: 'consent.changed',
        listener: function listener(e) {
          onConsentChanged(e.consentToken);
        }
      });
    }
    if (onNoticeShown) {
      window.didomiEventListeners.push({
        event: 'notice.shown',
        listener: function listener() {
          return onNoticeShown();
        }
      });
    }
    if (onNoticeHidden) {
      window.didomiEventListeners.push({
        event: 'notice.hidden',
        listener: function listener() {
          return onNoticeHidden();
        }
      });
    }
    if (onNoticeBackdropclick) {
      window.didomiEventListeners.push({
        event: 'notice.backdropclick',
        listener: function listener() {
          return onNoticeBackdropclick();
        }
      });
    }
    if (onNoticeClickAgree) {
      window.didomiEventListeners.push({
        event: 'notice.clickagree',
        listener: function listener() {
          return onNoticeClickAgree();
        }
      });
    }
    if (onNoticeClickMoreInfo) {
      window.didomiEventListeners.push({
        event: 'notice.clickmoreinfo',
        listener: function listener() {
          return onNoticeClickMoreInfo();
        }
      });
    }
    if (onPreferencesClickAgreeToAll) {
      window.didomiEventListeners.push({
        event: 'preferences.clickagreetoall',
        listener: function listener() {
          return onPreferencesClickAgreeToAll();
        }
      });
    }
    if (onPreferencesClickDisagreeToAll) {
      window.didomiEventListeners.push({
        event: 'preferences.clickdisagreetoall',
        listener: function listener() {
          return onPreferencesClickDisagreeToAll();
        }
      });
    }
    if (onPreferencesClickPurposeAgree) {
      window.didomiEventListeners.push({
        event: 'preferences.clickpurposeagree',
        listener: function listener() {
          return onPreferencesClickPurposeAgree();
        }
      });
    }
    if (onPreferencesClickPurposeDisagree) {
      window.didomiEventListeners.push({
        event: 'preferences.clickpurposedisagree',
        listener: function listener() {
          return onPreferencesClickPurposeDisagree();
        }
      });
    }
    if (onPreferencesClickViewVendors) {
      window.didomiEventListeners.push({
        event: 'preferences.clickviewvendors',
        listener: function listener() {
          return onPreferencesClickViewVendors();
        }
      });
    }
    if (onPreferencesClickSaveChoices) {
      window.didomiEventListeners.push({
        event: 'preferences.clicksavechoices',
        listener: function listener() {
          return onPreferencesClickSaveChoices();
        }
      });
    }
    if (onPreferencesClickVendorAgree) {
      window.didomiEventListeners.push({
        event: 'preferences.clickvendoragree',
        listener: function listener() {
          return onPreferencesClickVendorAgree();
        }
      });
    }
    if (onPreferencesClickVendorDisagree) {
      window.didomiEventListeners.push({
        event: 'preferences.clickvendordisagree',
        listener: function listener() {
          return onPreferencesClickVendorDisagree();
        }
      });
    }
    if (onPreferencesClickVendorSaveChoices) {
      window.didomiEventListeners.push({
        event: 'preferences.clickvendorsavechoices',
        listener: function listener() {
          return onPreferencesClickVendorSaveChoices();
        }
      });
    }
  };

  /**
   * Get the API Key from the props or from the config if it exists
   */
  var getApiKey = function getApiKey() {
    var apiKey;
    if (config.app && config.app.apiKey) {
      apiKey = config.app.apiKey;
    }
    return apiKeyProp || apiKey;
  };

  /**
   * Initialize the SDK, set the config object and insert the loader.js into the DOM
   */
  var init = function init() {
    var loaderParams;
    var apiKey = getApiKey();
    var gdprAppliesGlobally = gdprAppliesGloballyProp === false ? false : true;
    window.didomiConfig = config || {};

    // Set the SDK path
    window.didomiConfig.sdkPath = sdkPath;

    // Embed the Didomi SDK on the page
    window.gdprAppliesGlobally = gdprAppliesGlobally;
    if (noticeId) {
      loaderParams = "target_type=notice&target=" + noticeId;
      if (platform) {
        loaderParams = "platform=" + platform + "&" + loaderParams;
      }
    } else {
      loaderParams = "target=" + document.location.hostname;
    }

    // Embed the TCF stub
    if (embedTCFStub) {
      if (iabVersion === 2) {
        // TCF v2
        // prettier-ignore
        (function () {
          function a(e) {
            if (!window.frames[e]) {
              if (document.body && document.body.firstChild) {
                var t = document.body;
                var n = document.createElement("iframe");
                n.style.display = "none";
                n.name = e;
                n.title = e;
                t.insertBefore(n, t.firstChild);
              } else {
                setTimeout(function () {
                  a(e);
                }, 5);
              }
            }
          }
          function e(n, r, o, c, s) {
            function e(e, t, n, a) {
              if (typeof n !== "function") {
                return;
              }
              if (!window[r]) {
                window[r] = [];
              }
              var i = false;
              if (s) {
                i = s(e, t, n);
              }
              if (!i) {
                window[r].push({
                  command: e,
                  parameter: t,
                  callback: n,
                  version: a
                });
              }
            }
            e.stub = true;
            function t(a) {
              if (!window[n] || window[n].stub !== true) {
                return;
              }
              if (!a.data) {
                return;
              }
              var i = typeof a.data === "string";
              var e;
              try {
                e = i ? JSON.parse(a.data) : a.data;
              } catch (t) {
                return;
              }
              if (e[o]) {
                var r = e[o];
                window[n](r.command, r.parameter, function (e, t) {
                  var n = {};
                  n[c] = {
                    returnValue: e,
                    success: t,
                    callId: r.callId
                  };
                  a.source.postMessage(i ? JSON.stringify(n) : n, "*");
                }, r.version);
              }
            }
            if (typeof window[n] !== "function") {
              window[n] = e;
              if (window.addEventListener) {
                window.addEventListener("message", t, false);
              } else {
                window.attachEvent("onmessage", t);
              }
            }
          }
          e("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn");
          a("__tcfapiLocator");
        })();
      } else {
        // TCF v1
        // prettier-ignore
        (function () {
          function r() {
            if (!window.frames.__cmpLocator) {
              if (document.body && document.body.firstChild) {
                var e = document.body;
                var t = document.createElement("iframe");
                t.style.display = "none";
                t.name = "__cmpLocator";
                t.title = "cmpLocator";
                e.insertBefore(t, e.firstChild);
              } else {
                setTimeout(r, 5);
              }
            }
          }
          function e(e, t, r) {
            if (typeof r !== "function") {
              return;
            }
            if (!window.__cmpBuffer) {
              window.__cmpBuffer = [];
            }
            if (e === "ping") {
              r({
                gdprAppliesGlobally: window.gdprAppliesGlobally,
                cmpLoaded: false
              }, true);
            } else {
              window.__cmpBuffer.push({
                command: e,
                parameter: t,
                callback: r
              });
            }
          }
          e.stub = true;
          function t(a) {
            if (!window.__cmp || window.__cmp.stub !== true) {
              return;
            }
            if (!a.data) {
              return;
            }
            var n = typeof a.data === "string";
            var e;
            try {
              e = n ? JSON.parse(a.data) : a.data;
            } catch (t) {
              return;
            }
            if (e.__cmpCall) {
              var o = e.__cmpCall;
              window.__cmp(o.command, o.parameter, function (e, t) {
                var r = {
                  __cmpReturn: {
                    returnValue: e,
                    success: t,
                    callId: o.callId
                  }
                };
                a.source.postMessage(n ? JSON.stringify(r) : r, "*");
              });
            }
          }
          if (typeof window.__cmp !== "function") {
            window.__cmp = e;
            if (window.addEventListener) {
              window.addEventListener("message", t, false);
            } else {
              window.attachEvent("onmessage", t);
            }
          }
          r();
        })();
      }
    }
    var spcloaderId = 'spcloader';
    var spcloaderScript = document.getElementById(spcloaderId);

    // Didomi is already loaded, no need to add the script again
    if (spcloaderScript) {
      return null;
    }

    // Embed the SDK
    var loaderScript = document.createElement('script');
    loaderScript.id = spcloaderId;
    loaderScript.type = 'text/javascript';
    loaderScript.async = true;
    loaderScript.src = sdkPath + apiKey + '/loader.js?' + loaderParams;
    loaderScript.charset = 'utf-8';
    var firstScriptTagInDocument = document.getElementsByTagName('script')[0];
    firstScriptTagInDocument.parentNode.insertBefore(loaderScript, firstScriptTagInDocument);
  };
  react_default.a.useEffect(function () {
    setEvents();
    init();
  }, []);
  return null;
};
es_DidomiSDK.propTypes = {
  apiKey: prop_types_default.a.string,
  iabVersion: prop_types_default.a.number,
  noticeId: prop_types_default.a.string,
  platform: prop_types_default.a.string,
  config: prop_types_default.a.object,
  gdprAppliesGlobally: prop_types_default.a.bool,
  onReady: prop_types_default.a.func,
  onConsentChanged: prop_types_default.a.func,
  onNoticeShown: prop_types_default.a.func,
  onNoticeHidden: prop_types_default.a.func,
  onNoticeBackdropclick: prop_types_default.a.func,
  onNoticeClickAgree: prop_types_default.a.func,
  onNoticeClickMoreInfo: prop_types_default.a.func,
  onPreferencesClickAgreeToAll: prop_types_default.a.func,
  onPreferencesClickDisagreeToAll: prop_types_default.a.func,
  onPreferencesClickPurposeAgree: prop_types_default.a.func,
  onPreferencesClickPurposeDisagree: prop_types_default.a.func,
  onPreferencesClickViewVendors: prop_types_default.a.func,
  onPreferencesClickSaveChoices: prop_types_default.a.func,
  onPreferencesClickVendorAgree: prop_types_default.a.func,
  onPreferencesClickVendorDisagree: prop_types_default.a.func,
  onPreferencesClickVendorSaveChoices: prop_types_default.a.func,
  sdkPath: prop_types_default.a.string,
  embedTCFStub: prop_types_default.a.bool
};

// CONCATENATED MODULE: ./src/hooks/use-on-click-outside/useOnClickOutside.js

function useOnClickOutside(ref, handler) {
  var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'mousedown';
  Object(react["useEffect"])(function () {
    var handleClickOutsideWrapper = function handleClickOutsideWrapper(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handler(event);
      }
    };

    document.addEventListener(eventType, handleClickOutsideWrapper);
    return function () {
      document.removeEventListener(eventType, handleClickOutsideWrapper);
    };
  }, [handler, eventType]);
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("WNMA");

// CONCATENATED MODULE: ./src/client/tracking/cookies/getCookieValue.js


var getCookieValue = function getCookieValue(name) {
  var _document$cookie$matc;

  return ((_document$cookie$matc = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')) === null || _document$cookie$matc === void 0 ? void 0 : _document$cookie$matc.pop()) || '';
};
// CONCATENATED MODULE: ./src/client/tracking/didomi/DidomiBanner.jsx










var DidomiBanner_jsx = react_default.a.createElement;


/* eslint-disable dot-notation */








var cookie = js_cookie_default.a.withConverter({
  write: function write(value) {
    return value.replace('%2C', ',');
  }
});

var generateVendorsConsentString = function generateVendorsConsentString(value) {
  var enabledVendorsIds = Object.values(value).filter(function (_ref) {
    var enabled = _ref.enabled;
    return enabled;
  }).map(function (_ref2) {
    var id = _ref2.id;
    return id;
  });
  return enabledVendorsIds.join(',');
}; // eslint-disable-next-line no-promise-executor-return


var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var DidomiBanner_DidomiBanner = function DidomiBanner(_ref3) {
  var optMode = _ref3.optMode;
  var didomi = Object(react["useRef"])();
  var didomiNotice = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      didomiConfig = _useState[0],
      setDidomiConfig = _useState[1];

  var _getConfig = next_config_default()(),
      publicRuntimeConfig = _getConfig.publicRuntimeConfig;

  var apiKey = publicRuntimeConfig.NEXT_PUBLIC_DIDOMI_API_KEY || config_default.a.get('tracking.didomi.apiKey');

  if (!apiKey) {
    console.error('Didomi apiKey is not defined');
  } // Build consent URLs dynamically from current domain
  // This allows the SDK to be served via reverse proxy to bypass adblockers
  // See: https://developers.didomi.io/cmp/web-sdk/serve-didomi-assets-from-your-domain


  var _useState2 = Object(react["useState"])(null),
      consentUrls = _useState2[0],
      setConsentUrls = _useState2[1];

  Object(react["useEffect"])(function () {
    var hostname = window.location.hostname;
    var baseUrl = "https://".concat(hostname);
    setConsentUrls({
      sdkPath: "".concat(baseUrl, "/consent/"),
      apiPath: "".concat(baseUrl, "/consent/api")
    });
  }, []);
  Object(react["useEffect"])(function () {
    if (!consentUrls) {
      return;
    }

    var organizationUserId = getCookieValue('_ga');
    setDidomiConfig({
      organizationUserId: organizationUserId,
      externalConsent: {
        enabled: true
      },
      apiPath: consentUrls.apiPath
    });
  }, [consentUrls]);

  var agreeAndHideNotice = function agreeAndHideNotice() {
    if (didomi.current && optMode === 'opt-out') {
      didomi.current.setUserAgreeToAll();
      didomi.current.notice.hide();
    }
  };

  useOnClickOutside(didomiNotice, agreeAndHideNotice);

  var setUp = function setUp(didomiSDK) {
    didomi.current = didomiSDK;

    if (!getCookieValue(constants["j" /* DIDOMI_VENDOR_CONSENT_COOKIE */])) {
      cookie.set(constants["j" /* DIDOMI_VENDOR_CONSENT_COOKIE */], generateVendorsConsentString(didomiSDK.getCurrentUserStatus().vendors), {
        expires: 180
      });
    }
  };

  var setUpNoticeRef = /*#__PURE__*/function () {
    var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var didomiNoticeElement;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              didomiNoticeElement = document.getElementById('didomi-notice');

              if (didomiNoticeElement) {
                _context2.next = 4;
                break;
              }

              _context2.next = 4;
              return sleep(1000).then( /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                return regenerator_default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        didomiNoticeElement = document.getElementById('didomi-notice');

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 4:
              didomiNotice.current = didomiNoticeElement;

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function setUpNoticeRef() {
      return _ref4.apply(this, arguments);
    };
  }();

  var updateVendorCookie = function updateVendorCookie() {
    if (didomi.current) {
      cookie.set(constants["j" /* DIDOMI_VENDOR_CONSENT_COOKIE */], generateVendorsConsentString(didomi.current.getCurrentUserStatus().vendors), {
        expires: 180
      });
    }
  };

  if (!didomiConfig || !consentUrls) {
    return null;
  }

  return DidomiBanner_jsx(es_DidomiSDK, {
    apiKey: apiKey,
    sdkPath: consentUrls.sdkPath,
    config: didomiConfig,
    onReady: setUp,
    onNoticeShown: setUpNoticeRef,
    onConsentChanged: updateVendorCookie
  });
};
// CONCATENATED MODULE: ./src/client/components/layouts/layout/Layout.jsx










var Layout_jsx = react_default.a.createElement;



































var FooterContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 159).then(__webpack_require__.bind(null, "ByKL")).then(function (m) {
    return m.FooterContainer;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ByKL")];
    },
    modules: ["../footer/FooterContainer"]
  }
});
var NavigationBar = userInfoWrapper(Navigation_Navigation);

var Layout_getLocales = function getLocales(currentLocale, availableLocales) {
  var _config$get;

  var hiddenLocales = ((_config$get = config_default.a.get('featureFlipping.hiddenLocales')) !== null && _config$get !== void 0 ? _config$get : '').split(',').filter(function (l) {
    return l !== currentLocale;
  });
  return omit_default()(availableLocales, hiddenLocales);
};

var PAGE_COUNTER = 'PAGE_COUNTER';
var USER_TYPE = 'userType';
var Layout_Layout = /*#__PURE__*/Object(react["memo"])(function Layout(_ref) {
  var _crisisAlert$link, _crisisAlert$link2;

  var _ref$config = _ref.config,
      cmsConfig = _ref$config === void 0 ? {} : _ref$config,
      disableFooter = _ref.disableFooter,
      disableHeader = _ref.disableHeader,
      className = _ref.className,
      isMicePage = _ref.isMicePage,
      legalInformations = _ref.legalInformations,
      newsletters = _ref.newsletters,
      children = _ref.children;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var availableLocales = appContext.availableLocales,
      defaultLocale = appContext.defaultLocale,
      currentLocale = appContext.locale,
      googleTrackingId = appContext.googleTrackingId;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageId = _usePageContext.pageId;

  var _useRouter = Object(next_router["useRouter"])(),
      asPath = _useRouter.asPath;

  var pathname = new URI_default.a(asPath).pathname();
  var promoBannerRef = Object(react["useRef"])();
  var track = Object(useTracking["a" /* useTracking */])({});
  var userInfo = Object(es["e" /* useSelector */])(userInfo_selectors["a" /* userInfoSelector */]);
  var leadScore = Object(es["e" /* useSelector */])(leadInfo_selector["a" /* getLeadScore */]);
  var tracking = cmsConfig.tracking;
  Object(react["useEffect"])(function () {
    var _userInfo$loyaltyProg;

    var caTracking = {
      connection_status: Object(tracking_api["d" /* userStatus */])(appContext),
      full_visitor_id: appContext.googleTrackingId,
      fidelity_status: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$loyaltyProg = userInfo.loyaltyProgram) === null || _userInfo$loyaltyProg === void 0 ? void 0 : _userInfo$loyaltyProg.status) || '',
      lead_scoring_range: leadScore
    };
    Object(local_storage_api["c" /* setInLocalStorage */])(constants["e" /* CA_TRACKING */], caTracking, {
      ttl: tracking_storage_api["a" /* ONE_HOUR_IN_MS */]
    });
  }, [leadScore]);

  var _useState = Object(react["useState"])(Object(local_storage_api["a" /* getFromLocalStorage */])(PAGE_COUNTER) || 0),
      viewedPageCount = _useState[0],
      setViewedPageCount = _useState[1];

  Object(react["useEffect"])(function () {
    var pageCounter = Object(local_storage_api["a" /* getFromLocalStorage */])(PAGE_COUNTER) || 0;
    Object(local_storage_api["c" /* setInLocalStorage */])(PAGE_COUNTER, pageCounter + 1);
    setViewedPageCount(pageCounter + 1);
  }, [pathname]);
  Object(react["useEffect"])(function () {
    if (googleTrackingId && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('enableUserPersonalization')) {
      var userType = js_cookie_default.a.get(USER_TYPE);

      if (!userType) {
        graphqlClient["a" /* default */].runNoCacheQuery("query {\n          userPersonalization(visitorUuid: \"".concat(googleTrackingId, "\") {\n            template\n          }\n        }"), appContext, {
          requestName: requestDictionary["ab" /* GET_USER_PERSONALIZATION */]
        }).then(function (_ref2) {
          var userPersonalization = _ref2.userPersonalization;
          var inThirtyMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);
          js_cookie_default.a.set(USER_TYPE, userPersonalization.template, {
            expires: inThirtyMinutes
          });
          track({
            event: 'userTypeReady',
            userType: userPersonalization.template
          });
        });
      }
    }
  }, [pathname, googleTrackingId]);
  var navigationBar = cmsConfig.navigationBar,
      _cmsConfig$promotiona = cmsConfig.promotionalBanner,
      promotionalBanner = _cmsConfig$promotiona === void 0 ? {
    enabled: false
  } : _cmsConfig$promotiona,
      faceting = cmsConfig.faceting,
      crisisAlert = cmsConfig.crisisAlert;
  Object(i18n["a" /* addTranslationKeys */])(cmsConfig);
  var navLanguage = {
    currentLocale: currentLocale,
    defaultLocale: defaultLocale,
    locales: Layout_getLocales(currentLocale, availableLocales)
  };
  var isConfirmation = pathname === '/confirmation';
  var shouldDisplayPromoBanner = !disableHeader && !isMicePage && promotionalBanner.enabled && !isConfirmation;
  var promotionalBannerLink = {
    url: promotionalBanner.link
  };
  return Layout_jsx(react["Fragment"], null, tracking.optMode !== 'off' && Layout_jsx(DidomiBanner_DidomiBanner, {
    optMode: tracking.optMode
  }), shouldDisplayPromoBanner && Layout_jsx(PromotionalBanner_PromotionalBanner, {
    className: Object(classnames_utils["a" /* classnames */])('relative z-6', "text-".concat(promotionalBanner.color)),
    callToAction: promotionalBanner.callToAction,
    closeLabel: promotionalBanner.closeButtonLabel,
    description: promotionalBanner.description,
    disabledPages: promotionalBanner.disabledPages,
    enabledPages: promotionalBanner.enabledPages,
    link: promotionalBannerLink,
    title: promotionalBanner.title,
    ref: promoBannerRef
  }), Layout_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('Layout relative table w-full table-fixed', className)
  }, !disableHeader ? Layout_jsx(react_default.a.Fragment, null, Layout_jsx(Pancakes_Pancakes, {
    key: 'pancakes-' + pageId
  }, Layout_jsx(PriceRemoteMaximumFavoriteToaster_PriceRemoteMaximumFavoriteToaster, null), Layout_jsx(ResortNotBookingToasterContainer_ResortNotBookingToasterContainer, null), Layout_jsx(CrisisAlertLinkBanner_CrisisAlertLinkBanner, {
    alertDate: (crisisAlert === null || crisisAlert === void 0 ? void 0 : crisisAlert.enabled) ? crisisAlert.alertDate : '',
    className: "ms-auto",
    linkLabel: crisisAlert === null || crisisAlert === void 0 ? void 0 : (_crisisAlert$link = crisisAlert.link) === null || _crisisAlert$link === void 0 ? void 0 : _crisisAlert$link.label,
    linkUrl: crisisAlert === null || crisisAlert === void 0 ? void 0 : (_crisisAlert$link2 = crisisAlert.link) === null || _crisisAlert$link2 === void 0 ? void 0 : _crisisAlert$link2.url
  }), Layout_jsx(FTCToasterContainer_FTCToasterContainer, null)), Layout_jsx("div", {
    className: "absolute inset-x-0 top-0"
  }, pathname === '/confirmation' || pathname === '/option/c/200' || pathname === '/option/c/400' ? Layout_jsx(ConfirmationHeader_ConfirmationHeader, {
    contact: navigationBar.contact
  }) : Layout_jsx(NavigationBar, {
    facetingSuggestedRequests: faceting === null || faceting === void 0 ? void 0 : faceting.suggestedRequests,
    language: navLanguage,
    navigation: navigationBar,
    promoBannerRef: promoBannerRef
  }))) : null, children, !disableFooter && (['/confirmation', '/option/c/200', '/option/c/400'].includes(pathname) ? Layout_jsx(SiteContainer["a" /* SiteContainer */], null, Layout_jsx(BookingFooter["a" /* BookingFooter */], {
    footer: cmsConfig.footer,
    className: "mt-100"
  })) : Layout_jsx(FooterContainer, {
    config: cmsConfig,
    legalInformations: legalInformations,
    newsletters: newsletters,
    viewedPageCount: viewedPageCount
  }))), Layout_jsx(DataScore_DataScore, null), Layout_jsx("div", {
    id: Portal_constants["e" /* TOASTERS */]
  }));
});
// CONCATENATED MODULE: ./src/client/components/layouts/layout/Layout.query.js


var Layout_query_fetchLayoutConfig = function fetchLayoutConfig(appContext) {
  return graphqlClient["a" /* default */].runQuery('', appContext, {
    requestName: requestDictionary["f" /* CORE_LAYOUT */],
    queryId: requestDictionary["f" /* CORE_LAYOUT */]
  });
};
// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");
var domains_service_dist_default = /*#__PURE__*/__webpack_require__.n(domains_service_dist);

// EXTERNAL MODULE: ./src/client/components/third-party/thirdParty.utils.js
var thirdParty_utils = __webpack_require__("kD1E");

// CONCATENATED MODULE: ./src/client/components/third-party/GoogleTagManager.jsx












function GoogleTagManager_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function GoogleTagManager_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GoogleTagManager_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GoogleTagManager_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable vars-on-top */

/* eslint-disable no-var */






 // Constants
// B2C

var GA4_CONTAINER_ID = 'GTM-K4T9XZJP';
var GA4_CONTAINER_ID_SERVER_SIDE = 'GTM-N83KGJBT';
var GA3_CONTAINER_ID = 'GTM-KJ3DSC'; // B2B

var SELLER_GTM_KEY = 'GTM-P9H7QS7';

var GoogleTagManager_getGTMKey = function getGTMKey(_ref) {
  var isSeller = _ref.isSeller,
      isShopping = _ref.isShopping,
      asPath = _ref.asPath;

  // We doing this for compatibility between ga3 and ga4 for new and old shopping
  if (isShopping) {
    var shouldLoadShoppingGA4 = Object(utils["m" /* isPBFLandingPage */])(asPath) || Object(utils["n" /* isQuotationLandingPage */])(asPath) || Object(utils["o" /* isQuotationSuccessPage */])(asPath);

    if (shouldLoadShoppingGA4) {
      return GA4_CONTAINER_ID;
    }

    return GA3_CONTAINER_ID;
  }

  if (isSeller) {
    return SELLER_GTM_KEY;
  }

  return GA4_CONTAINER_ID;
};

var buildTrackingContext = function buildTrackingContext(context, queryParams) {
  // $FlowFixMe
  var isFromCmta = queryParams.isFromCmta === 'true';
  var isSellerInCustomerAccount = !!queryParams.cxo_neolid;
  var isSeller = context.isSeller;
  var isFromSeller = queryParams.isFromSeller === 'true';
  return {
    isSeller: isSeller || isFromCmta || isSellerInCustomerAccount || isFromSeller
  };
};

function addGTMScript(newKey) {
  var _document$body;

  var noscript = document.createElement('noscript'); // Dynamically add an iframe

  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  iframe.width = '0';
  iframe.height = '0';
  iframe.src = "https://www.googletagmanager.com/ns.html?id=".concat(newKey);
  noscript.appendChild(iframe);
  (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.insertBefore(noscript, document.body.firstChild); // Function to dynamically load the GTM script
  // eslint-disable-next-line max-params

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0];
    var j = d.createElement(s);
    var dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'clubMedLayer', newKey);
}

function addGTMScriptServerSide(gtmConfig) {
  var _document$body2;

  var noscript = document.createElement('noscript'); // Dynamically add an iframe

  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  iframe.width = '0';
  iframe.height = '0';
  iframe.src = "https://www.clubmed.".concat(gtmConfig.tld, "/metrics/ns.html?id=").concat(GA4_CONTAINER_ID_SERVER_SIDE);
  noscript.appendChild(iframe);
  (_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : _document$body2.insertBefore(noscript, document.body.firstChild); // Function to dynamically load the GTM script
  // eslint-disable-next-line max-params

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0];
    var j = d.createElement(s);
    var dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = "https://www.clubmed.".concat(gtmConfig.tld, "/metrics/").concat(gtmConfig.id, ".js?aw=") + i.replace(/^GTM-/, '') + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'clubMedLayer', GA4_CONTAINER_ID_SERVER_SIDE);
}

var GoogleTagManager_GoogleTagManager = function GoogleTagManager() {
  var _useRouter = Object(next_router["useRouter"])(),
      queryParams = _useRouter.query,
      asPath = _useRouter.asPath;

  var context = Object(ReactAppContext["c" /* useAppContext */])();

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageType = _usePageContext.pageType;

  var siteSection = Object(utils["i" /* getScopeSiteSection */])({
    pageType: pageType
  });
  var locale = context.locale;
  var trackingContext = buildTrackingContext(context, queryParams);

  var _getConfigWithNoThird = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'tracking',
    locale: locale,
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled;

  Object(react["useEffect"])(function () {
    var _window$clubMedLayer, _window$clubMedLayer2;

    // KEEP THIS IN PLACE !  Caution: This clears the entire dataLayer But Necessary to avoid duplicate GTM tags
    (_window$clubMedLayer = window.clubMedLayer) === null || _window$clubMedLayer === void 0 ? void 0 : _window$clubMedLayer.push((_window$clubMedLayer2 = window.clubMedLayer) === null || _window$clubMedLayer2 === void 0 ? void 0 : _window$clubMedLayer2.filter(function (item) {
      return !!item['gtm.start'];
    })); // Update GTM key based on site section

    var newKey = GoogleTagManager_getGTMKey(GoogleTagManager_objectSpread(GoogleTagManager_objectSpread({}, trackingContext), {}, {
      isShopping: siteSection === 'shopping',
      asPath: asPath
    }));
    var isKeyLoaded = document.querySelector("script[src*=\"googletagmanager.com/gtm.js?id=".concat(newKey, "\"]"));
    var gtmConfig = domains_service_dist_default.a.getGTMConfig(locale);

    if (newKey && !isKeyLoaded && enabled) {
      if (gtmConfig && !trackingContext.isSeller) {
        addGTMScriptServerSide(gtmConfig);
      }

      addGTMScript(newKey);
    }
  }, [siteSection]);
  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/PriorityThirdPartyScripts.jsx
var PriorityThirdPartyScripts_jsx = react_default.a.createElement;


var PriorityThirdPartyScripts = /*#__PURE__*/Object(react["memo"])(function () {
  return PriorityThirdPartyScripts_jsx(GoogleTagManager_GoogleTagManager, null);
});
// EXTERNAL MODULE: ./src/client/components/utils/ab-tasty/abTasty.utils.js
var abTasty_utils = __webpack_require__("FtaI");

// CONCATENATED MODULE: ./src/client/components/third-party/AbTasty.jsx
var AbTasty_jsx = react_default.a.createElement;


var script = {
  __html: "\ndocument.addEventListener('cm_app_mounting', function () {\n  if (window.ABTasty && window.ABTasty.rollbackModifications) {\n    window.ABTasty.rollbackModifications();\n  }\n});\ndocument.addEventListener('cm_app_mounted', function () {\n  if (window.ABTasty && window.ABTasty.applyModifications) {\n    window.ABTasty.applyModifications();\n  }\n});\n"
};
var AbTasty_AbTasty = function AbTasty() {
  var _useAbTasty = Object(abTasty_utils["e" /* useAbTasty */])(),
      abTastyScriptUrl = _useAbTasty.abTastyScriptUrl,
      isAbTastyActive = _useAbTasty.isAbTastyActive;

  if (!isAbTastyActive) {
    return null;
  }

  return AbTasty_jsx(react["Fragment"], null, AbTasty_jsx("script", {
    key: "abtasty-lib",
    async: true,
    defer: true,
    src: abTastyScriptUrl
  }), AbTasty_jsx("script", {
    key: "abtasty-inline-script"
    /* eslint-disable-next-line react/no-danger */
    ,
    dangerouslySetInnerHTML: script
  }));
};
// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// CONCATENATED MODULE: ./src/client/components/third-party/ContentSquare.jsx
var ContentSquare_jsx = react_default.a.createElement;






var ContentSquare_ContentSquare = function ContentSquare() {
  var _useRouter = Object(next_router["useRouter"])(),
      queryParams = _useRouter.query;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isSeller = _useAppContext.isSeller,
      locale = _useAppContext.locale;

  var _getConfigWithNoThird = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'tracking',
    locale: locale,
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled,
      contentsquare = _getConfigWithNoThird.contentsquare;

  if (!Object(contextUtils["f" /* isStrictlyProductionEnv */])(config_default.a) && !Object(contextUtils["h" /* isStrictlyTestEnv */])(config_default.a) && !isSeller && enabled && contentsquare.devId) {
    return ContentSquare_jsx("script", {
      key: "contentsquare-lib",
      async: true,
      defer: true,
      src: "//t.contentsquare.net/uxa/".concat(contentsquare.devId, ".js"),
      type: "text/javascript",
      charSet: "utf-8"
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Hosting.jsx
var Hosting_jsx = react_default.a.createElement;


var Hosting_Hosting = function Hosting() {
  var _appConfig$get = config_default.a.get('hosting'),
      pixel = _appConfig$get.pixel;

  if (pixel.enabled) {
    return Hosting_jsx("img", {
      src: "https://s3.cn-north-1.amazonaws.com.cn/nscn/pixel.png",
      alt: "",
      width: "1",
      height: "1"
    });
  }

  return null;
};
// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// CONCATENATED MODULE: ./src/client/components/third-party/Udesk.jsx


var Udesk_jsx = react_default.a.createElement;





var Udesk_Udesk = function Udesk() {
  var _useRouter = Object(next_router["useRouter"])(),
      queryParams = _useRouter.query;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isSeller = _useAppContext.isSeller,
      locale = _useAppContext.locale;

  var _getConfigWithNoThird = Object(thirdParty_utils["a" /* getConfigWithNoThirdPartySupport */])({
    name: 'udesk',
    locale: locale,
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled,
      code = _getConfigWithNoThird.code,
      link = _getConfigWithNoThird.link,
      scriptUrl = _getConfigWithNoThird.scriptUrl;

  if (!isSeller && enabled && code) {
    return Udesk_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n(function(a,h,c,b,f,g){a[\"UdeskApiObject\"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})(window,document,\"script\",\"".concat(scriptUrl, "\",\"ud\");\nud({\n  \"code\": \"").concat(code, "\",\n  \"link\": \"").concat(link, "\",\n  \"isInvite\": true,\n  \"mode\": \"inner\",\n  \"color\": \"#307AE8\",\n  \"panel\": {\n    \"css\" : {\n      \"left\": \"4%\",\n    },\n  },\n  \"pos_flag\": \"slb\",\n  \"language\": \"").concat(locale === locale_constants["a" /* LOCALES */].ZH_CN ? 'zh-cn' : 'en-us', "\",\n  \"mobile\": {\n    \"mode\": \"inner\",\n    \"color\": \"#307AE8\",\n    \"pos_flag\": \"clb\",\n  }\n});\n    ")
      }
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Cedexis.jsx
var Cedexis_jsx = react_default.a.createElement;



var Cedexis_Cedexis = function Cedexis() {
  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      isSeller = _useAppContext.isSeller;

  var performance = config_default.a.get('performance');

  if (!isSeller && performance.cedexis.enabled) {
    return Cedexis_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\n(function(e,c,a,g,f){function d(){var b=c.createElement(\"script\");b.async=!0;\n  b.src=\"//radar.cedexis.com/1/10015/radar.js\";c.body.appendChild(b)}\n  (function(){for(var b=[/\bMSIE (5|6)/i],a=b.length;a--;)if(b[a]\n    .test(navigator.userAgent))return!1;return!0})()\n  &&(\"complete\"!==c.readyState?(a=e[a])?a(f,d,!1):(a=e[g])&&a(\"on\"+f,d):d())})\n(window,document,\"addEventListener\",\"attachEvent\",\"load\");\n        "
      }
    });
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/Sentry.jsx

var Sentry_jsx = react_default.a.createElement;



var Sentry_Sentry = function Sentry() {
  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var appVersion = config_default.a.get('APP_VERSION');
  var deploymentEnv = config_default.a.get('DEPLOYMENT_ENV');

  var _appConfig$get = config_default.a.get('clientError.sentry'),
      enabled = _appConfig$get.enabled,
      url = _appConfig$get.url,
      dsn = _appConfig$get.dsn;

  if (enabled && url && dsn) {
    return Sentry_jsx(react["Fragment"], null, Sentry_jsx("script", {
      key: "sentry-lib",
      async: true,
      defer: true,
      src: url,
      crossOrigin: "anonymous"
    }), Sentry_jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "\nif (window.Sentry) {\n  Sentry.init({\n    dsn: '".concat(dsn, "',\n    environment: '").concat(deploymentEnv, "',\n    release: '").concat(appVersion, "',\n  });\n  Sentry.configureScope(function (scope) {\n    scope.setExtra('locale', '").concat(locale, "');\n    scope.setTag('locale', '").concat(locale, "');\n  });\n}\n          ")
      }
    }));
  }

  return null;
};
// CONCATENATED MODULE: ./src/client/components/third-party/ThirdPartyScripts.jsx
var ThirdPartyScripts_config$get, _config$get2;

var ThirdPartyScripts_jsx = react_default.a.createElement;








var DELAY_LOAD = (ThirdPartyScripts_config$get = config_default.a.get('thirdParty.delayLoad')) !== null && ThirdPartyScripts_config$get !== void 0 ? ThirdPartyScripts_config$get : false;
var DELAY_TIMER = (_config$get2 = config_default.a.get('thirdParty.timer')) !== null && _config$get2 !== void 0 ? _config$get2 : 5000;
var LOAD_OPTIONS = {
  once: true,
  passive: true
};
var ThirdPartyScripts = /*#__PURE__*/Object(react["memo"])(function () {
  var _useState = Object(react["useState"])(DELAY_LOAD),
      delaying = _useState[0],
      setDelaying = _useState[1];

  Object(react["useEffect"])(function () {
    if (!DELAY_LOAD || false) {
      return;
    }

    var timeoutHandler = function timeoutHandler() {
      setDelaying(false);
    };

    var timeout = null;

    var loadHandler = function loadHandler() {
      timeout = setTimeout(timeoutHandler, DELAY_TIMER);
    };

    window.addEventListener('load', loadHandler, LOAD_OPTIONS);
    return function () {
      window.removeEventListener('load', loadHandler, LOAD_OPTIONS);
      clearTimeout(timeout);
    };
  }, []);

  if (delaying) {
    return null;
  }

  return ThirdPartyScripts_jsx(react["Fragment"], null, ThirdPartyScripts_jsx(Udesk_Udesk, null), ThirdPartyScripts_jsx(ContentSquare_ContentSquare, null), ThirdPartyScripts_jsx(Hosting_Hosting, null), ThirdPartyScripts_jsx(AbTasty_AbTasty, null), ThirdPartyScripts_jsx(Cedexis_Cedexis, null), ThirdPartyScripts_jsx(Sentry_Sentry, null));
});
// EXTERNAL MODULE: ./src/client/components/widgets/cookie-warning/constants.js
var cookie_warning_constants = __webpack_require__("+LXU");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("hqKg");

// CONCATENATED MODULE: ./src/client/store/global-loader/storeHelper.js


var globalLoaderSelector = function globalLoaderSelector(_ref) {
  var globalLoader = _ref.globalLoader;
  return globalLoader || {};
};

var getShouldDisplayGlobalLoader = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref2) {
  var shouldDisplay = _ref2.shouldDisplay;
  return shouldDisplay;
});
var getGlobalLoaderLabel = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref3) {
  var label = _ref3.label;
  return label;
});
var getIsNavigation = Object(reselect_lib["createSelector"])(globalLoaderSelector, function (_ref4) {
  var isNavigation = _ref4.isNavigation;
  return isNavigation;
});

// CONCATENATED MODULE: ./src/client/components/widgets/loading/Loading.jsx
var Loading_jsx = react_default.a.createElement;











var Loading_Loading = function Loading() {
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var shouldDisplay = Object(es["e" /* useSelector */])(getShouldDisplayGlobalLoader);
  var isNavigation = Object(es["e" /* useSelector */])(getIsNavigation);
  var isPreviousNavigation = Object(usePrevious["a" /* usePrevious */])(isNavigation);
  var previousShouldDisplay = Object(usePrevious["a" /* usePrevious */])(shouldDisplay);
  var label = Object(es["e" /* useSelector */])(getGlobalLoaderLabel);

  var _useState = Object(react["useState"])(0),
      bodyScrollTop = _useState[0],
      setBodyScrollTop = _useState[1];

  Object(react["useEffect"])(function () {
    if (shouldDisplay) {
      setBodyScrollTop(Object(stopScroll["a" /* getTopScrollValue */])(document));
      Object(stopScroll["b" /* lockBodyScroll */])(document);
    } else if (previousShouldDisplay) {
      // prevent removing the body locker when hydrate from server (there is no previousShouldDisplay)
      if (isPreviousNavigation) {
        // in case of navigation to another page we do not have to scroll to the last position
        Object(stopScroll["c" /* resumeBodyScroll */])(document, 0);
      } else {
        Object(stopScroll["c" /* resumeBodyScroll */])(document, bodyScrollTop);
      }

      setBodyScrollTop(0);
    }
  }, [shouldDisplay]);

  if (!isAppMounted || !shouldDisplay) {
    return null;
  }

  return Loading_jsx(Portal["a" /* default */], {
    name: Portal_constants["d" /* OVER_BOT */]
  }, Loading_jsx("div", {
    className: "bg-white/90 fixed flex flex-col inset-0 items-center justify-center z-4",
    id: "loading"
  }, Loading_jsx(Spinner["a" /* Spinner */], {
    iconName: icons["a" /* ICONS */].TRIDENT1
  }), Loading_jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    label: label
  })));
};
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/components/widgets/seller/InitializeSellerInfos.jsx




var sellerInfoQuery = "{\n  sellerInfo {\n    email\n    salesmanID\n  }\n}";
var InitializeSellerInfos_InitializeSellerInfos = function InitializeSellerInfos(_ref) {
  var appContext = _ref.appContext;
  var isCmta = appContext.isCmta,
      cmta = appContext.cmta,
      isIndirectCxo = appContext.isIndirectCxo,
      cxoQueryParams = appContext.cxoQueryParams; // initializes CMTA and CxoIndirect email & salesmanID in Redux store

  var sellerInfo = Object(es["e" /* useSelector */])(function (state) {
    return state.seller.sellerInfo;
  });
  var dispatch = Object(es["d" /* useDispatch */])();
  Object(react["useEffect"])(function () {
    if ((isCmta || isIndirectCxo) && (!sellerInfo.email || !sellerInfo.salesmanID)) {
      // if sellerInfo is not initialized in the store
      var email = cmta.email,
          cmtaSalesmanID = cmta.salesmanID;
      var salesmanID = isCmta ? cmtaSalesmanID : cxoQueryParams.salesman_code;

      if (email || salesmanID) {
        // no need to make a call if we have sellerInfo in the context
        dispatch({
          type: sellerInfoReducer["a" /* GET_SELLER_INFOS */],
          payload: {
            sellerInfo: {
              email: email,
              salesmanID: salesmanID
            }
          }
        });
      } else {
        graphqlClient["a" /* default */].runNoCacheQuery(sellerInfoQuery, appContext).then(function (data) {
          dispatch({
            type: sellerInfoReducer["a" /* GET_SELLER_INFOS */],
            payload: data
          });
        });
      }
    }
  }, []);
  return null;
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var react_collapse_lib = __webpack_require__("3OwS");

// CONCATENATED MODULE: ./src/client/components/widgets/three-sixty/ThreeSixty.jsx



var ThreeSixty_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */





var ThreeSixty_ThreeSixty = function ThreeSixty(_ref) {
  var clientName = _ref.clientName,
      lastVisitsLabel = _ref.lastVisitsLabel,
      lastVisits = _ref.lastVisits;

  var _useState = Object(react["useState"])(false),
      isOpened = _useState[0],
      toggleThreeSixty = _useState[1];

  return ThreeSixty_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('fixed top-[25%] z-4 mx-15 bg-gradient-to-br from-[#235472] to-[#a6dade] p-2 shadow transition-rounded duration-250 ease-in', {
      'rounded-pill': !isOpened,
      rounded: isOpened
    })
  }, ThreeSixty_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('relative min-h-60 bg-white p-20 transition-all duration-250 ease-in', {
      'w-100 rounded-pill': !isOpened,
      'w-[256px] rounded-12': isOpened
    }),
    "data-testid": "ThreeSixty-content",
    onClick: function onClick() {
      return toggleThreeSixty(!isOpened);
    }
  }, ThreeSixty_jsx("div", {
    className: "flex h-24 items-center"
  }, ThreeSixty_jsx("svg", {
    className: "ThreeSixty-cxoLogo block h-auto w-56 shrink-0",
    width: "130px",
    height: "60px",
    viewBox: "0 0 130 60",
    version: "1.1"
  }, ThreeSixty_jsx("defs", null, ThreeSixty_jsx("linearGradient", {
    x1: "44.7159195%",
    y1: "50%",
    x2: "75.035875%",
    y2: "50%",
    id: "linearGradient-1"
  }, ThreeSixty_jsx("stop", {
    stopColor: "#235472",
    offset: "0%"
  }), ThreeSixty_jsx("stop", {
    stopColor: "#A6DADE",
    offset: "100%"
  }))), ThreeSixty_jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, ThreeSixty_jsx("g", {
    id: "10-B2B/Desktop/01-1_CXO",
    transform: "translate(0.000000, -403.000000)"
  }, ThreeSixty_jsx("g", {
    id: "Group-2",
    transform: "translate(0.000000, 403.160714)"
  }, ThreeSixty_jsx("path", {
    d: "M71.2064596,29.6873674 L85.6177833,42.8646077 C90.4453086,46.8799323 94.6046143,49.5481129 100.552511,49.5481129 C111.547972,49.5481129 120.461554,40.7137316 120.461554,29.81597 C120.461554,18.9182085 111.547972,10.0838272 100.552511,10.0838272 C94.4637587,10.0838272 89.1245616,12.6929064 85.219571,16.8145493 L71.2064596,29.6873674 Z M64.84932,23.3302278 L77.7054691,11.0848976 C84.1408993,4.71799111 91.2565906,0.502982484 100.390844,0.502982484 C116.691308,0.502982484 129.905444,13.7171187 129.905444,30.0175819 C129.905444,46.318045 116.691308,58.2393852 100.390844,58.2393852 C90.5625021,58.2393852 85.6177833,56.1114281 76.0119282,47.4843048 L64.3463874,36.5474396 L55.5310792,45.6122108 L48.7298497,38.8109814 L57.5340046,29.7350568 L47.9798065,20.32894 L54.9139193,13.3948271 L64.84932,23.3302278 Z M49.9291515,8.41005929 L42.9950386,15.3441722 C39.4697613,12.110536 34.7699391,10.0838272 29.6091556,10.0838272 C18.66937,10.0838272 9.80092149,19.0053746 9.80092149,29.9451602 C9.80092149,40.8849458 18.66937,48.7579875 29.6091556,48.7579875 C34.7678471,48.7579875 39.4659509,47.7813842 42.990751,44.5500801 L49.7919804,51.3513095 C44.5137473,56.3000378 37.4153607,59.3305694 29.6091556,59.3305694 C13.3086924,59.3305694 0.0945561695,46.1164332 0.0945561695,29.81597 C0.0945561695,13.5155069 13.3086924,0.301370651 29.6091556,0.301370651 C37.483187,0.301370651 44.6370464,3.38479421 49.9291515,8.41005929 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), ThreeSixty_jsx("path", {
    d: "M104.611739,34.6884892 L102.092025,37.2082036 L104.611739,39.7279181 L107.131453,37.2082036 L104.611739,34.6884892 Z M106.214867,18.7758278 C106.099844,18.2043091 104.726762,19.005873 101.750551,21.6370156 C102.893589,22.8950756 103.468702,22.2085343 104.496716,21.8670609 C105.29828,23.2401435 105.528326,29.764083 100.607514,31.7122788 C100.722537,25.1883392 100.837559,18.2043091 100.837559,18.2043091 C100.722537,18.0892865 100.607514,18.0892865 100.492491,18.0892865 C99.1194087,18.3193317 96.7147169,20.6090009 94.8815438,22.6686248 C95.9131529,24.3867753 97.1712129,22.7836474 98.2028221,22.4385795 C98.2028221,22.6686248 97.9727768,27.4744139 98.0877995,32.3988201 C93.0519651,32.7402935 93.853529,22.4385795 94.0799798,21.1805196 C94.1950025,20.0374822 90.8737241,22.4385795 89.1591681,23.9266848 C89.7306868,24.8432713 90.4172281,24.7282487 91.3338146,24.3831808 C90.9887468,28.9625191 94.1950025,33.1967896 98.0877995,33.0817669 C98.2028221,37.8911505 98.7743408,42.4668943 100.147423,42.8119622 C100.377469,42.8119622 100.492491,38.0025787 100.603919,32.5102483 C109.651168,29.764083 106.214867,18.7758278 106.214867,18.7758278 Z",
    id: "Shape",
    fill: "#005589",
    fillRule: "nonzero"
  }))))), isOpened && ThreeSixty_jsx(Icon["a" /* Icon */], {
    className: "ms-auto cursor-pointer",
    name: icons["a" /* ICONS */].CROSS,
    width: "16px"
  })), ThreeSixty_jsx(react_collapse_lib["UnmountClosed"], {
    theme: {
      content: 'w-[214px]'
    },
    isOpened: isOpened
  }, ThreeSixty_jsx("div", {
    className: "py-25 text-20",
    "data-testid": "ThreeSixty-clientName"
  }, clientName), ThreeSixty_jsx("div", {
    className: "pb-15 text-14 text-black"
  }, lastVisitsLabel), ThreeSixty_jsx("div", {
    className: "space-y-10"
  }, lastVisits.map(function (lastVisit, index) {
    return ThreeSixty_jsx("div", {
      key: lastVisit.name + index,
      className: "flex-end flex",
      "data-testid": "ThreeSixty-lastVisit"
    }, ThreeSixty_jsx("div", null, lastVisit.name), ThreeSixty_jsx("div", {
      className: "whitespace-nowrap"
    }, ThreeSixty_jsx("span", null, "\xA0-\xA0"), lastVisit.category.join(' / ')));
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/three-sixty/ThreeSixtyContainer.jsx




























var ThreeSixtyContainer_jsx = react_default.a.createElement;


function ThreeSixtyContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ThreeSixtyContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ThreeSixtyContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ThreeSixtyContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ThreeSixtyContainer_createSuper(Derived) { var hasNativeReflectConstruct = ThreeSixtyContainer_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ThreeSixtyContainer_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }








var ThreeSixtyContainer_ThreeSixtyContainer = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(ThreeSixtyContainer, _PureComponent);

  var _super = ThreeSixtyContainer_createSuper(ThreeSixtyContainer);

  function ThreeSixtyContainer(props, context) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ThreeSixtyContainer);

    _this = _super.call(this, props, context);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "cxoMainContactId", void 0);

    var _URI$search = new URI_default.a(dist["windowWrapper"].getLocation() || '').search(true),
        cxoMainContactId = _URI$search.cxo_primarycontact,
        _URI$search$cxo_villa = _URI$search.cxo_village,
        cxoLastResorts = _URI$search$cxo_villa === void 0 ? [] : _URI$search$cxo_villa; // when there is always one village it's not an array so we need to force it


    var arrayCxoLastResorts = Array.prototype.concat(cxoLastResorts);
    _this.cxoMainContactId = cxoMainContactId;
    _this.state = {
      i18n: null,
      cxoMainContact: null,
      cxoLastResorts: arrayCxoLastResorts.map(function (resort) {
        var _resort$split = resort.split(' '),
            _resort$split2 = Object(slicedToArray["a" /* default */])(_resort$split, 2),
            resortId = _resort$split2[0],
            roomCategories = _resort$split2[1];

        return {
          id: resortId,
          name: resortId,
          category: roomCategories.split(',')
        };
      }),
      shouldRender: Object(sellerUtils["f" /* isSeller */])(context) && cxoMainContactId && cxoLastResorts.length > 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(ThreeSixtyContainer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _yield$graphQLClient$, resorts, config, profile;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.state.shouldRender) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return graphqlClient["a" /* default */].runNoCacheQuery("{\n        resorts(resortIds: [\"".concat(this.state.cxoLastResorts.map(function (_ref) {
                  var id = _ref.id;
                  return id;
                }).join('","'), "\"]) {\n          id\n          name\n        }\n        config {\n          booking {\n            cxo {\n              v360 {\n                resortsAndRooms\n              }\n            }\n          }\n        }\n        profile(userId: \"").concat(this.cxoMainContactId, "\", throw401Error: true) {\n          firstName\n          lastName\n        }\n    }"), this.context);

              case 5:
                _yield$graphQLClient$ = _context.sent;
                resorts = _yield$graphQLClient$.resorts;
                config = _yield$graphQLClient$.config;
                profile = _yield$graphQLClient$.profile;
                this.setState({
                  i18n: config,
                  cxoMainContact: "".concat(profile.firstName, " ").concat(profile.lastName),
                  cxoLastResorts: this.state.cxoLastResorts.map(function (resort) {
                    return ThreeSixtyContainer_objectSpread(ThreeSixtyContainer_objectSpread({}, resort), {}, {
                      name: get_default()(resorts.find(function (_ref2) {
                        var id = _ref2.id;
                        return id === resort.id;
                      }), 'name', resort.id)
                    });
                  }),
                  shouldRender: true
                });
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](2);
                Object(sellerUtils["e" /* handle401GraphqlErrorSeller */])(_context.t0, this.context);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 12]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.state.shouldRender || !this.state.cxoMainContact) {
        return null;
      }

      return ThreeSixtyContainer_jsx(ThreeSixty_ThreeSixty, {
        clientName: this.state.cxoMainContact,
        lastVisitsLabel: get_default()(this.state.i18n, 'booking.cxo.v360.resortsAndRooms') // $FlowFixMe
        ,
        lastVisits: this.state.cxoLastResorts
      });
    }
  }]);

  return ThreeSixtyContainer;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(ThreeSixtyContainer_ThreeSixtyContainer, "contextType", ReactAppContext["a" /* B2CAppContext */]);
// EXTERNAL MODULE: ./src/client/context/createOrUpdateAppContext.js
var createOrUpdateAppContext = __webpack_require__("LamU");

// EXTERNAL MODULE: ./src/client/context/ErrorBoundary.jsx
var ErrorBoundary = __webpack_require__("oG87");

// EXTERNAL MODULE: ./src/errors/clientErrorHandler.js
var clientErrorHandler = __webpack_require__("aPQG");

// EXTERNAL MODULE: ./src/server/context/createAppContextFromReq.js + 2 modules
var createAppContextFromReq = __webpack_require__("xb8T");

// CONCATENATED MODULE: ./src/server/context/patchAppContext.js








var getPathname = function getPathname(ctx) {
  if (typeof ctx.asPath === 'string') {
    return ctx.asPath;
  }

  if (typeof ctx.resolvedUrl === 'string') {
    return ctx.resolvedUrl;
  }

  return '';
};

var patchAppContextUrl = function patchAppContextUrl(ctx) {
  var _req$get;

  var req = ctx.req;
  var host = (_req$get = req.get('host')) !== null && _req$get !== void 0 ? _req$get : '';
  var baseUrl = "".concat(req.protocol, "://").concat(host, "/");
  var pathname = getPathname(ctx);
  var url = new URL(pathname, baseUrl);
  var originalUrl = url.toString();
  return {
    originalUrl: originalUrl
  };
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omitBy.js
var omitBy = __webpack_require__("jq/l");
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/merge.js
var merge = __webpack_require__("H8sf");
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isInteger.js
var isInteger = __webpack_require__("RYcy");
var isInteger_default = /*#__PURE__*/__webpack_require__.n(isInteger);

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// EXTERNAL MODULE: ./src/utils/ple-utils/cookies.js
var cookies = __webpack_require__("H6pA");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// CONCATENATED MODULE: ./src/client/store/getInitialReduxState.client.js















function getInitialReduxState_client_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function getInitialReduxState_client_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? getInitialReduxState_client_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : getInitialReduxState_client_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}















var LOCAL_STORAGE_STATE_KEY = 'state';
/**
 * Handle legacy state saved as a string
 * Remove completly after some time in production (~6 months ?)
 */

function parse(state) {
  if (typeof state === 'string') {
    return JSON.parse(state);
  }

  return state;
}

function stateFromLocalStorage(locale) {
  var serializedState = Object(local_storage_api["a" /* getFromLocalStorage */])("".concat(LOCAL_STORAGE_STATE_KEY, "-").concat(locale));

  if (!serializedState) {
    return {};
  }

  var _merge2 = merge_default()(parse(serializedState), {
    tripInformation: {
      kids: []
    }
  }),
      seller = _merge2.seller,
      kids = _merge2.tripInformation.kids;

  return {
    faceting: {
      kidsValidationState: Object(kidsValidationStateUtils["b" /* getValidationStateFromKids */])(kids)
    },
    tripInformation: {
      kids: kids.map(function (_ref) {
        var birthdate = _ref.birthdate;
        return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]), {}, {
          birthdate: birthdate
        });
      }),
      adults: kids.length > 0 ? Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : []
    },
    seller: seller
  };
}

function stateFromCookies() {
  var encodedUserInfo = js_cookie_default.a.get(cookies["e" /* USER_INFO */]);
  var userInfo = encodedUserInfo ? dist["oidc"].fromUriEncodedState(encodedUserInfo) : {};
  var encodedSellerInfo = js_cookie_default.a.get(cookies["c" /* SELLER_INFO */]);
  var seller = encodedSellerInfo ? {
    seller: {
      sellerInfo: dist["oidc"].fromUriEncodedState(encodedSellerInfo)
    }
  } : {};
  return getInitialReduxState_client_objectSpread({
    userInfo: userInfo
  }, seller);
}

function parseCxoKids(cxoKids) {
  return cxoKids.length <= faceting_constants["H" /* KIDS_NUMBER_MAX_SELLER */] ? cxoKids.map(function (_ref2) {
    var neolid = _ref2.neolid,
        birthdate = _ref2.birthdate;
    return {
      neolid: neolid,
      birthdate: birthdate
    };
  }) : [];
}

function parseCxoAdults(cxoAdults) {
  return cxoAdults.length <= faceting_constants["L" /* MAX_PAX_SELLER */] ? cxoAdults.map(function (_ref3) {
    var neolid = _ref3.neolid,
        birthdate = _ref3.birthdate;
    return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */]), {}, {
      neolid: neolid,
      birthdate: birthdate
    });
  }) : [{}, {}];
}

function parseAdultsQueryParam(adultQueryParam) {
  var nbAdults = parseInt(adultQueryParam, 10);
  var hasAdults = isInteger_default()(nbAdults) && nbAdults <= faceting_constants["L" /* MAX_PAX_SELLER */];
  return hasAdults ? Array(nbAdults).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : [];
}

function stateFromQueryParams() {
  // NOTE: getCxoTravelers() and getNeolids() rely on queryparams
  var neolids = Object(sellerUtils["c" /* getNeolids */])();
  var queryParams = Object(uriUtils["j" /* getQueryParameters */])(dist["windowWrapper"].getLocation()) || {};
  var departureDate = queryParams[uri_constants["g" /* QUERY_DEPARTURE_DATE */]],
      cmtaQueryParam = queryParams[uri_constants["d" /* QUERY_CMTA */]],
      cxoQueryParam = queryParams[uri_constants["e" /* QUERY_CXO_SALES_NETWORK_ID */]];
  var isSeller = typeof cmtaQueryParam !== 'undefined' || Boolean(cxoQueryParam);
  var departureDateIsValid = Object(dateUtils["g" /* isYearsRangeValid */])(queryParams[uri_constants["g" /* QUERY_DEPARTURE_DATE */]], uri_constants["f" /* QUERY_DATE_FORMAT */], faceting_constants["t" /* DEPARTURE_DATE_MAX_DATE */]);
  var kids = Object(facetingUtils["q" /* unserializeKidsFromQueryParam */])(queryParams[uri_constants["j" /* QUERY_KIDS */]], isSeller);
  var adults = parseAdultsQueryParam(queryParams[uri_constants["l" /* QUERY_NUMBER_OF_ADULTS */]]);
  var numberAttendees = kids.length + adults.length;
  var maxPaxByUser = isSeller ? faceting_constants["L" /* MAX_PAX_SELLER */] : faceting_constants["K" /* MAX_PAX */];
  var numberAttendeesNotAllowed = numberAttendees > maxPaxByUser;
  return {
    calendar: {
      selectedMonth: departureDateIsValid ? Object(calendar_helper["c" /* getDefaultSelectedMonth */])(departureDate) : undefined
    },
    // null states are explicitly omitted further
    faceting: {
      activeCustomFacets: Object(facetingUtils["f" /* getActiveFacetsFromQueryParams */])(queryParams, facetingUtils["a" /* customFacetsQueryParamMapping */]),
      activeFacets: Object(facetingUtils["f" /* getActiveFacetsFromQueryParams */])(queryParams, facetingUtils["b" /* facetsQueryParamMapping */]),
      query: {
        label: queryParams[faceting_constants["P" /* QUERY_QUERY_PARAM */]] || ''
      },
      kidsValidationState: Object(kidsValidationStateUtils["b" /* getValidationStateFromKids */])(kids),
      orderByPrice: ['asc', 'desc'].includes(queryParams[faceting_constants["W" /* SORT_BY_PRICE_QUERY_PARAM */]]) ? queryParams[faceting_constants["W" /* SORT_BY_PRICE_QUERY_PARAM */]] : ''
    },
    facetingTripInformation: neolids.length > 0 ? null : undefined,
    seller: neolids.length > 0 ? {
      neolids: neolids
    } : undefined,
    tripCriteria: {
      departureDate: departureDateIsValid ? Object(dateUtils["e" /* getTimestamp */])(departureDate, uri_constants["f" /* QUERY_DATE_FORMAT */]) : undefined,
      duration: parseInt(queryParams[uri_constants["h" /* QUERY_DURATION */]], 10) || null,
      departureCity: queryParams[uri_constants["m" /* QUERY_TRANSPORT */]]
    },
    tripInformation: {
      kids: numberAttendeesNotAllowed ? [] : kids,
      adults: adults.length === 0 && kids.length || numberAttendeesNotAllowed ? Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */]) : adults
    }
  };
}

function getSellerTripInformation() {
  // CMTA sellers
  var queryParams = Object(uriUtils["j" /* getQueryParameters */])(dist["windowWrapper"].getLocation()) || {};
  var cmtaQueryParam = queryParams[uri_constants["d" /* QUERY_CMTA */]];

  if (typeof cmtaQueryParam !== 'undefined') {
    var _stateFromQueryParams = stateFromQueryParams(),
        tripInformation = _stateFromQueryParams.tripInformation;

    return tripInformation;
  } // CXO sellers


  var cxoTravelers = Object(sellerUtils["b" /* getCxoTravelers */])() || [];

  if (cxoTravelers.length === 0) {
    return;
  }

  var numberAttendeesAllowed = cxoTravelers.length > 0 && cxoTravelers.length <= faceting_constants["L" /* MAX_PAX_SELLER */];
  return {
    kids: numberAttendeesAllowed ? parseCxoKids(cxoTravelers.filter(function (_ref4) {
      var isChild = _ref4.isChild;
      return isChild;
    })) : [],
    adults: numberAttendeesAllowed ? parseCxoAdults(cxoTravelers.filter(function (_ref5) {
      var isChild = _ref5.isChild;
      return !isChild;
    })) : Array(adults_constants["a" /* DEFAULT_ADULTS_NB */]).fill(adults_constants["b" /* DEFAULT_ADULT_VALUE */])
  };
}

function cleanTripInfoKids(state) {
  if (!state.tripInformation) {
    return state;
  }

  var _state$tripInformatio = state.tripInformation.kids,
      kids = _state$tripInformatio === void 0 ? [] : _state$tripInformatio;
  var cleanedKids = kids.map(function (_ref6) {
    var neolid = _ref6.neolid,
        birthdate = _ref6.birthdate,
        _ref6$childcareInclud = _ref6.childcareIncluded,
        childcareIncluded = _ref6$childcareInclud === void 0 ? false : _ref6$childcareInclud;
    return {
      neolid: neolid,
      birthdate: birthdate,
      childcareIncluded: childcareIncluded
    };
  });
  return getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state), {}, {
    tripInformation: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.tripInformation), {}, {
      kids: cleanedKids
    })
  });
}

function getInitialReduxState(initialState, locale) {
  var state = getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, initialState), stateFromLocalStorage(locale)), stateFromCookies()); // NOTE: With merge() behavior, subvalues that are undefined won't override existing values
  // ie: merge({ a: 1, b: 2 }, { a: undefined, b: null }) returns { a: 1, b: null }


  state = merge_default()({}, state, stateFromQueryParams()); // for seller erase tripInformation

  state = getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state), {}, {
    tripInformation: getInitialReduxState_client_objectSpread(getInitialReduxState_client_objectSpread({}, state.tripInformation), getSellerTripInformation())
  });
  state = cleanTripInfoKids(state);
  state = omitBy_default()(state, function (value) {
    return value === null;
  });
  return state;
}
// EXTERNAL MODULE: ./src/client/store/configureStore.js
var configureStore = __webpack_require__("Crz2");

// CONCATENATED MODULE: ./src/client/store/withReduxStore.js
// https://github.com/zeit/next.js/blob/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux/lib/with-redux-store.js
// From this example https://github.com/zeit/next.js/tree/126eb498675e6f1a27d568672c2a9da49eec09f9/examples/with-redux


var isServer = false;
var __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__'; // The store is a singleton on the client, but is created every time on the server

function getOrCreateStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // Always make a new store if server, otherwise state is shared between requests

  if (isServer) {
    return Object(configureStore["a" /* init */])(initialState);
  } // Create store if unavailable on the client and set it on the window object


  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = Object(configureStore["a" /* init */])(initialState);
  }

  return window[__NEXT_REDUX_STORE__];
}
// EXTERNAL MODULE: ./src/utils/booking-payment-status/bookingPaymentStatus.constants.js
var bookingPaymentStatus_constants = __webpack_require__("ycRU");

// EXTERNAL MODULE: ./src/utils/invariant/invariant.js
var invariant = __webpack_require__("UQkB");

// EXTERNAL MODULE: ./src/utils/ple-utils/handleInvalidToken.js
var handleInvalidToken = __webpack_require__("bJ4E");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./pages/_error.js + 1 modules
var _error = __webpack_require__("Y0NT");

// EXTERNAL MODULE: ./src/client/views/errors/not-found/NotFoundView.jsx
var NotFoundView = __webpack_require__("LP0I");

// EXTERNAL MODULE: ./src/client/components/stylesheets/critical.css
var critical = __webpack_require__("yAUU");

// EXTERNAL MODULE: ./src/client/components/stylesheets/app.css
var stylesheets_app = __webpack_require__("ZSqt");

// CONCATENATED MODULE: ./pages/_app.js




















var _app_jsx = react_default.a.createElement;


function _app_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _app_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? _app_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : _app_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _app_createSuper(Derived) {
  var hasNativeReflectConstruct = _app_isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = Object(getPrototypeOf["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(possibleConstructorReturn["a" /* default */])(this, result);
  };
}

function _app_isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}












































 // $FlowFixMe issue with next typings

var _app_App = /*#__PURE__*/function (_NextApp) {
  Object(inherits["a" /* default */])(App, _NextApp);

  var _super = _app_createSuper(App);

  Object(createClass["a" /* default */])(App, null, [{
    key: "getInitialProps",
    value: function () {
      var _getInitialProps = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(nextAppContext) {
        var Component, ctx, pageId, _Component$pageType, pageType, requireAuthentication, req, res, asPath, query, appContext, _appContext, isUserQuickLogged, originalUrl, userAgent, device, reduxStore, currentUri, location, isOption, staticPageContext, pageProps, _yield$NextApp$getIni, initProps, CMProps, _require, getRedirect, RULES, _yield$getRedirect, status, url, _pageProps, _pageProps$pageContex, pageContext, layoutData, appContextLight;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Component = nextAppContext.Component, ctx = nextAppContext.ctx;
                pageId = Component.pageId, _Component$pageType = Component.pageType, pageType = _Component$pageType === void 0 ? pageId || 'none' : _Component$pageType, requireAuthentication = Component.requireAuthentication;
                req = ctx.req, res = ctx.res, asPath = ctx.asPath, query = ctx.query;

                if (!req) {
                  _context.next = 15;
                  break;
                }

                _context.t0 = _app_objectSpread;
                _context.t1 = _app_objectSpread;
                _context.t2 = {};
                _context.next = 9;
                return Object(createAppContextFromReq["a" /* createAppContextFromReq */])(req);

              case 9:
                _context.t3 = _context.sent;
                _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
                _context.t5 = patchAppContextUrl(ctx);
                appContext = (0, _context.t0)(_context.t4, _context.t5);
                _context.next = 16;
                break;

              case 15:
                appContext = Object(createOrUpdateAppContext["a" /* getAppContext */])();

              case 16:
                // If no appContext, we reload the page. It's occurring when navigating back from an error layer
                if (!appContext && true && Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])(config_default.a)) {
                  window.location.reload();
                }

                _appContext = appContext, isUserQuickLogged = _appContext.isUserQuickLogged, originalUrl = _appContext.originalUrl, userAgent = _appContext.userAgent, device = _appContext.device; // Get or Create the store with initialState from cookies
                // This allows you to set a custom default initialState

                reduxStore = getOrCreateStore(stateFromCookies());

                if (requireAuthentication) {
                  currentUri = req ? Object(contextUtils["b" /* getCurrentUri */])(req) : new URI_default.a(window.location.href);
                  Object(handleInvalidToken["a" /* handleInvalidToken */])({
                    appContext: appContext,
                    currentUri: currentUri,
                    res: res,
                    userInfo: Object(userInfo_selectors["a" /* userInfoSelector */])(reduxStore.getState())
                  });
                }

                location = createRouterLocation_createRouterLocation({
                  asPath: asPath,
                  query: query,
                  originalUrl: originalUrl
                });
                isOption = query.bookingStatusBeforePayment === bookingPaymentStatus_constants["c" /* BOOKING_PAYMENT_STATUS_OPTION */]; // There are two possibilities for the pageContext
                // - it's created in the getInitialProps of the page (DynamicPage.jsx)
                // - it's static, the properties depending on the pages can be statically resolved (e.g. pageId)
                // We create it before the getInitialProps and pass it to the getInitialProps because some
                // components might need it, like ThemeView which does render lines

                staticPageContext = {
                  pageId: pageId,
                  pageTitle: dist["constants"].WEBSITE_NAME,
                  pageDescription: '',
                  // usually we don't care about the statusCode in the pageContext, since a 404/500 will
                  // directly route us to a specific branch
                  statusCode: statusCode_constants["a" /* STATUS_CODE_200 */],
                  canonicalUrl: Object(uriUtils["i" /* getPageCanonicalUrl */])(originalUrl, originalUrl),
                  pageMeta: {},
                  pageType: pageType,
                  siteSection: Object(utils["k" /* getSiteSection */])({
                    isOption: isOption,
                    isUserQuickLogged: isUserQuickLogged,
                    pageType: pageType
                  })
                }; // clear cms keys before handling page request to avoid getting unwanted data

                if (req) {
                  Object(i18n["b" /* clearAll */])();
                }

                pageProps = {}; // $FlowFixMe

                _context.next = 27;
                return app_default.a.getInitialProps(nextAppContext);

              case 27:
                _yield$NextApp$getIni = _context.sent;
                pageProps = _yield$NextApp$getIni.pageProps;

                if (!Component.getCMInitialProps) {
                  _context.next = 62;
                  break;
                }

                _context.prev = 30;
                initProps = _app_objectSpread(_app_objectSpread({}, ctx), {}, {
                  reduxStore: reduxStore,
                  appContext: appContext,
                  pageContext: staticPageContext,
                  location: location
                });
                _context.next = 34;
                return Component.getCMInitialProps(initProps);

              case 34:
                CMProps = _context.sent;
                pageProps = _app_objectSpread(_app_objectSpread({}, pageProps), CMProps);
                _context.next = 41;
                break;

              case 38:
                _context.prev = 38;
                _context.t6 = _context["catch"](30);
                pageProps = _app_objectSpread(_app_objectSpread({}, pageProps), _context.t6);

              case 41:
                if (!(pageProps.statusCode === statusCode_constants["d" /* STATUS_CODE_404 */])) {
                  _context.next = 62;
                  break;
                }

                _context.prev = 42;

                if (false) {}

                throw new Error('NotFound');

              case 45:
                _require = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module '@clubmed/redirects'"); e.code = 'MODULE_NOT_FOUND'; throw e; }())), getRedirect = _require.getRedirect, RULES = _require.RULES;
                _context.next = 48;
                return getRedirect(config_default.a.get(), req, [// Those rules only apply to b2c pages that couldn't be found in the CMS content b2c-pages
                RULES.NORMALIZE_B2C_SHOPPING_PATHS, // this redirection rule is temporary (i.e. issue #11090)
                RULES.B2C_CMS_CONTENT, RULES.PRODUCT_SHORT_LINKS, RULES.GLOBAL_B2C, RULES.LEGACY_B2C_NOT_FOUND]);

              case 48:
                _yield$getRedirect = _context.sent;
                status = _yield$getRedirect.status;
                url = _yield$getRedirect.url;
                return _context.abrupt("return", res.redirect(status, url));

              case 54:
                _context.prev = 54;
                _context.t7 = _context["catch"](42);
                _context.t8 = _app_objectSpread;
                _context.t9 = _app_objectSpread({}, pageProps);
                _context.next = 60;
                return Object(_error["notFoundInitialProps"])(req);

              case 60:
                _context.t10 = _context.sent;
                pageProps = (0, _context.t8)(_context.t9, _context.t10);

              case 62:
                _pageProps = pageProps, _pageProps$pageContex = _pageProps.pageContext, pageContext = _pageProps$pageContex === void 0 ? _app_objectSpread(_app_objectSpread({}, staticPageContext), {}, {
                  statusCode: pageProps.statusCode || statusCode_constants["a" /* STATUS_CODE_200 */] || statusCode_constants["d" /* STATUS_CODE_404 */]
                }) : _pageProps$pageContex;
                Object(invariant["a" /* invariant */])(pageId, "The page corresponding to the url ".concat(asPath, " doesn't have a pageId. This is an error."));

                if (!req) {
                  _context.next = 70;
                  break;
                }

                _context.next = 67;
                return Layout_query_fetchLayoutConfig(appContext);

              case 67:
                _context.t11 = _context.sent;
                _context.next = 71;
                break;

              case 70:
                _context.t11 = {};

              case 71:
                layoutData = _context.t11;
                appContextLight = {
                  locale: appContext.locale,
                  userAgent: userAgent,
                  device: device,
                  featureFlippingKeysFromCms: appContext.featureFlippingKeysFromCms,
                  originalUrl: originalUrl,
                  cookies: {}
                };

                if (false) {}

                return _context.abrupt("return", {
                  appContext: appContextLight,
                  pageContext: pageContext,
                  pageProps: pageProps,
                  i18nData: Object(i18n["c" /* getAll */])(),
                  layoutData: layoutData,
                  disableHeader: pageContext.statusCode === statusCode_constants["f" /* STATUS_CODE_500 */] || appContext.isSeller || query.disableLayout === 'true' || appContext.isComingFromMobileApp ||  true && (!!js_cookie_default.a.get('fromMobileApp') || !!appContext.isComingFromMobileApp) || (typeof Component.disableHeader === 'function' ? Component.disableHeader(appContext) : Component.disableHeader),
                  disableFooter: pageContext.statusCode === statusCode_constants["f" /* STATUS_CODE_500 */] || appContext.isSeller || Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa') || query.disableLayout === 'true' || appContext.isComingFromMobileApp ||  true && (!!js_cookie_default.a.get('fromMobileApp') || !!appContext.isComingFromMobileApp) || (typeof Component.disableFooter === 'function' ? Component.disableHeader(appContext) : Component.disableFooter),
                  location: location,
                  initialReduxState: reduxStore.getState(),
                  statusCode: pageContext.statusCode
                });

              case 75:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[30, 38], [42, 54]]);
      }));

      function getInitialProps(_x) {
        return _getInitialProps.apply(this, arguments);
      }

      return getInitialProps;
    }()
  }]);

  function App(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, App); // $FlowFixMe issue with next typings


    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "appContext", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "pageContext", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "reduxStore", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toastRef", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "componentDidMount", function () {
      Object(clientErrorHandler["c" /* start */])(); // Sync the state with the local storage

      _this.reduxStore.subscribe(throttle_default()(function () {
        var state = _this.reduxStore.getState();

        var persistedStore = {
          tripInformation: {
            kids: Object(storeHelper["c" /* getKids */])(state)
          },
          seller: state.seller
        };
        Object(local_storage_api["c" /* setInLocalStorage */])("".concat(LOCAL_STORAGE_STATE_KEY, "-").concat(_this.appContext.locale), persistedStore);
      }, 1000));
    });

    _this.toastRef = /*#__PURE__*/Object(react["createRef"])();
    _this.appContext = true ? Object(createOrUpdateAppContext["b" /* saveAppContext */])(props.appContext) : undefined; // Get or Create the store with initialState from cookies

    _this.reduxStore = getOrCreateStore(true ? getInitialReduxState(props.initialReduxState, _this.appContext.locale) : undefined);
    Object(i18n["g" /* setLocale */])(_this.appContext.locale.slice(0, 2)); // First time on the render it comes from the props, then it's there and won't have to be refeched

    _this.layoutData = props.layoutData || _this.layoutData;
    return _this;
  }

  Object(createClass["a" /* default */])(App, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps,
          i18nData = _this$props.i18nData,
          disableFooter = _this$props.disableFooter,
          disableHeader = _this$props.disableHeader;

      var pageContext = _app_objectSpread(_app_objectSpread({}, this.props.pageContext), pageProps.pageContext);

      var pageId = pageContext.pageId || 'pageWrapper';
      var isMicePage = dist["b2cPagesService"].isMicePage(pageContext.pageType); // Storing configuration from CMS in the context

      var appContext = _app_objectSpread(_app_objectSpread({}, this.appContext), {}, {
        freeDepositDeadline: i18nData[this.appContext.isSeller ? 'booking.sellers.banking.freeDepositDeadline' : 'booking.banking.freeDepositDeadline']
      });

      if (true) {
        Object(i18n["a" /* addTranslationKeys */])(i18nData);
      }

      return _app_jsx(ErrorBoundary["a" /* ErrorBoundary */], null, _app_jsx(AppProviders_AppProviders, {
        appContext: appContext,
        pageContext: pageContext,
        reduxStore: this.reduxStore,
        toastRef: this.toastRef
      }, _app_jsx(HeadInfos_HeadInfos, null), _app_jsx(PriorityThirdPartyScripts, null), _app_jsx(RouteChangeListener_RouteChangeListener, null), _app_jsx(ThreeSixtyContainer_ThreeSixtyContainer, null), _app_jsx(InitializeSellerInfos_InitializeSellerInfos, {
        appContext: this.appContext
      }), _app_jsx(Loading_Loading, null), _app_jsx("div", {
        id: pageId,
        "data-cs-override-id": "page"
      }, _app_jsx(Layout_Layout, Object(esm_extends["a" /* default */])({}, this.layoutData, {
        disableHeader: disableHeader,
        disableFooter: disableFooter,
        isMicePage: isMicePage
      }), pageProps.statusCode === 404 ? _app_jsx(NotFoundView["a" /* default */], pageProps) : _app_jsx(Component, pageProps))), _app_jsx(ToastContainer, {
        ref: this.toastRef
      }), _app_jsx(ThirdPartyScripts, null)));
    }
  }]);

  return App;
}(app_default.a);

/* harmony default export */ var _app = __webpack_exports__["default"] = (_app_App);

/***/ }),

/***/ "1YFU":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var $documentAll = __webpack_require__("S8S5");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "1a7w":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("1s2Y");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "1aYn":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    isArrayLike = __webpack_require__("9y2L"),
    keys = __webpack_require__("BlJA");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ "1m4l":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");
var uncurryThis = __webpack_require__("kZDm");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var anObject = __webpack_require__("ep/x");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);




var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(_ref) {
  var _ref$seasons = _ref.seasons,
      seasons = _ref$seasons === void 0 ? [] : _ref$seasons,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type;
  return seasons.length === 1 && seasons.includes('WINTER') && type.toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(product) {
  return product.category === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(product) {
  return product.activityCategories.leisure.some(function (_ref2) {
    var subCategories = _ref2.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "1s2Y":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("Y8c0");
var fails = __webpack_require__("fhLv");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "1sLo":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("JBn+"),
    arrayIncludes = __webpack_require__("OfKG"),
    arrayIncludesWith = __webpack_require__("sCL+"),
    arrayMap = __webpack_require__("H87J"),
    baseUnary = __webpack_require__("SU8Q"),
    cacheHas = __webpack_require__("S0iI");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),

/***/ "1tzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isChineseLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLocaleToDisplayDidomi; });
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kiXb");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("qFX+");



var isChineseLocale = function isChineseLocale(locale) {
  return locale === _constants__WEBPACK_IMPORTED_MODULE_1__[/* LOCALES */ "a"].EN_CN || locale === _constants__WEBPACK_IMPORTED_MODULE_1__[/* LOCALES */ "a"].ZH_CN;
};

var isLocaleToDisplayDidomi = function isLocaleToDisplayDidomi() {
  return Object(_i18n__WEBPACK_IMPORTED_MODULE_0__[/* getKeyValue */ "d"])('common.activateDidomi');
};



/***/ }),

/***/ "2CYk":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "2GfD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Technically, this is not related to the address, since it can work with any type of validationSchema
// but other form of schemas, might not be object. So here we went for the simplest case, the one we
// use, i.e. address
var validationSchemaFieldFragment = "\n fragment ValidationSchemaField on SchemaValidationFieldInterface {\n  name\n  ...on ValidationSchemaObjectField {\n    fields {\n      display\n      type\n      name\n      required\n      values {\n        code\n        label\n      }\n      validators {\n        name\n        value\n      }\n    }\n  }\n }\n";
/* harmony default export */ __webpack_exports__["a"] = (validationSchemaFieldFragment);

/***/ }),

/***/ "2Lg3":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ "2N/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ENGINE_ENTRIES; });
/* unused harmony export BOOKING_TRACKING_UPSELL_REVENUE */
var BOOKING_ENGINE_ENTRIES = {
  PRICE_CALENDAR: 'PriceCalendar',
  PRICE_REMOTE: 'PriceRemote',
  QUICK_SEARCH: 'QuickSearch',
  CRUISE_BOOKING: 'CruiseBooking'
};
var BOOKING_TRACKING_UPSELL_REVENUE = 'BOOKING_TRACKING_UPSELL_REVENUE';

/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1cDg");
/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.querySelector(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_OFFSET_SELECTOR */ "a"]);

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    setTimeout(function () {
      var element = document.querySelector(hash);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });

        if (scrollUnderNav) {
          scrollUnderNavBar();
        }
      }
    }, 100);
  }
}

/***/ }),

/***/ "3K/D":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var create = __webpack_require__("Znn2");
var defineProperty = __webpack_require__("87KK").f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "3LIW":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var isCallable = __webpack_require__("ANQd");
var classofRaw = __webpack_require__("XywU");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "3dHC":
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ "3dm5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var classof = __webpack_require__("3LIW");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVRL_PMNTS; });
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllProposalsIdWithAlternative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return trackErrorOnAddService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return handleWrongUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureDateRange; });
/* unused harmony export hexToRgba */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getExclusiveCollectionFromComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getExclusiveCollectionFromAccomodation; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("WNMA");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("3voH");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("OOYD");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_reject__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("zytj");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("aWOT");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("1qsz");






















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_23__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var SVRL_PMNTS = 'svrl-pmnts';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, product) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_28__[/* hasChildcare */ "n"])(selectedProposal) && !product.isJoyview && !product.isUrbanOasis && selectedProposal.additionalServices.childcares.length === 0 || product.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY || product.isUrbanOasis && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_28__[/* hasTransfer */ "q"])(selectedProposal) && !lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isPartiallyPaid = _ref.isPartiallyPaid,
      isPartiallyPaid = _ref$isPartiallyPaid === void 0 ? false : _ref$isPartiallyPaid,
      _ref$shouldHideActivi = _ref.shouldHideActivitiesStepAbTest,
      shouldHideActivitiesStepAbTest = _ref$shouldHideActivi === void 0 ? false : _ref$shouldHideActivi;
  var bankingStep = {
    name: 'banking',
    eventPageName: 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: 'banking',
    agenceType: 'NonDucroire',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: true,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title,
    gridSize: ''
  };

  if (isPartiallyPaid) {
    // the proposals should not be modified after an household has already paid
    return [bankingStep];
  }

  var isRecommendedTransportSelected = selectedProposal.transports && Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_28__[/* isRecommendedTransport */ "w"])(selectedProposal.transports, selectedProposal.id);
  var activitiesView = isActivitiesViewFeatureFlipped && !shouldHideActivitiesStepAbTest && (selectedProposal.additionalServices.activities.some(function (activity) {
    var _activity$productInfo;

    return ((_activity$productInfo = activity.productInfo) === null || _activity$productInfo === void 0 ? void 0 : _activity$productInfo.isIncluded) === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_29__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;

  var isJoyview = lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(resort, 'isJoyview');

  var isUrbanOasis = lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(resort, 'isUrbanOasis');

  var isUrbanOasisOrJoyview = isJoyview || isUrbanOasis;
  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_26__[/* tAlt */ "u"])({
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      product: resort,
      resortKeyPath: 'booking.accommodation.pageTitle'
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_25__[/* getTransportIcon */ "m"])(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(selectedProposal, 'transports.inbound'), lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(selectedProposal, 'transports.outbound')),
    // eslint-disable-next-line no-nested-ternary
    title: isRecommendedTransportSelected ? i18n.booking.transport.transportPageTitle : i18n.booking.transport.additionalTransports.transportSelection,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].TRANSFER,
    title: i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal),
    gridSize: 'large'
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isUrbanOasisOrJoyview ? 'allInclusive' : 'service',
    labelGA: isUrbanOasisOrJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isUrbanOasisOrJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isUrbanOasisOrJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'large'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_24__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('booking.summary.pageTitle'),
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'medium'
  }];

  if (activitiesView) {
    breadcrumbPages.splice(3, 0, activitiesView);
  } // adds the banking step if the optionHoldOnly featureFlip is disabled


  if (!isOptionHoldOnlyFeatureFlipped) {
    breadcrumbPages.push(bankingStep);
  } // $FlowFixMe Absolutely no clue of why


  return lodash_reject__WEBPACK_IMPORTED_MODULE_19___default()(breadcrumbPages, 'isToBeHidden');
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};
var trackErrorOnAddService = function trackErrorOnAddService(error, trackCallback, defaultValue) {
  if (error) {
    var _error$errors, _error$errors$;

    var errorCode = error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.errorCode;
    trackCallback({
      labelGA: "error_".concat(errorCode ? errorCode : defaultValue)
    });
  }
};
var handleWrongUrl = function handleWrongUrl(router) {
  var _router$query, _router$query2, _router$query3;

  var proposalIds = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.proposalIds;
  var bookingStep = (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.bookingStep;
  var date = (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.date;
  var today = new Date();
  var isExpiredDate = moment__WEBPACK_IMPORTED_MODULE_22___default()(date).isBefore(moment__WEBPACK_IMPORTED_MODULE_22___default()(today), 'day');

  if (!router.query || !proposalIds || proposalIds.length < 1 || !bookingStep || isExpiredDate) {
    // If the url misses proposalsIds or bookingStep, or has a date in the past
    // then, we should redirect to homepage instead of throwing a 500 error
    _logger_logger__WEBPACK_IMPORTED_MODULE_21__["default"].error('If the url misses proposalsIds or bookingStep, or has a date in the past, then we should redirect to homepage instead of throwing a 500 error');
    router.push('/');
    throw new Error('Invalid booking paramerter');
  }
};
var getDepartureDateRange = function getDepartureDateRange(daysBeforeDeparture) {
  if (daysBeforeDeparture <= 34) {
    return 'late_booking';
  }

  if (daysBeforeDeparture <= 90) {
    return 'middle_booking';
  }

  return 'early_booking';
};
var hexToRgba = function hexToRgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (hex === '' || hex === null || !hex.startsWith('#')) {
    hex = '#924833';
  }

  var matches = hex && hex.match(/\w\w/g);

  if (!matches) {
    return hex;
  }

  var _matches$map = matches.map(function (x) {
    return parseInt(x, 16);
  }),
      _matches$map2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(_matches$map, 3),
      r = _matches$map2[0],
      g = _matches$map2[1],
      b = _matches$map2[2];

  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
};
var getExclusiveCollectionFromComfort = function getExclusiveCollectionFromComfort(comfort, hasECSpace) {
  if (hasECSpace) {
    return 'exclusive_collection_space';
  }

  if (comfort == null) {
    return undefined;
  }

  if (comfort < 5) {
    return 'no';
  }

  return 'exclusive_collection';
};
var getExclusiveCollectionFromAccomodation = function getExclusiveCollectionFromAccomodation(hasECSpace, isEclusiveCollectionAccommodation) {
  if (isEclusiveCollectionAccommodation && hasECSpace) {
    return 'exclusive_collection_space';
  }

  if (isEclusiveCollectionAccommodation && !hasECSpace) {
    return 'exclusive_collection';
  }

  return 'no';
};

/***/ }),

/***/ "4Grf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAVIGATION_TRACKING_LOGO_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAVIGATION_TRACKING_CONTACT_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNavigationCallCenterButtonTrackingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getNavigationLanguagesButtonTrackingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getNavigationItemLinkTrackingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNavigationSubItemLinkTrackingData; });
var categoryGA = 'headerMenu';
var NAVIGATION_TRACKING_LOGO_BUTTON = {
  actionGA: 'header_logo',
  categoryGA: categoryGA,
  labelGA: null // to override any value coming from previous tracking

};
var NAVIGATION_TRACKING_CONTACT_BUTTON = {
  actionGA: 'header_contact',
  categoryGA: categoryGA,
  labelGA: 'clickToCall'
};
var getNavigationCallCenterButtonTrackingData = function getNavigationCallCenterButtonTrackingData(label) {
  return {
    actionGA: 'header_contact',
    categoryGA: categoryGA,
    labelGA: label
  };
};
var getNavigationLanguagesButtonTrackingData = function getNavigationLanguagesButtonTrackingData(label) {
  return {
    actionGA: 'header_language',
    categoryGA: categoryGA,
    labelGA: label
  };
};
var getNavigationItemLinkTrackingData = function getNavigationItemLinkTrackingData(label) {
  return {
    actionGA: "header_".concat(label),
    categoryGA: categoryGA,
    labelGA: label
  };
};
var getNavigationSubItemLinkTrackingData = function getNavigationSubItemLinkTrackingData(_ref) {
  var label = _ref.label,
      parentLabel = _ref.parentLabel;
  return {
    actionGA: "header_".concat(parentLabel),
    categoryGA: categoryGA,
    labelGA: label
  };
};

/***/ }),

/***/ "4I0e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-20 text-black text-20', {
      'sr-only': !label
    }, className),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4gXF":
/***/ (function(module, exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__("nnO8");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "4tGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useExtendedConnect; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var query = "\n  query {\n    facebookConnect {\n      isAvailable\n    }\n    wechatConnect {\n      isAvailable\n    }\n  }\n";
var useExtendedConnect = function useExtendedConnect() {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isFacebookConnectAvailable = _useState[0],
      setIsFacebookConnectAvailable = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      isWechatConnectAvailable = _useState2[0],
      setIsWechatConnectAvailable = _useState2[1];

  var _useGQL = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_1__[/* useGQL */ "a"])({
    query: query,
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_FACEBOOK_CONNECT_CONFIG */ "d"]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var _data$facebookConnect, _data$wechatConnect;

    setIsFacebookConnectAvailable(!!(data === null || data === void 0 ? void 0 : (_data$facebookConnect = data.facebookConnect) === null || _data$facebookConnect === void 0 ? void 0 : _data$facebookConnect.isAvailable));
    setIsWechatConnectAvailable(!!(data === null || data === void 0 ? void 0 : (_data$wechatConnect = data.wechatConnect) === null || _data$wechatConnect === void 0 ? void 0 : _data$wechatConnect.isAvailable));
  }, [isLoading]);
  return {
    isFacebookConnectAvailable: isFacebookConnectAvailable,
    isWechatConnectAvailable: isWechatConnectAvailable
  };
};

/***/ }),

/***/ "54uq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ACTIVATED; });
/* unused harmony export API_EDITABLE */
/* unused harmony export API_UNAVAILABLE */
/* unused harmony export API_NOTYET */
/* unused harmony export API_UNEDITABLE */
/* unused harmony export API_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_RESORT_ONLY; });
/* unused harmony export API_UPSELL_AVAILABLE */
/* unused harmony export API_RESORT_ONLY_FORM_SENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_DONE; });
var API_AVAILABLE = 'AVAILABLE';
var API_VALIDATED = 'VALIDATED';
var API_ACTIVATED = 'ACTIVATED';
var API_EDITABLE = 'EDITABLE';
var API_UNAVAILABLE = 'UNAVAILABLE';
var API_NOTYET = 'NOT_YET';
var API_UNEDITABLE = 'UNEDITABLE';
var API_OPTION = 'OPTION';
var API_RESORT_ONLY = 'RESORT_ONLY';
var API_RESORT_ONLY_FORM_SENT = 'RESORT_ONLY_FORM_SENT';
var API_UPSELL_AVAILABLE = 'UPSELL_AVAILABLE';
var API_DONE = 'DONE';


/***/ }),

/***/ "5LiQ":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("dNjr");
var toAbsoluteIndex = __webpack_require__("Jm8J");
var lengthOfArrayLike = __webpack_require__("XhyO");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "5h8T":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var call = __webpack_require__("we+H");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var createPropertyDescriptor = __webpack_require__("OouP");
var toIndexedObject = __webpack_require__("dNjr");
var toPropertyKey = __webpack_require__("RWUY");
var hasOwn = __webpack_require__("/GgU");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "5iaM":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("lPgN");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "60DJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("C8GU").charAt;
var toString = __webpack_require__("vnfA");
var InternalStateModule = __webpack_require__("9jKB");
var defineIterator = __webpack_require__("6WRp");
var createIterResultObject = __webpack_require__("b86L");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ "6R5o":
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__("1aYn"),
    findIndex = __webpack_require__("FllU");

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ "6WRp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var call = __webpack_require__("we+H");
var IS_PURE = __webpack_require__("SRps");
var FunctionName = __webpack_require__("mu8A");
var isCallable = __webpack_require__("ANQd");
var createIteratorConstructor = __webpack_require__("Mv+R");
var getPrototypeOf = __webpack_require__("yvHl");
var setPrototypeOf = __webpack_require__("iBXc");
var setToStringTag = __webpack_require__("CGO5");
var createNonEnumerableProperty = __webpack_require__("g51W");
var defineBuiltIn = __webpack_require__("Swp0");
var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");
var IteratorsCore = __webpack_require__("JpEK");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "6aqx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("RWUY");
var definePropertyModule = __webpack_require__("87KK");
var createPropertyDescriptor = __webpack_require__("OouP");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "6qX7":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("1s2Y");

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "70jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export servicesWithSchedulePricingInfoQuery */
/* unused harmony export childcareWithSchedulePricingInfoQuery */
/* unused harmony export childcaresQuery */
/* unused harmony export transfersQuery */
/* unused harmony export insuranceAdditionalServicesQuery */
/* unused harmony export additionalServicesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAccommodationMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addServiceMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTransportMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPaymentScheduleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceDetailFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return proposalsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return proposalFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return proposalPriceQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return transportDetailsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return paymentProvidersRequest; });
/* unused harmony export getKnownAttendeesInformation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return promoCodeProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return autosaveProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return putServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return switchProposalsOffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return refreshProposal; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("H0gB");
/* harmony import */ var _client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("MAH5");
/* harmony import */ var _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("BYx+");
/* harmony import */ var _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SQLw");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("L7OA");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("PIvV");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("ldK3");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("NLwV");


















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;
var paymentScheduleRequest = "paymentSchedule {\n  commissionIncluded\n  total {...priceDetails}\n  depositAmount {...priceDetails}\n  repaymentSchedules{\n    amount {...priceDetails}\n    deadline\n  }\n}";

function getPaymentScheduleRequest(appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.deposit') ? paymentScheduleRequest : '';
}

function getPriceDetailFragment(locale) {
  var precision = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17___default.a.getBookingPrecision(locale);
  return "\n    fragment priceDetails on PriceDetailType {\n      formattedValue(precision : ".concat(precision, ")\n      value\n    }\n  ");
}

var flightFragment = "{\n  id\n  cityId\n  label\n  airportLabel\n  terminalCode\n  date\n  time\n}";
var transportFragment = "{\n  type\n  class\n  travelNumber\n  baggage {\n    quantity\n    weight\n    unit\n  }\n  companyOperator {\n    id\n    label\n    logo\n  }\n  companyExploiter {\n    id\n    label\n    logo\n  }\n  vehicleType\n  carbonEmission\n  averageCarbonEmission\n}";
var transportDetailsFragment = "\n  fragment transportsDetails on TransportDetailType {\n    isClubmedTransport\n    durationInMin\n    travelSections {\n      connectionDurationInMin\n      isClubmedTransport\n      stopDurationInMin\n      technicalStops\n      departure {\n        ...".concat(flightFragment, "\n      }\n      arrival {\n        ...").concat(flightFragment, "\n      }\n      transport {\n        ...").concat(transportFragment, "\n      }\n    }\n    cancellationPolicyType\n    transferIncluded\n    stayId\n  }\n");
var servicesWithSchedulePricingInfoQuery = "\n    pricingInfo {\n        id\n        progId\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        rentedAmountWithoutDiscount {...priceDetails, currency}\n        startingPricePerAdult {\n          ...priceDetails\n          currency\n          discount\n          discountUnit\n          formattedInitialValue\n        }\n        isPartiallyRented\n        attendees {\n          id\n          rentedAmount {\n            ...priceDetails\n            currency\n          }\n          rentedAmountWithoutDiscount {\n            ...priceDetails\n            currency\n          }\n          price {\n            discount\n            discountUnit\n            formattedValue(precision:0)\n            formattedInitialValue\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {\n                ...priceDetails\n                currency\n                discount\n                discountUnit\n                formattedInitialValue\n              }\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {\n                ...priceDetails\n              }\n            }\n          }\n        }\n      }";
/**
 * childcare with schedule and childId
 */

var childcareWithSchedulePricingInfoQuery = "\n    pricingInfo {\n        id\n        progId\n        childId\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        startingPricePerAdult {\n          ...priceDetails\n          currency\n          discount\n          discountUnit\n          formattedInitialValue\n        }\n        isPartiallyRented\n        attendees {\n          id\n          rentedAmount {...priceDetails currency}\n          price {\n            discount\n            discountUnit\n            formattedValue(precision:0)\n            formattedInitialValue\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {\n                ...priceDetails\n                currency\n                discount\n                discountUnit\n                formattedInitialValue\n              }\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {\n                ...priceDetails\n              }\n            }\n          }\n        }\n      }";
var childcaresQuery = "\nchildcares {\n  ".concat(childcareWithSchedulePricingInfoQuery, "\n  productInfo {\n    id\n    label\n    images\n    description\n    durationDescription\n    isIncluded\n    ageInMonths {\n      min\n      max\n    }\n    closingWeekdays\n    openingHours {\n      start\n      end\n    }\n    timeSlots {\n      type\n      opening\n      closing\n    }\n  }\n}");
var transfersQuery = "\ntransfers {\n  pricingInfo {\n    id\n    isIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    totalPrice {\n      value\n      formattedValue\n      currency\n    }\n    isPartiallyRented\n    isFullyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    description\n    durationInMinutes\n    vehicle {\n      id\n      label\n    }\n    label\n  }\n}\n";
var insuranceAdditionalServicesQuery = "insurance {\n        pricingInfo {\n          id\n          type\n          rentedAmount {...priceDetails, currency}\n          totalPrice {\n            value\n            formattedValue(precision: 2)\n            currency\n          }\n          isPartiallyRented\n          isPartiallyPaid\n          isFullyPaid\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n            }\n          }\n        }\n        productInfo {\n          id\n          label\n          shortDescription\n          insuranceDetails {\n            id\n            label\n            images\n            description\n            shortDescription\n            videos\n            attachedDocuments {\n              label\n              url\n            }\n            company {\n              label\n              logo\n            }\n            coverageDescriptions\n            subscriptionConditions {\n              age_min\n              ageMax\n              byAttendees\n            }\n          }\n        }\n      }";
var additionalServicesQuery = "\n  additionalServices(types: [EXCURSION, RENTAL, CHILDCARE, LAND_SPORT, WATER_SPORT, WINTER_SPORT, TRANSFER, WELLNESS, INSURANCE]) {\n    activities {\n      ".concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        isIncluded\n        parentActivityCategoriesId\n        description\n      }\n    }\n    rentals {\n      ").concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        ageInMonths {\n          min\n          max\n        }\n        useCase {\n          id\n          label\n        }\n        typeId: type\n        typeLabel\n        description: longDescription\n        sizes {\n          min\n          max\n          unit\n        }\n        practiceLevels {\n          id\n          label\n        }\n      }\n    }\n    ").concat(childcaresQuery, "\n    ").concat(transfersQuery, "\n    ").concat(insuranceAdditionalServicesQuery, "\n  }\n  ");

function proposalPriceQuery() {
  return "\n    price {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerId\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      insurance {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n        offerDescription\n        offerLabel\n        offerType\n        currentProposalCode {\n          id\n          label\n          description\n          value\n          unit\n        }\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      excursions {...priceDetails}\n      wellness {...priceDetails}\n      sports {...priceDetails}\n      currency\n      hasFlexRates\n      selectedRate\n      yieldPricingVariation\n      gap\n    }\n    alternativePrice {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerId\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n        offerDescription\n        offerLabel\n        offerType\n        currentProposalCode {\n          id\n          label\n          description\n          value\n          unit\n        }\n      }\n      transfer {...priceDetails}\n      insurance {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      currency\n    }\n    attendeesPrice {\n      id\n      householdId\n      total {\n        ...priceDetails\n        currency\n      }\n      priceItems {\n        type\n        offerId\n        price {\n          ...priceDetails\n          currency\n        }\n      }\n    }\n    ";
}

function proposalFields(params, appContext) {
  return "\n    id\n    packageId\n    productId\n    originalLocale\n    greatMembersLoyaltyPoints\n    ".concat(additionalServicesQuery, "\n    ").concat(params.isJoyView || params.isUrbanOasis ? "\n    alternativePackages {\n      proposalId\n      packageId\n      upsellPrice\n    }\n    packages(packageIds : [\"".concat(JOYVIEW_ROOM_ONLY, "\", \"").concat(JOYVIEW_ALL_INCLUSIVE, "\", \"").concat(JOYVIEW_FOOD_AND_BEVERAGES, "\"]) {\n      id\n      image\n      additionalInfo\n      description\n      label\n      prices {\n        perAdultPerNight {\n          ...priceDetails\n          currency\n        }\n        perKidPerNight {\n          ...priceDetails\n          currency\n        }\n      }\n    }") : '', "\n    label\n    accommodationsCount\n    persistenceExtended\n    accommodations {\n      id\n      label\n      description\n      quantity\n      connectingRoom\n      familyRoom\n      surface\n      view {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      services {\n        id\n        label\n      }\n      outsideFacilities {\n        id\n        label\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      categories {\n        id\n      }\n      exclusiveCollection\n      floorPlans\n      category\n      categoryId\n      comfortType\n      comfortId\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      roomType\n      attendeesDistribution {\n        attendees {\n          id\n          type\n          birthdate,\n          customerId\n        }\n      }\n      ranking\n    }\n    duration\n    media {\n      photos {\n        url\n      }\n    }\n    ").concat(proposalPriceQuery(), "\n    arrivalDate\n    departureDate\n    attendees {\n      list {\n        id\n        birthdate\n        customerId\n        email\n        civility\n        firstName\n        lastName\n        gmNumber\n        optins {\n          channel\n          optin\n        }\n      }\n      adults {\n        id\n        customerId\n      }\n      children(birthdateSort: asc) {\n        id\n        birthdate\n        customerId\n      }\n    }\n    households(withSchedule: ").concat((!!params.withSchedule).toString(), ") {\n      attendees {\n        id\n        customerId\n        birthdate\n        isAdult\n        isMain\n      }\n      ").concat(getPaymentScheduleRequest(appContext), "\n    }\n    remainingStock\n    optionAvailable\n    isCounterProposal\n    transports {\n      inbound {\n        ...transportsDetails\n      }\n      outbound {\n        ...transportsDetails\n      }\n    }\n    expirationDateTime\n    durationDisclaimer\n    allInclusiveServices {\n      icon\n      label\n      description\n    }\n    ").concat(params.withCommission ? "sellerCommission {\n            formattedValue(precision: 2)\n          }" : '', "\n     ");
}

var paymentProvidersRequest = function paymentProvidersRequest() {
  return "paymentProviders {\n  description\n  id\n  selectorId\n  label\n  logo\n  categoryPaymentMethod\n  shouldSkipPayment\n  withBillingAddress\n  paymentMethods {\n    category\n    id\n    image\n    label\n    timePaymentConditions {\n      chargePercentage\n      id\n      paymentCount\n    }\n  }\n  requiredDelayBeforeDeparture\n  token {\n    format\n    value\n  }\n}";
};

function fetchPayment(proposalId, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposal(id: \"".concat(proposalId, "\") {\n        households(withSchedule: true) {\n          ").concat(getPaymentScheduleRequest(appContext), "\n        }\n      }\n      ").concat(paymentProvidersRequest(), "\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_GET_SCHEDULE_PAYMENT */ "Pc"]
  });
}

function getKnownAttendeesInformation(attendees, neolaneId) {
  var travelCompanionContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var attendeeInfo = attendees.map(function (attendee, index) {
    var _attendee$neolid = attendee.neolid,
        neolid = _attendee$neolid === void 0 ? '' : _attendee$neolid,
        birthdate = attendee.birthdate;
    var customerId = index === 0 && neolaneId ? neolaneId : neolid; // neolid : Send by CXO in query params
    // neolaneId : In appContext, identify user logged
    // When not seller, set first adult with neolaneId if user is authenticated
    // adding connected user infos creates 2 households for travel companions context which should always only have one household

    return _objectSpread({
      customer_id: travelCompanionContext ? undefined : customerId
    }, birthdate ? {
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_26__[/* timestampToApiDate */ "n"])(birthdate)
    } : null);
  });
  return Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeInfo);
}

function proposalsQuery(_x, _x2) {
  return _proposalsQuery.apply(this, arguments);
}

function _proposalsQuery() {
  _proposalsQuery = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee4(params, appContext) {
    var _params$adultsAttende, _params$kidsAttendees, _proposalsResponse$pr, _proposalsResponse$pr2, _proposalsResponse$pr3, _proposalsResponse$pr4, _proposalsResponse$pr5;

    var adults, _params$kids, kids, attendees, neolaneId, travelCompanionContext, knownAttendeesInformation, displayCommission, displayDurationsCounterProposals, displayCounterExtendedDurations, displayCounterDates, proposalArgs, proposalsResponse, validationSchema;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            adults = params.adults, _params$kids = params.kids, kids = _params$kids === void 0 ? [] : _params$kids;
            attendees = adults.concat(kids || []); // When quick logged neolaneId but should not call profile api
            // TODO: handle quicklogged status and not call profile API every fucking time because 401 is silent

            neolaneId = appContext.isUserLogged ? appContext.neolaneId : null;
            travelCompanionContext = !appContext.isSeller && appContext.isUserLogged && Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.travelCompanions');
            knownAttendeesInformation = getKnownAttendeesInformation( // $FlowFixMe
            attendees, neolaneId, travelCompanionContext);
            displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
            displayDurationsCounterProposals = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDurationsCounterProposals').toString();
            displayCounterExtendedDurations = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayExtendedDurationsCounterProposals').toString();
            displayCounterDates = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDateCounterProposals').toString();
            proposalArgs = ["productId: \"".concat(params.productId, "\""), "arrivalDate: \"".concat(params.arrivalDate, "\""), "duration: ".concat(params.duration), "numberAttendees: ".concat(params.numberAttendees), "knownAttendeesInformation: ".concat(knownAttendeesInformation)].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.departureCity ? ["departureCity : \"".concat(params.departureCity, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.isJoyView ? ['isJoyView: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.isUrbanOasis ? ['isUrbanOasis: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.salesNetworkId ? ["salesNetworkId: \"".concat(params.salesNetworkId, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.voucherCode ? ["voucherCode: \"".concat(params.voucherCode, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.isPrebookingFormQuery ? ['isPrebookingFormQuery: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.accommodationIds ? ["accommodationIds : ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(params.accommodationIds))] : []), ["displayCounterDurations: ".concat(displayDurationsCounterProposals), "displayCounterExtendedDurations: ".concat(displayCounterExtendedDurations), "displayCounterDates: ".concat(displayCounterDates)]);
            _context4.next = 12;
            return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals(".concat(proposalArgs.join(', '), ") {\n        ... on ErrorsProposalType {\n          errors {\n            errorCode\n          }\n        }\n        ... on ProposalsType {\n          proposals {\n            ").concat(proposalFields(_objectSpread(_objectSpread({}, params), {}, {
              withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
            }), appContext), "\n          }\n          dateSuggestion {\n            dateOffset\n            price {\n              total\n            }\n            resortArrivalDate\n            resortDepartureDate\n          }\n          priceCurrency\n          suggestions {\n            resort {\n              badgeIcon\n              color\n              comfort\n              comfortLabel\n              destination {\n                country\n              }\n              hasECSpace\n              href\n              id\n              images\n              isExplicitEC\n              isUrbanOasis\n              name\n              type\n            }\n            remainingStock\n            initialStock\n          }\n          durationSuggestions {\n            ids\n            data {\n              price {\n                total {\n                  formattedValue\n                }\n              }\n              duration\n              resortArrivalDate: arrivalDate\n              resortDepartureDate: departureDate\n            }\n          }\n          ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* getResort */ "c"])(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(appContext.isUserLogged ? 'profile { ...BookingProfile }' : '', "\n      ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* getAttendeesData */ "b"])(params), "\n    }\n\n    ").concat(params.fetchActivityCategories ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* activityCategoryFragment */ "a"] : '', "\n    ").concat(params.fetchActivityCategories || _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* thematicFragment */ "g"] ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* activityFragment */ "b"] : '', "\n    ").concat(params.fetchActivityCategories ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* rentalsFragment */ "f"] : '', "\n    ").concat(_client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* thematicFragment */ "g"], "\n    ").concat(appContext.isUserLogged ? _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_21__[/* profileFragment */ "a"] : '', "\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    ").concat(((_params$adultsAttende = params.adultsAttendeesIds) === null || _params$adultsAttende === void 0 ? void 0 : _params$adultsAttende[0]) || ((_params$kidsAttendees = params.kidsAttendeesIds) === null || _params$kidsAttendees === void 0 ? void 0 : _params$kidsAttendees[0]) ? _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"] : '', "\n    "), appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_GET_SEVERAL */ "Rc"]
            });

          case 12:
            proposalsResponse = _context4.sent;

            if (!(proposalsResponse === null || proposalsResponse === void 0 ? void 0 : (_proposalsResponse$pr = proposalsResponse.proposals) === null || _proposalsResponse$pr === void 0 ? void 0 : (_proposalsResponse$pr2 = _proposalsResponse$pr.proposals) === null || _proposalsResponse$pr2 === void 0 ? void 0 : _proposalsResponse$pr2.length)) {
              _context4.next = 19;
              break;
            }

            _context4.next = 16;
            return Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* fetchValidationSchema */ "a"])(proposalsResponse === null || proposalsResponse === void 0 ? void 0 : (_proposalsResponse$pr3 = proposalsResponse.proposals) === null || _proposalsResponse$pr3 === void 0 ? void 0 : (_proposalsResponse$pr4 = _proposalsResponse$pr3.proposals) === null || _proposalsResponse$pr4 === void 0 ? void 0 : (_proposalsResponse$pr5 = _proposalsResponse$pr4[0]) === null || _proposalsResponse$pr5 === void 0 ? void 0 : _proposalsResponse$pr5.id, appContext, 'profile');

          case 16:
            _context4.t0 = _context4.sent;
            _context4.next = 20;
            break;

          case 19:
            _context4.t0 = {};

          case 20:
            validationSchema = _context4.t0;
            return _context4.abrupt("return", _objectSpread(_objectSpread({}, proposalsResponse), validationSchema));

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _proposalsQuery.apply(this, arguments);
}

function addTransportMutation(transportId, proposalsId, isJoyView, isUrbanOasis, appContext) {
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addTransport (proposalsId: [\"".concat(proposalsId.join('","'), "\"], transportId: \"").concat(transportId, "\") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    isUrbanOasis: isUrbanOasis,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }, appContext), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADD_TRANSPORT */ "Kc"]
  });
}

function addAccommodationMutation(arrangement, proposalsId, isJoyView, isUrbanOasis, appContext) {
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addAccommodation (proposalsId: [\"".concat(proposalsId.join('","'), "\"], arrangement: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(arrangement), ") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    isUrbanOasis: isUrbanOasis,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }, appContext), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ACCOMMODATION_ADD */ "Gc"]
  });
}

var putServicesGraphQLQuery = function putServicesGraphQLQuery(proposalsId, services, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      putServices(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalsId), ", attendees: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(services), ") {\n        id\n        greatMembersLoyaltyPoints\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_UPDATE */ "Jc"]
  });
};
/**
 * We don't want to have this request in parallel, it's a put and it can be really long, so we create a queue to do
 * these requests synchronously
 */


var serviceRequestRunning = null;

var putServicesMutation = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee(proposalIds, attendees, appContext) {
    var result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (serviceRequestRunning) {
              _context.next = 15;
              break;
            }

            serviceRequestRunning = putServicesGraphQLQuery(proposalIds, attendees, appContext);
            _context.prev = 2;
            _context.next = 5;
            return serviceRequestRunning;

          case 5:
            result = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            throw _context.t0;

          case 11:
            _context.prev = 11;
            serviceRequestRunning = null;
            return _context.finish(11);

          case 14:
            return _context.abrupt("return", result);

          case 15:
            _context.next = 17;
            return serviceRequestRunning;

          case 17:
            return _context.abrupt("return", putServicesMutation(proposalIds, attendees, appContext));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8, 11, 14]]);
  }));

  return function putServicesMutation(_x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var deleteServiceGraphQLQuery = function deleteServiceGraphQLQuery(_ref2) {
  var proposalIds = _ref2.proposalIds,
      serviceIds = _ref2.serviceIds,
      attendeeIds = _ref2.attendeeIds,
      overloadForSpecificProposalIds = _ref2.overloadForSpecificProposalIds,
      appContext = _ref2.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      deleteService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalIds), " serviceIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(serviceIds), " attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeIds), " ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        greatMembersLoyaltyPoints\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_DELETE */ "Ic"]
  });
};

var deleteServicesMutation = /*#__PURE__*/function () {
  var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee2(_ref3) {
    var proposalIds, serviceIds, attendeeIds, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalIds = _ref3.proposalIds, serviceIds = _ref3.serviceIds, attendeeIds = _ref3.attendeeIds, overloadForSpecificProposalIds = _ref3.overloadForSpecificProposalIds, appContext = _ref3.appContext;

            if (serviceRequestRunning) {
              _context2.next = 16;
              break;
            }

            serviceRequestRunning = deleteServiceGraphQLQuery({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            });
            _context2.prev = 3;
            _context2.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            throw _context2.t0;

          case 12:
            _context2.prev = 12;
            serviceRequestRunning = null;
            return _context2.finish(12);

          case 15:
            return _context2.abrupt("return", result);

          case 16:
            _context2.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context2.abrupt("return", deleteServicesMutation({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9, 12, 15]]);
  }));

  return function deleteServicesMutation(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

var addServiceGraphQLQuery = function addServiceGraphQLQuery(_ref5) {
  var proposalIds = _ref5.proposalIds,
      serviceId = _ref5.serviceId,
      attendeeIds = _ref5.attendeeIds,
      schedules = _ref5.schedules,
      overloadForSpecificProposalIds = _ref5.overloadForSpecificProposalIds,
      appContext = _ref5.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalIds), ", serviceId: \"").concat(serviceId, "\", attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeIds), ", schedules: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(schedules), "  ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        greatMembersLoyaltyPoints\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_ADD */ "Hc"]
  });
};

var addServiceMutation = /*#__PURE__*/function () {
  var _ref7 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee3(_ref6) {
    var proposalIds, serviceId, attendeeIds, schedules, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            proposalIds = _ref6.proposalIds, serviceId = _ref6.serviceId, attendeeIds = _ref6.attendeeIds, schedules = _ref6.schedules, overloadForSpecificProposalIds = _ref6.overloadForSpecificProposalIds, appContext = _ref6.appContext;

            if (serviceRequestRunning) {
              _context3.next = 16;
              break;
            }

            serviceRequestRunning = addServiceGraphQLQuery(_objectSpread(_objectSpread({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules
            }, overloadForSpecificProposalIds && {
              overloadForSpecificProposalIds: {
                proposalIds: overloadForSpecificProposalIds.proposalIds,
                serviceId: overloadForSpecificProposalIds.serviceIds[0]
              }
            }), {}, {
              appContext: appContext
            }));
            _context3.prev = 3;
            _context3.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context3.sent;
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            throw _context3.t0;

          case 12:
            _context3.prev = 12;
            serviceRequestRunning = null;
            return _context3.finish(12);

          case 15:
            return _context3.abrupt("return", result);

          case 16:
            _context3.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context3.abrupt("return", addServiceMutation({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 9, 12, 15]]);
  }));

  return function addServiceMutation(_x7) {
    return _ref7.apply(this, arguments);
  };
}();

function promoCodeProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      promoCodeProposal(type: \"".concat(params.type, "\", id: \"").concat(params.proposalId, "\", promoCode: \"").concat(params.promoCode, "\" ").concat(params.partnerId && params.accessCode ? ", partnerId: \"".concat(params.partnerId, "\", accessCode: \"").concat(params.accessCode, "\"") : '', " ").concat(params.customerId && params.type === 'apply' ? ", customerId: ".concat(params.customerId) : '', ") {\n        id\n        price {\n          aggregateDiscount {\n            offerColor\n            offerName\n            amount {...priceDetails}\n          }\n          aggregateDiscountPromoCode {\n            offerColor\n            offerName\n            amount {...priceDetails}\n         }\n          promoCode {\n            offerColor\n            offerName\n            amount {\n              value\n              formattedValue\n            }\n          }\n          total {...priceDetails}\n          discounts {\n            offerId\n            amount {...priceDetails}\n            offerName\n            offerColor\n            offerDescription\n            offerLabel\n            offerType\n            currentProposalCode {\n              id\n              label\n              description\n              value\n              unit\n            }\n          }\n        }\n        attendeesPrice {\n          id\n          householdId\n          total {\n            ...priceDetails\n            currency\n          }\n          priceItems {\n            type\n            offerId\n            price {\n              ...priceDetails\n              currency\n            }\n          }\n        }\n        households {\n          attendees {\n            id\n            customerId\n            birthdate\n            isAdult\n            isMain\n          }\n          paymentSchedule {\n            commissionIncluded\n            total {...priceDetails}\n            depositAmount {...priceDetails}\n            repaymentSchedules{\n              amount {...priceDetails}\n              deadline\n            }\n          }\n        }\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_USE_PROMO_CODE */ "Zc"]
  });
}

function autosaveProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      autosaveProposal(id: \"".concat(params.proposalId, "\") {\n        id\n        }\n    }\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_AUTOSAVE */ "Lc"]
  });
}

function switchProposalsOffers(proposalIds, offerIds, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("mutation {\n      proposals: switchProposalsOffers(proposalIds: [\"".concat(proposalIds.join('","'), "\"], offerIds: [\"").concat(offerIds.join('","'), "\"]) {\n        id\n        greatMembersLoyaltyPoints\n        optionAvailable\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_SWITCH_OFFER */ "Wc"]
  });
}

function refreshProposal(proposalId, salesNetworkId, appContext) {
  var graphqlParams = "id: \"".concat(proposalId, "\"").concat(salesNetworkId ? ", salesNetworkId: \"".concat(salesNetworkId, "\"") : '');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    query {\n      refreshProposal (".concat(graphqlParams, ") {\n        proposal {\n          id\n          productId\n          optionAvailable\n          optionDurability {\n            expirationDateTime\n            isReliable\n          },\n          duration\n          extendPersistence\n          price {\n            ...refreshProposalPrice\n          }\n          remainingStock\n          households {\n            attendees {\n              id\n              customerId\n              customerType\n              birthdate\n            }\n          }\n          transportationSummary {\n            way\n            departureCity\n            arrivalCity\n            transportationType\n            cancellationPolicyType\n            clubmedTransport\n            departureDate\n            arrivalDate\n          }\n          isBookable\n          creationDateTime\n          packageId\n          resortArrivalDate\n          resortDepartureDate\n          accommodations {\n            id\n            quantity\n            sharedRoom\n          }\n          label\n          locale\n          alternativePrice {\n            ...refreshProposalPrice\n          }\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n          errorDescription\n        }\n      }\n    }\n    fragment refreshProposalPrice on RefreshProposalPriceType {\n      currency\n      total {...priceDetails}\n      totalWithoutFees {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      discounts {\n        type\n        amount {...priceDetails}\n        offerId\n        currentProposalCode {\n          id\n          label\n          description\n          value\n          unit\n        }\n      }\n      yieldPricingVariation {...priceDetails}\n      trip {\n        initialPrice {...priceDetails}\n        initialPriceWithFees {...priceDetails}\n        fees {\n          type\n          amount {...priceDetails}\n        }\n      }\n      includedServices {\n        id\n        amount {...priceDetails}\n      }\n      packageOptions {\n        type\n        amount {...priceDetails}\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_REFRESH */ "Uc"]
  });
}



/***/ }),

/***/ "7BVm":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "7Z8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openToast; });
/* unused harmony export showTemporaryToast */
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rJ95");



var CLOSE_TOAST = 'CLOSE_TOAST';
var OPEN_TOAST = 'OPEN_TOAST';

function openToast(toastLabel, className, style) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(OPEN_TOAST, {
    className: className,
    toastLabel: toastLabel,
    style: style
  });
}

function closeToast() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(CLOSE_TOAST);
}

var showTemporaryToast = function showTemporaryToast(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 2000 : _ref$timeout,
      toastLabel = _ref.toastLabel;
  return function (dispatch) {
    return Promise.resolve(dispatch(openToast(toastLabel, className, style))).then(function () {
      setTimeout(function () {
        return dispatch(closeToast());
      }, timeout);
    });
  };
};



/***/ }),

/***/ "8+jV":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("SRps");
var store = __webpack_require__("l6h7");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.29.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.29.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "87KK":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("+xJO");
var anObject = __webpack_require__("ep/x");
var toPropertyKey = __webpack_require__("RWUY");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8D46":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "8miM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormErrors; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DwNm");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;


var FormErrors = function FormErrors(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      _ref$texts = _ref.texts,
      texts = _ref$texts === void 0 ? [] : _ref$texts;
  return __jsx("div", {
    className: className,
    "data-testid": dataTestId
  }, texts.map(function (text) {
    return __jsx(_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_2__[/* FormFeedback */ "a"], {
      key: text,
      isError: true,
      message: text
    });
  }));
};

/***/ }),

/***/ "8uyH":
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__("dpio"),
    baseAggregator = __webpack_require__("OekA"),
    baseIteratee = __webpack_require__("S3pA"),
    isArray = __webpack_require__("wxYD");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ "9KBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsletterForm; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Ub5k");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("L7OA");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("/HC4");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;






var subscriptionSchema = function subscriptionSchema(displayEmailInput, displayPhoneInput, locale) {
  return function () {
    return yup__WEBPACK_IMPORTED_MODULE_1__["object"]().shape({
      civility: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
      firstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(20, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.fieldTooLong', {
        label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.firstName'),
        maxlength: 20
      })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
      .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
      lastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(30, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.fieldTooLong', {
        label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.lastName'),
        maxlength: 30
      })) // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
      .matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.noSpecialCharsField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
      unicodeFirstName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
      unicodeLastName: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().max(100),
      email: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().when([], {
        is: function is() {
          return displayEmailInput;
        },
        then: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().nullable().when('phone', {
          is: function is(phone) {
            return !phone;
          },
          then: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().email(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.invalidEmailField')).required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
          otherwise: yup__WEBPACK_IMPORTED_MODULE_1__["string"]().notRequired()
        })
      }),
      phone: yup__WEBPACK_IMPORTED_MODULE_1__["number"]().nullable().when([], {
        is: function is() {
          return displayPhoneInput;
        },
        then: yup__WEBPACK_IMPORTED_MODULE_1__["number"]().when('email', {
          is: function is(email) {
            return !email;
          },
          then: yup__WEBPACK_IMPORTED_MODULE_1__["number"]().required(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.errors.requiredField')),
          otherwise: yup__WEBPACK_IMPORTED_MODULE_1__["number"]().notRequired()
        })
      }),
      // add conditional validation if legalAgreement is locale is russian
      legalAgreement: locale === 'ru-RU' ? yup__WEBPACK_IMPORTED_MODULE_1__["boolean"]().oneOf([true], Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.participants.errorMessage.legalAgreement')) : yup__WEBPACK_IMPORTED_MODULE_1__["boolean"]().notRequired().nullable()
    });
  };
};
var NewsletterForm = function NewsletterForm() {
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_2__[/* useAppContext */ "c"])();
  var locale = appContext.locale;

  var _useMemo = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
    return [Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_4__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.displayPhoneInput') && {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('newsletter.signup.mobileNumber'),
      name: 'phone',
      type: 'tel'
    }, Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_4__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.displayEmailInput') && {
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.participants.labels.email'),
      name: 'email',
      placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.inputFormats.email'),
      type: 'email'
    }];
  }, [locale]),
      phoneInputProps = _useMemo[0],
      emailInputProps = _useMemo[1];

  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx("div", {
    className: "-mx-10 md:flex"
  }, __jsx("div", {
    className: "w-full px-10 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.participants.labels.civility'),
    name: "civility",
    options: [{
      isDisabled: true,
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.participants.labels.civility'),
      value: ''
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('newsletter.signup.civilityMale'),
      value: 'M'
    }, {
      name: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('newsletter.signup.civilityFemale'),
      value: 'F'
    }],
    type: "select"
  })), __jsx("div", {
    className: "mt-15 w-full px-10 md:mt-0 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.firstName'),
    name: "firstName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.firstName'),
    type: "text"
  })), __jsx("div", {
    className: "mt-15 w-full px-10 md:mt-0 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    isRequired: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.lastName'),
    name: "lastName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.lastName'),
    type: "text"
  }))), appContext.displayUnicodeFields && Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_4__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.displayUnicodeFields') && __jsx("div", {
    className: "-mx-10 mt-15 md:flex"
  }, __jsx("div", {
    className: "w-full px-10 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.unicodeFirstName'),
    name: "unicodeFirstName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.unicodeFirstName'),
    type: "text"
  })), __jsx("div", {
    className: "mt-15 w-full px-10 md:mt-0 md:w-1/3"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], {
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.unicodeLastName'),
    name: "unicodeLastName",
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.form.labels.unicodeLastName'),
    type: "text"
  }))), phoneInputProps && __jsx("div", {
    className: "mt-15"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], phoneInputProps)), emailInputProps && __jsx("div", {
    className: "mt-15"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_5__[/* FormikInput */ "a"], emailInputProps)));
};

/***/ }),

/***/ "9LZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBookingEngineI18nQuery; });
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");


function fetchBookingEngineI18nQuery(appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].runQuery('', appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"],
    queryId: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"]
  });
}

/***/ }),

/***/ "9YYj":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "9jKB":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("bWWS");
var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");
var createNonEnumerableProperty = __webpack_require__("g51W");
var hasOwn = __webpack_require__("/GgU");
var shared = __webpack_require__("l6h7");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "9vpE":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "A+R+":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("4gXF");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "A0C2":
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__("a49g"),
    isIndex = __webpack_require__("pnw1");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),

/***/ "ANQd":
/***/ (function(module, exports, __webpack_require__) {

var $documentAll = __webpack_require__("S8S5");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "AY+A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationContact", function() { return NavigationContact; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _Navigation_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("4Grf");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("jD8k");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("MWZw");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kiXb");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;













var NavigationContact = function NavigationContact(_ref) {
  var _ref$contact = _ref.contact,
      contact = _ref$contact === void 0 ? {} : _ref$contact,
      hasTel = _ref.hasTel,
      isBookingEnginePage = _ref.isBookingEnginePage;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_6__[/* useTracking */ "a"])();
  var description = contact.description,
      hours = contact.hours,
      _contact$phoneNumber = contact.phoneNumber,
      phoneNumber = _contact$phoneNumber === void 0 ? '' : _contact$phoneNumber,
      _contact$title = contact.title,
      title = _contact$title === void 0 ? '' : _contact$title,
      toll = contact.toll,
      storeLocatorLabel = contact.storeLocatorLabel,
      storeLocatorLink = contact.storeLocatorLink,
      _contact$whatsAppNumb = contact.whatsAppNumber,
      whatsAppNumber = _contact$whatsAppNumb === void 0 ? '' : _contact$whatsAppNumb,
      whatsappHours = contact.whatsappHours;
  var link = "tel:".concat(phoneNumber);

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_12__["useRouter"])(),
      bookingId = _useRouter.query.bi;

  if (!isBookingEnginePage) {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_10__[/* Title */ "a"], {
      className: "mb-10",
      theme: "title-sans-n4"
    }, title), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
      "data-testid": "NavigationContact-description",
      text: description
    }), toll && __jsx("p", {
      className: "mb-20 font-sans text-12 leading-normal text-mediumGrey",
      "data-testid": "NavigationContact-toll"
    }, toll), whatsAppNumber !== '' && __jsx("p", {
      className: "font-bold"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('navigationBar.contact.byPhone')), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
      className: "mt-10 text-sienna",
      "data-testid": "NavigationContact-hours",
      text: hours,
      theme: "text-sans-n2"
    }), phoneNumber && hasTel && __jsx("div", {
      className: "mt-20 flex items-center justify-center"
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_7__[/* Button */ "a"], {
      "data-testid": "phoneNumber-button",
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].SAFFRON,
      colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].SAFFRON,
      iconLeft: {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].PHONE_BUBBLE
      },
      onClick: function onClick() {
        return track(Object(_Navigation_tracking__WEBPACK_IMPORTED_MODULE_5__[/* getNavigationCallCenterButtonTrackingData */ "c"])(phoneNumber));
      },
      url: link
    }, __jsx("span", {
      dir: "ltr"
    }, phoneNumber))), whatsAppNumber !== '' && __jsx(react__WEBPACK_IMPORTED_MODULE_2___default.a.Fragment, null, __jsx("p", {
      className: "mt-40 font-bold"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('navigationBar.contact.byWhatsApp')), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
      className: "mt-10 text-sienna",
      "data-testid": "NavigationContact-hours-whatsApp",
      text: whatsappHours,
      theme: "text-sans-n2"
    }), __jsx("div", {
      className: "mb-40 mt-30 flex items-center justify-center"
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_7__[/* Button */ "a"], {
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].WHITE,
      colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLACK,
      "data-testid": "whatsAppCTA",
      iconLeft: {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].WHATSAPP,
        width: '1.715em'
      },
      onClick: function onClick() {
        return track({
          event: 'eventGA',
          categoryGA: 'headerMenu',
          actionGA: 'header_contact',
          labelGA: 'whatsapp',
          valueGA: 0,
          nonInteraction: 0
        });
      },
      url: whatsAppNumber
    }, __jsx("span", {
      dir: "ltr"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('navigationBar.contact.whatsappCTA'))))), !!(storeLocatorLabel && storeLocatorLink) && __jsx("div", {
      className: "mt-10 flex justify-center gap-10"
    }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_14__[/* Icon */ "a"], {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].TRIDENT,
      width: "1.5em"
    }), __jsx(_frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__[/* TextLink */ "a"], {
      className: "text-12 font-bold underline",
      label: storeLocatorLabel,
      onClick: function onClick() {
        return track({
          actionGA: 'header_contact',
          categoryGA: 'headerMenu',
          labelGA: 'clickStoreLocator'
        });
      },
      url: storeLocatorLink
    })));
  }

  return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], null, __jsx("p", {
    className: "mb-20 mt-0 font-brand text-18 text-sienna",
    "data-testid": "contact-popin-title"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('navigationBar.contact.advice')), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    "data-testid": "NavigationContact-description",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('booking.confirmation.noteReference')
  }), __jsx("p", {
    className: "mb-20 mt-0 font-brand text-18 text-sienna",
    "data-testid": "contact-popin-bookingId"
  }, bookingId), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    "data-testid": "NavigationContact-description",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('booking.confirmation.callTravelAgent')
  }), __jsx("div", {
    className: "flex items-baseline gap-15"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_14__[/* Icon */ "a"], {
    className: "text-sienna",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].PHONE_BUBBLE
  }), __jsx("p", {
    className: "mb-10 mt-0 font-brand text-18 text-sienna underline",
    "data-testid": "contact-popin-phone-number"
  }, __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"], {
    url: link
  }, phoneNumber))), toll && __jsx("p", {
    className: "font-sans text-12 leading-normal text-mediumGrey",
    "data-testid": "NavigationContact-toll"
  }, toll), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    className: "text-sienna",
    "data-testid": "NavigationContact-hours",
    text: hours,
    theme: "text-sans-n2"
  }), phoneNumber && hasTel && __jsx("div", {
    className: "mt-20 flex items-center justify-center"
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_7__[/* Button */ "a"], {
    iconLeft: {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].PHONE_BUBBLE
    },
    onClick: function onClick() {
      return track(Object(_Navigation_tracking__WEBPACK_IMPORTED_MODULE_5__[/* getNavigationCallCenterButtonTrackingData */ "c"])(phoneNumber));
    },
    url: link
  }, __jsx("span", {
    dir: "ltr"
  }, phoneNumber))));
};

/***/ }),

/***/ "AZSF":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "AbLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePrevious; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(value); // Store current value in ref

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
};

/***/ }),

/***/ "AnR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ applyProposalPromoCode; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ removeProposalPromoCode; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ addAccommodation; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ putTransportAndDispatchProposals; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ proposals_action_addAdditionalService; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ proposals_action_deleteAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "z", function() { return /* binding */ updateAttendees; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ clearProposals; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ fetchProposalsAndRedirect; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ fetchProposalsById; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ proposals_action_fetchSelectedProposalPayment; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ proposals_action_saveCustomerProposalsHandler; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ proposals_action_saveCustomerProposalsOpportunityIdHandler; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ proposals_action_patchProposalHandler; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ proposals_action_deleteInsurances; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ proposals_action_addInsurances; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ refuseInsuranceAction; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ proposals_action_prepareBe; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ displayToastOnContextShare; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ editCriteriaFetchProposals; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* binding */ simpleFetchProposals; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* binding */ proposals_action_saveDonationToProposals; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ proposals_action_addOrReplaceAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "y", function() { return /* binding */ proposals_action_switchProposalsOffers; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ getTransportSearchCriteria; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ fetchRefreshProposal; });

// UNUSED EXPORTS: getNumberOfAttendees, handleError, setProposalAsAutosaved

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("IAdD");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__("Qavd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__("CzFL");
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/intersection.js
var intersection = __webpack_require__("Nsha");
var intersection_default = /*#__PURE__*/__webpack_require__.n(intersection);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesUtils.js












function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var ATTENDEE_SCHEMA_PROPERTIES = ['id', 'lastName', 'firstName', 'unicodeLastName', 'unicodeFirstName', 'birthdate', 'email', 'mobile', 'optinSms', 'optinMail', 'optinFosun', 'optinEmail', 'optinPhone', 'optinClubmedPlus', 'civility', 'identityNumber', 'healthPassId', 'travelDocuments', 'customerId', 'address', 'mainContactId', 'isChild', 'optinsCGU'];
/**
 * Remove all properties that don't match GQL Schema Otherwise the mutation fails
 */

var attendeesUtils_removeUselessProperties = function removeUselessProperties(attendee) {
  var travelDocuments = attendee.document ? Object.keys(attendee.document).reduce(function (fullDocuments, type) {
    var document = attendee.document[type] || {};

    if (!isEmpty_default()(document)) {
      var newDocument = {}; // We fill all fields once we have a documentNumber

      if (document.documentNumber) {
        newDocument.document_number = document.documentNumber || undefined;
        newDocument.issuing_country = (document === null || document === void 0 ? void 0 : document.issuingCountry) || undefined;
        newDocument.birth_country = (document === null || document === void 0 ? void 0 : document.birthCountry) || undefined;
        newDocument.birth_city = (document === null || document === void 0 ? void 0 : document.birthCity) || undefined;
        newDocument.second_name = (document === null || document === void 0 ? void 0 : document.secondName) || undefined;
        newDocument.third_name = (document === null || document === void 0 ? void 0 : document.thirdName) || undefined;
        newDocument.fourth_name = (document === null || document === void 0 ? void 0 : document.fourthName) || undefined;
        newDocument.expiration_date = Object(apiDate["n" /* timestampToApiDate */])(document === null || document === void 0 ? void 0 : document.expirationDate) || undefined;
        newDocument.issuing_date = Object(apiDate["n" /* timestampToApiDate */])(document === null || document === void 0 ? void 0 : document.issuingDate) || undefined;
        newDocument.nationality = document.nationality || undefined;
        newDocument.type = (document === null || document === void 0 ? void 0 : document.type) || undefined;
      }

      if (!isEmpty_default()(newDocument)) {
        fullDocuments.push(newDocument);
      }
    }

    return fullDocuments;
  }, []) : [];
  return pick_default()(_objectSpread(_objectSpread({}, attendee), {}, {
    travelDocuments: travelDocuments,
    // keep customerId like this because we cannot update attendees for B2C
    customerId: attendee.neolid,
    birthdate: Object(apiDate["n" /* timestampToApiDate */])(attendee.birthdate)
  }), ATTENDEE_SCHEMA_PROPERTIES);
};
// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesQuery.js








/**
 * Connected customer experience : Put attendees
 */

function updateAttendeesMutation(_ref) {
  var proposalId = _ref.proposalId,
      attendees = _ref.attendees,
      appContext = _ref.appContext;
  var adults = attendees.adults.map(attendeesUtils_removeUselessProperties);
  var children = attendees.children.map(attendeesUtils_removeUselessProperties);
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      modifyAttendees (\n        proposalId: \"".concat(proposalId, "\",\n        adults: ").concat(Object(graphql["d" /* graphqlify */])(adults), ",\n        children: ").concat(Object(graphql["d" /* graphqlify */])(children), "\n        ) {\n        proposal {\n          id\n          attendees {\n            list {\n              id\n              customerId\n              civility\n              firstName\n              lastName\n              birthdate\n              email\n              optins {\n                channel\n                optin\n              }\n            }\n          }\n          households {\n            attendees {\n              id\n              customerId\n              birthdate\n              isAdult\n              isMain\n            }\n            ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n          }\n          ").concat(Object(proposalQuery["l" /* proposalPriceQuery */])(), "\n        }\n        errors {\n          concernedAttendees\n          errorKey\n          errorValue\n          errorCode\n          errorDescription\n        }\n        attendees {\n          id\n          ").concat(appContext.isSeller ? 'gmNumber' : '', "\n          customerId\n          customerType\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(get_default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["Yc" /* PROPOSAL_UPDATE_ATTENDEES */]
  });
}

var attendeesQuery_queryBookingAttendees = function queryBookingAttendees(bookingId) {
  return graphqlClient["a" /* default */].runQuery("query {\n    bookingAttendees(bookingId: ".concat(bookingId, ") {\n      civility\n      gmNumber\n      customerId\n      identityNumber\n      healthPassId\n      mainContact\n      lastName\n      unicodeLastName\n      firstName\n      unicodeFirstName\n      email\n      birthdate\n    }\n  }"));
};


// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 2 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/store/booking/attendees/attendees.selector.js
var attendees_selector = __webpack_require__("eZ08");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.action.js



























/* eslint-disable flowtype/no-weak-types */

var _BOOKING_ENGINE_ENTRY;

function proposals_action_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function proposals_action_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? proposals_action_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : proposals_action_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





























var BOOKING_ENGINE_ENTRY_TRACKING_LABELS = (_BOOKING_ENGINE_ENTRY = {}, Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR, 'calendarPrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE, 'remotePrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].QUICK_SEARCH, 'quickSearch'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].CRUISE_BOOKING, 'cruiseBooking'), _BOOKING_ENGINE_ENTRY);

function throwFormatError(data) {
  // $FlowFixMe
  var error = Object.assign(new Error(), data);
  throw error;
}

function applyProposalPromoCode(proposalId, params, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["F" /* SET_PROMO_CODE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["j" /* promoCodeProposalMutation */])(proposals_action_objectSpread(proposals_action_objectSpread({}, params), {}, {
      proposalId: proposalId,
      type: 'apply'
    }), appContext)
  });
}

function removeProposalPromoCode(proposalId, params, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["A" /* REMOVE_PROMO_CODE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["j" /* promoCodeProposalMutation */])(proposals_action_objectSpread(proposals_action_objectSpread({}, params), {}, {
      proposalId: proposalId,
      type: 'remove'
    }), appContext)
  });
}

function setProposalAsAutosaved(proposalId, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["g" /* AUTOSAVE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["d" /* autosaveProposalMutation */])({
      proposalId: proposalId
    }, appContext)
  });
}

function fetchProposalsById(_ref) {
  var proposalsId = _ref.proposalsId,
      appContext = _ref.appContext,
      shouldRequestPayment = _ref.shouldRequestPayment,
      adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return function (dispatch, getState) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */], {}, {
      optimist: true,
      promise: Object(BookingEngine_query["e" /* proposalsByIdQuery */])({
        proposalsId: proposalsId,
        shouldRequestPayment: shouldRequestPayment,
        adultsAttendeesIds: adultsAttendeesIds,
        kidsAttendeesIds: kidsAttendeesIds,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities'),
        selectedProposalId: Object(booking_selector["v" /* getSelectedProposalId */])(getState())
      }, appContext)
    }));
  };
}

function getNumberOfAttendees() {
  var nbAdults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var nbKids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isSeller = arguments.length > 2 ? arguments[2] : undefined;
  var numberOfAttendees = nbAdults + nbKids;
  var maxPaxByUser = isSeller ? faceting_constants["L" /* MAX_PAX_SELLER */] : faceting_constants["K" /* MAX_PAX */];
  /** reset to default adults number if no adults or if the number exceeds the allowed sum (maxPaxByUser) */

  return numberOfAttendees === 0 || numberOfAttendees > maxPaxByUser ? adults_constants["a" /* DEFAULT_ADULTS_NB */] : numberOfAttendees;
}

function getTransportSearchCriteria(_ref2) {
  var _inbound$travelSectio;

  var proposal = _ref2.proposal,
      flightClass = _ref2.flightClass,
      _ref2$directFlights = _ref2.directFlights,
      directFlights = _ref2$directFlights === void 0 ? false : _ref2$directFlights,
      departureCity = _ref2.departureCity;

  if (!proposal.transports) {
    return {};
  }

  var _proposal$transports = proposal.transports,
      inbound = _proposal$transports.inbound,
      outbound = _proposal$transports.outbound;

  function formatTransportDetail(transportDetail, way) {
    var arrivalDate = proposal.arrivalDate,
        departureDate = proposal.departureDate;
    var firstTravelSection = transportDetail.travelSections[0];
    var lastTravelSection = transportDetail.travelSections[transportDetail.travelSections.length - 1];
    return {
      way: way,
      travelSections: [{
        departure: {
          city: {
            id: way === 'INBOUND' ? departureCity || firstTravelSection.departure.cityId : firstTravelSection.departure.cityId
          },
          date: way === 'INBOUND' ? '' : departureDate,
          location: {
            id: firstTravelSection.departure.id,
            terminalCode: firstTravelSection.departure.terminalCode
          }
        },
        arrival: {
          city: {
            id: way === 'INBOUND' ? lastTravelSection.arrival.cityId : departureCity || lastTravelSection.arrival.cityId
          },
          date: way === 'INBOUND' ? arrivalDate : '',
          location: {
            id: lastTravelSection.arrival.id,
            terminalCode: lastTravelSection.arrival.terminalCode
          }
        }
      }]
    };
  }

  return {
    journeys: [formatTransportDetail(inbound, 'INBOUND'), formatTransportDetail(outbound, 'OUTBOUND')],
    transportClass: flightClass || (inbound === null || inbound === void 0 ? void 0 : (_inbound$travelSectio = inbound.travelSections[0].transport) === null || _inbound$travelSectio === void 0 ? void 0 : _inbound$travelSectio["class"]),
    isDirectFlightOnly: directFlights,
    maxConnections: directFlights ? 0 : undefined,
    transportConnectionDuration: undefined,
    isTransportStationsChangesAllowed: undefined,
    isCabinMixingAllowed: undefined,
    isCompaniesMixingAllowed: undefined,
    imposedCompanies: undefined,
    imposedConnectionCities: undefined,
    excludedCompanies: undefined,
    excludedConnectionCities: undefined
  };
}
/*
  ATTENTION:
  Les valeurs par défaut de departureCity et duration sont mises dans le CMS,
  on ne peut donc pas récupérer les valeurs du store
 */


function fetchProposalsAndRedirect(params, appContext, router) {
  var pageType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Booking Engine';
  return function (dispatch, getState) {
    var _queryParams$kids, _queryParams$kids$spl;

    var state = getState();
    var intArrivalDate = params.newArrivalDate || Object(storeHelper["a" /* getArrivalDate */])(state) || Object(apiDate["n" /* timestampToApiDate */])(state.tripCriteria.departureDate);

    if (!intArrivalDate) {
      // $FlowFixMe
      logger["default"].error('the arrivalDate is required in fetchProposalsAndRedirect action');
      return;
    }

    var queryParams = omit_default()(router.query, ['dynamicPage']);

    var adultsAttendees = Object(trip_information_storeHelper["a" /* getAdults */])(state) || [];
    var kidsAttendees = Object(trip_information_storeHelper["c" /* getKids */])(state) || [];
    var nbAdults = appContext.isSeller ? Number(queryParams.number_of_adults || adultsAttendees.length) : adultsAttendees.length;
    var nbKids = appContext.isSeller ? ((_queryParams$kids = queryParams.kids) === null || _queryParams$kids === void 0 ? void 0 : (_queryParams$kids$spl = _queryParams$kids.split('_')) === null || _queryParams$kids$spl === void 0 ? void 0 : _queryParams$kids$spl.length) || 0 : kidsAttendees.length;
    var allowedAttendeesNumber = getNumberOfAttendees(nbAdults, nbKids, appContext.isSeller);

    var proposalParams = proposals_action_objectSpread(proposals_action_objectSpread({
      arrivalDate: intArrivalDate.toString(),
      kids: kidsAttendees,
      adults: adultsAttendees,
      numberAttendees: allowedAttendeesNumber,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }, appContext.isSeller ? {
      salesNetworkId: queryParams.cxo_sales_network_id
    } : null), params);

    var redirectUri = Object(sellerUtils["d" /* getSigninURIWithRedirection */])({
      locale: appContext.locale,
      proposalId: null,
      step: null,
      isCmta: appContext.isCmta
    });
    /**  Method 5 steps
     * 1. fetch BE i18n config
     * 2. fetch proposal
     * 3. send tracking
     * 4. Set search criteria if transport for MoreTransports
     * 5. redirect to signin redirection URL
     */

    /* 1. fetch BE i18n config */

    dispatch(Object(cms_actions["c" /* getBookingEngineI18n */])(appContext));
    /* 2. fetch proposal */

    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_PROPOSALS */], {
      globalLoaderLabel: params.globalLoaderLabel,
      bookingEngineEntry: params.bookingEngineEntry
    }, {
      optimist: true,
      promise: Object(proposalQuery["m" /* proposalsQuery */])(proposalParams, appContext).then(function (response) {
        var _proposals$errors, _proposals$errors$;

        var proposals = response.proposals;
        var isFetchProposalsFailed = Object(proposalUtils["p" /* hasFetchProposalsFailed */])(proposals);

        if (!isFetchProposalsFailed) {
          var bookingUrl = Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals || [], proposals.resort, undefined, queryParams);
          /* 5. redirect to signin redirection URL */

          router.push(bookingUrl);
        }

        var errorCode = proposals === null || proposals === void 0 ? void 0 : (_proposals$errors = proposals.errors) === null || _proposals$errors === void 0 ? void 0 : (_proposals$errors$ = _proposals$errors[0]) === null || _proposals$errors$ === void 0 ? void 0 : _proposals$errors$.errorCode;
        tracking_api["b" /* setDataLayer */]({
          categoryGA: 'resort',
          actionGA: BOOKING_ENGINE_ENTRY_TRACKING_LABELS[params.bookingEngineEntry],
          labelGA: isFetchProposalsFailed ? "errorCheckPrices".concat(errorCode ? "_".concat(snakeCase_default()(errorCode).toUpperCase()) : '') : 'checkPrices',
          siteSection: "Shopping_".concat(pageType)
        }, appContext);
        return response;
      }),
      redirect_uri: redirectUri
    }));
  };
}

function handleError(errors, appContext) {
  var _error$errors, _error$errors$; // We don't do anything specific with the errors, but this will let us display per field errors


  logger["default"].error(errors);
  var error = errors.errors ? errors : {
    errors: errors
  }; // Redirect to oidc if the statusCode is 401

  if (ple_utils["l" /* hasAuthResponseError */](error)) {
    Object(redirectUtils["a" /* redirectToOidc */])(appContext);
    return;
  } // Some errors are properly handled by graphql. But we don't handle them explicitly
  // We rely on the message to know the source of the error because of babel < 7


  throwFormatError(proposals_action_objectSpread(proposals_action_objectSpread({}, error), {}, {
    statusCode: error.message === 'Unhandled field form error' ? statusCode_constants["b" /* STATUS_CODE_400 */] : // $FlowFixMe
    error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.statusCode
  }));
}

function editCriteriaFetchProposals(criteria, proposalsLoderLabel, appContext, queryParams) {
  return function (dispatch, getState) {
    var _attendees$kids;

    var search = criteria.search,
        departure = criteria.departure,
        attendees = criteria.attendees,
        departureCity = criteria.departureCity;
    var payload = {
      globalLoaderLabel: proposalsLoderLabel
    };
    var state = getState();

    var _selectAttendeesWithI = Object(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */])(state),
        _selectAttendeesWithI2 = _selectAttendeesWithI.attendees,
        adultsAttendees = _selectAttendeesWithI2.adults,
        kidsAttendees = _selectAttendeesWithI2.children;

    var adults = new Array(attendees.adults).fill({}).map(function (_, index) {
      return {
        neolid: (adultsAttendees[index] || {}).customerId
      };
    });
    var kids = attendees.kids.map(function (kid) {
      var kidFromStore = kidsAttendees === null || kidsAttendees === void 0 ? void 0 : kidsAttendees.find(function (kidAtt) {
        return kidAtt.birthdate === kid.birthdate;
      });
      return {
        neolid: kidFromStore === null || kidFromStore === void 0 ? void 0 : kidFromStore.customerId,
        birthdate: kid.birthdate
      };
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */], payload, {
      optimist: true,
      promise: Object(proposalQuery["m" /* proposalsQuery */])(proposals_action_objectSpread({
        productId: search.value,
        arrivalDate: moment_default()(departure.date).format('YYYYMMDD'),
        duration: departure.duration,
        departureCity: departureCity.value,
        isJoyView: criteria.isJoyView,
        isUrbanOasis: criteria.isUrbanOasis,
        kids: kids,
        adults: adults,
        numberAttendees: getNumberOfAttendees(attendees.adults, (attendees === null || attendees === void 0 ? void 0 : (_attendees$kids = attendees.kids) === null || _attendees$kids === void 0 ? void 0 : _attendees$kids.length) || 0, appContext.isSeller),
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
      }, appContext.isSeller ? {
        salesNetworkId: queryParams.cxo_sales_network_id
      } : null), appContext)
    }));
  };
}

function simpleFetchProposals(criterias, proposalsLoaderLabel, appContext, location) {
  var productId = criterias.productId,
      arrivalDate = criterias.arrivalDate,
      duration = criterias.duration,
      attendees = criterias.attendees,
      departureCity = criterias.departureCity,
      bookingEngineEntry = criterias.bookingEngineEntry;
  var payload = {
    globalLoaderLabel: proposalsLoaderLabel,
    bookingEngineEntry: bookingEngineEntry
  };

  var sellerParams = proposals_action_objectSpread(proposals_action_objectSpread({}, Object(ContactInfoUtils["f" /* getAllAttendeesIds */])({
    adults: attendees.adults,
    kids: attendees.kids
  })), {}, {
    salesNetworkId: location.queryParams.cxo_sales_network_id
  });

  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_PROPOSALS */], payload, {
    optimist: true,
    promise: Object(proposalQuery["m" /* proposalsQuery */])(proposals_action_objectSpread(proposals_action_objectSpread({}, appContext.isSeller ? sellerParams : null), {}, {
      productId: productId,
      arrivalDate: arrivalDate,
      duration: duration,
      departureCity: departureCity,
      numberAttendees: attendees.adults.length + attendees.kids.length,
      // $FlowFixMe
      adults: attendees.adults,
      // $FlowFixMe
      kids: attendees.kids,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }), appContext)
  });
}

function putTransportAndDispatchProposals(transportId, proposalsId, isJoyview, isUrbanOasis, appContext, globalLoaderLabel, toastLabel) {
  return function (dispatch) {
    // TODO show a toast if error
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["f" /* ADD_TRANSPORT */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel,
      transportId: transportId
    }, {
      optimist: true,
      promise: Object(proposalQuery["c" /* addTransportMutation */])(transportId, proposalsId, isJoyview, isUrbanOasis, appContext)
    }));
  };
}

function fetchRefreshProposal(proposalId, salesNetworkId, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["z" /* PROPOSAL_REFRESH */], {}, {
    optimist: true,
    promise: Object(proposalQuery["o" /* refreshProposal */])(proposalId, salesNetworkId, appContext)
  });
}

function displayToastOnContextShare(toastLabel) {
  return {
    type: proposals_constants["k" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */],
    payload: {
      toastLabel: toastLabel
    }
  };
}

function addAccommodation(_ref3) {
  var arrangement = _ref3.arrangement,
      proposalsId = _ref3.proposalsId,
      isJoyview = _ref3.isJoyview,
      isUrbanOasis = _ref3.isUrbanOasis,
      appContext = _ref3.appContext,
      globalLoaderLabel = _ref3.globalLoaderLabel,
      toastLabel = _ref3.toastLabel,
      _ref3$reduxAction = _ref3.reduxAction,
      reduxAction = _ref3$reduxAction === void 0 ? proposals_constants["a" /* ADD_ACCOMMODATION */] : _ref3$reduxAction;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(reduxAction, {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel
    }, {
      optimist: true,
      promise: Object(proposalQuery["a" /* addAccommodationMutation */])(arrangement, proposalsId, isJoyview, isUrbanOasis, appContext)
    }));
  };
}

function updateAttendees(_ref4) {
  var proposalId = _ref4.proposalId,
      attendees = _ref4.attendees,
      appContext = _ref4.appContext;
  return function (dispatch) {
    dispatch(Object(globalLoader_action["d" /* startLoading */])());
    return updateAttendeesMutation({
      proposalId: proposalId,
      attendees: attendees,
      appContext: appContext
    }).then(function (_ref5) {
      var _proposal$attendees, _proposal$attendees$l, _proposal$attendees$l2, _modifiedAttendees$;

      var modifyAttendees = _ref5.modifyAttendees;
      var errors = modifyAttendees.errors,
          proposal = modifyAttendees.proposal,
          modifiedAttendees = modifyAttendees.attendees;

      if (errors) {
        throwFormatError({
          errors: errors
        });
      }

      var cookieToSet = proposals_action_objectSpread(proposals_action_objectSpread({}, tracking_storage_api["b" /* get */](constants["c" /* BE_TRACKING */])), {}, {
        neolaneId: proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$l = _proposal$attendees.list) === null || _proposal$attendees$l === void 0 ? void 0 : (_proposal$attendees$l2 = _proposal$attendees$l[0]) === null || _proposal$attendees$l2 === void 0 ? void 0 : _proposal$attendees$l2.customerId,
        BE_customerStatus: modifiedAttendees === null || modifiedAttendees === void 0 ? void 0 : (_modifiedAttendees$ = modifiedAttendees[0]) === null || _modifiedAttendees$ === void 0 ? void 0 : _modifiedAttendees$.customerType
      });

      tracking_storage_api["c" /* set */](cookieToSet);
      dispatch(Object(createAction["b" /* default */])(proposals_constants["J" /* UPDATE_ATTENDEES */], modifyAttendees));
    })["catch"](function (error) {
      return handleError(error, appContext);
    })["finally"](function () {
      return dispatch(Object(globalLoader_action["c" /* endLoading */])());
    });
  };
}

function refuseInsuranceAction(insuranceId) {
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(proposals_constants["s" /* INSURANCE_DELETED */], insuranceId));
  };
}

function clearProposals() {
  return Object(createAction["b" /* default */])(proposals_constants["h" /* CLEAR_PROPOSALS */]);
}

var proposals_action_fetchSelectedProposalPayment = function fetchSelectedProposalPayment(selectedProposal, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */], {
    selectedProposalId: selectedProposal.id
  }, {
    optimist: true,
    promise: Object(proposalQuery["f" /* fetchPayment */])(selectedProposal.id, appContext)
  });
};

var proposals_action_saveCustomerProposalsHandler = function saveCustomerProposalsHandler(proposalId, appContext, customerId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["C" /* SAVE_CUSTOMER_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["h" /* saveCustomerProposal */])(proposalId, appContext, customerId)
    }));
  };
};

var proposals_action_patchProposalHandler = function patchProposalHandler(proposalId, appContext, extend) {
  var options = {
    operation: 'extend_persistence',
    parameters: extend.toString()
  };
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["u" /* PATCH_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["g" /* patchProposal */])(proposalId, appContext, options.operation, options.parameters)
    }));
  };
};

var proposals_action_saveCustomerProposalsOpportunityIdHandler = function saveCustomerProposalsOpportunityIdHandler(proposalId, appContext, customerId, opportunityId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["D" /* SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID */], {}, {
      optimist: true,
      promise: Object(sellerUtils["j" /* saveCustomerProposalOpportunityId */])(proposalId, appContext, customerId, opportunityId)
    }));
  };
};

var proposals_action_addOrReplaceAdditionalServices = function addOrReplaceAdditionalServices(_ref6) {
  var attendees = _ref6.attendees,
      _ref6$showNotificatio = _ref6.showNotification,
      showNotification = _ref6$showNotificatio === void 0 ? false : _ref6$showNotificatio,
      appContext = _ref6.appContext;
  return function (dispatch, getState) {
    var proposal = Object(booking_selector["i" /* getCurrentProposal */])(getState());
    var proposals = Object(booking_selector["y" /* proposalsSelector */])(getState());
    var servicesIds = attendees.map(function (_ref7) {
      var productInfoId = _ref7.productInfoId;
      return productInfoId;
    }); // keep only proposals that have thoses services ids

    var proposalsWithServices = proposals.filter(function (p) {
      var additionalServicesValues = Object.values(p.additionalServices);
      return additionalServicesValues === null || additionalServicesValues === void 0 ? void 0 : additionalServicesValues.some(function (services) {
        return Array.isArray(services) && ( // $FlowFixMe
        services === null || services === void 0 ? void 0 : services.some(function (_ref8) {
          var pricingInfo = _ref8.pricingInfo;
          return servicesIds.includes(pricingInfo === null || pricingInfo === void 0 ? void 0 : pricingInfo.id);
        }));
      });
    });
    var proposalsWithServicesInAttendees = proposals.filter(function (_ref9) {
      var _Object$values;

      var additionalServices = _ref9.additionalServices;
      return (_Object$values = Object.values(additionalServices)) === null || _Object$values === void 0 ? void 0 : _Object$values.some(function (services) {
        if (Array.isArray(services)) {
          return services === null || services === void 0 ? void 0 : services.some(function (typedServices) {
            // $FlowFixMe
            return Object(proposalUtils["a" /* areAnyTimeSlotIdsPresent */])((typedServices === null || typedServices === void 0 ? void 0 : typedServices.pricingInfo.attendees) || [], servicesIds);
          });
        }
      });
    });
    var validProposalIds = (proposalsWithServices.length > 0 ? proposalsWithServices : proposalsWithServicesInAttendees).map(function (_ref10) {
      var id = _ref10.id;
      return id;
    });
    var additionalServicesValues = Object.values(proposal.additionalServices);
    var isUpdatingAlreadyReservedService = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref11) {
          var pricingInfo = _ref11.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.isPartiallyRented;
        })
      );
    });
    var newReservedServiceToastLabel = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref12) {
          var pricingInfo = _ref12.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.type === 'RENTAL';
        })
      );
    }) ? 'booking.activities.skiEquipment.newEquipmentSelection' : 'booking.activities.newActivitySelection';
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["L" /* UPDATE_SERVICES */], showNotification ? {
      toastLabel: isUpdatingAlreadyReservedService ? 'booking.activities.activityUpdate' : newReservedServiceToastLabel
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["n" /* putServicesMutation */])(validProposalIds, attendees, appContext)
    }));
  };
};

var proposals_action_deleteAdditionalServices = function deleteAdditionalServices(_ref13) {
  var serviceIds = _ref13.serviceIds,
      attendeeIds = _ref13.attendeeIds,
      _ref13$showNotificati = _ref13.showNotification,
      showNotification = _ref13$showNotificati === void 0 ? false : _ref13$showNotificati,
      overloadForSpecificProposalIds = _ref13.overloadForSpecificProposalIds,
      appContext = _ref13.appContext,
      proposalsParam = _ref13.proposals;
  return function (dispatch, getState) {
    var proposals = proposalsParam || Object(booking_selector["y" /* proposalsSelector */])(getState()); // keep only proposals that have thoses services ids

    var proposalsWithServices = proposals.filter(function (_ref14) {
      var _Object$values2;

      var additionalServices = _ref14.additionalServices;
      return (_Object$values2 = Object.values(additionalServices)) === null || _Object$values2 === void 0 ? void 0 : _Object$values2.some(function (services) {
        if (Array.isArray(services)) {
          return services === null || services === void 0 ? void 0 : services.some(function (typedServices) {
            var _typedServices$pricin, _typedServices$pricin2; // $FlowFixMe


            var schedules = (typedServices === null || typedServices === void 0 ? void 0 : (_typedServices$pricin = typedServices.pricingInfo) === null || _typedServices$pricin === void 0 ? void 0 : _typedServices$pricin.schedules) || [];
            var slots = Object.values(schedules[0].slots || {}); // $FlowFixMe

            var slotsIds = slots === null || slots === void 0 ? void 0 : slots.map(function (_ref15) {
              var id = _ref15.id;
              return id;
            });
            return (// $FlowFixMe
              serviceIds.includes(typedServices === null || typedServices === void 0 ? void 0 : (_typedServices$pricin2 = typedServices.pricingInfo) === null || _typedServices$pricin2 === void 0 ? void 0 : _typedServices$pricin2.id) || // $FlowFixMe
              (intersection_default()(slotsIds, serviceIds) || []).length > 0
            );
          });
        }
      });
    });
    var proposalsWithServicesInAttendees = proposals.filter(function (_ref16) {
      var _Object$values3;

      var additionalServices = _ref16.additionalServices;
      return (_Object$values3 = Object.values(additionalServices)) === null || _Object$values3 === void 0 ? void 0 : _Object$values3.some(function (services) {
        if (Array.isArray(services)) {
          return services === null || services === void 0 ? void 0 : services.some(function (typedServices) {
            // $FlowFixMe
            return Object(proposalUtils["a" /* areAnyTimeSlotIdsPresent */])((typedServices === null || typedServices === void 0 ? void 0 : typedServices.pricingInfo.attendees) || [], serviceIds);
          });
        }
      });
    });
    var validProposalIds = (proposalsWithServices.length > 0 ? proposalsWithServices : proposalsWithServicesInAttendees).map(function (_ref17) {
      var id = _ref17.id;
      return id;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* DELETE_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["e" /* deleteServicesMutation */])({
        proposalIds: validProposalIds,
        serviceIds: serviceIds,
        attendeeIds: attendeeIds,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_addAdditionalService = function addAdditionalService(_ref18) {
  var proposalIds = _ref18.proposalIds,
      serviceId = _ref18.serviceId,
      attendeeIds = _ref18.attendeeIds,
      schedules = _ref18.schedules,
      _ref18$showNotificati = _ref18.showNotification,
      showNotification = _ref18$showNotificati === void 0 ? false : _ref18$showNotificati,
      overloadForSpecificProposalIds = _ref18.overloadForSpecificProposalIds,
      appContext = _ref18.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["d" /* ADD_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["b" /* addServiceMutation */])({
        proposalIds: proposalIds,
        serviceId: serviceId,
        attendeeIds: attendeeIds,
        schedules: schedules,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};
/**
INSURANCE ADD/DELETE
* */


var proposals_action_addInsurances = function addInsurances(_ref19) {
  var insurance = _ref19.insurance,
      attendeeIds = _ref19.attendeeIds,
      appContext = _ref19.appContext;
  var _insurance$pricingInf = insurance.pricingInfo,
      id = _insurance$pricingInf.id,
      schedules = _insurance$pricingInf.schedules;
  return function (dispatch, getState) {
    var proposals = Object(booking_selector["y" /* proposalsSelector */])(getState()); // keep only proposals that have thoses services ids

    var proposalsWithServices = proposals.filter(function (p) {
      var _Object$values4;

      return (_Object$values4 = Object.values(p.additionalServices)) === null || _Object$values4 === void 0 ? void 0 : _Object$values4.some(function (services) {
        return Array.isArray(services) && ( // $FlowFixMe
        services === null || services === void 0 ? void 0 : services.some(function (_ref20) {
          var pricingInfo = _ref20.pricingInfo;
          return id === (pricingInfo === null || pricingInfo === void 0 ? void 0 : pricingInfo.id);
        }));
      });
    });
    var validProposalIds = proposalsWithServices.map(function (_ref21) {
      var proposalId = _ref21.id;
      return proposalId;
    });
    return dispatch(proposals_action_addAdditionalService({
      proposalIds: validProposalIds,
      serviceId: id,
      attendeeIds: attendeeIds,
      schedules: schedules.map(function (_ref22) {
        var startDate = _ref22.startDate,
            endDate = _ref22.endDate;
        return {
          startDate: startDate,
          endDate: endDate
        };
      }),
      appContext: appContext
    })).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["K" /* UPDATE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["r" /* INSURANCE_ADDED */], id));
    });
  };
};

var proposals_action_deleteInsurances = function deleteInsurances(_ref23) {
  var insurance = _ref23.insurance,
      attendeeIds = _ref23.attendeeIds,
      appContext = _ref23.appContext;
  var insuranceId = insurance.pricingInfo.id;
  return function (dispatch, getState) {
    var proposals = Object(booking_selector["y" /* proposalsSelector */])(getState()); // keep only proposals that have thoses services ids

    var proposalsWithServices = proposals.filter(function (p) {
      var _Object$values5;

      return (_Object$values5 = Object.values(p.additionalServices)) === null || _Object$values5 === void 0 ? void 0 : _Object$values5.some(function (services) {
        return Array.isArray(services) && ( // $FlowFixMe
        services === null || services === void 0 ? void 0 : services.some(function (_ref24) {
          var pricingInfo = _ref24.pricingInfo;
          return insuranceId === (pricingInfo === null || pricingInfo === void 0 ? void 0 : pricingInfo.id);
        }));
      });
    });
    var validProposalIds = proposalsWithServices.map(function (_ref25) {
      var id = _ref25.id;
      return id;
    });
    return dispatch(proposals_action_deleteAdditionalServices({
      proposalIds: validProposalIds,
      serviceIds: [insuranceId],
      attendeeIds: attendeeIds,
      appContext: appContext
    })).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["i" /* DELETE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["s" /* INSURANCE_DELETED */], insuranceId));
    });
  };
};
/**
END INSURANCE
* */


var proposals_action_prepareBe = function prepareBe(payload) {
  return Object(createAction["b" /* default */])(proposals_constants["v" /* PREPARE_BE */], payload);
};

var proposals_action_saveDonationToProposals = function saveDonationToProposals(donation) {
  return function (dispatch) {
    dispatch({
      type: proposals_constants["E" /* SAVE_DONATION_TO_PROPOSALS */],
      payload: donation
    });
  };
};

var proposals_action_switchProposalsOffers = function switchProposalsOffers(offers, appContext) {
  return function (dispatch, getState) {
    var state = getState();
    var proposals = Object(booking_selector["y" /* proposalsSelector */])(state); // isolate proposals elligible for switching offers because offers are not for all proposals sadly

    var validProposals = proposals.filter(function (_ref26) {
      var alternativePrice = _ref26.alternativePrice;
      return alternativePrice && alternativePrice.discounts && alternativePrice.discounts.length > 0 && intersection_default()(alternativePrice.discounts.map(function (_ref27) {
        var offerId = _ref27.offerId;
        return offerId;
      }), offers).length > 0;
    });
    var proposalsIds = validProposals.map(function (_ref28) {
      var id = _ref28.id;
      return id;
    }).filter(function (id) {
      return !!id;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["H" /* SWITCH_PROPOSALS_OFFERS */], {}, {
      optimist: true,
      promise: Object(proposalQuery["p" /* switchProposalsOffers */])(proposalsIds, offers, appContext)
    }));
  };
};



/***/ }),

/***/ "BYx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export documentFragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profileFragment; });
/* unused harmony export commonProfileFieldsFragment */
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kH/m");


var documentFragment = "{ issuingDate\n  expirationDate\n  nationality\n  documentNumber\n  issuingCountry\n  birthCountry\n  birthCity\n  secondName\n  thirdName\n  fourthName\n  type }";
var profileFragment = "\n  fragment BookingProfile on Profile {\n    optinEmail\n    optinSms\n    optinPhone\n    optinMail\n    optinClubmedPlus\n    address {\n      ...Address\n    }\n    document {\n      passport {\n        ...".concat(documentFragment, "\n      }\n      idcard{\n        ...").concat(documentFragment, "\n      }\n    }\n    passport {\n      issuingDate\n      expirationDate\n      nationality\n      documentNumber\n    }\n   dateOfBirth\n   civility\n   mobilePhoneNumber\n   identityNumber\n   travelCompanions {\n    id: customerId\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n    birthdate: dateOfBirth\n    document {\n      passport {\n        ...").concat(documentFragment, "\n      }\n      idcard{\n        ...").concat(documentFragment, "\n      }\n    }\n   }\n  }\n  ").concat(_utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__[/* addressFragment */ "a"], "\n");
/**
 * Common fields between adults and children
 * customerId is used as temp id, till being override by real proposal attendees id
 * see addSearchDataToAttendees
 *  */

var commonProfileFieldsFragment = "\n  fragment CommonProfileFields on Profile {\n    birthdate:dateOfBirth\n    civility\n    firstName\n    gmNumber\n    id\n    lastName\n    neolid:customerId\n    unicodeFirstName\n    unicodeLastName\n  }\n";


/***/ }),

/***/ "C56r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("kZDm");
var aCallable = __webpack_require__("eGzU");
var isObject = __webpack_require__("1YFU");
var hasOwn = __webpack_require__("/GgU");
var arraySlice = __webpack_require__("gp/v");
var NATIVE_BIND = __webpack_require__("vCWs");

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ "C8GU":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var toIntegerOrInfinity = __webpack_require__("aXF+");
var toString = __webpack_require__("vnfA");
var requireObjectCoercible = __webpack_require__("4gXF");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "CGO5":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("87KK").f;
var hasOwn = __webpack_require__("/GgU");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "Crz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fGyu");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9OUN");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var redux_thunk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("V8Kl");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("igjW");
/* harmony import */ var _middlewares_authenticationMiddleware__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u9tP");
/* harmony import */ var _rootReducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("v315");









function getReduxMiddlewares() {
  return [redux_thunk__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default()(), Object(_middlewares_authenticationMiddleware__WEBPACK_IMPORTED_MODULE_6__[/* createAuthenticationMiddleware */ "a"])()];
}

function init(initialState) {
  var enhancer = Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_5__[/* isStrictlyDevelopmentEnv */ "d"])(_config__WEBPACK_IMPORTED_MODULE_1___default.a) ? global.window && global.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_2__[/* compose */ "d"] : redux__WEBPACK_IMPORTED_MODULE_2__[/* compose */ "d"];
  return Object(redux__WEBPACK_IMPORTED_MODULE_2__[/* createStore */ "e"])(_rootReducer__WEBPACK_IMPORTED_MODULE_7__[/* rootReducer */ "a"], initialState, enhancer(redux__WEBPACK_IMPORTED_MODULE_2__[/* applyMiddleware */ "a"].apply(void 0, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(getReduxMiddlewares()))));
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "CwJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterAccommodations; });
/* unused harmony export sortAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterReducedMobilityAccomodation; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("OOYD");
/* harmony import */ var lodash_reject__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_reject__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("u6DZ");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("lZ21");

















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



function sortAccommodations(accommodationsSets) {
  return lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default()(accommodationsSets, function (set) {
    // sort accommodations by comfort level: Standard, Deluxe, Suite
    return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_16__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(set, 'accommodations[0].categoryId'));
  }).map(function (set, index) {
    // accommodationSetNumber was set to index + 1 in accommodationsSetsReducer
    // need to be updated after filtering & sorting
    return _objectSpread(_objectSpread({}, set), {}, {
      accommodationSetNumber: index + 1
    });
  });
}

function filterAccommodations(proposal, accommodationsSets) {
  var proposalAccommodations = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(proposal, 'accommodations', []); // remove additional accommodation if already exists in selected proposal


  var filteredAccommodations = lodash_reject__WEBPACK_IMPORTED_MODULE_12___default()(accommodationsSets, function (_ref) {
    var accommodations = _ref.accommodations;
    return lodash_isEqual__WEBPACK_IMPORTED_MODULE_14___default()(accommodations, proposalAccommodations);
  }); // sort additional accommodations by comfort level: Standard, Deluxe, Suite


  return sortAccommodations(filteredAccommodations);
}

function filterReducedMobilityAccomodation(visibility, filteredAccommodations) {
  if (visibility) {
    return filteredAccommodations;
  }

  var pmr = filteredAccommodations.reduce(function (acc, filteredAccommodation) {
    var accommodations = filteredAccommodation.accommodations;

    if (accommodations.filter(function (_ref2) {
      var reducedMobilityAccess = _ref2.reducedMobilityAccess;
      return reducedMobilityAccess === true;
    }).length === 0) {
      return acc.concat(filteredAccommodation);
    }

    return acc;
  }, []);
  return pmr;
}



/***/ }),

/***/ "D092":
/***/ (function(module, exports, __webpack_require__) {

var defineBuiltIn = __webpack_require__("Swp0");

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "DOIJ":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("aXF+");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "DwNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFeedback; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RUiN");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var BEACON_SELECTOR = 'FormFeedbackBeacon';
var FormFeedback = function FormFeedback(_ref) {
  var className = _ref.className,
      hasAutoScroll = _ref.hasAutoScroll,
      isError = _ref.isError,
      message = _ref.message;
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (hasAutoScroll) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__[/* scrollToElement */ "a"])("[data-testid=\"".concat(BEACON_SELECTOR, "\"]"));
    }
  }, []);
  return __jsx("p", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('flex font-bold gap-10 items-center leading-1 my-10 text-14', "".concat(isError ? 'text-red' : 'text-success'), className),
    "data-testid": BEACON_SELECTOR
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_1__[/* classnames */ "a"])('shrink-0', {
      'pt-5 px-5': !isError
    }),
    name: isError ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].WARNING : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].CHECK,
    width: "1.25rem"
  }), __jsx("span", {
    "data-testid": "FormFeedback-message"
  }, message));
};

/***/ }),

/***/ "E+Ue":
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__("XywU");
var uncurryThis = __webpack_require__("kZDm");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ "E8Xq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return capitalizeFromUppercase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return capitalizeWordFirstCaracter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalize; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TYRa");
/* harmony import */ var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5__);







function capitalize(string) {
  if (!string) {
    return '';
  }

  return string[0].toUpperCase() + string.slice(1);
}

var capitalizeFromUppercase = function capitalizeFromUppercase(str) {
  return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default()(str.toLowerCase());
};
var capitalizeWordFirstCaracter = function capitalizeWordFirstCaracter(str) {
  return str === null || str === void 0 ? void 0 : str.toLowerCase().split(' ').map(function (w) {
    return lodash_upperFirst__WEBPACK_IMPORTED_MODULE_5___default()(w);
  }).join(' ');
};


/***/ }),

/***/ "EVS9":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var aCallable = __webpack_require__("eGzU");

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "Ed3r":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("XywU");
var toIndexedObject = __webpack_require__("dNjr");
var $getOwnPropertyNames = __webpack_require__("8D46").f;
var arraySlice = __webpack_require__("VrMS");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "F9U4":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var fails = __webpack_require__("fhLv");
var classof = __webpack_require__("XywU");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "FllU":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("DuXo"),
    baseIteratee = __webpack_require__("S3pA"),
    toInteger = __webpack_require__("m2YG");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ "FtaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sendTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useAbTasty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storeAbTastyEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAbTastyEvent; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zygG");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kD1E");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Ub5k");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("d1HQ");
/* harmony import */ var _session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("9NGo");
/* harmony import */ var _session_storage_api_sessionStorage_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("4paF");
















var sendTransaction = function sendTransaction(_ref) {
  var id = _ref.id,
      affiliation = _ref.affiliation,
      revenue = _ref.revenue,
      currency = _ref.currency;
  var timeLimit = moment__WEBPACK_IMPORTED_MODULE_9___default()().add(5, 's');
  var waiter = setInterval(function () {
    var _window, _window$abtasty;

    if ((_window = window) === null || _window === void 0 ? void 0 : (_window$abtasty = _window.abtasty) === null || _window$abtasty === void 0 ? void 0 : _window$abtasty.send) {
      window.abtasty.send('transaction', {
        tid: id,
        // Transaction ID
        ta: affiliation,
        // Transaction Affiliation
        tr: revenue,
        // Transaction Revenue
        tc: currency,
        // Transaction Currency
        icn: 1 // Number of items

      });
      clearInterval(waiter);
    } else if (moment__WEBPACK_IMPORTED_MODULE_9___default()().isAfter(timeLimit)) {
      // clear after Maximum 5s, we assume that it should be there by then
      clearInterval(waiter);
    }
  }, 100);
};
var sendItem = function sendItem(_ref2) {
  var id = _ref2.id,
      name = _ref2.name,
      price = _ref2.price,
      code = _ref2.code,
      category = _ref2.category;
  var timeLimit = moment__WEBPACK_IMPORTED_MODULE_9___default()().add(5, 's');
  var waiter = setInterval(function () {
    var _window2, _window2$abtasty;

    if ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$abtasty = _window2.abtasty) === null || _window2$abtasty === void 0 ? void 0 : _window2$abtasty.send) {
      window.abtasty.send('item', {
        tid: id,
        // Transaction ID (links to transaction)
        "in": name,
        // Resort name
        ip: price,
        // Resort price
        iq: 1,
        // Quantity (always 1)
        ic: code,
        // Resort code (SKU)
        iv: category // Resort exclusive collection category

      });
      clearInterval(waiter);
    } else if (moment__WEBPACK_IMPORTED_MODULE_9___default()().isAfter(timeLimit)) {
      // clear after Maximum 5s, we assume that it should be there by then
      clearInterval(waiter);
    }
  }, 100);
};

var getABTastyId = function getABTastyId(abtasty, _ref3) {
  var isCmta = _ref3.isCmta,
      isCxo = _ref3.isCxo;

  if (isCmta && abtasty.cmta) {
    return abtasty.cmta.id;
  }

  if (isCxo && abtasty.cxo) {
    return abtasty.cxo.id;
  }

  return abtasty.id;
};

var useAbTasty = function useAbTasty() {
  var _useAppContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_12__[/* useAppContext */ "c"])(),
      isCmta = _useAppContext.isCmta,
      isCxo = _useAppContext.isCxo,
      locale = _useAppContext.locale;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_10__["useRouter"])(),
      queryParams = _useRouter.query;

  var _getConfigWithNoThird = Object(_third_party_thirdParty_utils__WEBPACK_IMPORTED_MODULE_11__[/* getConfigWithNoThirdPartySupport */ "a"])({
    locale: locale,
    name: 'tracking',
    queryParams: queryParams
  }),
      enabled = _getConfigWithNoThird.enabled,
      abtasty = _getConfigWithNoThird.abtasty;

  var abTastyId = getABTastyId(abtasty, {
    isCmta: isCmta,
    isCxo: isCxo
  });
  var isAbTastyActive = Boolean(enabled && (abtasty === null || abtasty === void 0 ? void 0 : abtasty.enabled) && (abtasty === null || abtasty === void 0 ? void 0 : abtasty.host) && abTastyId);
  var abTastyScriptUrl = isAbTastyActive ? "https://".concat(abtasty.host, "/").concat(abTastyId, ".js") : '';
  return {
    abTastyScriptUrl: abTastyScriptUrl,
    isAbTastyActive: isAbTastyActive
  };
};
var storeAbTastyEvent = function storeAbTastyEvent() {
  var _getDataLayer = Object(_tracking_tracking_api__WEBPACK_IMPORTED_MODULE_13__[/* getDataLayer */ "a"])(),
      google = _getDataLayer.google;

  var abTastyEventsToStore = {};
  var abTastyEvents = google === null || google === void 0 ? void 0 : google.filter(function (event) {
    return event.event === 'ab_tasty';
  });
  abTastyEvents.forEach(function (abTastyEvent) {
    for (var _i = 0, _Object$entries = Object.entries(abTastyEvent); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      if (key.includes('ab_tasty')) {
        abTastyEventsToStore[key] = value;
      }
    }
  });
  Object(_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_14__[/* setInSessionStorage */ "d"])(_session_storage_api_sessionStorage_constants__WEBPACK_IMPORTED_MODULE_15__[/* KEY_BE_ABTASTY_EVENTS */ "a"], abTastyEventsToStore);
};
var getAbTastyEvent = function getAbTastyEvent() {
  return Object(_session_storage_api_sessionStorageApi__WEBPACK_IMPORTED_MODULE_14__[/* getFromSessionStorage */ "b"])(_session_storage_api_sessionStorage_constants__WEBPACK_IMPORTED_MODULE_15__[/* KEY_BE_ABTASTY_EVENTS */ "a"]) || {};
};

/***/ }),

/***/ "GJxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "listen", function() { return /* binding */ index_es_listen; });
__webpack_require__.d(__webpack_exports__, "subscribe", function() { return /* binding */ index_es_subscribe; });
__webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return /* binding */ index_es_unsubscribe; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("whR3");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: /opt/webapp/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("Gpi5");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, supportPassiveEvent_options);
    window.removeEventListener('test', null, supportPassiveEvent_options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new eventemitter3_default.a(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/clone.js
var clone = __webpack_require__("zr3P");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent_AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent_AugmentedEvent);

// EXTERNAL MODULE: /opt/webapp/node_modules/raf/index.js
var raf = __webpack_require__("0xii");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || noop_default.a, ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ "GZgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_OF_STAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE_OF_STAY_REQUEST_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_SERVICES_REQUEST; });
var PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
var PRICE_OF_STAY_REQUEST_ABORT = 'PRICE_OF_STAY_REQUEST_ABORT';
var RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
var ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';

/***/ }),

/***/ "Gpi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "H0gB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return productChildcareDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return productChildcaresQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activityCategoryFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activityFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return thematicFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return rentalsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productActivitiesQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");



function productFeatureServiceQuery(lineProps) {
  var ageInformation = lineProps.ageInformation,
      groupMin = lineProps.groupMin,
      groupMax = lineProps.groupMax,
      groupRange = lineProps.groupRange;
  return "\n    hasBookingOnline\n    hasBookingOnsite\n    id\n    isIdealForFamily\n    label\n    description\n    detailedDescription\n    durationDescription\n    ageRestriction(message: \"".concat(ageInformation, "\")\n    level\n    note\n    group(min: \"").concat(groupMin, "\" max: \"").concat(groupMax, "\" range: \"").concat(groupRange, "\")\n    specificConditions\n    equipments {\n      label\n      included\n    }\n    utilities {\n      label\n      included\n    }\n    targetPrice {\n      price\n      currency\n    }\n  ");
}

var productFeatureFacilityQuery = "\n    description\n    distance\n    id\n    label\n    localisation\n    nightLighting\n    onSite\n    outdoor\n    quantity\n    specificInformation {\n      type\n      value\n    }\n    technicalSpecificities {\n      typeDescription\n      length\n      width\n      minDepth\n      maxDepth\n      unit\n    }\n  ";
function productChildcareDetailQuery(productId, activityId, _ref) {
  var lineProps = _ref.lineProps,
      urlParams = _ref.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  var productActivitiesArgs = "activityId : \"".concat(activityId, "\"");
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
  return "query {\n    config {\n      common { previous next }\n    }\n    resort(".concat(productArgs, ") {\n      facilities(types: [\"CHILDREN\"], withEquipments: true) {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n      productActivities(idFilter: \"").concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n    }\n    productActivities(").concat(productArgs, ") {\n      childcare(").concat(productActivitiesArgs, ") {\n        closingWeekdays\n        description\n        duration\n        furtherInformation\n        id\n        label\n        openingDates {\n          opening\n          closing\n        }\n        openingHours {\n          start\n          end\n        }\n        timeSlots {\n          type\n          opening\n          closing\n        }\n        philosophy\n        targetPrice {\n          currency\n          price\n        }\n      }\n      facilities(").concat(productActivitiesArgs, ") {\n        ").concat(productFeatureFacilityQuery, "\n      }\n    }\n    includedServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n    onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n  }");
}
/* lists of features */

var productFeaturesConfigQuery = "\n    config {\n      common {\n        allInclusive\n        backNavigation\n        bookOnlineOnly\n        bookOnlineOrOnsite\n        bookOnsiteOnly\n        childcarealacarte\n        downloadLeafletLabel\n        extraCost\n        howToBookLabel\n        idealForFamilyLabel\n        included\n        loadLess\n        onDemandService\n        philosophyLabel\n        price {\n          priceFrom\n        }\n        scrollBackward\n        scrollForward\n        treatmentsLabel\n        viewMore\n      }\n    }\n  ";

function productFeaturesCategoriesFields(defaultLabel) {
  var activityLabel = defaultLabel ? "label(defaultLabel: \"".concat(defaultLabel, "\")") : 'label';
  return "\n    activities: subCategories {\n      bookingDescription\n      bookletUrl\n      brandLogoUrl\n      description\n      equipmentRentalDescription\n      id\n      image: imageUrl\n      isChildrenClub\n      isIncluded\n      keywords\n      ".concat(activityLabel, "\n      name\n      numberOfIncludedActivities\n      numberOfOnDemandActivities\n      philosophy\n      ranking\n      rentalEquipmentsUsecasesId\n      supervisionDescription\n      termsAndConditionsDescription\n    }\n    id\n    label\n    ranking\n  ");
}

function productChildcaresQuery(productId, _ref2) {
  var urlParams = _ref2.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      kidsActivitiesIntroduction {\n        description\n        shortDescription\n      }\n      categories: activityCategories {\n        children {\n          ").concat(productFeaturesCategoriesFields(), "\n        }\n      }\n    }\n  }");
}
/* ACTIVITIES */

var activityCategoryFragment = "fragment activityCategory on UpsellsActivityCategoryType {\n  activitiesCounters {\n    included\n    onDemand\n  }\n  bookingDescription\n  bookletUrl\n  description\n  equipmentRentalDescription\n  facilities {\n    areaId\n    categoriesIds\n    description\n    distanceAndTransferDescription\n    equipments {\n      id\n      label\n    }\n    hasFreeAccess\n    hasNightLighting\n    id\n    isOnSite\n    isOutdoor\n    level\n    localisation\n    name\n    quantity\n    ranking\n    specificInformation {\n      type\n      value\n    }\n    subTitle\n    technicalSpecificities {\n      height\n      isHeated\n      length\n      maxDepth\n      minDepth\n      typesDescription\n      unit\n      width\n    }\n  }\n  id\n  images\n  keywords\n  name\n  philosophy\n  ranking\n  shortDescription\n  supervisionDescription\n  termsAndConditionsDescription\n  upsellType\n}";
var activityFragment = "fragment activity on UpsellsActivityType {\n  ageRestriction {\n    formatted\n    min\n    max\n    specificConditions\n  }\n  categoriesIds\n  description\n  duration\n  equipments {\n    id\n    isIncluded\n    label\n  }\n  furtherInformation\n  hasBookingOnline\n  hasBookingOnsite\n  id\n  images\n  isIncluded\n  level\n  name\n  openingDates {\n    endDate\n    startDate\n  }\n  participants {\n    min\n    max\n  }\n  price {\n    currency\n    formattedValue\n    value\n  }\n  ranking\n  seasonality\n  services {\n    id\n    isIncluded\n    label\n  }\n  subtitle\n  transportation\n  treatments\n  upsellType\n}";
var thematicFragment = "fragment thematics on UpsellsActivityThematicType {\n  activitiesCounters {\n    included\n    onDemand\n  }\n  description\n  id\n  images\n  name\n}\n";
var rentalsFragment = "fragment rentals on RentalsTreeType {\n  id\n  label\n  items {\n    id\n    label\n    items {\n      ageRestriction {\n        formatted\n        max\n        min\n      }\n      availableBrands\n      furtherInformation\n      formalities\n      id\n      images\n      levels {\n        id\n        label\n      }\n      longDescription\n      name\n      price {\n        currency\n        formattedValue\n        value\n      }\n      productRange {\n        id\n        label\n      }\n      shortDescription\n      sizes {\n        max\n        min\n        unit\n      }\n      type {\n        id\n        label\n      }\n      upsellType\n      usecase {\n        id\n        label\n      }\n    }\n  }\n}";
var productActivitiesQuery = function productActivitiesQuery(_ref3) {
  var productId = _ref3.productId,
      urlParams = _ref3.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    resort(".concat(productArgs, ") {\n      activityTree {\n        ...activityCategory\n        activities {\n          ...activity\n        }\n        categories {\n          ...activityCategory\n          activities {\n            ...activity\n          }\n          categories {\n            ...activityCategory\n            activities {\n              ...activity\n            }\n          }\n        }\n      }\n      thematicActivityTree {\n        ...thematics\n        activities {\n          ...activity\n        }\n      }\n      id\n      name\n      rentalsTree {\n        ...rentals\n      }\n    }\n  }\n  ").concat(activityCategoryFragment, "\n  ").concat(activityFragment, "\n  ").concat(rentalsFragment, "\n  ").concat(thematicFragment, "\n  ");
};

/***/ }),

/***/ "H8tl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OptinsContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OptinsProvider; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

var OptinsContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  optins: {},
  setOptins: function setOptins() {}
});
var OptinsProvider = function OptinsProvider(_ref) {
  var children = _ref.children;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])({}),
      optins = _useState[0],
      setOptins = _useState[1];

  var value = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
    return {
      optins: optins,
      setOptins: setOptins
    };
  }, [optins]);
  return __jsx(OptinsContext.Provider, {
    value: value
  }, children);
};

/***/ }),

/***/ "HKx7":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("+xJO");
var definePropertyModule = __webpack_require__("87KK");
var anObject = __webpack_require__("ep/x");
var toIndexedObject = __webpack_require__("dNjr");
var objectKeys = __webpack_require__("X95k");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "HRNz":
/***/ (function(module, exports, __webpack_require__) {

var isIndex = __webpack_require__("pnw1");

/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return isIndex(n, length) ? array[n] : undefined;
}

module.exports = baseNth;


/***/ }),

/***/ "HaU7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("IAdD");

__webpack_require__("7x/C");

__webpack_require__("OZaJ");

__webpack_require__("KqXw");

__webpack_require__("DZ+c");

__webpack_require__("MvUL");

var _regeneratorRuntime = __webpack_require__("IebI");

__webpack_require__("3yYM");

var _classCallCheck = __webpack_require__("zQIG");

var _createClass = __webpack_require__("8mBC");

var _inherits = __webpack_require__("I/kN");

var _possibleConstructorReturn = __webpack_require__("cMav");

var _getPrototypeOf = __webpack_require__("pSQP");

var _asyncToGenerator = __webpack_require__("4mCN");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = __webpack_require__("Y3ZS");

exports.__esModule = true;
exports.Container = Container;
exports.createUrl = createUrl;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _utils = __webpack_require__("fvxO");

exports.AppInitialProps = _utils.AppInitialProps;
exports.NextWebVitalsMetric = _utils.NextWebVitalsMetric;
/**
* `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
* This allows for keeping state between navigation, custom error handling, injecting additional data.
*/

function appGetInitialProps(_x) {
  return _appGetInitialProps.apply(this, arguments);
}

function _appGetInitialProps() {
  _appGetInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Component, ctx, pageProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.next = 3;
            return (0, _utils.loadGetInitialProps)(Component, ctx);

          case 3:
            pageProps = _context.sent;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _appGetInitialProps.apply(this, arguments);
}

var App = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(App, _react$default$Compon);

  var _super = _createSuper(App);

  function App() {
    _classCallCheck(this, App);

    return _super.apply(this, arguments);
  }

  _createClass(App, [{
    key: "componentDidCatch",
    // Kept here for backwards compatibility.
    // When someone ended App they could call `super.componentDidCatch`.
    // @deprecated This method is no longer needed. Errors are caught at the top level
    value: function componentDidCatch(error, _errorInfo) {
      throw error;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          router = _this$props.router,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps,
          __N_SSG = _this$props.__N_SSG,
          __N_SSP = _this$props.__N_SSP;
      return /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, pageProps, // we don't add the legacy URL prop if it's using non-legacy
      // methods like getStaticProps and getServerSideProps
      !(__N_SSG || __N_SSP) ? {
        url: createUrl(router)
      } : {}));
    }
  }]);

  return App;
}(_react.default.Component);

exports.default = App;
App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
var warnContainer;
var warnUrl;

if (false) {} // @deprecated noop for now until removal


function Container(p) {
  if (false) {}
  return p.children;
}

function createUrl(router) {
  // This is to make sure we don't references the router object at call time
  var pathname = router.pathname,
      asPath = router.asPath,
      query = router.query;
  return {
    get query() {
      if (false) {}
      return query;
    },

    get pathname() {
      if (false) {}
      return pathname;
    },

    get asPath() {
      if (false) {}
      return asPath;
    },

    back: function back() {
      if (false) {}
      router.back();
    },
    push: function push(url, as) {
      if (false) {}
      return router.push(url, as);
    },
    pushTo: function pushTo(href, as) {
      if (false) {}
      var pushRoute = as ? href : '';
      var pushUrl = as || href;
      return router.push(pushRoute, pushUrl);
    },
    replace: function replace(url, as) {
      if (false) {}
      return router.replace(url, as);
    },
    replaceTo: function replaceTo(href, as) {
      if (false) {}
      var replaceRoute = as ? href : '';
      var replaceUrl = as || href;
      return router.replace(replaceRoute, replaceUrl);
    }
  };
}

/***/ }),

/***/ "HnW7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "HvGN":
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__("X+YX"),
    baseFlatten = __webpack_require__("YpBQ"),
    baseRest = __webpack_require__("R3TX"),
    isArrayLikeObject = __webpack_require__("Ndl3"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function(array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
    : [];
});

module.exports = differenceWith;


/***/ }),

/***/ "Hz96":
/***/ (function(module, exports, __webpack_require__) {

var baseNth = __webpack_require__("HRNz"),
    toInteger = __webpack_require__("m2YG");

/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
}

module.exports = nth;


/***/ }),

/***/ "I2c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("dNjr");
var addToUnscopables = __webpack_require__("3K/D");
var Iterators = __webpack_require__("oa0l");
var InternalStateModule = __webpack_require__("9jKB");
var defineProperty = __webpack_require__("87KK").f;
var defineIterator = __webpack_require__("6WRp");
var createIterResultObject = __webpack_require__("b86L");
var IS_PURE = __webpack_require__("SRps");
var DESCRIPTORS = __webpack_require__("uGjT");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "IYAN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var uncurryThis = __webpack_require__("kZDm");
var isForced = __webpack_require__("wxLG");
var defineBuiltIn = __webpack_require__("Swp0");
var InternalMetadataModule = __webpack_require__("wKkN");
var iterate = __webpack_require__("ZuH9");
var anInstance = __webpack_require__("V/va");
var isCallable = __webpack_require__("ANQd");
var isNullOrUndefined = __webpack_require__("nnO8");
var isObject = __webpack_require__("1YFU");
var fails = __webpack_require__("fhLv");
var checkCorrectnessOfIteration = __webpack_require__("AZSF");
var setToStringTag = __webpack_require__("CGO5");
var inheritIfRequired = __webpack_require__("XmKO");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "Iev9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAuthentication; });
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Ub5k");

function useAuthentication() {
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_0__[/* useAppContext */ "c"])();
  return {
    isLogged: appContext.isUserLogged,
    isQuickLogged: appContext.isUserQuickLogged
  };
}

/***/ }),

/***/ "JOeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOAST_DURATION; });
/* unused harmony export getAdditionalServiceFromUpsellId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSmallerPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return mapActivitiesCategoriesWithAdditionnalServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return mapRentalsWithAdditionnalServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAttendeesFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updatePriceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return excludePaidSlots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatServiceToUpdateBookingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return servicesWithSchedulePricingInfoQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return childcaresQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return transfersQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return whiteLabelServicesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return insuranceQuery; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_filter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("+DnP");
/* harmony import */ var lodash_filter__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_filter__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_map__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("mbB6");
/* harmony import */ var lodash_map__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_map__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_partial__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("naLQ");
/* harmony import */ var lodash_partial__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_partial__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_flow__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("jPI1");
/* harmony import */ var lodash_flow__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_flow__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var lodash_curry__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("kUU+");
/* harmony import */ var lodash_curry__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(lodash_curry__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var lodash_add__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("/yCi");
/* harmony import */ var lodash_add__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(lodash_add__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("lKOy");
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(lodash_difference__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var lodash_flatten__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("1xil");
/* harmony import */ var lodash_flatten__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(lodash_flatten__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var lodash_values__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("0iyY");
/* harmony import */ var lodash_values__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(lodash_values__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("Rj53");
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("6R5o");
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__);





























function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}
/* eslint-disable no-shadow */







var AGE_OF_MAJORITY = 18;

var isAdult = function isAdult(birthday) {
  return !moment__WEBPACK_IMPORTED_MODULE_28___default()(birthday, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_29__[/* API_DATE_FORMAT */ "a"]).isAfter(moment__WEBPACK_IMPORTED_MODULE_28___default()().startOf('day').subtract(AGE_OF_MAJORITY, 'years'));
};

var TOAST_DURATION = 4000;
var getAdditionalServiceFromUpsellId = function getAdditionalServiceFromUpsellId(id) {
  var availableUpsellsUpdatedWithCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return availableUpsellsUpdatedWithCart.find(function (a) {
    return a.pricingInfo.id === id;
  }) || null;
};
function getSmallerPrice(prev, next) {
  if (!(prev === null || prev === void 0 ? void 0 : prev.value)) {
    return next;
  }

  if (next === null || next === void 0 ? void 0 : next.value) {
    return next.value < prev.value ? next : prev;
  }
}

var mergeActivitiesCategoriesWithAdditionnalServices = function mergeActivitiesCategoriesWithAdditionnalServices(cat, availableActivities, options) {
  var _cat$categories, _cat$activities;

  if ((_cat$categories = cat.categories) === null || _cat$categories === void 0 ? void 0 : _cat$categories.length) {
    var _category$categories, _category$categories2;

    var category = _objectSpread(_objectSpread({}, cat), {}, {
      categories: cat.categories.map(function (subcat) {
        return mergeActivitiesCategoriesWithAdditionnalServices(subcat, availableActivities, options);
      }).filter(function (subcat) {
        var _subcat$categories, _subcat$activities;

        return !!((_subcat$categories = subcat.categories) === null || _subcat$categories === void 0 ? void 0 : _subcat$categories.length) || !!((_subcat$activities = subcat.activities) === null || _subcat$activities === void 0 ? void 0 : _subcat$activities.length);
      })
    });

    return _objectSpread(_objectSpread({}, category), {}, {
      bestPrice: (_category$categories = category.categories) === null || _category$categories === void 0 ? void 0 : _category$categories.reduce(function (acc, _ref) {
        var bestPrice = _ref.bestPrice;
        return getSmallerPrice(acc, bestPrice);
      }, null),
      onlineBookableCount: (_category$categories2 = category.categories) === null || _category$categories2 === void 0 ? void 0 : _category$categories2.reduce(function (acc, _ref2) {
        var onlineBookableCount = _ref2.onlineBookableCount;
        return acc + onlineBookableCount;
      }, 0)
    });
  }

  if ((_cat$activities = cat.activities) === null || _cat$activities === void 0 ? void 0 : _cat$activities.length) {
    var mergedActivities = (cat.activities || []).map(function (a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        additionalService: getAdditionalServiceFromUpsellId(a.id, availableActivities)
      });
    }) // filter depending on additionalService (nullable)
    // then merge activities received from resort and the result of '/additional_services'
    .filter(function (a) {
      return (options === null || options === void 0 ? void 0 : options.filtered) ? !!a.additionalService : true;
    }) // and display online bookable activities first
    .sort(function (activity1, activity2) {
      return Number(!!activity2.additionalService) - Number(!!activity1.additionalService);
    });
    var onlineBookableActivities = mergedActivities.filter(function (_ref3) {
      var additionalService = _ref3.additionalService;
      return !!additionalService;
    });
    var mergedActivitiesWithPrice = onlineBookableActivities.filter(function (_ref4) {
      var _additionalService$pr, _additionalService$pr2, _additionalService$pr3;

      var additionalService = _ref4.additionalService;
      return Boolean(additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr = additionalService.pricingInfo) === null || _additionalService$pr === void 0 ? void 0 : _additionalService$pr.startingPricePerAdult) && typeof (additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr2 = additionalService.pricingInfo) === null || _additionalService$pr2 === void 0 ? void 0 : (_additionalService$pr3 = _additionalService$pr2.startingPricePerAdult) === null || _additionalService$pr3 === void 0 ? void 0 : _additionalService$pr3.value) === 'number';
    });
    return _objectSpread(_objectSpread({}, cat), {}, {
      activities: mergedActivities,
      bestPrice: mergedActivitiesWithPrice.length ? mergedActivitiesWithPrice.reduce(function (acc, _ref5) {
        var _additionalService$pr4;

        var additionalService = _ref5.additionalService;
        return getSmallerPrice(acc, additionalService === null || additionalService === void 0 ? void 0 : (_additionalService$pr4 = additionalService.pricingInfo) === null || _additionalService$pr4 === void 0 ? void 0 : _additionalService$pr4.startingPricePerAdult);
      }, null) : null,
      onlineBookableCount: onlineBookableActivities.length
    });
  }

  return cat;
};

var mapActivitiesCategoriesWithAdditionnalServices = function mapActivitiesCategoriesWithAdditionnalServices(categories, availableActivities, options) {
  return (categories || []).map(function (category) {
    return mergeActivitiesCategoriesWithAdditionnalServices(category, availableActivities, options);
  });
};
var mapRentalsWithAdditionnalServices = function mapRentalsWithAdditionnalServices(rentals, availableRentals, options) {
  return rentals.map(function (useCase) {
    return _objectSpread(_objectSpread({}, useCase), {}, {
      items: useCase.items.map(function (type) {
        return _objectSpread(_objectSpread({}, type), {}, {
          items: type.items.map(function (rental) {
            return _objectSpread(_objectSpread({}, rental), {}, {
              additionalService: getAdditionalServiceFromUpsellId(rental.id, availableRentals)
            });
          }).filter(function (r) {
            return (options === null || options === void 0 ? void 0 : options.filtered) ? r.additionalService : true;
          })
        });
      }).filter(function (uc) {
        return !!uc.items.length;
      })
    });
  });
};
var getAttendeesFromCart = function getAttendeesFromCart(cart) {
  return ((cart === null || cart === void 0 ? void 0 : cart.attendees) || []).map(function (_ref6) {
    var birthday = _ref6.birthday,
        firstname = _ref6.firstname,
        id = _ref6.id,
        lastname = _ref6.lastname,
        unicodeFirstname = _ref6.unicodeFirstname,
        unicodeLastname = _ref6.unicodeLastname;
    return {
      birthdate: birthday,
      firstName: firstname,
      id: id,
      lastName: lastname,
      unicodeFirstName: unicodeFirstname,
      unicodeLastName: unicodeLastname
    };
  });
};

var updatePrice = function updatePrice(obj, price, currency, locale) {
  var value = obj.value + price;
  return _objectSpread(_objectSpread({}, obj), {}, {
    value: value,
    formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_30__[/* formatAmount */ "a"])(value, currency, locale)
  });
};

var compose2 = function compose2(g, f) {
  return function (x) {
    return g(f(x));
  };
};

var deepClone = compose2(JSON.parse, JSON.stringify); // The updatePriceInfo function updates the pricingInfo of one activity get from the activity tree
// and the booking cart in order to give the GM a correct feedback of what he can or has, already or not rented
// The activity tree containes all the activities that can be ranted online, ordered and classed by categories.
// It's build from the v0/additional_services API endpoint by the graphql server. The goal of the data
// transformations made by the graphql endpoint is to deliver to the front, for each activity, a data structure
// that fits well into the ReservationBlock UI form.

var updatePriceInfo = function updatePriceInfo(pInfo, cActivities, locale) {
  if (!pInfo || !cActivities) {
    return pInfo;
  } // pricingInfo should be unmutable since updatePriceInfo could be called multiple times


  var pricingInfo = deepClone(pInfo);
  var cartActivities = deepClone(cActivities); // we explode the cart structure to update easyly the pricingInfo
  // we use implepmented the unwind function of the mongodb aggregate framework
  // In that example, unwinding on 'size' turns
  // { id: 1, item: 'ABC1', sizes: [ 'S', 'M', 'L'] }
  // into
  // [
  //   { id : 1, item : ABC1, sizes : 'S' }
  //   { id : 1, item : ABC1, sizes : 'M' }
  //   { id : 1, item : ABC1, sizes : 'L' }
  // ]

  var cardRawTable = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"])(Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"])(cartActivities, 'schedules'), 'schedules.attendees').map(function (_ref7) {
    var id = _ref7.id,
        schedules = _ref7.schedules,
        others = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_ref7, ["id", "schedules"]);

    var startDate = schedules.startDate,
        endDate = schedules.endDate;
    var _schedules$attendees = schedules.attendees,
        attendeeId = _schedules$attendees.id,
        price = _schedules$attendees.price;
    return _objectSpread(_objectSpread({}, others), {}, {
      attendeeId: attendeeId,
      price: price,
      startDate: startDate,
      endDate: endDate,
      slotId: id
    });
  }); // we update the pricingInfo with the content of the cart

  pricingInfo.attendees.forEach(function (attendee) {
    attendee.schedules.forEach(function (schedule) {
      schedule.timeSlots && schedule.timeSlots.forEach(function (slot) {
        var foundSlot = lodash_find__WEBPACK_IMPORTED_MODULE_27___default()(cardRawTable, function (cardEntry) {
          return cardEntry.attendeeId === attendee.id && cardEntry.startDate === schedule.startDate && cardEntry.endDate === schedule.endDate && cardEntry.slotId === slot.id;
        });

        var isRented = !!foundSlot;
        slot.isRented = isRented;

        if (isRented) {
          pricingInfo.isPartiallyRented = true;
          schedule.isPartiallyRented = true;
          attendee.rentedAmount = updatePrice(attendee.rentedAmount, foundSlot === null || foundSlot === void 0 ? void 0 : foundSlot.price, pricingInfo.currency, locale);
          schedule.rentedAmount = updatePrice(schedule.rentedAmount, foundSlot === null || foundSlot === void 0 ? void 0 : foundSlot.price, pricingInfo.currency, locale);
          pricingInfo.rentedAmount = updatePrice(pricingInfo.rentedAmount, foundSlot === null || foundSlot === void 0 ? void 0 : foundSlot.price, pricingInfo.currency, locale);
        }
      });

      if (schedule.timeSlots && schedule.timeSlots.every(function (_ref8) {
        var isRented = _ref8.isRented;
        return isRented;
      })) {
        schedule.isFullyRented = true;
      }
    });
    pricingInfo.isFullyRented = pricingInfo.attendees.every(function (attendee) {
      return attendee.schedules.every(function (_ref9) {
        var isFullyRented = _ref9.isFullyRented;
        return isFullyRented;
      });
    });
  });
  return pricingInfo;
};

var filterAvailableServices = function filterAvailableServices(_ref10) {
  var availableActivities = _ref10.availableActivities,
      availableRentals = _ref10.availableRentals,
      paymentStatus = _ref10.paymentStatus;
  return availableActivities.concat(availableRentals).filter(function (activity) {
    return paymentStatus === 'isPaid' ? activity.pricingInfo.isPartiallyPaid || activity.pricingInfo.isFullyPaid : activity.pricingInfo.isPartiallyRented || activity.pricingInfo.isFullyRented;
  });
};

var gatherPrimaryKeys = function gatherPrimaryKeys(_ref11) {
  var pricingInfo = _ref11.pricingInfo,
      productInfo = _ref11.productInfo;

  var attendees = pricingInfo.attendees,
      drop = pricingInfo.schedules,
      othersP = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(pricingInfo, ["attendees", "schedules"]);

  var id = attendees.id,
      schedules = attendees.schedules,
      othersA = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(attendees, ["id", "schedules"]);

  var startDate = schedules.startDate,
      endDate = schedules.endDate,
      timeSlot = schedules.timeSlots,
      othersS = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(schedules, ["startDate", "endDate", "timeSlots"]);

  return {
    attendeeId: attendees.id,
    startDate: startDate,
    endDate: endDate,
    slotId: timeSlot.id,
    attendee: _objectSpread({
      id: id
    }, othersA),
    schedule: _objectSpread({
      startDate: startDate,
      endDate: endDate
    }, othersS),
    timeSlot: timeSlot,
    pricingInfo: _objectSpread({}, othersP),
    productInfo: productInfo
  };
};

var explodeToJoinTable = lodash_flow__WEBPACK_IMPORTED_MODULE_20___default()(lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"]), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, 'pricingInfo.attendees'), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"]), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, 'pricingInfo.attendees.schedules'), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"]), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, 'pricingInfo.attendees.schedules.timeSlots'), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(lodash_map__WEBPACK_IMPORTED_MODULE_18___default.a), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, gatherPrimaryKeys));

var reaggragateRentedServicesOverJoinTable = function reaggragateRentedServicesOverJoinTable(pricingInfoJoinTable, locale, attendee, paymentStatus) {
  return lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(pricingInfoJoinTable, 'pricingInfo.id')).map(function (rentedService) {
    var services = lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(rentedService, 'slotId')).filter(function (entries) {
      return entries.some(function (entry) {
        return entry.attendeeId === attendee.id && entry.timeSlot[paymentStatus];
      });
    }).map(function (entries) {
      var rentedAmountValue = entries.map(function (_ref12) {
        var timeSlot = _ref12.timeSlot;
        return timeSlot;
      }).filter(function (timeSlot) {
        return timeSlot[paymentStatus];
      }).map(function (_ref13) {
        var price = _ref13.price;
        return price.value;
      }).reduce(lodash_add__WEBPACK_IMPORTED_MODULE_22___default.a, 0);
      return {
        pricingInfo: {
          id: entries[0].slotId,
          productId: entries[0].pricingInfo.id,
          timeSlot: entries[0].timeSlot.slotName,
          type: entries[0].pricingInfo.type,
          rentedAmount: {
            value: rentedAmountValue,
            formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_30__[/* formatAmount */ "a"])(rentedAmountValue, entries[0].pricingInfo.currency, locale),
            currency: entries[0].pricingInfo.currency
          },
          startingPricePerAdult: entries[0].pricingInfo.startingPricePerAdult,
          isPartiallyRented: true,
          isPartiallyPaid: entries.map(function (_ref14) {
            var timeSlot = _ref14.timeSlot;
            return timeSlot;
          }).filter(function (_ref15) {
            var isPaid = _ref15.isPaid;
            return isPaid;
          }).length > 0,
          isFullyPaid: entries.map(function (_ref16) {
            var timeSlot = _ref16.timeSlot;
            return timeSlot;
          }).filter(function (_ref17) {
            var isPaid = _ref17.isPaid;
            return isPaid;
          }).length === entries.length,
          schedules: lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(entries, 'startDate')).map(function (entries) {
            return {
              startDate: entries[0].startDate,
              endDate: entries[0].endDate,
              attendees: entries.map(function (entry) {
                return _objectSpread(_objectSpread({}, entry.timeSlot), {}, {
                  id: entry.attendeeId
                });
              })
            };
          })
        },
        productInfo: entries[0].productInfo
      };
    });

    return {
      price: lodash_flatten__WEBPACK_IMPORTED_MODULE_24___default()(lodash_flatten__WEBPACK_IMPORTED_MODULE_24___default()(services.map(function (service) {
        return service.pricingInfo.schedules;
      })).map(function (_ref18) {
        var attendees = _ref18.attendees;
        return attendees;
      })).filter(function (entry) {
        return entry.id === attendee.id && entry[paymentStatus];
      }).map(function (_ref19) {
        var price = _ref19.price;
        return price.value;
      }).reduce(lodash_add__WEBPACK_IMPORTED_MODULE_22___default.a, 0),
      services: services
    };
  });
}; // In order to send to the CartComponent the data turned into the right format, we have to reverse
// the strcuture of it. We do this by exploding it and reaggregating over it. It'as a generic way to
// make that kind of transformation.


var transformToCardFormat = function transformToCardFormat(_ref20) {
  var attendees = _ref20.attendees,
      locale = _ref20.locale,
      paymentStatus = _ref20.paymentStatus,
      availableActivities = _ref20.availableActivities,
      availableRentals = _ref20.availableRentals;
  return lodash_map__WEBPACK_IMPORTED_MODULE_18___default()(attendees, function (attendee, index) {
    var id = attendee.id,
        firstname = attendee.firstname,
        lastname = attendee.lastname,
        unicodeLastname = attendee.unicodeLastname,
        unicodeFirstname = attendee.unicodeFirstname,
        birthday = attendee.birthday;
    return {
      id: id,
      firstName: firstname,
      lastName: lastname,
      unicodeLastName: unicodeLastname,
      unicodeFirstName: unicodeFirstname,
      isAdult: isAdult(birthday),
      index: index + 1,
      rentedServices: lodash_flow__WEBPACK_IMPORTED_MODULE_20___default()(filterAvailableServices, explodeToJoinTable, lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(reaggragateRentedServicesOverJoinTable), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, locale, attendee, paymentStatus))({
        availableActivities: availableActivities,
        availableRentals: availableRentals,
        paymentStatus: paymentStatus
      })
    };
  });
};

var keepOnlyAttendeesWithRentedServices = function keepOnlyAttendeesWithRentedServices(attendee) {
  return attendee.rentedServices.some(function (_ref21) {
    var services = _ref21.services;
    return services.length > 0;
  });
};

var cleanRentedServices = function cleanRentedServices(attendee) {
  return _objectSpread(_objectSpread({}, attendee), {}, {
    rentedServices: attendee.rentedServices.filter(function (_ref22) {
      var services = _ref22.services;
      return services.length > 0;
    })
  });
}; // The BIG function that make the structure upside down. Turns pricingInfo strcture to the Cart one.


var getReservedServicesByAttendee = function getReservedServicesByAttendee(_ref23) {
  var attendees = _ref23.attendees,
      _ref23$availableActiv = _ref23.availableActivities,
      availableActivities = _ref23$availableActiv === void 0 ? [] : _ref23$availableActiv,
      _ref23$availableRenta = _ref23.availableRentals,
      availableRentals = _ref23$availableRenta === void 0 ? [] : _ref23$availableRenta,
      locale = _ref23.locale,
      paymentStatus = _ref23.paymentStatus;
  return lodash_flow__WEBPACK_IMPORTED_MODULE_20___default()(transformToCardFormat, lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(lodash_filter__WEBPACK_IMPORTED_MODULE_17___default.a), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, keepOnlyAttendeesWithRentedServices), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default()(lodash_curry__WEBPACK_IMPORTED_MODULE_21___default()(lodash_map__WEBPACK_IMPORTED_MODULE_18___default.a), lodash_partial__WEBPACK_IMPORTED_MODULE_19___default.a.placeholder, cleanRentedServices))({
    attendees: attendees,
    locale: locale,
    paymentStatus: paymentStatus,
    availableActivities: deepClone(availableActivities),
    availableRentals: deepClone(availableRentals)
  });
};
var excludePaidSlots = function excludePaidSlots(updatedService, activities) {
  return updatedService.map(function (attendee) {
    return _objectSpread(_objectSpread({}, attendee), {}, {
      schedules: attendee.schedules.map(function (schedule) {
        return _objectSpread(_objectSpread({}, schedule), {}, {
          slots: schedule.slots.filter(function (slotId) {
            return !activities.find(function (activity) {
              return activity.pricingInfo.id === attendee.productInfoId;
            }).pricingInfo.attendees.find(function (att) {
              return att.id === attendee.customerId;
            }).schedules.find(function (sched) {
              return sched.startDate === schedule.startDate && sched.endDate === schedule.endDate;
            }).timeSlots.find(function (slot) {
              return slot.id === slotId;
            }).isPaid;
          })
        });
      }).filter(function (schedule) {
        return schedule.slots.length !== 0;
      })
    });
  }).filter(function (attendee) {
    return attendee.schedules.length !== 0;
  });
}; // The same technic is used here to reverse the strcture shape: explode (unwind) and reaggregate (groupBy)
// This transformation resolves to the POST /v0/customers/{customer_id}/bookings/{booking_id}/cart/services payload format

var formatServiceToUpdateBookingCart = function formatServiceToUpdateBookingCart(_ref24) {
  var appContext = _ref24.appContext,
      bookingId = _ref24.bookingId,
      serviceIds = _ref24.serviceIds,
      type = _ref24.type,
      updatedService = _ref24.updatedService,
      stayIndex = _ref24.stayIndex;
  var table = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"])(updatedService, 'schedules');
  table = Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_31__["unwind"])(table, 'schedules.slots');
  table = table.map(function (_ref25) {
    var attendeeId = _ref25.customerId,
        schedules = _ref25.schedules,
        productInfoId = _ref25.productInfoId;
    var slots = schedules.slots,
        startDate = schedules.startDate,
        endDate = schedules.endDate;
    return {
      attendeeId: attendeeId,
      productInfoId: productInfoId,
      startDate: startDate,
      endDate: endDate,
      slotId: slots
    };
  });

  var card = lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(table, 'slotId')).map(function (entries) {
    var schedules = lodash_values__WEBPACK_IMPORTED_MODULE_25___default()(lodash_groupBy__WEBPACK_IMPORTED_MODULE_26___default()(entries, 'startDate')).map(function (entries) {
      return {
        start_date: entries[0].startDate,
        end_date: entries[0].endDate,
        attendees: entries.map(function (entry) {
          return {
            id: entry.attendeeId
          };
        })
      };
    });

    return {
      id: entries[0].slotId,
      action: 'update',
      context: appContext,
      bookingId: bookingId,
      serviceName: type,
      schedules: schedules,
      stayIndex: stayIndex
    };
  });

  var diff = lodash_difference__WEBPACK_IMPORTED_MODULE_23___default()(serviceIds, card.map(function (_ref26) {
    var id = _ref26.id;
    return id;
  }));

  if (diff.length) {
    diff.forEach(function (id) {
      card.push({
        id: id,
        action: 'remove',
        context: appContext,
        bookingId: bookingId,
        serviceName: type,
        schedules: [],
        stayIndex: stayIndex
      });
    });
  }

  return card;
};
var servicesWithSchedulePricingInfoQuery = "\npricingInfo {\n        id\n        ids\n        progId\n        childId\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        startingPricePerAdult {\n          ...priceDetails\n          currency\n          discount\n          discountUnit\n          formattedInitialValue\n        }\n        isFullyPaid\n        isPartiallyRented\n        isPartiallyPaid\n        attendees {\n          id\n          rentedAmount {...priceDetails}\n          price {\n            currency\n            discount\n            discountUnit\n            formattedInitialValue\n            formattedValue(precision:0)\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {\n                ...priceDetails\n                currency\n                discount\n                discountUnit\n                formattedInitialValue\n              }\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {\n                ...priceDetails\n              }\n            }\n          }\n        }\n      }";
var childcaresQuery = "\nchildcares {\n  ".concat(servicesWithSchedulePricingInfoQuery, "\n  productInfo {\n    id\n    label\n    images\n    description\n    durationDescription\n    isIncluded\n    ageInMonths {\n      min\n      max\n    }\n    openingHours {\n      start\n      end\n    }\n    timeSlots {\n      type\n      opening\n      closing\n    }\n    closingWeekdays\n  }\n}");
var transfersQuery = function transfersQuery(appContext) {
  return "\n      transfers {\n        pricingInfo {\n          id\n          ids\n          isFullyPaid\n          isFullyRented\n          isIncluded\n          isPartiallyPaid\n          isPartiallyRented\n          price: startingPricePerAdult {\n            ...priceDetails\n            formattedValueRounded : formattedValue(precision : 0)\n          }\n          totalPrice {\n            value\n            formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__["getBookingPrecision"])(appContext.locale), ")\n            currency\n          }\n          rentedAmount {\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            remainingStock\n            attendees {\n              id\n            }\n          }\n          type\n        }\n        productInfo {\n          accessId\n          description\n          durationInMinutes\n          id\n          label\n          vehicle {\n            id\n            label\n          }\n          waitingInMinutes\n        }\n      }\n      ");
};
var whiteLabelServicesQuery = function whiteLabelServicesQuery(appContext) {
  return "whiteLabelServices {\n        pricingInfo {\n          id\n          ids\n          type\n          totalPrice {\n            value\n            formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__["getBookingPrecision"])(appContext.locale), ")\n            currency\n          }\n          startingPricePerAdult {\n            value\n            formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__["getBookingPrecision"])(appContext.locale), ")\n            currency\n          }\n          isPartiallyRented\n          isPartiallyPaid\n          isFullyPaid\n          schedules {\n            startDate\n            endDate\n            remainingStock\n            isPartiallyPaid\n            isFullyPaid\n            attendees {\n              id\n            }\n          }\n        }\n        productInfo {\n          id\n          image\n          type\n          title\n          description\n        }\n      }\n      ");
};
var insuranceQuery = function insuranceQuery(appContext) {
  return "insurance {\n        pricingInfo {\n          id\n          type\n          totalPrice {\n            value\n            formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_32__["getBookingPrecision"])(appContext.locale), ")\n            currency\n          }\n          isPartiallyRented\n          isPartiallyPaid\n          isFullyPaid\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n            }\n          }\n        }\n        productInfo {\n          id\n          label\n          shortDescription\n          insuranceDetails {\n            id\n            label\n            images\n            description\n            shortDescription\n            videos\n            attachedDocuments {\n              label\n              url\n            }\n            company {\n              label\n              logo\n            }\n            coverageDescriptions\n            subscriptionConditions {\n              age_min\n              ageMax\n              byAttendees\n            }\n          }\n        }\n      }");
};

/***/ }),

/***/ "JYr1":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("dSaG");

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "Jm8J":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("aXF+");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "JpEK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var create = __webpack_require__("Znn2");
var getPrototypeOf = __webpack_require__("yvHl");
var defineBuiltIn = __webpack_require__("Swp0");
var wellKnownSymbol = __webpack_require__("nJrx");
var IS_PURE = __webpack_require__("SRps");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "Jsmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tripInformationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdultsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKids; });
/* unused harmony export getMainContactOptins */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);

var tripInformationSelector = function tripInformationSelector(state) {
  return (state === null || state === void 0 ? void 0 : state.tripInformation) || {};
};

var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var getAdults = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref2) {
  var adults = _ref2.adults;
  return adults || [];
});
var getAdultsNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref3) {
  var adults = _ref3.adults;
  return (adults || []).length;
});
var getKids = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref4) {
  var kids = _ref4.kids;
  return kids || [];
});
var getMainContactOptins = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var mainContact = _ref5.mainContact;
  return mainContact;
});


/***/ }),

/***/ "Jzv7":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('map', __webpack_require__("mbB6"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "KXRF":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("vCWs");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "Khd+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("HaU7")


/***/ }),

/***/ "KxdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ filterUtils_getFilters; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ filterUtils_updateFilters; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createFilters; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ unselectCategory; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ handleReducedMobilityFilter; });

// UNUSED EXPORTS: COMFORT_CATEGORY, EXTRA_FEATURES_CATEGORY, CONFIGURATION_CATEGORY, REDUCED_MOBILITY_CATEGORY, REDUCED_MOBILITY_FILTER_ID, matchConfiguration, matchComfort, matchExtraFeatures, createConfigurationFilters, createComfortFilters, createExtraFeaturesFilters, matchExtraFeaturesReducedMobility

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/uniqBy.js
var uniqBy = __webpack_require__("z+NW");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/compact.js
var compact = __webpack_require__("LVnT");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/flatten.js
var flatten = __webpack_require__("Z/bG");
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/path.js
var path = __webpack_require__("Z0Tt");
var path_default = /*#__PURE__*/__webpack_require__.n(path);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/map.js
var map = __webpack_require__("Jzv7");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/fp/pipe.js
var pipe = __webpack_require__("eYK6");
var pipe_default = /*#__PURE__*/__webpack_require__.n(pipe);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/client/components/utils/booking/bookingUtils.js + 1 modules
var bookingUtils = __webpack_require__("aWOT");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js + 1 modules
var additionalAccommodations_action = __webpack_require__("06Jt");

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/filter-mobility/FilterMobility.jsx
var __jsx = react_default.a.createElement;






var FilterMobility_FilterMobility = function FilterMobility(_ref) {
  var className = _ref.className,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      onChange = _ref.onChange,
      _ref$selectedOptions = _ref.selectedOptions,
      selectedOptions = _ref$selectedOptions === void 0 ? [] : _ref$selectedOptions;
  var result = Object(es["e" /* useSelector */])(function (state) {
    return state.booking.additionalAccommodations;
  });
  var isActive = Boolean(result === null || result === void 0 ? void 0 : result.isPmrChecked);

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var handleCheck = function handleCheck() {
    onChange('reducedMobilityVisibility', selectedOptions, null);
    trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_ACCOMMODATION_LAYER, {
      detail_click: 'filter_mobility'
    });
  };

  return __jsx(InputSwitch["a" /* InputSwitch */], {
    checked: isActive,
    className: className,
    isDisabled: isDisabled,
    label: Object(i18n["h" /* t */])('filters.reducedMobilityCheckbox'),
    name: "filters.reducedMobility",
    onChange: handleCheck,
    size: "small"
  });
};
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js























var filterUtils_jsx = react_default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}









var COMFORT_CATEGORY = 'accommodations';
var EXTRA_FEATURES_CATEGORY = 'extra';
var CONFIGURATION_CATEGORY = 'configuration';
var REDUCED_MOBILITY_CATEGORY = 'reduced_mobility';
var REDUCED_MOBILITY_FILTER_ID = 'reduced_mobility_access';

var getOptions = function getOptions(v, c) {
  return v.filter(function (_ref) {
    var category = _ref.category;
    return category === c;
  }).map(function (o) {
    var _o$meta, _o$meta2;

    return {
      iconName: (_o$meta = o.meta) === null || _o$meta === void 0 ? void 0 : _o$meta.icon,
      id: o.id,
      isDisabled: !o.matchedOccurrences,
      isSelected: o.selected,
      label: (_o$meta2 = o.meta) === null || _o$meta2 === void 0 ? void 0 : _o$meta2.label,
      matched: o.matchedOccurrences || 0,
      value: o.value
    };
  });
};

var filterUtils_getFilters = function getFilters(product) {
  var filterValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 ? arguments[2] : undefined;
  return [{
    id: COMFORT_CATEGORY,
    label: Object(i18n["h" /* t */])('filters.comfort.categoryTitle'),
    options: getOptions(filterValues, COMFORT_CATEGORY)
  }, {
    id: CONFIGURATION_CATEGORY,
    label: Object(bookingUtils["u" /* tAlt */])({
      cruiseKeyPath: 'filters.configuration.categoryTitleCruise',
      product: product,
      resortKeyPath: 'filters.configuration.categoryTitle'
    }),
    options: getOptions(filterValues, CONFIGURATION_CATEGORY)
  }, {
    id: EXTRA_FEATURES_CATEGORY,
    label: Object(i18n["h" /* t */])('filters.extraFeatures.categoryTitle'),
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY)
  }, (options === null || options === void 0 ? void 0 : options.ignoreReducedMobility) ? null : {
    id: REDUCED_MOBILITY_CATEGORY,
    label: '',
    options: getOptions(filterValues, EXTRA_FEATURES_CATEGORY),
    // eslint-disable-next-line clubmed/no-fake-component
    customRenderParent: function customRenderParent(selectedOptions, onChange, isDisabled) {
      return filterUtils_jsx(FilterMobility_FilterMobility, {
        isDisabled: isDisabled,
        onChange: onChange,
        selectedOptions: selectedOptions
      });
    }
  }].filter(Boolean);
};

var matchConfiguration = function matchConfiguration(accommodations, roomType) {
  var SINGLE_ROOM = 'SINGLE_ROOM',
      SEPARATE_ROOMS = 'SEPARATE_ROOMS',
      SEPARATE_ROOMS_3 = 'SEPARATE_ROOMS_3',
      CONNECTING_ROOMS = 'CONNECTING_ROOMS';
  var matchSingleConfiguration = roomType === SINGLE_ROOM;
  var matchSeparatedConfiguration = roomType === SEPARATE_ROOMS;
  var matchSeparated3Configuration = roomType === SEPARATE_ROOMS_3;
  var matchCommunicatingConfiguration = roomType === CONNECTING_ROOMS;

  if (matchSingleConfiguration) {
    return accommodations.length === 1 && accommodations[0].roomType === SINGLE_ROOM;
  }

  if (matchSeparatedConfiguration) {
    var separateConfigurations = accommodations.length === 2 && accommodations.every(function (accommodation) {
      return accommodation.roomType === SEPARATE_ROOMS || accommodation.roomType === SINGLE_ROOM;
    }) || // some combinations of two or more rooms come in one accommodation with ex : C4+C4 but roomtype is SEPARATE_ROOMS
    accommodations.length === 1 && accommodations[0].roomType === SEPARATE_ROOMS;
    return separateConfigurations;
  }

  if (matchSeparated3Configuration) {
    var _separateConfigurations = accommodations.length >= 3 && accommodations.every(function (accommodation) {
      return accommodation.roomType === SEPARATE_ROOMS || accommodation.roomType === SEPARATE_ROOMS_3 || accommodation.roomType === SINGLE_ROOM;
    }) || accommodations.length === 1 && accommodations[0].roomType === SEPARATE_ROOMS_3;

    return _separateConfigurations;
  }

  if (matchCommunicatingConfiguration) {
    var communicatingConfigurations = accommodations.length >= 1 && accommodations.some(function (accommodation) {
      return accommodation.roomType === CONNECTING_ROOMS;
    });
    return communicatingConfigurations;
  } // default case for all other room types ( we never know what to expect )


  return accommodations.some(function (accommodation) {
    return accommodation.roomType === roomType;
  });
};

var filterUtils_matchComfort = function matchComfort(accommodations, categoryId) {
  return accommodations.some(function (accommodation) {
    return get_default()(accommodation, 'categories').find(function (category) {
      return get_default()(category, 'id') === categoryId;
    });
  });
};

var filterUtils_matchExtraFeatures = function matchExtraFeatures(accommodations, strengthId) {
  return accommodations.some(function (accommodation) {
    return get_default()(accommodation, 'view.id', null) === strengthId || get_default()(accommodation, 'strengths', []).find(function (strength) {
      return get_default()(strength, 'id') === strengthId;
    });
  });
};

var matchExtraFeaturesReducedMobility = function matchExtraFeaturesReducedMobility(accommodations) {
  return accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
};

function createConfigurationFilters(accommodationsSets, product) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('roomType')])(accommodationsSets);

  var roomTypes = accommodations.map(function (_ref2) {
    var roomType = _ref2.roomType;
    return roomType;
  }); // even we dont have the SEPARATE_ROOMS in the roomTypes, we need to show the filter
  // because two or more with SINGLE_ROOM can be combined to form SEPARATE_ROOMS
  // same for SEPARATE_ROOMS_3

  var roomTypesSR = roomTypes.includes('SEPARATE_ROOMS') ? roomTypes : [].concat(Object(toConsumableArray["a" /* default */])(roomTypes), ['SEPARATE_ROOMS']);
  var completeRoomTypes = roomTypes.includes('SEPARATE_ROOMS_3') ? roomTypesSR : [].concat(Object(toConsumableArray["a" /* default */])(roomTypesSR), ['SEPARATE_ROOMS_3']);
  return completeRoomTypes.map(function (roomType) {
    return {
      id: shortid_default.a.generate(),
      category: CONFIGURATION_CATEGORY,
      match: matchConfiguration,
      meta: {
        label: Object(bookingUtils["u" /* tAlt */])({
          cruiseKeyPath: "filters.configuration.".concat(accommodation_constants["b" /* CABIN_TYPE */][roomType]),
          product: product,
          resortKeyPath: "filters.configuration.".concat(accommodation_constants["e" /* ROOM_TYPE */][roomType])
        }),
        icon: icons["a" /* ICONS */][roomType]
      },
      path: 'accommodations',
      selected: false,
      value: roomType
    };
  });
}

function createComfortFilters(accommodationsSets) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, compact_default.a, uniqBy_default()('categoryId')])(accommodationsSets);

  var comfortSeen = [];
  return accommodations.map(function (accommodation) {
    /**
     * in some cases we have differents categories with same comfort type
     * it causes a duplicate filter
     * Concat comfort type & category, as label for teh second one
     */
    var comfortType = accommodation.comfortType,
        category = accommodation.category;
    var label = comfortSeen.includes(comfortType) ? "".concat(comfortType, " ").concat(category) : comfortType || category;
    comfortSeen.push(accommodation.comfortType);
    return {
      id: shortid_default.a.generate(),
      category: COMFORT_CATEGORY,
      match: filterUtils_matchComfort,
      meta: {
        label: label
      },
      path: 'accommodations',
      selected: false,
      value: accommodation.categoryId
    };
  });
}

function createExtraFeaturesFilters(accommodationsSets) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('id')])(accommodationsSets);

  var strengths = pipe_default()([map_default()(path_default()('strengths')), flatten_default.a, compact_default.a, uniqBy_default()('id')])(accommodations);

  var views = pipe_default()([map_default()(path_default()('view')), compact_default.a, uniqBy_default()('id')])(accommodations);

  var features = [].concat(Object(toConsumableArray["a" /* default */])(strengths), Object(toConsumableArray["a" /* default */])(views));
  return features.map(function (feature) {
    return {
      id: shortid_default.a.generate(),
      category: EXTRA_FEATURES_CATEGORY,
      match: feature.id === REDUCED_MOBILITY_FILTER_ID ? matchExtraFeaturesReducedMobility : filterUtils_matchExtraFeatures,
      meta: {
        label: feature.label,
        icon: icons["a" /* ICONS */][feature.id],
        iconClassName: "icon--".concat(feature.id),
        iconInheritColor: true
      },
      path: 'accommodations',
      selected: false,
      value: feature.id
    };
  });
}

function handleReducedMobilityFilter(accommodationsSets, reducedMobilityVisibility, state) {
  var accommodations = pipe_default()([map_default()(path_default()('accommodations')), flatten_default.a, uniqBy_default()('id')])(accommodationsSets);

  var isReducedMobility = accommodations.some(function (accommodation) {
    return accommodation.reducedMobilityAccess;
  });
  var matchedReducedMobility = isReducedMobility ? accommodationsSets.filter(function (filteredAccomodation) {
    return filteredAccomodation.accommodations.filter(function (acc) {
      return acc.reducedMobilityAccess === true;
    }).length > 0;
  }).length : 0;
  var newItem = {
    id: shortid_default.a.generate(),
    category: EXTRA_FEATURES_CATEGORY,
    match: matchExtraFeaturesReducedMobility,
    matchedOccurrences: matchedReducedMobility,
    meta: {
      label: Object(i18n["h" /* t */])('filters.reducedMobility'),
      icon: icons["a" /* ICONS */].reduced_mobility_access,
      iconClassName: 'icon--reduced_mobility_access',
      iconInheritColor: true
    },
    path: 'accommodations',
    selected: false,
    value: 'reduced_mobility_access'
  };
  return !reducedMobilityVisibility ? [].concat(Object(toConsumableArray["a" /* default */])(state), [newItem]) : state.filter(function (feature) {
    return feature.value !== 'reduced_mobility_access';
  });
}

function createFilters(accommodationsSets, product) {
  return [].concat(Object(toConsumableArray["a" /* default */])(createExtraFeaturesFilters(accommodationsSets)), Object(toConsumableArray["a" /* default */])(createConfigurationFilters(accommodationsSets, product)), Object(toConsumableArray["a" /* default */])(createComfortFilters(accommodationsSets)));
}

function unselectCategory(filters) {
  return function (category) {
    return filters.map(function (filter) {
      return _objectSpread(_objectSpread({}, filter), {}, {
        selected: filter.category === category ? false : filter.selected
      });
    });
  };
}

var filterUtils_updateFilters = function updateFilters(_ref3, dispatch, setVisibility) {
  var accommodationsSets = _ref3.accommodationsSets,
      filterValues = _ref3.filterValues,
      visibility = _ref3.visibility;
  return function (name, opts, updatedValue) {
    if (filterValues && updatedValue) {
      var f = filterValues.find(function (v) {
        return v.value === updatedValue;
      });

      if (f) {
        dispatch(Object(additionalAccommodations_action["o" /* toggleAdditionalAccommodationFilter */])(f));
      }
    } else {
      setVisibility(function (shown) {
        return !shown;
      });
      dispatch(Object(additionalAccommodations_action["q" /* togglePMRChecbox */])(!visibility, filterValues));

      if (opts.length === 1 && opts[0] === 'reduced_mobility_access' && visibility) {
        var _f = filterValues.find(function (v) {
          return v.value === 'reduced_mobility_access';
        });

        dispatch(Object(additionalAccommodations_action["p" /* toggleAdditionalAccommodationReducedMobilityFilter */])(accommodationsSets, visibility));

        if (_f) {
          dispatch(Object(additionalAccommodations_action["o" /* toggleAdditionalAccommodationFilter */])(_f));
        }
      } else {
        dispatch(Object(additionalAccommodations_action["p" /* toggleAdditionalAccommodationReducedMobilityFilter */])(accommodationsSets, visibility));
      }
    }
  };
};


/***/ }),

/***/ "LFxm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("kZDm");
var defineBuiltIns = __webpack_require__("D092");
var getWeakData = __webpack_require__("wKkN").getWeakData;
var anInstance = __webpack_require__("V/va");
var anObject = __webpack_require__("ep/x");
var isNullOrUndefined = __webpack_require__("nnO8");
var isObject = __webpack_require__("1YFU");
var iterate = __webpack_require__("ZuH9");
var ArrayIterationModule = __webpack_require__("VrMI");
var hasOwn = __webpack_require__("/GgU");
var InternalStateModule = __webpack_require__("9jKB");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};


/***/ }),

/***/ "LTtw":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var getOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var createNonEnumerableProperty = __webpack_require__("g51W");
var defineBuiltIn = __webpack_require__("Swp0");
var defineGlobalProperty = __webpack_require__("9vpE");
var copyConstructorProperties = __webpack_require__("sfoL");
var isForced = __webpack_require__("wxLG");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "LVnT":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('compact', __webpack_require__("3dHC"), __webpack_require__("zUlE"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "LdtY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("0D0S")


/***/ }),

/***/ "M4Qz":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var hasOwn = __webpack_require__("/GgU");
var toIndexedObject = __webpack_require__("dNjr");
var indexOf = __webpack_require__("5LiQ").indexOf;
var hiddenKeys = __webpack_require__("qXr/");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "MAH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchValidationSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return proposalsByIdQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return streetViewsByAccommodationCategoryId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getValidationSchema; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("QsI/");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("H0gB");
/* harmony import */ var _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("SQLw");
/* harmony import */ var _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("BYx+");
/* harmony import */ var _store_validation_schema_validationSchemaField_fragment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("2GfD");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("70jX");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("L7OA");
















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
function getResort() {
  var fetchActivityCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "\n    resort {\n      accommodations {\n        area {\n          max\n          min\n          unit\n        }\n        bathroomEquipments {\n          id\n          label\n        }\n        category\n        categoryId\n        comfortId\n        comfortType\n        connectingRoom\n        description\n        equipments {\n          id\n          label\n          ranking\n        }\n        exclusiveCollection\n        floorPlans\n        id\n        label\n        maxCapacity\n        media {\n          photos {\n            url\n          }\n        }\n        minCapacity\n        outsideFacilities {\n          id\n          label\n        }\n        ranking\n        roomType\n        services {\n          id\n          label\n          ranking\n        }\n        strengths {\n          id\n          label\n        }\n        surface\n        view {\n          id\n          label\n        }\n      }\n      thematicActivityTree {\n        ...thematics\n        activities {\n          ...activity\n        }\n      }\n      ".concat(fetchActivityCategories ? "activityTree {\n        ...activityCategory\n        activities {\n          ...activity\n        }\n        categories {\n          ...activityCategory\n          activities {\n            ...activity\n          }\n          categories {\n            ...activityCategory\n            activities {\n              ...activity\n            }\n          }\n        }\n      }" : '', "\n      adultOnly\n      associatedResort{\n        id\n        name\n      }\n      badgeIcon\n      category\n      childcareDetails {\n        isIncluded: included\n        ageInMonths {\n          min\n          max\n        }\n      }\n      childrenActivities: productActivities(idFilter: \"").concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        ageInMonths {\n          max\n          min\n        }\n        description\n        equipments {\n          id\n          label\n        }\n        id\n        isIncluded\n        label\n        subtitle\n      }\n      color\n      comfort\n      comfortLabel\n      destination {\n        area\n        country\n      }\n      facilities(types: [\"CHILDREN\",\"PARKING\"], withEquipments: true) {\n        equipments {\n          id\n          label\n        }\n        label\n        subtitle\n        type\n      }\n      factSheetUrl\n      href\n      id\n      image\n      images\n      hasECSpace\n      isCruise\n      isExclusiveCollection\n      isExplicitEC\n      isJoyview\n      isUrbanOasis\n      isWinter\n      name\n      offsetSell\n      openingDates {\n        opening\n        closing\n      }\n      ").concat(fetchActivityCategories ? "rentalsTree {\n        ...rentals\n      }" : '', "\n      seasonName\n      seasons\n      title\n      transportType\n      type\n      ").concat(fetchActivityCategories ? "activityCategories {\n        leisure {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            startDate\n            endDate\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n        wellness {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n      }" : '', "\n    }");
}

function getValidationSchema(proposalIds, resource, locale) {
  var proposalId = Array.isArray(proposalIds) ? proposalIds[0] : proposalIds;
  return "\n    {\n      validationSchema(\n        proposalId: \"".concat(proposalId || '', "\",\n        resource : \"").concat(resource, "\",\n        fields: [\"address\"],\n        locale: \"").concat(locale || '', "\") {\n        ...ValidationSchemaField\n      }\n    }\n    ").concat(_store_validation_schema_validationSchemaField_fragment__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"], "\n    ");
}

function fetchValidationSchema(_x, _x2, _x3) {
  return _fetchValidationSchema.apply(this, arguments);
}

function _fetchValidationSchema() {
  _fetchValidationSchema = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee(proposalId, appContext, resource) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery(getValidationSchema(proposalId, resource), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_SCHEMA */ "Qc"]
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchValidationSchema.apply(this, arguments);
}

var getAttendeesData = function getAttendeesData(_ref) {
  var adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return "".concat(adultsAttendeesIds && adultsAttendeesIds[0] ? "adultsAttendees: attendees(attendeesIds: [\"".concat(adultsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          birthdate: dateOfBirth\n          email\n          mobile: mobilePhoneNumber\n          optinEmail\n          optinSms\n          optinPhone\n          optinMail\n          optinClubmedPlus\n          identityNumber\n          healthPassId\n          address {\n            streetNumber\n            streetName\n            additionalInformation1\n            additionalInformation2\n            addOn\n            zipCode\n            city\n            town\n            stateOrDistrict\n            countryCode\n            country\n          }\n          document {\n            passport {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n              birthCountry\n              birthCity\n              secondName\n              thirdName\n              fourthName\n              type\n            }\n            idcard {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n              birthCountry\n              birthCity\n              secondName\n              thirdName\n              fourthName\n              type\n            }\n          }\n        }") : '', "\n  ").concat( // no need of birthday, we already have it
  kidsAttendeesIds && kidsAttendeesIds[0] ? "kidsAttendees: attendees(attendeesIds: [\"".concat(kidsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          healthPassId\n          document {\n            passport {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n            }\n            idcard {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n            }\n          }\n        }") : '', "\n");
};
/*
 * * Used in fetchProposalsById to get transports list and node for <TransportsSection/>
 * * Uses  API route /v2/proposals/{proposal_id}
 */


function proposalsByIdQuery(_x4, _x5) {
  return _proposalsByIdQuery.apply(this, arguments);
}
/*
 * * Used in fetchStreetViewsByAccommodationCategoryId to get street views list for <AccommodationRoomSlideshow/>
 * * Uses  API route GET /v0/products/{product_id}/accommodation_categories/{accommodation_category_id}/virtual_visits
 */


function _proposalsByIdQuery() {
  _proposalsByIdQuery = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee2(params, appContext) {
    var _proposalsResponse$pr, _params$adultsAttende, _params$kidsAttendees;

    var proposalsArgs, displayCommission, proposalsResponse, proposals, selectedProposal, adultsAttendeesIds, kidsAttendeesIds, hasAttendeeIds, validationSchema, attendeesResponse;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalsArgs = ["ids: [\"".concat(Array.isArray(params.proposalsId) ? params.proposalsId.join('","') : params.proposalsId, "\"]")];
            displayCommission = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
            _context2.next = 4;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n      {\n        proposals: proposalsById(".concat(proposalsArgs.join(', '), ") {\n          ... on ProposalsType {\n            proposals {\n              ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* proposalFields */ "k"])({
              isJoyView: true,
              isUrbanOasis: true,
              withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission,
              withSchedule: params.shouldRequestPayment
            }, appContext), "\n            }\n            ").concat(getResort(params.fetchActivityCategories), "\n          }\n        }\n        ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n        ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* paymentProvidersRequest */ "i"])() : '', "\n      }\n      ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* transportDetailsFragment */ "q"], "\n      ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* getPriceDetailFragment */ "h"])(lodash_get__WEBPACK_IMPORTED_MODULE_14___default()(appContext, 'locale')), "\n      ").concat(appContext.isUserLogged ? _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_18__[/* profileFragment */ "a"] : '', "\n      ").concat(params.fetchActivityCategories ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* activityCategoryFragment */ "a"] : '', "\n      ").concat(params.fetchActivityCategories || _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* thematicFragment */ "g"] ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* activityFragment */ "b"] : '', "\n      ").concat(params.fetchActivityCategories ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* rentalsFragment */ "f"] : '', "\n      ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* thematicFragment */ "g"], "\n    "), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_BY_ID */ "Oc"]
            });

          case 4:
            proposalsResponse = _context2.sent;
            proposals = ((_proposalsResponse$pr = proposalsResponse.proposals) === null || _proposalsResponse$pr === void 0 ? void 0 : _proposalsResponse$pr.proposals) || [];
            selectedProposal = params.selectedProposalId && proposals.find(function (_ref2) {
              var id = _ref2.id;
              return id === params.selectedProposalId;
            }) || proposals[0];

            if (selectedProposal) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", _objectSpread({}, proposalsResponse));

          case 9:
            adultsAttendeesIds = (params === null || params === void 0 ? void 0 : (_params$adultsAttende = params.adultsAttendeesIds) === null || _params$adultsAttende === void 0 ? void 0 : _params$adultsAttende.length) ? params.adultsAttendeesIds : ((selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.attendees.adults) || []).map(function (_ref3) {
              var customerId = _ref3.customerId;
              return customerId;
            }).filter(Boolean);
            kidsAttendeesIds = (params === null || params === void 0 ? void 0 : (_params$kidsAttendees = params.kidsAttendeesIds) === null || _params$kidsAttendees === void 0 ? void 0 : _params$kidsAttendees.length) ? params.kidsAttendeesIds : ((selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.attendees.children) || []).map(function (_ref4) {
              var customerId = _ref4.customerId;
              return customerId;
            }).filter(Boolean);
            hasAttendeeIds = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(adultsAttendeesIds) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(kidsAttendeesIds);
            _context2.next = 14;
            return fetchValidationSchema(selectedProposal.id, appContext, 'profile');

          case 14:
            validationSchema = _context2.sent;

            if (!(!appContext.isSeller || !hasAttendeeIds)) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", _objectSpread(_objectSpread({
              selectedProposal: selectedProposal
            }, proposalsResponse), validationSchema));

          case 17:
            _context2.next = 19;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n      {\n        ".concat( // When it is an attendee identified on the Cxo side we already know the customerIds
            // via the cxo_traveler query param
            getAttendeesData({
              adultsAttendeesIds: adultsAttendeesIds,
              kidsAttendeesIds: kidsAttendeesIds
            }), "\n      }\n      ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n      ").concat(adultsAttendeesIds && adultsAttendeesIds[0] || kidsAttendeesIds && kidsAttendeesIds[0] ? _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"] : '', "\n    "), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_BY_ID */ "Oc"]
            });

          case 19:
            attendeesResponse = _context2.sent;
            return _context2.abrupt("return", _objectSpread(_objectSpread(_objectSpread({
              selectedProposal: selectedProposal
            }, proposalsResponse), attendeesResponse), validationSchema));

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _proposalsByIdQuery.apply(this, arguments);
}

function streetViewsByAccommodationCategoryId(params, appContext) {
  var streetViewsArgs = ["productId: \"".concat(params.productId, "\"")];
  streetViewsArgs.push(Array.isArray(params.accommodationCategoryIds) ? "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds.join('","'), "\"]") : "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds, "\"]"));
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n    {\n      streetViews(".concat(streetViewsArgs.join(', '), ") {\n        accommodationCategoryId\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n          url\n        }\n      }\n    }\n  "), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* STREET_VIEW_GET_SEVERAL */ "ld"]
  });
}



/***/ }),

/***/ "MRpX":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var setPrototypeOf = __webpack_require__("iBXc");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "MU85":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");
var getMethod = __webpack_require__("Uey1");
var isNullOrUndefined = __webpack_require__("nnO8");
var Iterators = __webpack_require__("oa0l");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "MaE1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

module.exports = global;


/***/ }),

/***/ "Mn1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripDateCriteriaSelector = function tripDateCriteriaSelector(_ref) {
  var tripDateCriteria = _ref.tripDateCriteria;
  return tripDateCriteria || {};
};

var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref2) {
  var arrivalDate = _ref2.arrivalDate;
  return arrivalDate;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref3) {
  var departureDate = _ref3.departureDate;
  return departureDate;
});


/***/ }),

/***/ "Mv+R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("JpEK").IteratorPrototype;
var create = __webpack_require__("Znn2");
var createPropertyDescriptor = __webpack_require__("OouP");
var setToStringTag = __webpack_require__("CGO5");
var Iterators = __webpack_require__("oa0l");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "NEd/":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var isArray = __webpack_require__("gIGD");
var isCallable = __webpack_require__("ANQd");
var classof = __webpack_require__("XywU");
var toString = __webpack_require__("vnfA");

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) == 'Number' || classof(element) == 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ "NXDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstallmentPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalPriceWithDonation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasAtLeastOnePrice; });
/* unused harmony export hasPrice */
/* unused harmony export isLongFormat */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kiXb");















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var MAX_LENGTH = 10;

function getCurrencySymbol(locale, currency) {
  return 0 .toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim();
}

function hasPrice(price) {
  return !!(price === null || price === void 0 ? void 0 : price.value);
}

var hasDiscount = function hasDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      initialPrice = _ref.initialPrice;
  return hasPrice(initialPrice) && hasPrice(bestPrice) && (initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.value) !== (bestPrice === null || bestPrice === void 0 ? void 0 : bestPrice.value);
};

function hasAtLeastOnePrice() {
  var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = price || {},
      initialPrice = _ref2.initialPrice,
      bestPrice = _ref2.bestPrice;

  return hasPrice(initialPrice) || hasPrice(bestPrice);
}

var isLongFormat = function isLongFormat(amount) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_LENGTH;
  return amount ? amount.toString().length > limit : false;
};

var getTotalPriceWithDonation = function getTotalPriceWithDonation(price, locale) {
  var donation = price.donation,
      total = price.total,
      totalWithoutDiscount = price.totalWithoutDiscount;

  var totalWithDonation = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(donation, 'value', 0) + lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(total, 'value', 0);

  var totalWithoutDiscountWithDonation = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(donation, 'value', 0) + lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(totalWithoutDiscount, 'value', 0);

  var currencyOptions = {
    precision: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__["getBookingPrecision"])(locale)
  };
  return _objectSpread(_objectSpread({}, price), {}, {
    withDonation: {
      total: {
        value: totalWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithDonation, locale, price.currency, currencyOptions)
      },
      totalWithoutDiscount: {
        value: totalWithoutDiscountWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithoutDiscountWithDonation, locale, price.currency, currencyOptions)
      },
      hasFlexRates: price.hasFlexRates,
      selectedRate: price.selectedRate
    }
  });
};

var getInstallmentPrice = function getInstallmentPrice(price, locale) {
  if (!price || !price.value) {
    return '';
  }

  if (Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.displayInstalmentsPrice')) {
    var instalmentValue = Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.instalmentValue');
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.price.instalmentPrice', {
      instalmentValue: instalmentValue,
      dividedPrice: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(Math.ceil(price.value / instalmentValue), locale, price.currency, {
        precision: 0
      })
    });
  }

  return price.formattedValue;
};


/***/ }),

/***/ "Nsha":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIntersection = __webpack_require__("1sLo"),
    baseRest = __webpack_require__("R3TX"),
    castArrayLikeObject = __webpack_require__("VZDm");

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),

/***/ "O7yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_OPTION_VALIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSET_OPTION_VALIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return optionValidityReducer; });
var SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
var UNSET_OPTION_VALIDITY = 'UNSET_OPTION_VALIDITY';
var initialState = null;
var optionValidityReducer = function optionValidityReducer() {
  var _action$payload$local, _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_OPTION_VALIDITY:
      /**
       * TODO: fix async tests with payload missing
       * broke:
       * - src/client/components/widgets/price-remote/PriceRemote.spec.js
       * - src/client/views/booking/booking-confirmation/BookingConfirmationView.spec.js
       */
      return (_action$payload$local = action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.locale.optionValidity) !== null && _action$payload$local !== void 0 ? _action$payload$local : null;

    case UNSET_OPTION_VALIDITY:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "O94r":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "OOYD":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("W0vE"),
    baseFilter = __webpack_require__("sjzV"),
    baseIteratee = __webpack_require__("S3pA"),
    isArray = __webpack_require__("wxYD"),
    negate = __webpack_require__("J4/4");

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "OekA":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ "OoaE":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var hasOwn = __webpack_require__("/GgU");
var DESCRIPTORS = __webpack_require__("uGjT");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("mu8A").CONFIGURABLE;
var inspectSource = __webpack_require__("/ExG");
var InternalStateModule = __webpack_require__("9jKB");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "OouP":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "OsvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NO_VIEW_ICON_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NO_OUTSIDE_FACILITY_ICON_ID; });
/* unused harmony export roomTypeIcons */
/* unused harmony export viewIcons */
/* unused harmony export outsideFacilitiesIcons */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isRoomTypeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isViewItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isOutsideFacilityItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isItemFilterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addViewIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addOutsideFacilitiesIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addRoomTypeIconPropertiesToFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTypedFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasTypedAlternative; });
/* unused harmony export submitAccommodation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return chooseOption; });
/* unused harmony export DefaultAccommodationFilterRadioButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DefaultAccommodationViewRadioButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultAccommodationOutsideFacilitiesRadioButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultAccommodationRoomTypeRadioButton; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _radio_button_with_icon_RadioButtonWithIcon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("dm5U");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("SPKZ");
/* harmony import */ var _accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("cb6o");
/* harmony import */ var _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("K0Lv");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("829J");
/* harmony import */ var _store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("AnR0");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("47Eh");
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("ljKo");
/* harmony import */ var _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("UIAR");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("/1vS");



















var __jsx = react__WEBPACK_IMPORTED_MODULE_19___default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var NO_VIEW_ICON_ID = 'no_view';
var NO_OUTSIDE_FACILITY_ICON_ID = 'no_outside_facility';
var roomTypeIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SINGLE_ROOM, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SUITE_ROOM, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SEPARATE_ROOMS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SEPARATE_ROOMS_3, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].CONNECTING_ROOMS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SEPARATED_BUILDINGS, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].separate_rooms, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].SHARED_ROOM];
var viewIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].fir_tree_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].pool_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].mountain_view_or_slopes_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].river_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].sea_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].seaview, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].garden_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].slopes_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].mountain_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].forest_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].golf_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].valley_view, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].view_chailifts_or_cable_railway, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].view_of_the_grounds, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].view_of_the_ski_resort];
var outsideFacilitiesIcons = [_utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].Balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].furnished_balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].double_balcony, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].furnished_terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].private_furnished_terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].private_garden, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].private_pool, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].terrace, _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].with_balcony_or_resort_view]; // used to identify the type of each item on accommodationRoomInfos

var isRoomTypeItem = function isRoomTypeItem(itemIcon) {
  return roomTypeIcons.includes(itemIcon);
};
var isViewItem = function isViewItem(itemIcon) {
  return viewIcons.includes(itemIcon);
};
var isOutsideFacilityItem = function isOutsideFacilityItem(itemIcon) {
  return outsideFacilitiesIcons.includes(itemIcon);
};
var isItemFilterable = function isItemFilterable(itemIcon) {
  return isRoomTypeItem(itemIcon) || isViewItem(itemIcon) || isOutsideFacilityItem(itemIcon);
};
var addViewIconPropertiesToFilters = function addViewIconPropertiesToFilters(filtersView) {
  return filtersView === null || filtersView === void 0 ? void 0 : filtersView.map(function (filter) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_22__[/* getViewIconItem */ "g"])({
        id: filter.id,
        label: filter.label
      })
    });
  });
};
var addOutsideFacilitiesIconPropertiesToFilters = function addOutsideFacilitiesIconPropertiesToFilters(outsideFacilitiesFilter) {
  return outsideFacilitiesFilter === null || outsideFacilitiesFilter === void 0 ? void 0 : outsideFacilitiesFilter.map(function (filter) {
    var accommodationOutsideFacility = [{
      id: filter.id,
      label: filter.label
    }];
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_22__[/* getOutsideFacilitiesIconItem */ "e"])(accommodationOutsideFacility)
    });
  });
};
var addRoomTypeIconPropertiesToFilters = function addRoomTypeIconPropertiesToFilters(filtersRoomType, product) {
  return filtersRoomType === null || filtersRoomType === void 0 ? void 0 : filtersRoomType.map(function (filter) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      icon: Object(_accommodations_BookingAccommodationsUtils__WEBPACK_IMPORTED_MODULE_22__[/* getSurfaceIconItem */ "f"])(filter.id, product, '')
    }); // filter.surface
  });
};
var getTypedFilters = function getTypedFilters(_ref, type) {
  var filtersView = _ref.filtersView,
      filtersOutsideFacilities = _ref.filtersOutsideFacilities,
      filtersRoomType = _ref.filtersRoomType;

  switch (type) {
    case _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].VIEW:
      return filtersView || [];

    case _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].OUTSIDE_FACILITIES:
      return filtersOutsideFacilities || [];

    case _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].ROOM_TYPE:
      return filtersRoomType || [];

    default:
      return [];
  }
};
var hasTypedAlternative = function hasTypedAlternative(_ref2) {
  var _currentComfortAltern, _currentComfortAltern2, _currentComfortAltern3;

  var currentComfortAlternatives = _ref2.currentComfortAlternatives,
      icon = _ref2.icon,
      proposal = _ref2.proposal;
  var viewAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern === void 0 ? void 0 : _currentComfortAltern.view;
  var outsideFacilityAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern2 = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern2 === void 0 ? void 0 : _currentComfortAltern2.outsideFacilities;
  var roomTypeAlternatives = currentComfortAlternatives === null || currentComfortAlternatives === void 0 ? void 0 : (_currentComfortAltern3 = currentComfortAlternatives.availableFilters) === null || _currentComfortAltern3 === void 0 ? void 0 : _currentComfortAltern3.roomType;

  if (isViewItem(icon) && viewAlternatives) {
    var _proposal$accommodati, _proposal$accommodati2;

    var viewAlternativeExceptNoView = viewAlternatives.filter(function (_ref3) {
      var id = _ref3.id;
      return id !== NO_VIEW_ICON_ID;
    });
    var proposalCurrentViewId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati = proposal.accommodations[0]) === null || _proposal$accommodati === void 0 ? void 0 : (_proposal$accommodati2 = _proposal$accommodati.view) === null || _proposal$accommodati2 === void 0 ? void 0 : _proposal$accommodati2.id;
    var pureViewAlternatives = proposalCurrentViewId ? viewAlternatives.filter(function (_ref4) {
      var id = _ref4.id;
      return id !== proposalCurrentViewId;
    }) : viewAlternativeExceptNoView;
    return pureViewAlternatives.length >= 1;
  }

  if (isOutsideFacilityItem(icon) && outsideFacilityAlternatives) {
    var _proposal$accommodati3, _proposal$accommodati4, _proposal$accommodati5;

    var outsideFacilityAlternativesExceptNoOF = outsideFacilityAlternatives.filter(function (_ref5) {
      var id = _ref5.id;
      return id !== NO_OUTSIDE_FACILITY_ICON_ID;
    });
    var proposalCurrentOutsideFacilityId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati3 = proposal.accommodations[0]) === null || _proposal$accommodati3 === void 0 ? void 0 : (_proposal$accommodati4 = _proposal$accommodati3.outsideFacilities) === null || _proposal$accommodati4 === void 0 ? void 0 : (_proposal$accommodati5 = _proposal$accommodati4[0]) === null || _proposal$accommodati5 === void 0 ? void 0 : _proposal$accommodati5.id; // remove same id option if necessary

    var pureOutsideFacilityAlternatives = proposalCurrentOutsideFacilityId ? outsideFacilityAlternatives.filter(function (_ref6) {
      var id = _ref6.id;
      return id !== proposalCurrentOutsideFacilityId;
    }) : outsideFacilityAlternativesExceptNoOF;
    return pureOutsideFacilityAlternatives.length >= 1;
  }

  if (isRoomTypeItem(icon) && roomTypeAlternatives) {
    var _proposal$accommodati6; // there is always a roomType


    var proposalCurrentRoomTypeId = proposal === null || proposal === void 0 ? void 0 : (_proposal$accommodati6 = proposal.accommodations[0]) === null || _proposal$accommodati6 === void 0 ? void 0 : _proposal$accommodati6.roomType; // remove same id option if necessary

    var pureRoomTypeAlternatives = proposalCurrentRoomTypeId ? roomTypeAlternatives.filter(function (_ref7) {
      var id = _ref7.id;
      return id !== proposalCurrentRoomTypeId;
    }) : roomTypeAlternatives;
    return pureRoomTypeAlternatives.length >= 1;
  }
};
var submitAccommodation = function submitAccommodation(_ref8) {
  var _selectedAccommodatio, _selectedAccommodatio2;

  var accommodationsSets = _ref8.accommodationsSets,
      proposal = _ref8.proposal,
      formSelectedAlternativeId = _ref8.formSelectedAlternativeId,
      resort = _ref8.resort,
      optionId = _ref8.optionId,
      optionCategory = _ref8.optionCategory,
      dispatch = _ref8.dispatch,
      appContext = _ref8.appContext,
      onClose = _ref8.onClose,
      trackRoomPersonalization = _ref8.trackRoomPersonalization;
  var selectedAccommodationSet = accommodationsSets === null || accommodationsSets === void 0 ? void 0 : accommodationsSets.find(function (_ref9) {
    var id = _ref9.id;
    return id === formSelectedAlternativeId;
  });

  if (!formSelectedAlternativeId) {
    return onClose();
  }

  var _ref10 = selectedAccommodationSet || {},
      totalDifferentialPrice = _ref10.totalDifferentialPrice;

  var storage = _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_24__[/* BE_TRACKING */ "c"]); // $FlowFixMe

  var selectedProposalId = storage.contextNumber; // $FlowFixMe

  var roomFilters = (storage.roomFilters || []).filter(function (roomFilter) {
    return roomFilter.proposalId === selectedProposalId;
  });
  var roomFilterIndex = roomFilters.findIndex(function (_ref11) {
    var upsellCategory = _ref11.upsellCategory;
    return upsellCategory === optionCategory;
  });

  if (roomFilterIndex > -1) {
    var upsellRevenue = totalDifferentialPrice.value + roomFilters[roomFilterIndex].upsellRevenue;
    trackRoomPersonalization(upsellRevenue === 0 ? 'remove' : 'add');
    _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* set */ "c"](_objectSpread(_objectSpread({}, _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_24__[/* BE_TRACKING */ "c"])), {}, {
      roomFilters: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(roomFilters.slice(0, roomFilterIndex)), [{
        upsellRevenue: upsellRevenue,
        upsellCategory: optionCategory,
        upsellName: optionId,
        proposalId: selectedProposalId
      }], Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(roomFilters.slice(roomFilterIndex + 1)))
    }));
  } else {
    trackRoomPersonalization('add');
    _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* set */ "c"](_objectSpread(_objectSpread({}, _tracking_tracking_storage_api__WEBPACK_IMPORTED_MODULE_23__[/* get */ "b"](_tracking_constants__WEBPACK_IMPORTED_MODULE_24__[/* BE_TRACKING */ "c"])), {}, {
      roomFilters: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(roomFilters), [{
        upsellRevenue: totalDifferentialPrice.value,
        upsellCategory: optionCategory,
        upsellName: optionId,
        proposalId: selectedProposalId
      }])
    }));
  } // get the arrangement


  var arrangement = selectedAccommodationSet === null || selectedAccommodationSet === void 0 ? void 0 : (_selectedAccommodatio = selectedAccommodationSet.accommodations) === null || _selectedAccommodatio === void 0 ? void 0 : (_selectedAccommodatio2 = _selectedAccommodatio.map(function (_ref12) {
    var attendeesDistribution = _ref12.attendeesDistribution;
    return attendeesDistribution;
  })) === null || _selectedAccommodatio2 === void 0 ? void 0 : _selectedAccommodatio2.filter(Boolean);
  arrangement && dispatch(Object(_store_booking_proposals_proposals_action__WEBPACK_IMPORTED_MODULE_25__[/* addAccommodation */ "a"])({
    arrangement: arrangement,
    globalLoaderLabel: '',
    toastLabel: '',
    isJoyview: resort.isJoyview,
    isUrbanOasis: resort.isUrbanOasis,
    proposalsId: Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_26__[/* getAllProposalsIdWithAlternative */ "b"])(proposal),
    appContext: appContext,
    reduxAction: _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_28__[/* ADD_ACCOMMODATION_FROM_ALTERNATIVES */ "c"]
  })).then(function () {
    // switch offers maybe ( Warning )
    return onClose();
  });
};
var chooseOption = function chooseOption(_ref13) {
  var appContext = _ref13.appContext,
      formik = _ref13.formik,
      filters = _ref13.filters,
      accommodationsSets = _ref13.accommodationsSets,
      proposal = _ref13.proposal,
      resort = _ref13.resort,
      optionCategory = _ref13.optionCategory,
      dispatch = _ref13.dispatch,
      onClose = _ref13.onClose,
      trackRoomPersonalization = _ref13.trackRoomPersonalization; // set the alternative

  var selectedOptionValueId = formik.values.selectedFilterValueId;
  var selectedOption = filters.find(function (_ref14) {
    var id = _ref14.id;
    return id === selectedOptionValueId;
  });

  if (selectedOption && selectedOption.firstAlternativeId) {
    var selectedOptionFirstAlternativeId = selectedOption.firstAlternativeId;
    submitAccommodation({
      accommodationsSets: accommodationsSets,
      proposal: proposal,
      formSelectedAlternativeId: selectedOptionFirstAlternativeId,
      resort: resort,
      optionId: selectedOptionValueId,
      optionCategory: optionCategory,
      dispatch: dispatch,
      appContext: appContext,
      onClose: onClose,
      trackRoomPersonalization: trackRoomPersonalization
    });
  }
};
var DefaultAccommodationFilterRadioButton = function DefaultAccommodationFilterRadioButton(_ref15) {
  var _accommodationIconPro, _accommodationIconPro2, _formik$values;

  var accommodationIconProps = _ref15.accommodationIconProps,
      value = _ref15.value;
  var formik = Object(formik__WEBPACK_IMPORTED_MODULE_27__[/* useFormikContext */ "e"])();
  return __jsx("li", {
    className: "w-150 flex-none",
    key: 0
  }, __jsx(_radio_button_with_icon_RadioButtonWithIcon__WEBPACK_IMPORTED_MODULE_20__[/* RadioButtonWithIcon */ "a"], {
    name: "selectedFilterValueId",
    title: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : (_accommodationIconPro = accommodationIconProps.labels) === null || _accommodationIconPro === void 0 ? void 0 : _accommodationIconPro[0]) || '',
    description: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : (_accommodationIconPro2 = accommodationIconProps.labels) === null || _accommodationIconPro2 === void 0 ? void 0 : _accommodationIconPro2[1]) || '',
    value: value,
    priceDifference: "",
    icon: (accommodationIconProps === null || accommodationIconProps === void 0 ? void 0 : accommodationIconProps.icon) || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].TRIDENT,
    isChecked: (formik === null || formik === void 0 ? void 0 : (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.selectedFilterValueId) === value
  }));
};
var getTitle = function getTitle(type) {
  if (type === _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].VIEW) {
    return 'booking.accommodation.roomFinder.viewFilterTitle';
  }

  if (type === _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].OUTSIDE_FACILITIES) {
    return 'booking.accommodation.roomFinder.facilitiesFilterTitle';
  }

  if (type === _constants__WEBPACK_IMPORTED_MODULE_29__[/* popinTypes */ "a"].ROOM_TYPE) {
    return 'booking.accommodation.roomFinder.roomConfigurationFilterTitle';
  }

  return 'booking.accommodation.roomFinder.filtersTitle';
};
var DefaultAccommodationViewRadioButton = function DefaultAccommodationViewRadioButton(_ref16) {
  var defaultAccommodationViewIcon = _ref16.defaultAccommodationViewIcon,
      value = _ref16.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationViewIcon,
    value: value
  });
};
var DefaultAccommodationOutsideFacilitiesRadioButton = function DefaultAccommodationOutsideFacilitiesRadioButton(_ref17) {
  var defaultAccommodationOutsideFacilitiesIcon = _ref17.defaultAccommodationOutsideFacilitiesIcon,
      value = _ref17.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationOutsideFacilitiesIcon,
    value: value
  });
};
var DefaultAccommodationRoomTypeRadioButton = function DefaultAccommodationRoomTypeRadioButton(_ref18) {
  var defaultAccommodationRoomTypeIcon = _ref18.defaultAccommodationRoomTypeIcon,
      value = _ref18.value;
  return __jsx(DefaultAccommodationFilterRadioButton, {
    accommodationIconProps: defaultAccommodationRoomTypeIcon,
    value: value
  });
};

/***/ }),

/***/ "Phb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

/* global window, document */


__webpack_require__("ZVqJ");

__webpack_require__("vuE1");

__webpack_require__("qs2G");

__webpack_require__("i2OK");

__webpack_require__("5iaM");

__webpack_require__("I2c1");

__webpack_require__("60DJ");

__webpack_require__("QRET");

__webpack_require__("bMl7");

__webpack_require__("zSnQ");

__webpack_require__("MRpX");

__webpack_require__("ieZH");

var _react = _interopRequireWildcard(__webpack_require__("ERkP"));

var _propTypes = _interopRequireDefault(__webpack_require__("aWzz"));

var _subscribeUiEvent = __webpack_require__("GJxp");

var _classnames = _interopRequireDefault(__webpack_require__("O94r"));

var _shallowequal = _interopRequireDefault(__webpack_require__("Pu0A"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.

var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.

var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform'; // global variable for all instances

var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr

var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = /*#__PURE__*/function (_Component) {
  _inherits(Sticky, _Component);

  var _super = _createSuper(Sticky);

  function Sticky(props, context) {
    var _this;

    _classCallCheck(this, Sticky);

    _this = _super.call(this, props, context);
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleScrollStart = _this.handleScrollStart.bind(_assertThisInitialized(_this));
    _this.delta = 0;
    _this.stickyTop = 0;
    _this.stickyBottom = 0;
    _this.frozen = false;
    _this.skipNextScrollEvent = false;
    _this.scrollTop = -1;
    _this.bottomBoundaryTarget;
    _this.topTarget;
    _this.subscribers;
    _this.state = {
      top: 0,
      // A top offset from viewport top where Sticky sticks to when scrolling up
      bottom: 0,
      // A bottom offset from viewport top where Sticky sticks to when scrolling down
      width: 0,
      // Sticky width
      height: 0,
      // Sticky height
      x: 0,
      // The original x of Sticky
      y: 0,
      // The original y of Sticky
      topBoundary: 0,
      // The top boundary on document
      bottomBoundary: Infinity,
      // The bottom boundary on document
      status: STATUS_ORIGINAL,
      // The Sticky status
      pos: 0,
      // Real y-axis offset for rendering position-fixed and position-relative
      activated: false // once browser info is available after mounted, it becomes true to avoid checksum error

    };
    return _this;
  }

  _createClass(Sticky, [{
    key: "getTargetHeight",
    value: function getTargetHeight(target) {
      return target && target.offsetHeight || 0;
    }
  }, {
    key: "getTopPosition",
    value: function getTopPosition(top) {
      // a top argument can be provided to override reading from the props
      top = top || this.props.top || 0;

      if (typeof top === 'string') {
        if (!this.topTarget) {
          this.topTarget = doc.querySelector(top);
        }

        top = this.getTargetHeight(this.topTarget);
      }

      return top;
    }
  }, {
    key: "getTargetBottom",
    value: function getTargetBottom(target) {
      if (!target) {
        return -1;
      }

      var rect = target.getBoundingClientRect();
      return this.scrollTop + rect.bottom;
    }
  }, {
    key: "getBottomBoundary",
    value: function getBottomBoundary(bottomBoundary) {
      // a bottomBoundary can be provided to avoid reading from the props
      var boundary = bottomBoundary || this.props.bottomBoundary; // TODO, bottomBoundary was an object, depricate it later.

      if (_typeof(boundary) === 'object') {
        boundary = boundary.value || boundary.target || 0;
      }

      if (typeof boundary === 'string') {
        if (!this.bottomBoundaryTarget) {
          this.bottomBoundaryTarget = doc.querySelector(boundary);
        }

        boundary = this.getTargetBottom(this.bottomBoundaryTarget);
      }

      return boundary && boundary > 0 ? boundary : Infinity;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        status: STATUS_ORIGINAL,
        pos: 0
      });
    }
  }, {
    key: "release",
    value: function release(pos) {
      this.setState({
        status: STATUS_RELEASED,
        pos: pos - this.state.y
      });
    }
  }, {
    key: "fix",
    value: function fix(pos) {
      this.setState({
        status: STATUS_FIXED,
        pos: pos
      });
    }
    /**
     * Update the initial position, width, and height. It should update whenever children change.
     * @param {Object} options optional top and bottomBoundary new values
     */

  }, {
    key: "updateInitialDimension",
    value: function updateInitialDimension(options) {
      options = options || {};

      if (!this.outerElement || !this.innerElement) {
        return;
      }

      var outerRect = this.outerElement.getBoundingClientRect();
      var innerRect = this.innerElement.getBoundingClientRect();
      var width = outerRect.width || outerRect.right - outerRect.left;
      var height = innerRect.height || innerRect.bottom - innerRect.top;
      ;
      var outerY = outerRect.top + this.scrollTop;
      this.setState({
        top: this.getTopPosition(options.top),
        bottom: Math.min(this.state.top + height, winHeight),
        width: width,
        height: height,
        x: outerRect.left,
        y: outerY,
        bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
        topBoundary: outerY
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize(e, ae) {
      if (this.props.shouldFreeze()) {
        return;
      }

      winHeight = ae.resize.height;
      this.updateInitialDimension();
      this.update();
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart(e, ae) {
      this.frozen = this.props.shouldFreeze();

      if (this.frozen) {
        return;
      }

      if (this.scrollTop === ae.scroll.top) {
        // Scroll position hasn't changed,
        // do nothing
        this.skipNextScrollEvent = true;
      } else {
        this.scrollTop = ae.scroll.top;
        this.updateInitialDimension();
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e, ae) {
      // Scroll doesn't need to be handled
      if (this.skipNextScrollEvent) {
        this.skipNextScrollEvent = false;
        return;
      }

      scrollDelta = ae.scroll.delta;
      this.scrollTop = ae.scroll.top;
      this.update();
    }
    /**
     * Update Sticky position.
     */

  }, {
    key: "update",
    value: function update() {
      var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

      if (disabled) {
        if (this.state.status !== STATUS_ORIGINAL) {
          this.reset();
        }

        return;
      }

      var delta = scrollDelta; // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
      // on document from viewport.

      var top = this.scrollTop + this.state.top;
      var bottom = this.scrollTop + this.state.bottom; // There are 2 principles to make sure Sticky won't get wrong so much:
      // 1. Reset Sticky to the original postion when "top" <= topBoundary
      // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary

      if (top <= this.state.topBoundary) {
        // #1
        this.reset();
      } else if (bottom >= this.state.bottomBoundary) {
        // #2
        this.stickyBottom = this.state.bottomBoundary;
        this.stickyTop = this.stickyBottom - this.state.height;
        this.release(this.stickyTop);
      } else {
        if (this.state.height > winHeight - this.state.top) {
          // In this case, Sticky is higher then viewport minus top offset
          switch (this.state.status) {
            case STATUS_ORIGINAL:
              this.release(this.state.y);
              this.stickyTop = this.state.y;
              this.stickyBottom = this.stickyTop + this.state.height;
            // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
            // from ORIGINAL when calling window.scrollTo().
            // break;

            case STATUS_RELEASED:
              // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
              // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
              // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
              this.stickyBottom = this.stickyTop + this.state.height;

              if (delta > 0 && bottom > this.stickyBottom) {
                this.fix(this.state.bottom - this.state.height);
              } else if (delta < 0 && top < this.stickyTop) {
                this.fix(this.state.top);
              }

              break;

            case STATUS_FIXED:
              var toRelease = true;
              var pos = this.state.pos;
              var height = this.state.height; // In regular cases, when Sticky is in FIXED status,
              // 1. it's top will stick to the screen top,
              // 2. it's bottom will stick to the screen bottom,
              // 3. if not the cases above, then it's height gets changed

              if (delta > 0 && pos === this.state.top) {
                // case 1, and scrolling down
                this.stickyTop = top - delta;
                this.stickyBottom = this.stickyTop + height;
              } else if (delta < 0 && pos === this.state.bottom - height) {
                // case 2, and scrolling up
                this.stickyBottom = bottom - delta;
                this.stickyTop = this.stickyBottom - height;
              } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                // case 3
                // This case only happens when Sticky's bottom sticks to the screen bottom and
                // its height gets changed. Sticky should be in RELEASE status and update its
                // sticky bottom by calculating how much height it changed.
                var deltaHeight = pos + height - this.state.bottom;
                this.stickyBottom = bottom - delta + deltaHeight;
                this.stickyTop = this.stickyBottom - height;
              } else {
                toRelease = false;
              }

              if (toRelease) {
                this.release(this.stickyTop);
              }

              break;
          }
        } else {
          // In this case, Sticky is shorter then viewport minus top offset
          // and will always fix to the top offset of viewport
          this.fix(this.state.top);
        }
      }

      this.delta = delta;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevState.status !== this.state.status && this.props.onStateChange) {
        this.props.onStateChange({
          status: this.state.status
        });
      }

      var arePropsChanged = !(0, _shallowequal.default)(this.props, prevProps);

      if (arePropsChanged) {
        // if the props for enabling are toggled, then trigger the update or reset depending on the current props
        if (prevProps.enabled !== this.props.enabled) {
          if (this.props.enabled) {
            this.setState({
              activated: true
            }, function () {
              _this2.updateInitialDimension();

              _this2.update();
            });
          } else {
            this.setState({
              activated: false
            }, function () {
              _this2.reset();
            });
          }
        } // if the top or bottomBoundary props were changed, then trigger the update
        else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
            this.updateInitialDimension();
            this.update();
          }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var subscribers = this.subscribers || [];

      for (var i = subscribers.length - 1; i >= 0; i--) {
        this.subscribers[i].unsubscribe();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Only initialize the globals if this is the first
      // time this component type has been mounted
      if (!win) {
        win = window;
        doc = document;
        docEl = doc.documentElement;
        docBody = doc.body;
        winHeight = win.innerHeight || docEl.clientHeight;
        M = window.Modernizr; // No Sticky on lower-end browser when no Modernizr

        if (M && M.prefixed) {
          canEnableTransforms = M.csstransforms3d;
          TRANSFORM_PROP = M.prefixed('transform');
        }
      } // when mount, the scrollTop is not necessary on the top


      this.scrollTop = docBody.scrollTop + docEl.scrollTop;

      if (this.props.enabled) {
        this.setState({
          activated: true
        });
        this.updateInitialDimension();
        this.update();
      } // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality


      this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), {
        useRAF: true
      }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), {
        useRAF: true,
        enableScrollInfo: true
      }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), {
        enableResizeInfo: true
      })];
    }
  }, {
    key: "translate",
    value: function translate(style, pos) {
      var enableTransforms = canEnableTransforms && this.props.enableTransforms;

      if (enableTransforms && this.state.activated) {
        style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
      } else {
        style.top = pos + 'px';
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !this.props.shouldFreeze() && !((0, _shallowequal.default)(this.props, nextProps) && (0, _shallowequal.default)(this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      // TODO, "overflow: auto" prevents collapse, need a good way to get children height
      var innerStyle = {
        position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
        top: this.state.status === STATUS_FIXED ? '0px' : '',
        zIndex: this.props.innerZ
      };
      var outerStyle = {}; // always use translate3d to enhance the performance

      this.translate(innerStyle, this.state.pos);

      if (this.state.status !== STATUS_ORIGINAL) {
        innerStyle.width = this.state.width + 'px';
        outerStyle.height = this.state.height + 'px';
      }

      var outerClasses = (0, _classnames.default)('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
      var innerClasses = (0, _classnames.default)('sticky-inner-wrapper', this.props.innerClass, _defineProperty({}, this.props.innerActiveClass, this.state.status === STATUS_FIXED));
      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(outer) {
          _this3.outerElement = outer;
        },
        className: outerClasses,
        style: outerStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(inner) {
          _this3.innerElement = inner;
        },
        className: innerClasses,
        style: innerStyle
      }, typeof children === 'function' ? children({
        status: this.state.status
      }) : children));
    }
  }]);

  return Sticky;
}(_react.Component);

Sticky.displayName = 'Sticky';
Sticky.defaultProps = {
  shouldFreeze: function shouldFreeze() {
    return false;
  },
  enabled: true,
  top: 0,
  bottomBoundary: 0,
  enableTransforms: true,
  activeClass: 'active',
  releasedClass: 'released',
  onStateChange: null,
  innerClass: '',
  innerActiveClass: ''
};
/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */

Sticky.propTypes = {
  enabled: _propTypes.default.bool,
  top: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  bottomBoundary: _propTypes.default.oneOfType([_propTypes.default.object, // TODO, may remove
  _propTypes.default.string, _propTypes.default.number]),
  enableTransforms: _propTypes.default.bool,
  activeClass: _propTypes.default.string,
  releasedClass: _propTypes.default.string,
  innerClass: _propTypes.default.string,
  innerActiveClass: _propTypes.default.string,
  className: _propTypes.default.string,
  onStateChange: _propTypes.default.func,
  shouldFreeze: _propTypes.default.func,
  innerZ: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;
module.exports = Sticky;

/***/ }),

/***/ "Pu0A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "PuIx":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("MzY2"),
    createAssigner = __webpack_require__("wpQC");

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ "PwcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTENDEES_ROLES; });
/* unused harmony export getAttendeeValidationSchema */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAttendeeValidationSchemaByRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAddressValidationSchema; });
/* unused harmony export getAttendeesValidationSchema */
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");


var ATTENDEES_ROLES = {
  MAIN: 'MAIN',
  OTHER_ADULT: 'OTHER_ADULT',
  KID: 'KID'
};

var getAttendeeValidationSchema = function getAttendeeValidationSchema(role) {
  return function (_ref) {
    var validationSchema = _ref.validationSchema;

    if (Object(ATTENDEES_ROLES).hasOwnProperty(role)) {
      return validationSchema[role];
    }

    throw new Error('USER ROLE DOES NOT EXIST');
  };
};

var getAttendeeValidationSchemaByRole = function getAttendeeValidationSchemaByRole(isMain, isChild) {
  var role = ATTENDEES_ROLES.OTHER_ADULT;

  if (isChild) {
    role = ATTENDEES_ROLES.KID;
  } else if (isMain) {
    role = ATTENDEES_ROLES.MAIN;
  }

  return getAttendeeValidationSchema(role);
};

var getAddressValidationSchema = function getAddressValidationSchema(_ref2) {
  var validationSchema = _ref2.validationSchema;
  return validationSchema.address;
};

var getAttendeesValidationSchema = function getAttendeesValidationSchema(_ref3) {
  var validationSchema = _ref3.validationSchema;
  var schemaByType = {};

  for (var _i = 0, _Object$entries = Object.entries(validationSchema); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        schema = _Object$entries$_i[1];

    if (Object(ATTENDEES_ROLES).hasOwnProperty(key)) {
      schemaByType[key] = schema;
    }
  }

  return schemaByType;
};



/***/ }),

/***/ "QRET":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var DOMIterables = __webpack_require__("YQkA");
var DOMTokenListPrototype = __webpack_require__("k4ez");
var ArrayIteratorMethods = __webpack_require__("I2c1");
var createNonEnumerableProperty = __webpack_require__("g51W");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "QRI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getPrePaymentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBookingTransportQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return packagesFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return priceDetailsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getStayAccommodationFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getStayTeaserBookingFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCustomerProfileQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCutomersQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCustomerBookingAttendeesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCustomerBookingDocumentsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCustomerBookingPriceQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCustomerBookingPriceAndPaymentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getRenewedOptionById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getVouchersQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_PAGINATED_TRIPS_LIST_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NOT_PAGINATED_TRIPS_LIST_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_TRIPS_LIST_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCustomerBookingsQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("H0gB");
/* harmony import */ var _components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JOeK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tI+f");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");









var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].PACKAGES,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY;
var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
var getPrePaymentQuery = function getPrePaymentQuery(_ref) {
  var bookingId = _ref.bookingId,
      customerId = _ref.customerId,
      isCartPayment = _ref.isCartPayment,
      isUpgradeRoomPayment = _ref.isUpgradeRoomPayment;
  return "query {\n      config {\n        booking {\n          banking {\n            freeDepositDeadline\n          }\n          sellers {\n            banking {\n              freeDepositDeadline\n            }\n          }\n        }\n      }\n      bookingsCart(bookingIds : [\"".concat(bookingId, "\"]) @include(if: ").concat(String(isCartPayment), ") {\n        cartBookings {\n          count\n          hasServicesInOption\n          price {\n            total {\n              value\n              currency\n            }\n          }\n        }\n      }\n      bookingAccomodationsCart(bookingId: \"").concat(bookingId, "\", customerId: \"").concat(customerId, "\") @include(if: ").concat(String(isUpgradeRoomPayment), ") {\n        cart {\n          count\n          price {\n            total {\n              value\n              currency\n            }\n          }\n        }\n\n      }\n      userBooking(bookingId : \"").concat(bookingId, "\") {\n        information {\n          shouldProposeOnlinePayment\n          status\n          stays {\n            id\n            departureDate\n          }\n        }\n        paymentDetails {\n          duePayment {\n            deadline\n            amount {\n              value\n            }\n          }\n        }\n      }\n  }");
};
var getBookingTransportQuery = function getBookingTransportQuery(bookingId) {
  return "query {\n      userBooking(bookingId: \"".concat(bookingId, "\") {\n        transports {\n          inbounds {\n            ...transportsDetails\n          }\n          multiTransport\n          outbounds {\n            ...transportsDetails\n          }\n        }\n      }\n    }\n    fragment transportsDetails on TransportDetailType {\n      stayId\n      transferIncluded\n      travelSections {\n        arrival {\n          airportLabel\n          cityId\n          date\n          id\n          label\n          terminalCode\n          time\n        }\n        connectionDurationInMin\n        departure {\n          airportLabel\n          cityId\n          date\n          id\n          label\n          terminalCode\n          time\n        }\n        durationInMin\n        isClubmedTransport\n        stopDurationInMin\n        technicalStops\n        transport {\n          baggage {\n            quantity\n            weight\n            unit\n          }\n          class\n          companyExploiter {\n            id\n            label\n            logo\n          }\n          companyOperator {\n            id\n            label\n            logo\n            url\n          }\n          reference\n          travelNumber\n          type\n          carbonEmission\n          averageCarbonEmission\n        }\n      }\n    }");
}; // FRAGMENTS

var packagesFragment = "\n    packages(packageIds : [\"".concat(JOYVIEW_ROOM_ONLY, "\", \"").concat(JOYVIEW_ALL_INCLUSIVE, "\", \"").concat(JOYVIEW_FOOD_AND_BEVERAGES, "\"]) {\n      ... on ProductPackageType {\n        additionalInfo\n        description\n        id\n        image\n        label\n        prices {\n          perAdultPerNight {\n            currency\n            formattedValue\n            value\n          }\n          perKidPerNight {\n            currency\n            formattedValue\n            value\n          }\n        }\n      }\n    }");
var priceDetailsFragment = function priceDetailsFragment(appContext) {
  return "\n    fragment priceDetails on PriceDetailType {\n        formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__["getBookingPrecision"])(appContext.locale), ")\n        value\n    }");
};
var getStayAccommodationFragment = function getStayAccommodationFragment() {
  return "\n  fragment accommodations on AccommodationType {\n    attendeesDistribution {\n      attendees {\n        birthdate\n        customerId\n        id\n        type\n      }\n      id\n      quantity\n    }\n    bathroomEquipments {\n      id\n      label\n    }\n    category\n    categoryId\n    comfortId\n    comfortType\n    description\n    endDate\n    equipments {\n      id\n      label\n    }\n    exclusiveCollection\n    guest\n    id\n    label\n    maxCapacity\n    media {\n      photos {\n        url\n      }\n    }\n    outsideFacilities {\n      id\n      label\n    }\n    quantity\n    ranking\n    rooms {\n      number\n    }\n    roomType\n    services {\n      id\n      label\n    }\n    startDate\n    strengths {\n      id\n      label\n    }\n    surface\n    view {\n      id\n      label\n    }\n    floorPlans\n  }";
};

var getStayUpsellsQuery = function getStayUpsellsQuery(appContext) {
  return "\nupsells(types: [CHILDCARE, EXCURSION, INSURANCE, LAND_SPORT, RENTAL, TRANSFER, WATER_SPORT, WINTER_SPORT, WELLNESS, PARKING, CONCIERGERIE]) {\n  activities {\n    ".concat(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* servicesWithSchedulePricingInfoQuery */ "k"], "\n    productInfo {\n      id\n      isIncluded\n      label\n      parentActivityCategoriesId\n    }\n  }\n  rentals {\n    ").concat(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* servicesWithSchedulePricingInfoQuery */ "k"], "\n    productInfo {\n      id\n      label\n      ageInMonths {\n        min\n        max\n      }\n      useCase {\n        id\n        label\n      }\n      typeId: type\n      typeLabel\n      description: longDescription\n      sizes {\n        min\n        max\n        unit\n      }\n      practiceLevels {\n        id\n        label\n      }\n    }\n  }\n  ").concat(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* childcaresQuery */ "b"], "\n  ").concat(Object(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* insuranceQuery */ "h"])(appContext), "\n  ").concat(packagesFragment, "\n  ").concat(Object(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* transfersQuery */ "l"])(appContext), "\n  ").concat(Object(_components_utils_booking_booking_additional_services_BookingAddtionalServices_utils__WEBPACK_IMPORTED_MODULE_5__[/* whiteLabelServicesQuery */ "n"])(appContext), "\n}\n");
};

var getStayTeaserBookingWithoutStaysFragment = function getStayTeaserBookingWithoutStaysFragment() {
  return "fragment stayBooking on CustomerBookingWithoutStaysType {\n    attendees {\n      birthday\n      civility\n      customerId\n      email\n      firstName:firstname\n      id\n      lastName:lastname\n      mainContact\n      type\n      unicodeFirstname\n      unicodeLastname\n    }\n    creationDate\n    dates {\n      duration\n      endDate\n      startDate\n    }\n    categories {\n      isOption\n      isOptionRenewed\n      isExpiredOption\n      isFromRenewal\n      isStandard\n      isTravelPlan\n      isTravelPlanPrebooking\n      isTravelPlanStandard\n    }\n    id\n    isMultiSaleContracts\n    isMultiStays\n    optionDurability {\n      expirationDateTime\n      isReliable\n    }\n    payment {\n      due {\n        deadlineDate\n        formattedValue\n        value\n      }\n      isEnabled\n      status {\n        isPaid\n        isPending\n        isUnPaid\n      }\n    }\n    status {\n      name\n      isArchived\n      isExpiredOption\n      isCanceled\n      isValidated\n    }\n    totalPrice {\n      value\n    }\n    vendor {\n      isSoldByClubmed\n      isSoldByPartners\n      name\n      phoneNumber\n      type\n    }\n  }";
};

var getStayTeaserBookingStayProductFragment = function getStayTeaserBookingStayProductFragment() {
  return "fragment stayProduct on Resort {\n    activityTree {\n      ...activityCategory\n      activities {\n        ...activity\n      }\n      categories {\n        ...activityCategory\n        activities {\n          ...activity\n        }\n        categories {\n          ...activityCategory\n          activities {\n            ...activity\n          }\n        }\n      }\n    }\n    associatedResort {\n      id\n      productTypeId\n    }\n    category\n    childrenActivities: productActivities(idFilter: \"".concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n      ageInMonths {\n        max\n        min\n      }\n      description\n      equipments {\n        id\n        label\n      }\n      id\n      isIncluded\n      label\n      subtitle\n    }\n    comfort\n    destination {\n      country\n    }\n    esfResortId\n    facilities(types: [\"CHILDREN\"], withEquipments: true) {\n      equipments {\n        id\n        label\n      }\n      label\n      subtitle\n    }\n    href\n    id\n    images\n    isCruise\n    isExclusiveCollection\n    isExplicitEC\n    isJoyview\n    isTour\n    name\n    rangeLabel\n    rentalsTree {\n      ...rentals\n    }\n    seasonTrad\n    type\n  }\n  ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_4__[/* activityFragment */ "b"], "\n  ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_4__[/* activityCategoryFragment */ "a"], "\n  ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_4__[/* rentalsFragment */ "f"]);
};

var getStayTeaserBookingFragment = function getStayTeaserBookingFragment(appContext, options) {
  return "\n  fragment booking on CustomerBookingType {\n    categories {\n      isOption\n      isOptionRenewed\n      isExpiredOption\n      isFromRenewal\n      isStandard\n      isTravelPlan\n    }\n    dates {\n      duration\n      endDate\n      startDate\n    }\n    id\n    optionDurability {\n      expirationDateTime\n      isReliable\n    }\n    status {\n      name\n    }\n    stays {\n      ".concat(options.withUpsells ? 'accommodations {  ...accommodations }' : '', "\n      accommodationsCount\n      booking {\n        ...stayBooking\n      }\n      dates {\n        duration\n        endDate\n        isCurrent\n        isPast\n        isToCome\n        startDate\n      }\n      features {\n        easyArrival {\n          status {\n            isAvailable\n            isDone\n          }\n          url\n        }\n        easyCheckInOut {\n          easyCheckIn {\n            isActivated\n            status {\n              isAvailable\n              isUneditable\n            }\n          }\n          easyCheckOut {\n            isActivated\n            status {\n              isAvailable\n              isUneditable\n            }\n          }\n        }\n        easyTransfer {\n          serviceStatus {\n            isUpsellAvailable\n            isValidated\n          }\n        }\n        policyForm {\n          status {\n            isAvailable\n          }\n        }\n        feedback {\n          status {\n            isAvailable\n          }\n          url\n        }\n        pickYourRoom {\n          status {\n            name\n          }\n        }\n      }\n      id\n      participants {\n        attendees {\n          id\n        }\n        adultsCount\n        children {\n          birthday\n        }\n        childrenCount\n      }\n      product {\n        ...stayProduct\n      }\n      stayIndex\n      transfers {\n        id\n      }\n      transport {\n        fromCity\n        fromCityCode\n        inbounds {\n          stayId\n        }\n        outbounds {\n          stayId\n        }\n        type\n        types\n      }\n      ").concat(options.withUpsells ? getStayUpsellsQuery(appContext) : '', "\n      vouchers {\n        value\n        unit\n        currency\n        dateOfUse\n        isAvailable\n        isFTC\n        validityEndDate\n      }\n    }\n  }\n  ").concat(options.withUpsells ? [priceDetailsFragment(appContext), getStayAccommodationFragment()].join('') : '', "\n  ").concat(getStayTeaserBookingWithoutStaysFragment(), "\n  ").concat(getStayTeaserBookingStayProductFragment(), "\n");
}; // QUERIES

var profileQuery = "\n  profile {\n    civility\n    firstName\n    GMNumber\n    isProspect\n    lastName\n    loyaltyProgram {\n      isPlatinumForLife\n      points\n      status\n    }\n    unicodeCivility\n    unicodeFirstName\n    unicodeLastName\n  }";
var getCustomerProfileQuery = function getCustomerProfileQuery(_ref2) {
  var _ref2$isQuickLogged = _ref2.isQuickLogged,
      isQuickLogged = _ref2$isQuickLogged === void 0 ? false : _ref2$isQuickLogged;
  return "query {\n  loyaltyProgram {\n    status\n    threshold\n  }\n    ".concat(isQuickLogged ? '' : profileQuery, "\n}");
};
var getCutomersQuery = function getCutomersQuery() {
  return "query {\n  customers {\n    currentTripsCount\n    futureTripsCount\n    hasSponsorship\n    pastTripsCount\n    searchesCount\n    type\n  }\n}";
};
var getCustomerBookingAttendeesQuery = function getCustomerBookingAttendeesQuery(_ref3) {
  var bookingId = _ref3.bookingId,
      isJoyview = _ref3.isJoyview,
      productId = _ref3.productId,
      _ref3$withPackage = _ref3.withPackage,
      withPackage = _ref3$withPackage === void 0 ? false : _ref3$withPackage;
  var packageQuery = withPackage ? "\n        package(productId : \"".concat(productId, "\", packageId : \"").concat(_utils_proposal_constants__WEBPACK_IMPORTED_MODULE_7__[/* PACKAGE_ALL_INCLUSIVE */ "f"], "\") {\n            description\n            id\n            label\n            prices {\n              perAdultPerNight {\n                formattedValue\n              }\n              perKidPerNight {\n                formattedValue\n              }\n            }\n          }\n        ") : '';
  var packageFragment = isJoyview ? "\n          package {\n            id\n            isAllInclusive\n            isRoomOnly\n            label\n          }\n        " : '';
  var packagesUpsellQuery = withPackage ? "\n            packagesUpsell {\n              amount\n              currency\n              id\n            }\n          " : '';
  return "query {\n          customerBooking(id: \"".concat(bookingId, "\") {\n            attendees {\n              birthday\n              civility\n              customerId\n              email\n              firstname\n              id\n              lastname\n              mainContact\n              type\n              unicodeFirstname\n              unicodeLastname\n              ").concat(packageFragment, "\n              ").concat(packagesUpsellQuery, "\n            }\n          }\n          ").concat(packageQuery, "\n        }");
};
var getCustomerBookingDocumentsQuery = function getCustomerBookingDocumentsQuery(bookingId) {
  return "\n  query {\n    customerBooking(id: \"".concat(bookingId, "\") {\n      documents {\n        clicType\n        id\n        label\n        type\n      }\n    }\n  }");
};
var getCustomerBookingPriceQuery = function getCustomerBookingPriceQuery(appContext, bookingId) {
  var precision = Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__["getBookingPrecision"])(appContext.locale);
  return "query {\n    customerBooking(id: \"".concat(bookingId, "\") {\n        totalPrice {\n          formattedValue(precision: ").concat(precision, ")\n          value\n        }\n      }\n    }");
};
var getCustomerBookingPriceAndPaymentQuery = function getCustomerBookingPriceAndPaymentQuery(appContext, bookingId) {
  var precision = Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_2__["getBookingPrecision"])(appContext.locale);
  return "query {\n    customerBooking(id: \"".concat(bookingId, "\") {\n      payment {\n        due {\n          deadlineDate\n          formattedValue\n          schedules {\n            deadlineDate\n            formattedValue\n            value\n          }\n          value\n        }\n        paid {\n          formattedValue\n          value\n        }\n        status {\n          isPending\n        }\n      }\n      totalPrice {\n        details {\n          cancellationInsurance {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          discount {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          donation {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          fees {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          onDemand {\n            formattedValue(precision: ").concat(precision, ")\n            id\n            label\n            value\n          }\n          package {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n          total {\n            formattedValue(precision: ").concat(precision, ")\n            value\n          }\n        }\n      }\n      vendor {\n        isSoldByClubmed\n      }\n    }\n  }");
};

var getRenewedOptionByIdQuery = function getRenewedOptionByIdQuery(bookingId) {
  return "query {\n    customerBooking(id: \"".concat(bookingId, "\") {\n      optionDurability {\n        expirationDateTime\n      }\n    }\n  }");
};

var getRenewedOptionById = function getRenewedOptionById(appContext, bookingId) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].runNoCacheQuery(getRenewedOptionByIdQuery(bookingId), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_GET_BOOKING_DATA */ "k"],
    strictErrors: false
  });
};
var getVouchersQuery = function getVouchersQuery() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$isSponsorship = _ref4.isSponsorship,
      isSponsorship = _ref4$isSponsorship === void 0 ? false : _ref4$isSponsorship;

  return "query {\n    vouchers {\n      items {\n        advantageCode\n        currency\n        dateOfUse\n        godchildInformation {\n          firstName\n          lastName\n          unicodeFirstName\n          unicodeLastName\n        }\n        godfatherInformation {\n          firstName\n          lastName\n          unicodeFirstName\n          unicodeLastName\n        }\n        id\n        isAvailable\n        isExpired\n        isFTC\n        isTargetedOffer\n        ".concat(!isSponsorship ? "offer {\n          description\n          id\n          name\n          shortDescription}" : '', "\n\n        origin {\n          bookingId\n          stay {\n            endDate\n            product {\n              destination {\n                country\n              }\n              href\n              name\n            }\n            startDate\n          }\n        }\n        originType\n        status\n        type\n        validityEndDate\n        value\n        unit\n      }\n      type\n    }\n }");
};
var DEFAULT_PAGINATED_TRIPS_LIST_LIMIT = 5;
var DEFAULT_NOT_PAGINATED_TRIPS_LIST_LIMIT = 10;
var DEFAULT_TRIPS_LIST_PAGE = 1;
var getCustomerBookingsQuery = function getCustomerBookingsQuery(appContext, params, options) {
  var _params$isCanceled = params.isCanceled,
      isCanceled = _params$isCanceled === void 0 ? false : _params$isCanceled,
      limit = params.limit,
      _params$page = params.page,
      page = _params$page === void 0 ? DEFAULT_TRIPS_LIST_PAGE : _params$page,
      period = params.period;
  var periods = period === 'all' ? '"CURRENTS" "FUTURS" "PASTS"' : '"' + {
    past: 'PASTS',
    future: 'FUTURS',
    current: 'CURRENTS'
  }[period] + '"';
  var statuses = isCanceled ? '"CANCELED"' : '"VALIDATED"';
  var limits = !isCanceled ? 'limit:' + limit + ' page:' + page : '';
  return "query {\n    customerBookings(period: [".concat(periods, "], status: [").concat(statuses, "], ").concat(limits, ") {\n        ...BookingsFragment\n    }\n  }\n  ").concat(getStayTeaserBookingFragment(appContext, options), "\n  fragment BookingsFragment on PaginatedCustomerBookings {\n    data {\n      ...booking\n    }\n    pageInfo {\n      currentPage\n      hasNextPage\n    }\n  }\n  ");
};

/***/ }),

/***/ "Qavd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var IS_PURE = __webpack_require__("DpO5");
var NativePromise = __webpack_require__("KQNt");
var fails = __webpack_require__("ct80");
var getBuiltIn = __webpack_require__("VCi3");
var speciesConstructor = __webpack_require__("Qzre");
var promiseResolve = __webpack_require__("nDYR");
var redefine = __webpack_require__("uLp7");

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && typeof NativePromise == 'function') {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromise.prototype['finally'] !== method) {
    redefine(NativePromise.prototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ "QknU":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "Qosd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POPIN_NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEWSLETTER_SUBSCRIPTION_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PopinNewsletter; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("3yYM");
/* harmony import */ var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("uDfI");
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("ljKo");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("UCZK");
/* harmony import */ var _profile_info_newsletter_subscription_NewsletterSubscription_utils__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("p9RO");
/* harmony import */ var _views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("TnNS");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_form_errors_FormErrors__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__("8miM");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__("/HC4");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__("EvYw");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__("MWZw");
/* harmony import */ var _newsletter_form_NewsletterForm__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__("9KBE");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__("taV1");
/* harmony import */ var _frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__("DwNm");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__("L7OA");





















var __jsx = react__WEBPACK_IMPORTED_MODULE_22___default.a.createElement;


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var POPIN_NEWSLETTER = 'POPIN_NEWSLETTER';
var NEWSLETTER_SUBSCRIPTION_VALIDATION = 'NEWSLETTER_SUBSCRIPTION_VALIDATION';
function PopinNewsletter(_ref) {
  var _ref$checkboxes = _ref.checkboxes,
      checkboxes = _ref$checkboxes === void 0 ? [] : _ref$checkboxes,
      _ref$legalInformation = _ref.legalInformations,
      legalInformations = _ref$legalInformation === void 0 ? [] : _ref$legalInformation,
      onClose = _ref.onClose;
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_25__[/* useAppContext */ "c"])();
  var defaultPayload = {
    categoryGA: 'newsletter',
    actionGA: 'shopping'
  };
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_28__[/* useTracking */ "a"])(defaultPayload);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_22__["useState"])([]),
      submitErrors = _useState[0],
      setSubmitErrors = _useState[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_23__[/* useDispatch */ "d"])();

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_26__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet;

  var labelConfirmation = "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('newsletter.confirmation.headline'), " \n ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('newsletter.confirmation.description'));
  Object(react__WEBPACK_IMPORTED_MODULE_22__["useEffect"])(function () {
    return track({
      labelGA: 'displayPopin',
      nonInteraction: 1
    });
  }, []);
  var displayPhoneInput = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_45__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.displayPhoneInput');
  var displayEmailInput = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_45__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.displayEmailInput');
  return __jsx(_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_39__[/* Modal */ "a"], {
    ariaLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('newsletter.popin.title'),
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_29__[/* ID_MODAL_HEADER__PLE__NEWSLETTER */ "B"],
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('common.close'),
    onClose: onClose,
    size: "large"
  }, __jsx("div", {
    className: "sm:flex"
  }, __jsx("div", {
    className: "relative w-full flex-none sm:w-12/25 md:w-1/3"
  }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_38__[/* default */ "b"], {
    className: "sm:absolute sm:inset-0",
    dimensions: isTablet ? {
      w: 320,
      h: 700
    } : {
      w: 500,
      h: 200
    },
    imageUrl: Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('newsletter.popin.imageUrl'),
    ratioDisplay: 1 / 2,
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_34__[/* default */ "c"].XS
  })), __jsx("div", {
    className: "m-25"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_41__[/* Title */ "a"], {
    iconColor: _utils_color_colors__WEBPACK_IMPORTED_MODULE_31__[/* COLORS */ "a"].SIENNA,
    iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__[/* ICONS */ "a"].MAIL,
    iconSize: "1.5rem",
    id: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_29__[/* ID_MODAL_HEADER__PLE__NEWSLETTER */ "B"],
    theme: "title-brand-n2"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('newsletter.popin.title')), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_40__[/* Text */ "a"], {
    className: "my-10",
    text: Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('newsletter.popin.subtitle')
  }), __jsx(formik__WEBPACK_IMPORTED_MODULE_24__[/* Formik */ "d"], {
    initialValues: _objectSpread({
      civility: 'M'
    }, checkboxes.reduce(function (newslettersCheckbox, newsletter) {
      newslettersCheckbox[newsletter.id] = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_45__[/* isFeatureFlipped */ "a"])(appContext)('newsletter.preCheckedNewsletterPopin');
      return newslettersCheckbox;
    }, {})),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_21___default.a.mark(function _callee(values) {
        var response, error;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_21___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(_views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_33__[/* submitSubscriptionForm */ "b"])({
                  appContext: appContext,
                  data: Object(_views_newsletter_newsletterActions__WEBPACK_IMPORTED_MODULE_33__[/* formatDataForSubscription */ "a"])(_objectSpread(_objectSpread({}, values), {}, {
                    originCode: _views_booking_constants__WEBPACK_IMPORTED_MODULE_43__[/* SUBSCRIPTION_ORIGIN */ "t"].POPIN
                  })),
                  isSubscription: true
                });

              case 2:
                response = _context.sent;
                track({
                  labelGA: 'registrationPopin',
                  user: {
                    neolaneID: lodash_get__WEBPACK_IMPORTED_MODULE_19___default()(response, 'subscription.neolaneId')
                  }
                });
                error = lodash_get__WEBPACK_IMPORTED_MODULE_19___default()(response, 'subscription.error.errorDescription', '');

                if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20___default()(error)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", setSubmitErrors([error]));

              case 7:
                dispatch({
                  payload: {
                    toastLabel: labelConfirmation
                  },
                  type: NEWSLETTER_SUBSCRIPTION_VALIDATION
                });
                onClose && onClose();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(),
    validationSchema: Object(_newsletter_form_NewsletterForm__WEBPACK_IMPORTED_MODULE_42__[/* subscriptionSchema */ "b"])(displayEmailInput, displayPhoneInput, appContext.locale)
  }, function (_ref3) {
    var _legalInformations$fi;

    var setFieldValue = _ref3.setFieldValue,
        isValid = _ref3.isValid,
        touched = _ref3.touched,
        values = _ref3.values;
    return __jsx(formik__WEBPACK_IMPORTED_MODULE_24__[/* Form */ "c"], null, __jsx(_newsletter_form_NewsletterForm__WEBPACK_IMPORTED_MODULE_42__[/* NewsletterForm */ "a"], null), checkboxes.map(function (checkbox) {
      return __jsx("div", {
        className: "mt-15",
        key: checkbox.id
      }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_37__[/* FormikInput */ "a"], {
        label: checkbox.description,
        name: checkbox.id,
        onChange: function onChange(e) {
          return Object(_profile_info_newsletter_subscription_NewsletterSubscription_utils__WEBPACK_IMPORTED_MODULE_32__[/* onCheckboxChange */ "a"])(e.target, setFieldValue);
        },
        type: "checkbox",
        value: checkbox.id
      }));
    }), ['en-CN', 'zh-CN'].includes(appContext.locale) && __jsx("div", {
      className: "mb-15"
    }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_37__[/* FormikInput */ "a"], {
      label: __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_40__[/* Text */ "a"], {
        text: (_legalInformations$fi = legalInformations.find(function (_ref4) {
          var id = _ref4.id;
          return id === 'PRIVACY_POLICY';
        })) === null || _legalInformations$fi === void 0 ? void 0 : _legalInformations$fi.label
      }),
      name: "privacyPolicyAggreement",
      type: "checkbox"
    }), touched.privacyPolicyAggreement && !values.privacyPolicyAggreement && __jsx(_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_44__[/* FormFeedback */ "a"], {
      key: "d",
      isError: true,
      message: Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('newsletter.errorMessages.privacyPolicyNotAccepted')
    })), __jsx("div", {
      className: "mt-15 text-right"
    }, !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20___default()(submitErrors) && __jsx(_frameworks_form_errors_FormErrors__WEBPACK_IMPORTED_MODULE_36__[/* FormErrors */ "a"], {
      texts: submitErrors
    }), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_35__[/* Button */ "a"], {
      isDisabled: !isValid || !values.CLUBMED || ['en-CN', 'zh-CN'].includes(appContext.locale) && !values.privacyPolicyAggreement,
      type: "submit"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_27__[/* t */ "h"])('newsletter.popin.cta'))));
  }), __jsx("div", {
    className: "mt-15"
  }, legalInformations.map(function (info) {
    return !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_20___default()(info.description) ? __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_40__[/* Text */ "a"], {
      key: info.id,
      text: info.description,
      theme: "text-sans-n2"
    }) : null;
  })))));
}

/***/ }),

/***/ "QsAM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("N4z3");
var toInteger = __webpack_require__("i7Kn");
var toLength = __webpack_require__("tJVe");
var arrayMethodIsStrict = __webpack_require__("f4p7");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "RWUY":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("pfAP");
var isSymbol = __webpack_require__("km0D");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "RYcy":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("m2YG");

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),

/***/ "Rj53":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("wC3K"),
    createAggregator = __webpack_require__("8uyH");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),

/***/ "RlI+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FREEZING = __webpack_require__("+pJz");
var global = __webpack_require__("HnW7");
var uncurryThis = __webpack_require__("kZDm");
var defineBuiltIns = __webpack_require__("D092");
var InternalMetadataModule = __webpack_require__("wKkN");
var collection = __webpack_require__("IYAN");
var collectionWeak = __webpack_require__("LFxm");
var isObject = __webpack_require__("1YFU");
var enforceInternalState = __webpack_require__("9jKB").enforce;
var fails = __webpack_require__("fhLv");
var NATIVE_WEAK_MAP = __webpack_require__("bWWS");

var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;

var FROZEN = {};
var SEALED = {};
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);

// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function () {
  return FREEZING && fails(function () {
    var frozenArray = freeze([]);
    nativeSet(new $WeakMap(), frozenArray, 1);
    return !isFrozen(frozenArray);
  });
};

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) if (IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
// Chakra Edge frozen keys fix
} else if (hasMSEdgeFreezingBug()) {
  defineBuiltIns(WeakMapPrototype, {
    set: function set(key, value) {
      var arrayIntegrityLevel;
      if (isArray(key)) {
        if (isFrozen(key)) arrayIntegrityLevel = FROZEN;
        else if (isSealed(key)) arrayIntegrityLevel = SEALED;
      }
      nativeSet(this, key, value);
      if (arrayIntegrityLevel == FROZEN) freeze(key);
      if (arrayIntegrityLevel == SEALED) seal(key);
      return this;
    }
  });
}


/***/ }),

/***/ "S8S5":
/***/ (function(module, exports) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "SQLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  fragment BookingAttendeesProfile on Profile {\n    customerId\n    gmNumber\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n    dateOfBirth\n  }\n");

/***/ }),

/***/ "SRps":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "Swp0":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var definePropertyModule = __webpack_require__("87KK");
var makeBuiltIn = __webpack_require__("OoaE");
var defineGlobalProperty = __webpack_require__("9vpE");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "TnNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDataForSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return submitSubscriptionForm; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_without__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uUTq");
/* harmony import */ var lodash_without__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_without__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("jq/l");
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_omitBy__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("Nhxn");














function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





function filterObjectWithMapping(data) {
  var rules = {
    email: 'email',
    phone: 'phone',
    civility: 'gender',
    originCode: 'originCode',
    legalAgreement: 'legalAgreement',
    firstName: 'firstName',
    lastName: 'lastName',
    unicodeFirstName: 'unicodeFirstName',
    unicodeLastName: 'unicodeLastName',
    subscriptions: 'newsletterSubscriptions'
  };
  return Object.keys(data).reduce(function (result, currentAttribute) {
    var mappedField = rules[currentAttribute];

    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(mappedField)) {
      result[mappedField] = data[currentAttribute];
    }

    return result;
  }, {});
}

var LIST_INPUTS = ['civility', 'firstName', 'lastName', 'email', 'originCode', 'phone', 'unicodeFirstName', 'unicodeLastName', 'privacyPolicyAggreement', 'legalAgreement'];
var formatDataForSubscription = function formatDataForSubscription(values) {
  var subscriptions = Object.keys(lodash_omitBy__WEBPACK_IMPORTED_MODULE_11___default()(values, function (value) {
    return value === false;
  }));
  return _objectSpread(_objectSpread({}, values), {}, {
    subscriptions: lodash_without__WEBPACK_IMPORTED_MODULE_10___default.a.apply(void 0, [subscriptions].concat(LIST_INPUTS))
  });
};
function submitSubscriptionForm(_ref) {
  var appContext = _ref.appContext,
      subscriptionId = _ref.subscriptionId,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      isSubscription = _ref.isSubscription;
  var filteredData = filterObjectWithMapping(data);

  if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(subscriptionId)) {
    filteredData.subscriptionId = subscriptionId;
  }

  filteredData.isSubscription = isSubscription;
  var selection = Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_15__[/* attributesToString */ "a"])(filteredData);
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].runNoCacheQuery("mutation RootMutationType {subscription (".concat(selection, ") { id neolaneId error { errorDescription }}}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* NEWSLETTER_SUBMIT_SUBSCRIPTION */ "pc"]
  });
}

/***/ }),

/***/ "UIAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ACCOMMODATION_FROM_ALTERNATIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ACCOMMODATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_TRANSFER_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_PROPOSALS; });
/* unused harmony export LOAD_PROPOSAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return IS_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_PROPOSALS_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_SELECTED_PROPOSAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return REMOVE_TRANSFER_FROM_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PATCH_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SAVE_CUSTOMER_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PREPARE_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISPLAY_TOAST_ON_CONTEXT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_PROPOSALS_FROM_EDIT_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SAVE_DONATION_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REMOVE_PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTOSAVE; });
/* unused harmony export SET_PROMO_CODE_FAILURE_STATUS */
/* unused harmony export SET_PROMO_CODE_SUCCESS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return UPDATE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SWITCH_PROPOSALS_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return INSURANCE_DELETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return INSURANCE_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return INIT_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return TOGGLE_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PROPOSAL_REFRESH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EDIT_HOUSEHOLDS; });
var ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
var ADD_ACCOMMODATION_FROM_ALTERNATIVES = 'ADD_ACCOMMODATION_FROM_ALTERNATIVES';
var ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
var ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
var ADD_TRANSPORT = 'ADD_TRANSPORT';
var UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
var CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
var LOAD_PROPOSAL = 'LOAD_PROPOSAL';
var IS_BOOKING = 'IS_BOOKING';
var FETCH_PROPOSALS = 'FETCH_PROPOSALS';
var FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
var FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
var REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
var SET_PROPOSALS = 'SET_PROPOSALS';
var PATCH_PROPOSAL = 'PATCH_PROPOSAL';
var SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
var SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID = 'SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID';
var UPDATE_INSURANCES = 'UPDATE_INSURANCES';
var DELETE_INSURANCES = 'DELETE_INSURANCES';
var PREPARE_BE = 'PREPARE_BE';
var DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
var FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
var SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
var SET_PROMO_CODE = 'SET_PROMO_CODE';
var REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE';
var AUTOSAVE = 'AUTOSAVE';
var SET_PROMO_CODE_FAILURE_STATUS = 'failure';
var SET_PROMO_CODE_SUCCESS_STATUS = 'success';
var UPDATE_SERVICES = 'UPDATE_SERVICES';
var ADD_SERVICE = 'ADD_SERVICE';
var DELETE_SERVICE = 'DELETE_SERVICE';
var SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
var PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD = 30;
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
var INSURANCE_DELETED = 'INSURANCE_DELETED';
var INSURANCE_ADDED = 'INSURANCE_ADDED';
var INIT_INSURANCES = 'INIT_INSURANCES';
var TOGGLE_TERMS = 'TOGGLE_TERMS';
var PROPOSAL_REFRESH = 'PROPOSAL_REFRESH';
var EDIT_HOUSEHOLDS = 'EDIT_HOUSEHOLDS';

/***/ }),

/***/ "Uey1":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("eGzU");
var isNullOrUndefined = __webpack_require__("nnO8");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "V/va":
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__("VXxY");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "V8Kl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js
var variants = {
  diamond: {
    root: ' transform rotate-45',
    item: ' transform -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var variant = _ref.variant;
    return {
      thRoot: "".concat(variant ? variants[variant].root : '', " bg-saffron border-saffron text-black relative isolate bg-saffron border-saffron size-50 text-black border-1 flex-none inline-flex items-center justify-center leading-0 overflow-hidden"),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-[1em] text-center ".concat(variant ? variants[variant].item : '')
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx


var __jsx = react_default.a.createElement;




var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      label = _ref.label,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["alt", "className", "iconName", "iconSize", "label", "theme", "variant"]);

  if (!iconName && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }), !!iconName && __jsx("span", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("span", {
    className: thLabel
  }, label));
};

/***/ }),

/***/ "VXxY":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "VZDm":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__("Ndl3");

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),

/***/ "VqLN":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var isInteger = __webpack_require__("JYr1");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ "VrMI":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("mwRp");
var uncurryThis = __webpack_require__("kZDm");
var IndexedObject = __webpack_require__("F9U4");
var toObject = __webpack_require__("A+R+");
var lengthOfArrayLike = __webpack_require__("XhyO");
var arraySpeciesCreate = __webpack_require__("kjCq");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "VrMS":
/***/ (function(module, exports, __webpack_require__) {

var toAbsoluteIndex = __webpack_require__("Jm8J");
var lengthOfArrayLike = __webpack_require__("XhyO");
var createProperty = __webpack_require__("6aqx");

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "W0vE":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "W1ge":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("0Ocv"),
    toInteger = __webpack_require__("m2YG");

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;


/***/ }),

/***/ "WGoB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTravelSectionSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pluralizeLabel; });
/* unused harmony export prefixWithPlusIfPositive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalizeName; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");





function pluralizeLabel(singularLabel, pluralLabel, value) {
  return value > 1 ? pluralLabel : singularLabel;
}

function prefixWithPlusIfPositive(value, label) {
  return value >= 0 ? "+".concat(label) : label;
}

function capitalizeName(text) {
  return (text || '').toLowerCase().replace(/(?:^|[-\s.'&])\S/g, function (a) {
    return a.toUpperCase();
  });
}

var getAttendeesSummary = function getAttendeesSummary(_ref) {
  var adultsCount = _ref.adultsCount,
      kidsCount = _ref.kidsCount;
  return "".concat(adultsCount, " ").concat(pluralizeLabel(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.adult'), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.adults'), adultsCount), " ").concat(kidsCount > 0 ? " - ".concat(kidsCount, " ").concat(pluralizeLabel(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.child'), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.children'), kidsCount)) : '');
};
var getTravelSectionSummary = function getTravelSectionSummary(_ref2) {
  var travelSection = _ref2.travelSection;
  return "".concat(travelSection.label.toLowerCase(), " (").concat(travelSection.id.toUpperCase(), ")");
};


/***/ }),

/***/ "WSQK":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "WeO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAttendeeNamePlaceholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNumberOfAdultsAndChildren; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var getAttendeeNamePlaceholder = function getAttendeeNamePlaceholder(attendee, isKid, isMain) {
  var firstName = attendee.firstName,
      lastName = attendee.lastName,
      civility = attendee.civility;
  var attendeeLabel = isKid ? Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.otherKidsInfosHeader.title') : Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.otherAdultsInfosHeader.title');

  if (isMain) {
    attendeeLabel = Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.personnalInfosHeader.title');
  }

  if (firstName && lastName && civility) {
    attendeeLabel = "".concat(civility, " ").concat(firstName, " ").concat(lastName);
  }

  return attendeeLabel;
};
var getNumberOfAdultsAndChildren = function getNumberOfAdultsAndChildren(quantityOfChildren, quantityOfAdults) {
  if (quantityOfChildren === 0) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'));
  }

  if (quantityOfChildren === 1) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'), " - ").concat(quantityOfChildren, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.child'));
  }

  if (quantityOfChildren > 1) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'), " - ").concat(quantityOfChildren, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.children'));
  }
};

/***/ }),

/***/ "X95k":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "XGb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FavoriteProductListContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var FavoriteProductListContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])({
  favoriteProductsState: {
    favoriteProductList: [],
    hasTooManyFavorites: false,
    showcaseLatestFavorite: false,
    showAllFavorite: false
  },
  loading: false,
  addTravelPlan: function addTravelPlan() {},
  setHasTooManyFavorites: function setHasTooManyFavorites() {},
  setFavoriteProductList: function setFavoriteProductList() {}
});

/***/ }),

/***/ "XTsI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var call = __webpack_require__("we+H");
var uncurryThis = __webpack_require__("kZDm");
var IS_PURE = __webpack_require__("SRps");
var DESCRIPTORS = __webpack_require__("uGjT");
var NATIVE_SYMBOL = __webpack_require__("1s2Y");
var fails = __webpack_require__("fhLv");
var hasOwn = __webpack_require__("/GgU");
var isPrototypeOf = __webpack_require__("VXxY");
var anObject = __webpack_require__("ep/x");
var toIndexedObject = __webpack_require__("dNjr");
var toPropertyKey = __webpack_require__("RWUY");
var $toString = __webpack_require__("vnfA");
var createPropertyDescriptor = __webpack_require__("OouP");
var nativeObjectCreate = __webpack_require__("Znn2");
var objectKeys = __webpack_require__("X95k");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternal = __webpack_require__("Ed3r");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");
var definePropertiesModule = __webpack_require__("HKx7");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var defineBuiltIn = __webpack_require__("Swp0");
var defineBuiltInAccessor = __webpack_require__("yYuE");
var shared = __webpack_require__("8+jV");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");
var uid = __webpack_require__("rvZv");
var wellKnownSymbol = __webpack_require__("nJrx");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineWellKnownSymbol = __webpack_require__("lPgN");
var defineSymbolToPrimitive = __webpack_require__("sCYz");
var setToStringTag = __webpack_require__("CGO5");
var InternalStateModule = __webpack_require__("9jKB");
var $forEach = __webpack_require__("VrMI").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "XhyO":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("DOIJ");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "XmKO":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var setPrototypeOf = __webpack_require__("iBXc");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "Xvk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID; });
var FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID = 'FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID';

/***/ }),

/***/ "XywU":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "Xzib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopOver_PopOver; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-large arrow-white bg-white after:drop-shadow-md mb-20 rounded-2 shadow-md',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  infoBanner: {
    thTrigger: 'w-full',
    thContainer: 'absolute top-full animate-fadeIn animation-duration-500 mt-5 rounded-2',
    thContent: ' arrow-white bg-white',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.875rem'
  },
  priceOfStayTooltip: {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md mb-20 rounded-2',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  fancy: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-bg arrow-bg-black arrow-downLeft arrow-large arrow-white bg-white border-1 border-black after:drop-shadow-md mb-20 rounded-12 shadow-md',
    thCloseButton: 'absolute leading-0 p-10 end-0 top-0 text-grey',
    thCloseIconWidth: '0.625rem'
  },
  favorite: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-end',
    thContent: 'arrow-downRight arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  'favorite-centered': {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-center',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  typesOfStaySearchFilter: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 -mb-5 w-screen',
    thContent: 'flex w-full leading-1',
    thCloseButton: '',
    thTrigger: 'leading-0',
    thCloseIconWidth: ''
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx

var __jsx = react_default.a.createElement;









var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      content = _ref.content,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _ref$isInitiallyVisib = _ref.isInitiallyVisible,
      isInitiallyVisible = _ref$isInitiallyVisib === void 0 ? false : _ref$isInitiallyVisib,
      _ref$isModalOnly = _ref.isModalOnly,
      isModalOnly = _ref$isModalOnly === void 0 ? false : _ref$isModalOnly,
      _onClick = _ref.onClick,
      onRender = _ref.onRender,
      onTimeout = _ref.onTimeout,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      timeoutInMs = _ref.timeoutInMs,
      triggerOnHover = _ref.triggerOnHover;

  var _useState = Object(react["useState"])(isInitiallyVisible),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(react["useEffect"])(function () {
    onRender && onRender();

    if (timeoutInMs && timeoutInMs > 0) {
      setTimeout(function () {
        setIsVisible(false);
        onTimeout && onTimeout();
      }, timeoutInMs);
    }

    return function () {
      onTimeout && onTimeout();
    };
  }, []);
  var shouldTriggerOnHover = triggerOnHover && isDesktop;
  Object(react["useEffect"])(function () {
    var timeoutId;

    if (shouldTriggerOnHover && isVisible && _onClick) {
      timeoutId = setTimeout(_onClick, 300);
      return function () {
        clearTimeout(timeoutId);
      };
    }
  }, [isVisible, shouldTriggerOnHover]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTrigger = _themes$theme.thTrigger,
      thContainer = _themes$theme.thContainer,
      thContent = _themes$theme.thContent,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseIconWidth = _themes$theme.thCloseIconWidth;
  return __jsx("div", Object(esm_extends["a" /* default */])({
    className: Object(classnames_utils["a" /* classnames */])('relative isolate', className)
  }, shouldTriggerOnHover && {
    onMouseEnter: function onMouseEnter(e) {
      setIsVisible(true);

      if (!shouldTriggerOnHover) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      }
    },
    onMouseLeave: function onMouseLeave() {
      setIsVisible(false);
    }
  }), __jsx("button", {
    className: thTrigger,
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();

      if (!timeoutInMs) {
        setIsVisible(!isVisible);
      }

      if (!isVisible && !shouldTriggerOnHover && _onClick) {
        _onClick(e);
      }
    },
    type: "button"
  }, children), isVisible && (isDesktop && !isModalOnly ? __jsx(ClickOutside["a" /* ClickOutside */], {
    className: Object(classnames_utils["a" /* classnames */])(thContainer, containerClassName),
    onClick: function onClick() {
      setIsVisible(false);
    }
  }, __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])(thContent, contentClassName)
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    onClick: function onClick() {
      return setIsVisible(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), content)) : __jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};

/***/ }),

/***/ "Y8c0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var userAgent = __webpack_require__("xe/R");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "YF+p":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var isObject = __webpack_require__("1YFU");
var classof = __webpack_require__("XywU");
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__("ZE1B");

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ "YQkA":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* unused harmony export ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE; });
/* unused harmony export ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__CA__ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__CA__CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__CA__ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__CA__INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__CA__MORE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__CA__PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__CA__RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__CA__STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__CA__TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__CA__VOUCHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* unused harmony export ID_MODAL_HEADER__BE__CXO_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* unused harmony export ID_MODAL_HEADER__BE__CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__EASY_ARRIVAL_INFO; });
/* unused harmony export ID_MODAL_HEADER__BE__HOUSEHOLD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_MODAL_HEADER__FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_MODAL_HEADER__BE_REFRESH_PROPOSAL; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS = 'AccommodationsLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE = 'TransportsFiltersMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__CA__ACTIVITIES = 'ActivitiesLayerHeaderId';
var ID_LAYER_HEADER__CA__CHILDCARES = 'ChildcaresLayerHeaderId';
var ID_LAYER_HEADER__CA__ESF = 'ESFLayerHeaderId';
var ID_LAYER_HEADER__CA__INSURANCES = 'InsurancesLayerHeaderId';
var ID_LAYER_HEADER__CA__MORE_ROOMS = 'MoreRoomsLayerHeaderId';
var ID_LAYER_HEADER__CA__PACKAGES = 'PackagesLayerHeaderId';
var ID_LAYER_HEADER__CA__RENTALS = 'RentalsLayerHeaderId';
var ID_LAYER_HEADER__CA__STAFF = 'StaffLayerHeaderId';
var ID_LAYER_HEADER__CA__TRANSFERS = 'TransfersLayerHeaderId';
var ID_LAYER_HEADER__CA__VOUCHERS = 'VouchersLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__CXO_OPTION = 'CxoOptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__EASY_ARRIVAL_INFO = 'EasyArrivalModalHeaderId';
var ID_MODAL_HEADER__BE__HOUSEHOLD = 'ParticipantsHouseholdModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__FILTERS = 'FiltersModalHeaderId';
var ID_MODAL_HEADER__BE_REFRESH_PROPOSAL = 'RefreshProposalModalHeaderId';

/***/ }),

/***/ "Z/bG":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('flatten', __webpack_require__("1xil"), __webpack_require__("zUlE"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "Z0Tt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("1Ll7");


/***/ }),

/***/ "ZE1B":
/***/ (function(module, exports, __webpack_require__) {

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__("fhLv");

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ "ZHK4":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__("1TCz");
      }
    ]);
  

/***/ }),

/***/ "ZSqt":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ZVqJ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var apply = __webpack_require__("KXRF");
var bind = __webpack_require__("C56r");
var aConstructor = __webpack_require__("jCye");
var anObject = __webpack_require__("ep/x");
var isObject = __webpack_require__("1YFU");
var create = __webpack_require__("Znn2");
var fails = __webpack_require__("fhLv");

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "Zl10":
/***/ (function(module, exports, __webpack_require__) {

var createAggregator = __webpack_require__("8uyH");

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

module.exports = partition;


/***/ }),

/***/ "Znn2":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("ep/x");
var definePropertiesModule = __webpack_require__("HKx7");
var enumBugKeys = __webpack_require__("WSQK");
var hiddenKeys = __webpack_require__("qXr/");
var html = __webpack_require__("QknU");
var documentCreateElement = __webpack_require__("a4SZ");
var sharedKey = __webpack_require__("mmil");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "ZoVA":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "ZuH9":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("mwRp");
var call = __webpack_require__("we+H");
var anObject = __webpack_require__("ep/x");
var tryToString = __webpack_require__("xS1b");
var isArrayIteratorMethod = __webpack_require__("zcYo");
var lengthOfArrayLike = __webpack_require__("XhyO");
var isPrototypeOf = __webpack_require__("VXxY");
var getIterator = __webpack_require__("cUh7");
var getIteratorMethod = __webpack_require__("MU85");
var iteratorClose = __webpack_require__("yUod");

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "a4SZ":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "aWOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ isUpsellBooked; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ bookingUtils_getFlatUpsells; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ hasSomeActivityBooked; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getTransferFromAccessId; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ hasSomeUpsellsPartiallyRented; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ hasSomeUpsellsAlreadyPaid; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ hasAllUpsellsPaid; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ bookingUtils_hasFreeDepositEnabled; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ isOptionBooking; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ doNotHaveValidStay; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ bookingUtils_getStayAccommodation; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ bookingUtils_getCGVFromLegalInfos; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ bookingUtils_getHealthRegulationsFromLegalInfos; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ bookingUtils_tAlt; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ bookingUtils_getActivityTypeName; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ bookingUtils_getBookingEngineUrl; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ bookingUtils_getShoppingUrl; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ bookingUtils_getOptionById; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ isOptionAboutToExpire; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ bookingUtils_getStaffChief; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ bookingUtils_getStaffCategories; });

// UNUSED EXPORTS: hasSomeUpsellsInCartOrPaid, isEasyArrivalEnabled, hasStayTransport

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/accommodation/accommodation.utils.js
var accommodation_utils = __webpack_require__("+2Ph");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodations/BookingAccommodationsUtils.js
var BookingAccommodationsUtils = __webpack_require__("cb6o");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/api-status/constants.js
var constants = __webpack_require__("54uq");

// EXTERNAL MODULE: ./src/utils/booking-process/constants.js
var booking_process_constants = __webpack_require__("XpIN");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/utils/legacy-booking-engine/legacyBookingUrlBuilder.js





/* eslint-disable flowtype/no-weak-types */



function buildProposalUrl(_ref) {
  var productId = _ref.productId,
      proposalId = _ref.proposalId,
      currentUri = _ref.currentUri,
      fromSearches = _ref.fromSearches;
  var redirectionQueryParameters = {
    proposalIds: proposalId,
    selectedProposalId: proposalId,
    product: productId,
    coderesort: productId,
    fromSearches: fromSearches
  };
  var uri = new URI_default.a(currentUri);
  var queryParams = URI_default.a.parseQuery(uri.search());

  if (queryParams.locale) {
    // $FlowFixMe
    redirectionQueryParameters.locale = queryParams.locale;
  }

  return uri.segment([config_default.a.get('booking.endpoints.responsive')]).query(redirectionQueryParameters).toString();
}

function buildUrlFromContextNumber(formData, appContext, currentUri) {
  return buildProposalUrl({
    appContext: appContext,
    productId: formData.resortId,
    proposalId: formData.reference,
    fromSearches: formData.fromSearches,
    currentUri: currentUri
  });
}


// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/client/views/account/dashboard/DashboardView.queries.js
var DashboardView_queries = __webpack_require__("+M7m");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/utils/booking/bookingUtils.js























/* eslint-disable camelcase */

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



















var BOOKING_STATUSES = dist["constants"].BOOKING_STATUSES,
    PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var BOOKING_STATUS_EXPIRED_OPTION = BOOKING_STATUSES.BOOKING_STATUS_EXPIRED_OPTION,
    BOOKING_STATUS_OPTION = BOOKING_STATUSES.BOOKING_STATUS_OPTION;
var isUpsellBooked = function isUpsellBooked(upsell) {
  var _upsell$pricingInfo, _upsell$pricingInfo2, _upsell$pricingInfo3;

  return Boolean((upsell === null || upsell === void 0 ? void 0 : (_upsell$pricingInfo = upsell.pricingInfo) === null || _upsell$pricingInfo === void 0 ? void 0 : _upsell$pricingInfo.isPartiallyRented) || (upsell === null || upsell === void 0 ? void 0 : (_upsell$pricingInfo2 = upsell.pricingInfo) === null || _upsell$pricingInfo2 === void 0 ? void 0 : _upsell$pricingInfo2.isPartiallyPaid) || (upsell === null || upsell === void 0 ? void 0 : (_upsell$pricingInfo3 = upsell.pricingInfo) === null || _upsell$pricingInfo3 === void 0 ? void 0 : _upsell$pricingInfo3.isFullyPaid));
};
var bookingUtils_getFlatUpsells = function getFlatUpsells(stay) {
  // $FlowFixMe
  return Object.values((stay === null || stay === void 0 ? void 0 : stay.upsells) || {}).reduce(function (acc, items) {
    return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(items));
  }, []);
};
var hasSomeActivityBooked = function hasSomeActivityBooked(category) {
  var _category$activities, _category$categories;

  var hasSomeBooked = false;

  if ((_category$activities = category.activities) === null || _category$activities === void 0 ? void 0 : _category$activities.length) {
    hasSomeBooked = category.activities.some(function (_ref) {
      var additionalService = _ref.additionalService;
      return isUpsellBooked(additionalService);
    });
  }

  if (((_category$categories = category.categories) === null || _category$categories === void 0 ? void 0 : _category$categories.length) && !hasSomeBooked) {
    hasSomeBooked = category.categories.some(function (cat) {
      return hasSomeActivityBooked(cat);
    });
  }

  return hasSomeBooked;
};
var getTransferFromAccessId = function getTransferFromAccessId(transfers, accessId) {
  return transfers.find(function (trans) {
    var _trans$access;

    return ((_trans$access = trans.access) === null || _trans$access === void 0 ? void 0 : _trans$access.id) === accessId && Number(trans.duration) > 0 && !trans.id.includes('MICE_');
  });
};
var hasSomeUpsellsPartiallyRented = function hasSomeUpsellsPartiallyRented(upsells) {
  return (upsells || []).some(function (_ref2) {
    var _ref2$pricingInfo = _ref2.pricingInfo,
        pricingInfo = _ref2$pricingInfo === void 0 ? {} : _ref2$pricingInfo;
    return pricingInfo.isPartiallyRented;
  });
};
var hasSomeUpsellsAlreadyPaid = function hasSomeUpsellsAlreadyPaid(upsells) {
  return (upsells || []).some(function (_ref3) {
    var _ref3$pricingInfo = _ref3.pricingInfo,
        pricingInfo = _ref3$pricingInfo === void 0 ? {} : _ref3$pricingInfo;
    return pricingInfo.isFullyPaid || pricingInfo.isPartiallyPaid;
  });
};
var hasSomeUpsellsInCartOrPaid = function hasSomeUpsellsInCartOrPaid(upsells) {
  return (upsells || []).some(function (_ref4) {
    var _ref4$pricingInfo = _ref4.pricingInfo,
        pricingInfo = _ref4$pricingInfo === void 0 ? {} : _ref4$pricingInfo;
    return pricingInfo.isPartiallyRented || pricingInfo.isPartiallyPaid || pricingInfo.isFullyPaid;
  });
};
var hasAllUpsellsPaid = function hasAllUpsellsPaid(upsells) {
  if (!(upsells === null || upsells === void 0 ? void 0 : upsells.length)) {
    return false;
  }

  return upsells.every(function (_ref5) {
    var _ref5$pricingInfo = _ref5.pricingInfo,
        pricingInfo = _ref5$pricingInfo === void 0 ? {} : _ref5$pricingInfo;
    return pricingInfo.isFullyPaid;
  });
};
var bookingUtils_isEasyArrivalEnabled = function isEasyArrivalEnabled(formalities, product) {
  var _formalities$easyArri;

  return !product.isJoyview && [constants["b" /* API_AVAILABLE */], constants["c" /* API_DONE */]].includes(formalities === null || formalities === void 0 ? void 0 : (_formalities$easyArri = formalities.easyArrival) === null || _formalities$easyArri === void 0 ? void 0 : _formalities$easyArri.status);
};
var bookingUtils_hasFreeDepositEnabled = function hasFreeDepositEnabled(b, appContext) {
  var _b$paymentDetails, _b$paymentDetails$due, _b$paymentDetails$due2, _b$paymentDetails2, _b$paymentDetails2$du, _b$information, _b$information$stays, _b$information$stays$;

  return Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.banking.enableFreeDeposit') && (((_b$paymentDetails = b.paymentDetails) === null || _b$paymentDetails === void 0 ? void 0 : (_b$paymentDetails$due = _b$paymentDetails.duePayment) === null || _b$paymentDetails$due === void 0 ? void 0 : (_b$paymentDetails$due2 = _b$paymentDetails$due.amount) === null || _b$paymentDetails$due2 === void 0 ? void 0 : _b$paymentDetails$due2.value) || 0) > 0 && (appContext.freeDepositDeadline === 999 ? moment_default()((_b$paymentDetails2 = b.paymentDetails) === null || _b$paymentDetails2 === void 0 ? void 0 : (_b$paymentDetails2$du = _b$paymentDetails2.duePayment) === null || _b$paymentDetails2$du === void 0 ? void 0 : _b$paymentDetails2$du.deadline, apiDate["a" /* API_DATE_FORMAT */]).diff(moment_default()()) > 0 : moment_default()((_b$information = b.information) === null || _b$information === void 0 ? void 0 : (_b$information$stays = _b$information.stays) === null || _b$information$stays === void 0 ? void 0 : (_b$information$stays$ = _b$information$stays[0]) === null || _b$information$stays$ === void 0 ? void 0 : _b$information$stays$.departureDate, apiDate["a" /* API_DATE_FORMAT */]).subtract(appContext.freeDepositDeadline, 'day').diff(moment_default()()) > 0);
};
var isOptionBooking = function isOptionBooking(status) {
  return [BOOKING_STATUS_OPTION, BOOKING_STATUS_EXPIRED_OPTION].includes(status);
};
var doNotHaveValidStay = function doNotHaveValidStay(booking) {
  return booking && (((booking === null || booking === void 0 ? void 0 : booking.stays) || []).length === 0 || ((booking === null || booking === void 0 ? void 0 : booking.stays) || []).every(function (stay) {
    return !stay.product;
  }));
};
var bookingUtils_getStayAccommodation = function getStayAccommodation(accommodations, product, streetViews) {
  return accommodations ? Object(BookingAccommodationsUtils["b" /* getAccommodationProps */])({
    accommodations: accommodations,
    accommodationsCount: accommodations.length || 0,
    attendeesWithDistributionData: [],
    product: product,
    proposal: null,
    remainingStock: accommodation_utils["a" /* REMAINING_STOCK_LIMIT */] + 1,
    streetViews: streetViews !== null && streetViews !== void 0 ? streetViews : []
  }) : {};
};
var bookingUtils_getCGVFromLegalInfos = function getCGVFromLegalInfos(bookingProcess) {
  // $FlowFixMe
  return (bookingProcess || []).find(function (bp) {
    return bp.id === booking_process_constants["b" /* LEGAL_INFO_CGV_ID */];
  }) || {
    label: ''
  };
};
var bookingUtils_getHealthRegulationsFromLegalInfos = function getHealthRegulationsFromLegalInfos(bookingProcess) {
  // $FlowFixMe
  return (bookingProcess || []).find(function (bp) {
    return bp.id === booking_process_constants["a" /* HEALTH_REGULATION */];
  }) || null;
};
var bookingUtils_tAlt = function tAlt(_ref6) {
  var cruiseKeyPath = _ref6.cruiseKeyPath,
      product = _ref6.product,
      resortKeyPath = _ref6.resortKeyPath,
      variables = _ref6.variables;
  return Object(i18n["h" /* t */])((product === null || product === void 0 ? void 0 : product.type) === PRODUCT_TYPES.CRUISE ? cruiseKeyPath : resortKeyPath, variables);
};
var bookingUtils_getActivityTypeName = function getActivityTypeName(type) {
  return Object(string_util["c" /* snakeToCamel */])(type.toLowerCase().replace('rental', 'ski'));
};
var bookingUtils_getBookingEngineUrl = function getBookingEngineUrl(appContext, bookingId, productId, currentUri) {
  var params = {
    reference: bookingId,
    resortId: productId,
    fromSearches: 'true'
  };
  return buildUrlFromContextNumber(params, appContext, currentUri);
};
var bookingUtils_getShoppingUrl = function getShoppingUrl(stay) {
  var _stay$transport, _participants$childre, _objectSpread2;

  var dates = stay.dates,
      participants = stay.participants,
      product = stay.product;
  var departureCity = (_stay$transport = stay.transport) === null || _stay$transport === void 0 ? void 0 : _stay$transport.fromCityCode;
  return new URI_default.a(product.href).setQuery(_objectSpread(_objectSpread({}, (_objectSpread2 = {}, Object(defineProperty["a" /* default */])(_objectSpread2, uri_constants["g" /* QUERY_DEPARTURE_DATE */], dates.startDate && Object(apiDate["j" /* momentFromApiDate */])(dates.startDate).format(uri_constants["f" /* QUERY_DATE_FORMAT */])), Object(defineProperty["a" /* default */])(_objectSpread2, uri_constants["h" /* QUERY_DURATION */], Object(apiDate["j" /* momentFromApiDate */])(dates.endDate).diff(Object(apiDate["j" /* momentFromApiDate */])(dates.startDate), 'days')), Object(defineProperty["a" /* default */])(_objectSpread2, uri_constants["j" /* QUERY_KIDS */], ((_participants$childre = participants.children) === null || _participants$childre === void 0 ? void 0 : _participants$childre.length) > 0 && Object(facetingUtils["o" /* serializeKidsToQueryParam */])({
    kids: participants.children,
    kidsValidationState: []
  }) || undefined), Object(defineProperty["a" /* default */])(_objectSpread2, uri_constants["l" /* QUERY_NUMBER_OF_ADULTS */], participants.adultsCount), _objectSpread2)), !!departureCity && Object(defineProperty["a" /* default */])({}, uri_constants["m" /* QUERY_TRANSPORT */], departureCity)));
};
var bookingUtils_getOptionById = function getOptionById(appContext, bookingId) {
  return graphqlClient["a" /* default */].runNoCacheQuery(Object(DashboardView_queries["c" /* getOptionByIdQuery */])(bookingId, appContext), appContext, {
    requestName: requestDictionary["k" /* CUSTOMER_ACCOUNT_GET_BOOKING_DATA */],
    strictErrors: false
  });
};
var isOptionAboutToExpire = function isOptionAboutToExpire(optionDateTimeEnd) {
  return optionDateTimeEnd ? optionDateTimeEnd - 3600000 * 1
  /* 1h */
  <= new Date().valueOf() : false;
};
var bookingUtils_getStaffChief = function getStaffChief() {
  var staff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return staff.find(function (_ref8) {
    var _ref8$categories = _ref8.categories,
        categories = _ref8$categories === void 0 ? [] : _ref8$categories;
    return categories.some(function (_ref9) {
      var code = _ref9.code,
          label = _ref9.label;
      return [code, label].includes(booking_constants["s" /* STAFF_CHIEF_CODE */]);
    });
  }) || staff[0];
};
var bookingUtils_getStaffCategories = function getStaffCategories() {
  var staff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (// $FlowFixMe
    sortBy_default()(uniqBy_default()(staff.reduce(function (acc, s) {
      return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(s.categories));
    }, []).map(function (_ref10) {
      var code = _ref10.code,
          label = _ref10.label;
      return {
        label: label,
        value: code
      };
    }), 'value'), ['label'])
  );
};
var hasStayTransport = function hasStayTransport(stay) {
  var _ref11 = (stay === null || stay === void 0 ? void 0 : stay.transport) || {},
      _ref11$inbounds = _ref11.inbounds,
      inbounds = _ref11$inbounds === void 0 ? [] : _ref11$inbounds,
      _ref11$outbounds = _ref11.outbounds,
      outbounds = _ref11$outbounds === void 0 ? [] : _ref11$outbounds,
      type = _ref11.type;

  var hasTransport = inbounds.length > 0 || outbounds.length > 0 || !!type;
  return hasTransport;
};

/***/ }),

/***/ "aXF+":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("7BVm");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "b86L":
/***/ (function(module, exports) {

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ "bJ4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isTokenValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleInvalidToken; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("L7OA");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("6jSF");








var isTokenValid = function isTokenValid(userInfo) {
  return userInfo && moment__WEBPACK_IMPORTED_MODULE_4___default()(userInfo.expirationDate, 'X').startOf('second').isAfter();
};
var handleInvalidToken = function handleInvalidToken(_ref) {
  var appContext = _ref.appContext,
      currentUri = _ref.currentUri,
      res = _ref.res,
      userInfo = _ref.userInfo;
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta,
      isUserLogged = appContext.isUserLogged,
      isUserQuickLogged = appContext.isUserQuickLogged,
      isSellerLogged = appContext.isSellerLogged;
  var redirectUri = isSeller ? Object(_index__WEBPACK_IMPORTED_MODULE_7__[/* buildSellerSigninUrl */ "e"])({
    isCmta: isCmta,
    locale: locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(_index__WEBPACK_IMPORTED_MODULE_7__[/* buildErrorUrl */ "c"])(currentUri.toString(), locale)
  }) : Object(_index__WEBPACK_IMPORTED_MODULE_7__[/* buildSigninUrl */ "f"])({
    locale: locale,
    redirectUri: currentUri.toString(),
    redirectURIError: Object(_index__WEBPACK_IMPORTED_MODULE_7__[/* buildErrorUrl */ "c"])(currentUri.toString(), locale),
    isQuickLoginFirst: currentUri.toString().includes("provider=".concat(_index__WEBPACK_IMPORTED_MODULE_7__[/* QUICK_LOGIN_QUERY_PARAM */ "a"])) || Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_6__[/* isFeatureFlipped */ "a"])(appContext)('memberSpace.isQuickLoginFirst')
  }); // not filled because the cookie is httpOnly
  // if (!appContext.authenticationToken) {

  if (!isUserLogged && !isUserQuickLogged && !isSellerLogged) {
    if (res) {
      res.redirect(302, redirectUri);
    } else {
      _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation(redirectUri);
    }
  } else if ((isUserLogged || isUserQuickLogged) && !isTokenValid(userInfo)) {
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation(redirectUri);
  }
};

/***/ }),

/***/ "bMl7":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("RlI+");


/***/ }),

/***/ "bWWS":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "cUh7":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var aCallable = __webpack_require__("eGzU");
var anObject = __webpack_require__("ep/x");
var tryToString = __webpack_require__("xS1b");
var getIteratorMethod = __webpack_require__("MU85");

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "cb6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAccommodationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return aggregateIconList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBabyBedIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCapacityIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSurfaceIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOutsideFacilitiesIconItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getViewIconItem; });
/* unused harmony export getNbBabies */
/* unused harmony export hasLowStock */
/* unused harmony export getAccommodationCategoryComfortIndex */
/* unused harmony export getBestAccommodationCategory */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("2dTi");
/* harmony import */ var lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_fp_last__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("cFQB");
/* harmony import */ var lodash_fp_last__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_last__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("lozs");
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("3dHC");
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("aWOT");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SPKZ");
/* harmony import */ var _accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("OsvN");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("lZ21");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("oL6k");




























var ATTENDEE_CATEGORIES = {
  BABY: 'BABY',
  CHILD: 'CHILD',
  ADULT: 'ADULT'
};
var ICONS_ROOM_TYPE = {
  CONNECTING_ROOMS: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SEPARATE_ROOMS_3,
  SEPARATE_ROOMS: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SEPARATE_ROOMS,
  SINGLE_ROOM: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SINGLE_ROOM
};

function getCapacityIconItem(capacity) {
  var label = Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.packageContent.numberPeople');

  if (!capacity || !label) {
    return null;
  }

  return {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].PEOPLE,
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.packageContent.capacityOfPeople'), Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_20__["messageFormat"])(label).format({
      count: capacity
    })]
  };
}

function getSurfaceIconItem(roomType, product, surface) {
  return {
    icon: ICONS_ROOM_TYPE[roomType] || null,
    labels: [Object(_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_21__[/* tAlt */ "u"])({
      cruiseKeyPath: "booking.accommodation.packageContent.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__[/* CORRESPONDENCE_CABIN_TYPE */ "d"][roomType]),
      product: product,
      resortKeyPath: "booking.accommodation.packageContent.configuration.".concat(_utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__[/* CORRESPONDANCE_ROOM_TYPE */ "c"][roomType])
    }), surface || roomType && ' ' || '']
  };
}

function getNbBabies(occupancies) {
  if (!occupancies) {
    return 0;
  }

  return occupancies.reduce(function () {
    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var occupancy = arguments.length > 1 ? arguments[1] : undefined;
    return acc + occupancy.baby_count;
  }, 0);
}

function getBabyBedIconItem(babyCount) {
  if (!babyCount || babyCount <= 0) {
    return null;
  }

  var label = babyCount > 1 ? Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.packageContent.babyBedincludedPlural') : Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.packageContent.babyBedincluded');
  return {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].baby_bed,
    labels: [label]
  };
}

function getOutsideFacilitiesIconItem(outsideFacilities) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(outsideFacilities, '[0].label') ? {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(outsideFacilities[0], 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
    labels: [outsideFacilities[0].label]
  } : null;
}

function getViewIconItem(view) {
  return view ? {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(view, 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
    labels: [view.label]
  } : null;
}

function aggregateIconList(strengths, surface, capacity, outsideFacility, view, babyBed) {
  var isComparator = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var isInMoreRoomLayer = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var proposal = arguments.length > 8 ? arguments[8] : undefined;
  var currentComfortAlternatives = arguments.length > 9 ? arguments[9] : undefined; // add a "strengths slot" for each missing item

  var maxStrengths = 3 - [view, capacity, babyBed, outsideFacility].filter(function (item) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(item, 'labels.0');
  }).length;
  var strengthsItems = (strengths || []).slice(0, Math.max(maxStrengths, 0)).map(function (strength) {
    return {
      icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(strength, 'id')] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
      labels: [lodash_get__WEBPACK_IMPORTED_MODULE_18___default()(strength, 'label') || '']
    };
  });
  var chooseYourViewItem = {
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].sea_view,
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.roomFinder.viewFilterTitle')],
    buttonText: Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.common.add')
  };
  var chooseYourFacilityItem = {
    icon: 'terrace',
    labels: [Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.accommodation.roomFinder.facilitiesFilterTitle')],
    buttonText: Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.common.add')
  };
  var hasViewAlternative = Object(_accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_23__[/* hasTypedAlternative */ "l"])({
    currentComfortAlternatives: currentComfortAlternatives,
    icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].sea_view,
    proposal: proposal
  });
  var hasOFAlternative = Object(_accommodation_room_infos_AccommodationRoomInfos_utils__WEBPACK_IMPORTED_MODULE_23__[/* hasTypedAlternative */ "l"])({
    currentComfortAlternatives: currentComfortAlternatives,
    icon: 'terrace',
    proposal: proposal
  });
  var viewWithDefaultIfNone = !isComparator && !isInMoreRoomLayer && hasViewAlternative ? view || chooseYourViewItem : view;
  var outsideFacilityWithDefaultIfNone = !isComparator && !isInMoreRoomLayer && hasOFAlternative ? outsideFacility || chooseYourFacilityItem : outsideFacility;
  return lodash_compact__WEBPACK_IMPORTED_MODULE_17___default()([surface, capacity, outsideFacilityWithDefaultIfNone, babyBed].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(strengthsItems), [viewWithDefaultIfNone])).filter(function (_ref) {
    var _ref$labels = _ref.labels,
        labels = _ref$labels === void 0 ? [] : _ref$labels;
    return labels.length && labels[0];
  });
}

function hasLowStock(threshold, stock) {
  return stock <= threshold;
}

function getAccommodationCategoryComfortIndex(category) {
  return _utils_accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(category.id);
}

function getBestAccommodationCategory(categories) {
  if (categories.length === 1) {
    return categories[0];
  }

  return lodash_fp_flow__WEBPACK_IMPORTED_MODULE_16___default()(lodash_fp_sortBy__WEBPACK_IMPORTED_MODULE_14___default()(getAccommodationCategoryComfortIndex), lodash_fp_last__WEBPACK_IMPORTED_MODULE_15___default.a)(categories);
}

var getAccommodationRoomsProps = function getAccommodationRoomsProps(_ref2) {
  var _ref2$accommodations = _ref2.accommodations,
      accommodations = _ref2$accommodations === void 0 ? [] : _ref2$accommodations,
      accommodationsCount = _ref2.accommodationsCount,
      attendeesWithDistributionData = _ref2.attendeesWithDistributionData,
      _ref2$proposal = _ref2.proposal,
      proposal = _ref2$proposal === void 0 ? {} : _ref2$proposal,
      remainingStock = _ref2.remainingStock,
      product = _ref2.product,
      streetViews = _ref2.streetViews,
      _ref2$isComparator = _ref2.isComparator,
      isComparator = _ref2$isComparator === void 0 ? false : _ref2$isComparator,
      _ref2$isInMoreRoomLay = _ref2.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref2$isInMoreRoomLay === void 0 ? false : _ref2$isInMoreRoomLay,
      alternatives = _ref2.alternatives;

  var sortedAccommodations = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(accommodations).sort(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__[/* compareAccommodationsByComfort */ "b"]).filter(Boolean);

  var sortedAttendees = {
    adults: attendeesWithDistributionData.filter(function (_ref3) {
      var type = _ref3.type;
      return type === ATTENDEE_CATEGORIES.ADULT;
    }),
    babies: attendeesWithDistributionData.filter(function (_ref4) {
      var type = _ref4.type;
      return type === ATTENDEE_CATEGORIES.BABY;
    }),
    children: attendeesWithDistributionData.filter(function (_ref5) {
      var type = _ref5.type;
      return type === ATTENDEE_CATEGORIES.CHILD;
    })
  };
  return sortedAccommodations.map(function (a) {
    var _a$attendeesDistribut, _proposal$attendees, _proposal$attendees$a, _proposal$attendees2, _proposal$attendees2$, _a$media, _proposal$attendees3, _proposal$attendees3$;

    var attendeesIds = (((_a$attendeesDistribut = a.attendeesDistribution) === null || _a$attendeesDistribut === void 0 ? void 0 : _a$attendeesDistribut.attendees) || []).map(function (at) {
      return at.id;
    });
    var matchingStreetViewElement = (streetViews === null || streetViews === void 0 ? void 0 : streetViews.length) ? streetViews.find(function (_ref6) {
      var accommodationCategoryId = _ref6.accommodationCategoryId;
      return accommodationCategoryId === a.categoryId;
    }) : {};
    var isPremium = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__[/* isPremiumAccommodation */ "v"])(a);
    var isExclusiveCollection = Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__[/* isExclusiveCollectionRoom */ "r"])(a, product);

    var getSplitServices = function getSplitServices(services) {
      var servicesToSplit = services.slice(0);

      if (isExclusiveCollection) {
        var mainServices = servicesToSplit.splice(0, 6);
        return [servicesToSplit, mainServices];
      }

      return [servicesToSplit];
    };

    var services = a.services && getSplitServices(a.services);

    var getServicesIconsList = function getServicesIconsList() {
      var _services$; // $FlowFixMe


      if ((services === null || services === void 0 ? void 0 : (_services$ = services[1]) === null || _services$ === void 0 ? void 0 : _services$.length) > 0) {
        // $FlowFixMe
        return services[1].map(function (_ref7) {
          var id = _ref7.id,
              label = _ref7.label;
          return {
            icon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"][id] || _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRIDENT1,
            labels: [label]
          };
        });
      }

      return null;
    };

    var currentComfortAlternatives = alternatives === null || alternatives === void 0 ? void 0 : alternatives.find(function (_ref8) {
      var categoryId = _ref8.categoryId;
      return categoryId === a.categoryId;
    });
    return {
      bathroomEquipments: a.bathroomEquipments,
      categoryId: a.categoryId,
      description: a.description,
      dates: {
        endDate: moment__WEBPACK_IMPORTED_MODULE_19___default()(a.endDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_26__[/* API_DATE_FORMAT */ "a"]).valueOf(),
        startDate: moment__WEBPACK_IMPORTED_MODULE_19___default()(a.startDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_26__[/* API_DATE_FORMAT */ "a"]).valueOf()
      },
      distribution: (sortedAccommodations.length > 1 || a.quantity > 1) && !!attendeesIds.length ? {
        adults: sortedAttendees.adults.filter(function (at) {
          return attendeesIds.includes(at.id);
        }),
        babies: sortedAttendees.babies.filter(function (at) {
          return attendeesIds.includes(at.id);
        }),
        children: sortedAttendees.children.filter(function (at) {
          return attendeesIds.includes(at.id);
        })
      } : null,
      equipments: a.equipments,
      hasArrangement: accommodations.length !== (accommodationsCount ? accommodationsCount : proposal === null || proposal === void 0 ? void 0 : proposal.accommodationsCount),
      hasDistribution: sortedAccommodations.length > 1 && !!attendeesIds.length,
      hasSharedRoom: ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$a = _proposal$attendees.adults) === null || _proposal$attendees$a === void 0 ? void 0 : _proposal$attendees$a.length) || 0) + ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees2 = proposal.attendees) === null || _proposal$attendees2 === void 0 ? void 0 : (_proposal$attendees2$ = _proposal$attendees2.children) === null || _proposal$attendees2$ === void 0 ? void 0 : _proposal$attendees2$.length) || 0) === 1 && product.id === 'KEMC',
      id: a.id,
      images: (((_a$media = a.media) === null || _a$media === void 0 ? void 0 : _a$media.photos) || []).map(function (m) {
        return {
          src: m.url
        };
      }),
      floorPlans: a.floorPlans,
      name: a.label,
      infosList: aggregateIconList(a.strengths, getSurfaceIconItem(a.roomType, product, a.surface), undefined, // $FlowFixMe
      getOutsideFacilitiesIconItem(a.outsideFacilities), getViewIconItem(a.view), getBabyBedIconItem(getNbBabies(a.occupancies)), isComparator, isInMoreRoomLayer, proposal, currentComfortAlternatives),
      servicesIconsList: getServicesIconsList(),
      isBestFamilyDeal: (a.familyRoom || a.connectingRoom) && ((proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees3 = proposal.attendees) === null || _proposal$attendees3 === void 0 ? void 0 : (_proposal$attendees3$ = _proposal$attendees3.children) === null || _proposal$attendees3$ === void 0 ? void 0 : _proposal$attendees3$.length) || 0) > 0,
      isCabin: product.isCruise,
      isPremium: isPremium,
      isExclusiveCollectionRoom: isExclusiveCollection,
      isExclusiveCollectionSpace: Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_27__[/* isExclusiveCollectionSpace */ "s"])(a, product),
      outsideFacilities: a.outsideFacilities,
      quantity: a.quantity,
      // $FlowFixMe
      services: services === null || services === void 0 ? void 0 : services[0],
      stock: remainingStock ? remainingStock : (proposal === null || proposal === void 0 ? void 0 : proposal.remainingStock) || 0,
      streetView: matchingStreetViewElement === null || matchingStreetViewElement === void 0 ? void 0 : matchingStreetViewElement.streetView,
      type: a.roomType
    };
  });
};

var getAccommodationProps = function getAccommodationProps(_ref9) {
  var _proposal$price;

  var _ref9$accommodations = _ref9.accommodations,
      accommodations = _ref9$accommodations === void 0 ? [] : _ref9$accommodations,
      accommodationsCount = _ref9.accommodationsCount,
      attendeesWithDistributionData = _ref9.attendeesWithDistributionData,
      _ref9$proposal = _ref9.proposal,
      proposal = _ref9$proposal === void 0 ? {} : _ref9$proposal,
      product = _ref9.product,
      remainingStock = _ref9.remainingStock,
      streetViews = _ref9.streetViews,
      _ref9$isComparator = _ref9.isComparator,
      isComparator = _ref9$isComparator === void 0 ? false : _ref9$isComparator,
      _ref9$isInMoreRoomLay = _ref9.isInMoreRoomLayer,
      isInMoreRoomLayer = _ref9$isInMoreRoomLay === void 0 ? false : _ref9$isInMoreRoomLay,
      _ref9$isUpgradableOnl = _ref9.isUpgradableOnline,
      isUpgradableOnline = _ref9$isUpgradableOnl === void 0 ? true : _ref9$isUpgradableOnl,
      alternatives = _ref9.alternatives;
  var rooms = getAccommodationRoomsProps({
    accommodations: accommodations,
    accommodationsCount: accommodationsCount,
    attendeesWithDistributionData: attendeesWithDistributionData,
    proposal: proposal,
    remainingStock: remainingStock,
    product: product,
    streetViews: streetViews,
    isComparator: isComparator,
    isInMoreRoomLayer: isInMoreRoomLayer,
    alternatives: alternatives
  });
  return {
    hasFlexRates: proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.hasFlexRates,
    isCabin: product.isCruise,
    isUpgradableOnline: isUpgradableOnline,
    proposal: proposal,
    rooms: rooms,
    stock: remainingStock ? remainingStock : (proposal === null || proposal === void 0 ? void 0 : proposal.remainingStock) || 0,
    streetViews: streetViews || []
  };
};


/***/ }),

/***/ "cdI6":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY) : [];
}

module.exports = flattenDeep;


/***/ }),

/***/ "cdJH":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var NATIVE_SYMBOL = __webpack_require__("1s2Y");
var fails = __webpack_require__("fhLv");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var toObject = __webpack_require__("A+R+");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "dATv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BookingFooter_BookingFooter; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// CONCATENATED MODULE: ./src/client/components/utils/booking-footer/bookingFooter.utils.js











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var mapFooterIconsToContactsBarTypes = {
  callMeBack: 'phone',
  phoneBubble: 'phone',
  storeLocator: 'storeLocator',
  faq: 'askQuestions',
  termsAndConditions: 'warning',
  mobileApp: 'smartphone',
  mail: 'mail'
};
var bookingFooter_utils_getDetailClickEventTrackingData = function getDetailClickEventTrackingData(type, href) {
  var _href$hostname, _href$hostname$call;

  var eventClick = _objectSpread({}, constants["k" /* EVENT_CLICK */]);

  var isWhatsapp = href === null || href === void 0 ? void 0 : (_href$hostname = href.hostname) === null || _href$hostname === void 0 ? void 0 : (_href$hostname$call = _href$hostname.call(href)) === null || _href$hostname$call === void 0 ? void 0 : _href$hostname$call.includes('whatsapp');
  eventClick.callMeBack = isWhatsapp ? constants["d" /* CALLMEBACK_EVENT */].whatsapp : constants["d" /* CALLMEBACK_EVENT */].phone;
  return eventClick[type];
};
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-footer/BookingFooterItem.jsx

var __jsx = react_default.a.createElement;







var BookingFooterItem_BookingFooterItem = function BookingFooterItem(_ref) {
  var href = _ref.href,
      text = _ref.text,
      type = _ref.type;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return __jsx("a", {
    className: "flex flex-col items-center text-center",
    "data-testid": "BookingFooterItem-".concat(type),
    target: "_blank",
    rel: "noopener noreferrer",
    href: href,
    onClick: function onClick() {
      var detailClick = bookingFooter_utils_getDetailClickEventTrackingData(type, href);
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_FOOTER, {
        detail_click: detailClick
      });
    }
  }, __jsx(Icon["a" /* Icon */], {
    name: (mapFooterIconsToContactsBarTypes === null || mapFooterIconsToContactsBarTypes === void 0 ? void 0 : mapFooterIconsToContactsBarTypes[type]) || icons["a" /* ICONS */].WARNING,
    width: "1.4375rem",
    className: "m-15",
    dataTestid: "BookingFooterItem-icon"
  }), text.map(function (txt, index) {
    return __jsx("p", {
      key: txt[index],
      className: Object(classnames_utils["a" /* classnames */])('text-14', {
        'font-bold': index === 0
      }, {
        'mb-10': index !== 0
      })
    }, txt);
  }));
};
// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-footer/BookingFooter.jsx













var BookingFooter_jsx = react_default.a.createElement;

function BookingFooter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingFooter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingFooter_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingFooter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var BookingFooter_BookingFooter = function BookingFooter(_ref) {
  var _footer$contactsBarBE;

  var footer = _ref.footer,
      className = _ref.className;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale; // we add number phone callCenter to link on click booking.callCenterPopIn.number


  var completedItemsFooter = (_footer$contactsBarBE = footer.contactsBarBE) === null || _footer$contactsBarBE === void 0 ? void 0 : _footer$contactsBarBE.map(function (item) {
    // phone number link
    if (item.href === '' && item.type === 'callMeBack') {
      return BookingFooter_objectSpread(BookingFooter_objectSpread({}, item), {}, {
        href: 'tel://' + Object(i18n["h" /* t */])('booking.callCenterPopIn.number').replace(/\s+/g, '')
      });
    } // store Locator link


    if (item.type === 'storeLocator') {
      return item;
    } // other links with locale


    return BookingFooter_objectSpread(BookingFooter_objectSpread({}, item), {}, {
      href: new URI_default.a(item.href).addQuery('locale', locale)
    });
  }); // for now the maximum active class in tailwind grid column is grid-cols-6
  // so if we have 0 or > 6 items we will use 6 columns which is the maximum
  // doesn't seem to work with media queries so ...

  var MAX_ITEMS_FOR_GRID_CSS = 6;
  var nbItems = completedItemsFooter === null || completedItemsFooter === void 0 ? void 0 : completedItemsFooter.length;
  var numberOfItemsMax6 = nbItems <= MAX_ITEMS_FOR_GRID_CSS ? nbItems : MAX_ITEMS_FOR_GRID_CSS;
  var gridClassDynamic = "md:grid-cols-".concat(numberOfItemsMax6);

  if (!completedItemsFooter) {
    return null;
  }

  return BookingFooter_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('w-ful flex items-center justify-center border-t-1', className)
  }, BookingFooter_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('grid grid-cols-2 items-start gap-20 p-20 md:w-1/2', gridClassDynamic)
  }, completedItemsFooter.map(function (footerItem, index) {
    var _completedItemsFooter;

    return BookingFooter_jsx(BookingFooterItem_BookingFooterItem, Object(esm_extends["a" /* default */])({
      key: "".concat((_completedItemsFooter = completedItemsFooter[index]) === null || _completedItemsFooter === void 0 ? void 0 : _completedItemsFooter.type, "-").concat(index * 2)
    }, footerItem));
  })));
};

/***/ }),

/***/ "dGyR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNSELECT_TRAVEL_COMPANION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return travelCompanionReducer; });
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_widgets_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ZHrn");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _proposals_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("UIAR");









var ADD_TRAVEL_COMPANION = 'ADD_TRAVEL_COMPANION';
var EDIT_TRAVEL_COMPANION = 'EDIT_TRAVEL_COMPANION';
var SELECT_TRAVEL_COMPANION = 'SELECT_TRAVEL_COMPANION';
var UNSELECT_TRAVEL_COMPANION = 'UNSELECT_TRAVEL_COMPANION';
var initialState = {
  list: [],
  selectedIndexes: []
};
var travelCompanionReducer = function travelCompanionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS_BY_ID */ "n"]):
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS */ "m"]):
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_7__["resolve"])(_proposals_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */ "o"]):
      {
        var attendees = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(action, 'payload.proposals.proposals.0.attendees', {});

        var _filterSearchedChildr = Object(_components_widgets_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_6__[/* filterSearchedChildren */ "b"])(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(action, 'payload.profile.travelCompanions', []), attendees),
            travelCompanions = _filterSearchedChildr.travelCompanions,
            selectedIndexes = _filterSearchedChildr.selectedIndexes;

        return {
          list: travelCompanions || [],
          selectedIndexes: selectedIndexes || []
        };
      }

    case ADD_TRAVEL_COMPANION:
      state.list.push(action.payload);
      return state;

    case EDIT_TRAVEL_COMPANION:
      var editedCompanionIndex = state.list.findIndex(function (_ref) {
        var companionId = _ref.companionId;
        return companionId === action.payload.companionId;
      });
      state.list[editedCompanionIndex] = action.payload;
      return state;

    case SELECT_TRAVEL_COMPANION:
      var selectedCompanionIndex = state.list.findIndex(function (_ref2) {
        var companionId = _ref2.companionId;
        return companionId === action.payload.companionId;
      });
      state.list[selectedCompanionIndex].isSelected = true;
      var parentIndex = action.payload.parentIndex;

      if (!state.selectedIndexes.map(function (_ref3) {
        var index = _ref3.index;
        return index;
      }).includes(parentIndex)) {
        state.selectedIndexes.push({
          index: parentIndex,
          position: action.payload.position
        });
      }

      return state;

    case UNSELECT_TRAVEL_COMPANION:
      var unselectedCompanionIndex = state.list.findIndex(function (_ref4) {
        var companionId = _ref4.companionId;
        return companionId === action.payload.companionId;
      });
      var unselectedParentIndex = state.selectedIndexes.findIndex(function (_ref5) {
        var index = _ref5.index,
            position = _ref5.position;
        return position === action.payload.position && index === action.payload.parentIndex;
      });
      state.list[unselectedCompanionIndex].isSelected = false;

      if (unselectedParentIndex !== -1) {
        state.selectedIndexes.splice(unselectedParentIndex, 1);
      }

      return state;

    default:
      return state;
  }
};

/***/ }),

/***/ "dNjr":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("F9U4");
var requireObjectCoercible = __webpack_require__("4gXF");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "dm5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioButtonWithIcon; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("/HC4");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;




var RadioButtonWithIcon = function RadioButtonWithIcon(_ref) {
  var icon = _ref.icon,
      isChecked = _ref.isChecked,
      title = _ref.title,
      description = _ref.description,
      value = _ref.value,
      name = _ref.name,
      priceDifference = _ref.priceDifference,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'RadioButtonWithIcon' : _ref$testId;
  return __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_4__[/* classnames */ "a"])('flex h-full flex-col overflow-hidden rounded-12 border-1 p-15 text-center leading-normal', {
      'border-lightGrey': !isChecked,
      'border-saffron': isChecked
    }),
    "data-testid": testId
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    className: "m-auto mb-10",
    dataTestid: "RadioButtonWithIcon-icon",
    name: icon,
    width: "2em"
  }), __jsx("div", {
    className: "w-full text-12 font-bold leading-tight"
  }, title), __jsx("div", {
    className: "w-full text-10 leading-tight text-black"
  }, description), __jsx("div", {
    className: "m-auto"
  }, __jsx(_frameworks_formik_FormikInput__WEBPACK_IMPORTED_MODULE_6__[/* FormikInput */ "a"], {
    className: "ml-10",
    name: name,
    value: value,
    type: "radio"
  })), !!priceDifference && __jsx("div", {
    className: "w-full text-12 font-bold leading-tight"
  }, priceDifference));
};

/***/ }),

/***/ "dpio":
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ "eGzU":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var tryToString = __webpack_require__("xS1b");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "eYK6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("lozs");


/***/ }),

/***/ "eZ08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectAttendeesByHouseholds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatHouseholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectAttendeesWithInfosByHouseholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addInfosToProposalAttendees; });
/* unused harmony export selectNumberOfHouseholds */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("PuIx");
/* harmony import */ var lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("zytj");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("WeO/");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("apzf");





















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var selectAttendeesByHouseholds = function selectAttendeesByHouseholds(state) {
  return state.booking.attendees.attendeesByHouseHolds;
};

var findFittingChild = function findFittingChild(childBirthdate, connectedUserInfo, childrenIds) {
  var _connectedUserInfo$tr;

  var siblinds = (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : (_connectedUserInfo$tr = connectedUserInfo.travelCompanions) === null || _connectedUserInfo$tr === void 0 ? void 0 : _connectedUserInfo$tr.filter(function (travelCompanion) {
    return moment__WEBPACK_IMPORTED_MODULE_21___default()(childBirthdate).isSame(travelCompanion.birthdate);
  })) || [];

  if (siblinds.length === 1 && !childrenIds.includes(siblinds[0].id)) {
    childrenIds.push(siblinds[0].id);
    return siblinds[0];
  }

  return null;
};

var formatHouseholds = function formatHouseholds(proposal, attendeesAfterPut) {
  var _proposal$households;

  return (proposal === null || proposal === void 0 ? void 0 : (_proposal$households = proposal.households) === null || _proposal$households === void 0 ? void 0 : _proposal$households.length) ? // $FlowFixMe
  proposal.households.map(function (household, index) {
    var _ref;

    var householdAttendees = (_ref = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])((household === null || household === void 0 ? void 0 : household.attendees) || [])) === null || _ref === void 0 ? void 0 : _ref.map(function (attendee) {
      var _proposal$attendees, _proposal$attendees$l;

      var attendeeWithInfos = proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$l = _proposal$attendees.list) === null || _proposal$attendees$l === void 0 ? void 0 : _proposal$attendees$l.find(function (att) {
        return attendee.customerId ? att.customerId === attendee.customerId : attendee.id === att.id;
      });
      var attendeeWithGmNumber = (attendeesAfterPut === null || attendeesAfterPut === void 0 ? void 0 : attendeesAfterPut.find(function (att) {
        return attendee.customerId ? att.customerId === attendee.customerId : attendee.id === att.id;
      })) || {};
      return lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19___default()(_objectSpread(_objectSpread({}, attendee), attendeeWithGmNumber), attendeeWithInfos || {}, function (a, b) {
        return a || b;
      });
    });
    return {
      all: householdAttendees,
      adults: householdAttendees === null || householdAttendees === void 0 ? void 0 : householdAttendees.filter(function (attendee) {
        return attendee.isAdult;
      }),
      children: (householdAttendees === null || householdAttendees === void 0 ? void 0 : householdAttendees.filter(function (attendee) {
        return !attendee.isAdult;
      })) || [],
      key: index
    };
  }) : [{
    all: [],
    adults: [],
    children: [],
    key: 0
  }];
};

var attendeeLabel = function attendeeLabel(proposalAttendee) {
  return Object(_utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_23__[/* getAttendeeNamePlaceholder */ "a"])(proposalAttendee, !proposalAttendee.isAdult, proposalAttendee.id === 'A');
};

var getAttendees = function getAttendees(_ref2) {
  var householdAttendees = _ref2.householdAttendees,
      householdId = _ref2.householdId,
      identifiedAttendees = _ref2.identifiedAttendees,
      connectedUserInfo = _ref2.connectedUserInfo;
  var childrenIds = [];
  return householdAttendees.map(function (_ref3, attendeeIndex) {
    var id = _ref3.id,
        customerId = _ref3.customerId,
        birthdate = _ref3.birthdate,
        neolid = _ref3.neolid,
        householdAttendee = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_ref3, ["id", "customerId", "birthdate", "neolid"]);

    var tripInformationAttendee = identifiedAttendees === null || identifiedAttendees === void 0 ? void 0 : identifiedAttendees.find(function (att) {
      return customerId ? att.customerId === customerId || att.neolid === customerId : att.id === id;
    });
    var connectedUserInfos = householdAttendee.isAdult && householdId === 0 && attendeeIndex === 0 && !!(connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.neolaneId) ? _objectSpread(_objectSpread({}, connectedUserInfo), {}, {
      neolid: connectedUserInfo.neolid || connectedUserInfo.customerId || connectedUserInfo.neolaneId,
      birthdate: connectedUserInfo.birthdate || connectedUserInfo.dateOfBirth,
      mobile: connectedUserInfo.mobilePhoneNumber
    }) : {};
    var child = findFittingChild(birthdate, connectedUserInfo, childrenIds) || {};

    var attendeeWithInfos = lodash_mergeWith__WEBPACK_IMPORTED_MODULE_19___default()(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      birthdate: birthdate,
      customerId: customerId,
      neolid: customerId
    }, householdAttendee), connectedUserInfos), !householdAttendee.isAdult ? lodash_omit__WEBPACK_IMPORTED_MODULE_18___default()(child, 'id') : {}), {}, {
      householdId: householdId,
      isChild: !householdAttendee.isAdult,
      // should be kept here to change all attendees last name in case of travel companions
      lastName: householdAttendee.lastName || (tripInformationAttendee === null || tripInformationAttendee === void 0 ? void 0 : tripInformationAttendee.lastName) || (!householdAttendee.isAdult ? child === null || child === void 0 ? void 0 : child.lastName : '') || (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.lastName),
      id: id,
      attendeeIndex: attendeeIndex
    }), tripInformationAttendee || {}, function (objValue, srcValue) {
      return objValue || srcValue;
    });

    var lastValue = {};

    for (var _i = 0, _Object$entries = Object.entries(attendeeWithInfos); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      lastValue[key] = value === null ? undefined : value;
    }

    return _objectSpread(_objectSpread({}, lastValue), {}, {
      name: attendeeLabel(lastValue)
    });
  });
};

var getFormattedHouseholds = function getFormattedHouseholds(_ref4) {
  var households = _ref4.households,
      tripInformationAttendees = _ref4.tripInformationAttendees,
      connectedUserInfo = _ref4.connectedUserInfo;
  return households === null || households === void 0 ? void 0 : households.map(function (_ref5, householdId) {
    var adults = _ref5.adults,
        children = _ref5.children;
    var newAdultsList = getAttendees({
      householdAttendees: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(adults),
      householdId: householdId,
      identifiedAttendees: tripInformationAttendees ? Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(tripInformationAttendees.adults) : [],
      connectedUserInfo: connectedUserInfo
    });
    var newChildrenList = children.length ? getAttendees({
      householdAttendees: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(children),
      householdId: householdId,
      identifiedAttendees: tripInformationAttendees ? Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(tripInformationAttendees.kids) : [],
      connectedUserInfo: connectedUserInfo
    }) : [];
    return {
      key: householdId,
      adults: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(newAdultsList),
      children: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(newChildrenList),
      all: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(newAdultsList), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(newChildrenList))
    };
  });
};

var selectAttendeesWithInfosByHouseholds = function selectAttendeesWithInfosByHouseholds(state) {
  var formattedHouseholds = selectAttendeesByHouseholds(state);
  var tripInformationAttendees = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__[/* tripInformationSelector */ "d"])(state);
  var connectedUserInfo = Object(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_24__[/* userInfoSelector */ "a"])(state) || {};

  try {
    var households = getFormattedHouseholds({
      households: formattedHouseholds,
      tripInformationAttendees: tripInformationAttendees,
      connectedUserInfo: connectedUserInfo
    });
    return {
      households: households,
      attendees: households.reduce(function (attendees, value) {
        return {
          adults: attendees.adults.concat(value.adults),
          children: attendees.children.concat(value.children),
          list: attendees.list.concat(value.all)
        };
      }, {
        list: [],
        adults: [],
        children: []
      })
    };
  } catch (error) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_20__["default"].error(error);
    return {
      households: [],
      attendees: {
        list: [],
        adults: [],
        children: []
      }
    };
  }
};
var addInfosToProposalAttendees = function addInfosToProposalAttendees(_ref6) {
  var proposal = _ref6.proposal,
      tripInformationAttendees = _ref6.tripInformationAttendees,
      connectedUserInfo = _ref6.connectedUserInfo;

  try {
    var formattedHouseholds = getFormattedHouseholds({
      households: formatHouseholds(proposal),
      tripInformationAttendees: tripInformationAttendees,
      connectedUserInfo: connectedUserInfo
    });
    var formattedAttendees = {
      list: [],
      adults: [],
      children: []
    };
    formattedHouseholds.map(function (value) {
      formattedAttendees.adults = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(formattedAttendees.adults), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(value.adults));
      formattedAttendees.children = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(formattedAttendees.children), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(value.children));
      formattedAttendees.list = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(formattedAttendees.list), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(value.all));
    });
    return {
      households: formattedHouseholds,
      attendees: formattedAttendees
    };
  } catch (error) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_20__["default"].error(error);
    return {
      households: [{
        all: [],
        adults: [],
        children: [],
        key: 0
      }],
      attendees: {
        list: [],
        adults: [],
        children: []
      }
    };
  }
};
var selectNumberOfHouseholds = function selectNumberOfHouseholds(state) {
  return state.booking.attendees.numberOfHouseHolds;
};

/***/ }),

/***/ "ep/x":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "fWEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductFavorite; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C/y5");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("VHif");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qBqs");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;





var ProductFavorite = function ProductFavorite(_ref) {
  var className = _ref.className,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].STAR_HOLLOW : _ref$iconName,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$total = _ref.total,
      total = _ref$total === void 0 ? 0 : _ref$total,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "iconName", "isDisabled", "total"]);

  return __jsx("button", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_3__[/* classnames */ "a"])('flex items-center justify-center leading-loose text-inherit', className),
    disabled: isDisabled,
    type: "button"
  }), __jsx("span", {
    className: "relative isolate flex"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_5__[/* Icon */ "a"], {
    name: iconName,
    width: "1.5rem"
  }), Boolean(total) && __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_4__[/* Badge */ "a"], {
    className: "top-O absolute end-0 -me-10 -mt-5 size-[21px] border-white bg-success text-12 font-bold text-white",
    label: total,
    variant: "pill"
  })));
};

/***/ }),

/***/ "fhLv":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "g51W":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var definePropertyModule = __webpack_require__("87KK");
var createPropertyDescriptor = __webpack_require__("OouP");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "gIGD":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("XywU");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "gp/v":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "hU7e":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var hasOwn = __webpack_require__("/GgU");
var isSymbol = __webpack_require__("km0D");
var tryToString = __webpack_require__("xS1b");
var shared = __webpack_require__("8+jV");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("6qX7");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "hfZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTestContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ABTestContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "hqKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "i2OK":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var defineBuiltIn = __webpack_require__("Swp0");
var toString = __webpack_require__("3dm5");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "iBXc":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__("EVS9");
var anObject = __webpack_require__("ep/x");
var aPossiblePrototype = __webpack_require__("2CYk");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "ieZH":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toObject = __webpack_require__("A+R+");
var nativeGetPrototypeOf = __webpack_require__("yvHl");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "jCye":
/***/ (function(module, exports, __webpack_require__) {

var isConstructor = __webpack_require__("ydRd");
var tryToString = __webpack_require__("xS1b");

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "jLkM":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("s+R0");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ "k4ez":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("a4SZ");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "kD1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfigWithNoThirdPartySupport; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1mr4");
/* harmony import */ var lodash_has__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_has__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_11__);










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



 // makes inexact to allow other query params

var shouldIgnoreThirdParty = function shouldIgnoreThirdParty(queryParams) {
  return lodash_has__WEBPACK_IMPORTED_MODULE_9___default()(queryParams, _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["appQueryParameters"].noThirdParty);
};

var appLocaleConfig;
var getConfigWithNoThirdPartySupport = function getConfigWithNoThirdPartySupport(_ref) {
  var name = _ref.name,
      locale = _ref.locale,
      queryParams = _ref.queryParams; // cache if on browser

  if (!appLocaleConfig || false) {
    appLocaleConfig = _config__WEBPACK_IMPORTED_MODULE_11___default.a.locale(locale);
  }

  var originalConfig = appLocaleConfig.get(name);
  return shouldIgnoreThirdParty(queryParams) ? _objectSpread(_objectSpread({}, originalConfig), {}, {
    enabled: false
  }) : originalConfig;
};

/***/ }),

/***/ "kH/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addressFragment; });
var addressFragment = "\nfragment Address on Address {\n    additionalInformation1\n    additionalInformation2\n    addOn\n    city\n    country\n    countryCode\n    stateOrDistrict\n    streetName\n    streetNumber\n    town\n    zipCode\n  }\n";

/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return synchronizeChildcareQPWithKidsQP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customFacetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return facetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getActiveFacetsFromQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateActiveFacetsQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasDepartureCityAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterFacetsToHide; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDepartureDateDisplayValue; });
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getInactiveFacetValues; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("i4UL");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VqLN");
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("LqLs");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("zygG");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("15pl");
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("sW3P");
































var _facetsQueryParamMapp;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_CRITERIA_FACET_ID */ "d"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_CITY_FACET_ID */ "r"]);
}

function getInactiveFacetValues(facets, activeFacets, facetId) {
  var _matchingFacet$list$m, _matchingFacet$list, _activeFacets$facetId;

  var _facets$filter = facets.filter(function (_ref) {
    var id = _ref.id;
    return id === facetId;
  }),
      _facets$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_facets$filter, 1),
      matchingFacet = _facets$filter2[0];

  var matchingFacetValues = (_matchingFacet$list$m = matchingFacet === null || matchingFacet === void 0 ? void 0 : (_matchingFacet$list = matchingFacet.list) === null || _matchingFacet$list === void 0 ? void 0 : _matchingFacet$list.map(function (_ref2) {
    var value = _ref2.value;
    return value;
  })) !== null && _matchingFacet$list$m !== void 0 ? _matchingFacet$list$m : [];
  var matchingActiveFacetValues = Object.keys((_activeFacets$facetId = activeFacets[facetId]) !== null && _activeFacets$facetId !== void 0 ? _activeFacets$facetId : {});
  return matchingFacetValues.filter(function (option) {
    return !matchingActiveFacetValues.includes(option);
  });
}

function filterFacetsToHide(facets, facetsToHide) {
  var facetIdsWithOptionsToHide = Object.keys(facetsToHide !== null && facetsToHide !== void 0 ? facetsToHide : {});
  return facets.map(function (facet) {
    if (facetIdsWithOptionsToHide.includes(facet.id)) {
      return _objectSpread(_objectSpread({}, facet), {}, {
        list: facet.list.filter(function (_ref3) {
          var value = _ref3.value;
          return !facetsToHide[facet.id].includes(value);
        })
      });
    }

    return facet;
  });
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facet, 'selected');
  });
  return selectedCity ? lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_31___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(timestampDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_31___default()(), 'day') : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_31___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"]) {
    return lodash_times__WEBPACK_IMPORTED_MODULE_30___default()(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_31___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function convertQueryParamToKids(value) {
  if (!value) {
    return [];
  }

  return value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
}

function convertKidsToChildcareQueryParam(_ref4) {
  var departureDate = _ref4.departureDate,
      kids = _ref4.kids;

  if (!departureDate) {
    return [];
  }

  return kids.reduce(function (acc, _ref5) {
    var birthdate = _ref5.birthdate;
    return birthdate ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(acc), [moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate).diff(moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate), 'months')]) : acc;
  }, []).map(function (diffInMonths) {
    if (diffInMonths >= 4 && diffInMonths < 24) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_0_TO_2 */ "i"];
    }

    if (diffInMonths >= 24 && diffInMonths < 48) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_2_TO_3 */ "k"];
    }

    if (diffInMonths >= 48 && diffInMonths < 132) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_4_TO_10 */ "l"];
    }

    if (diffInMonths >= 132 && diffInMonths < 216) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_11_TO_17 */ "j"];
    }

    return '';
  }).filter(Boolean);
}

function unserializeKidsFromQueryParam(value, isSeller) {
  var maxKidsNumber = isSeller ? _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX_SELLER */ "H"] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"];

  if (!value) {
    return [];
  }

  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > maxKidsNumber) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) {
    return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]));
  }

  var kids = convertQueryParamToKids(value);
  return kids.length > maxKidsNumber ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref6, index) {
    var birthdate = _ref6.birthdate,
        childcareIncluded = _ref6.childcareIncluded;

    if (!birthdate || !kidsValidationState || (kidsValidationState === null || kidsValidationState === void 0 ? void 0 : kidsValidationState.length) > 0 && kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"]);
    return childcareIncluded ? "".concat(formattedBirthdate).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });
    return childcareIncluded ? "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]);
};
var synchronizeChildcareQPWithKidsQP = function synchronizeChildcareQPWithKidsQP(_ref7) {
  var childcareFacetQueryParam = _ref7.childcareFacetQueryParam,
      departureDate = _ref7.departureDate,
      departureDateQueryParam = _ref7.departureDateQueryParam,
      kids = _ref7.kids,
      _ref7$kidsQueryParam = _ref7.kidsQueryParam,
      kidsQueryParam = _ref7$kidsQueryParam === void 0 ? '' : _ref7$kidsQueryParam;
  var previousDepartureDate = formatDepartureDateForStore(departureDateQueryParam, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]);
  var previousKids = convertQueryParamToKids(kidsQueryParam);
  var previousChildcareIncluded = previousKids.some(function (kid) {
    return kid.childcareIncluded;
  });
  var childcareIncluded = kids.some(function (kid) {
    return kid.childcareIncluded;
  });

  if (!childcareIncluded && !previousChildcareIncluded) {
    // childcareIncluded checkbox unchecked and unchanged => no override
    return undefined;
  }

  var childcareRemoved = previousChildcareIncluded && !childcareIncluded;
  var kidsRemoved = previousKids.length > 0 && kids.length === 0;

  if (childcareRemoved || kidsRemoved) {
    // childcareIncluded checkbox unchecked or kids removed from FilterWho => reset childcare filter
    return '';
  } // childcareIncluded checkbox checked => override childcare filter with matching kids age range and existing childcare options


  var childcareFilterOptionsFromPreviousKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: previousDepartureDate,
    kids: previousKids
  })));

  var childcareFilterOptionsFromKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: departureDate,
    kids: kids
  })));

  var childcareFilterOptionsToRemove = childcareFilterOptionsFromPreviousKids.filter(function (option) {
    return !childcareFilterOptionsFromKids.includes(option);
  });
  var chilcareFilterOptions = childcareFacetQueryParam.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set([].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(childcareFilterOptionsFromKids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(chilcareFilterOptions.filter(function (option) {
    return !childcareFilterOptionsToRemove.includes(option);
  }))))).filter(Boolean).join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref8) {
  var birthdate = _ref8.birthdate,
      departureDate = _ref8.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_31___default()().add(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "s"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};
var customFacetsQueryParamMapping = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_34__[/* FLIGHT_DURATION_FACET_ID */ "C"], 'f');
var facetsQueryParamMapping = (_facetsQueryParamMapp = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* ACTIVITIES_FACET_ID */ "a"], 'a'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_ID */ "f"], 'ch'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* COUNTRIES_FACET_ID */ "m"], 'c'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DESTINATIONS_FACET_ID */ "w"], 'd'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"], 's'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* TYPES_OF_STAY_FACET_ID */ "Z"], 't'), _facetsQueryParamMapp);
var getActiveFacetsFromQueryParams = function getActiveFacetsFromQueryParams(queryParams, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var _queryParams$queryPar;

    var activeFacets = ((_queryParams$queryPar = queryParams[queryParamMapping[facetId]]) === null || _queryParams$queryPar === void 0 ? void 0 : _queryParams$queryPar.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"])) || [];
    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, facetId, activeFacets.reduce(function (acc, activeFacet) {
      var facet = decodeURI(activeFacet);

      if (facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"]) {
        var _SEASON_FACET_QUERY_P;

        facet = (_SEASON_FACET_QUERY_P = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_EN_TO_FR */ "U"][facet]) !== null && _SEASON_FACET_QUERY_P !== void 0 ? _SEASON_FACET_QUERY_P : facet;
      }

      acc[facet] = true;
      return acc;
    }, {})));
    return facets;
  }, {});
};
var generateActiveFacetsQueries = function generateActiveFacetsQueries(activeFacets, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var facet = Object.keys(activeFacets[facetId] || {});

    if (facet.length && facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "R"]) {
      facet = facet.map(function (label) {
        var _SEASON_FACET_QUERY_P2;

        return (_SEASON_FACET_QUERY_P2 = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_FR_TO_EN */ "V"][label]) !== null && _SEASON_FACET_QUERY_P2 !== void 0 ? _SEASON_FACET_QUERY_P2 : label;
      });
    }

    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, queryParamMapping[facetId], facet.length ? facet.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]) : undefined));
    return facets;
  }, {});
};
var hasDepartureCityAvailable = function hasDepartureCityAvailable(departureCities, departureCity) {
  return departureCities === null || departureCities === void 0 ? void 0 : departureCities.some(function (_ref9) {
    var value = _ref9.value;
    return value === departureCity;
  });
};


/***/ }),

/***/ "kZDm":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("vCWs");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "kdyR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasAcceptedCookies */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAnalyticsEnabled; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_components_widgets_cookie_warning_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("+LXU");
/* harmony import */ var _locale_localeUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("1tzK");





var hasAcceptedCookies = function hasAcceptedCookies() {
  var didomiCookieValue = js_cookie__WEBPACK_IMPORTED_MODULE_2___default.a.get(_client_components_widgets_cookie_warning_constants__WEBPACK_IMPORTED_MODULE_3__[/* COOKIE_PREFERENCES_DIDOMI_CONSENT */ "b"]);
  return !!didomiCookieValue && didomiCookieValue.includes('c:ga-');
};

var isAnalyticsEnabled = function isAnalyticsEnabled() {
  return !Object(_locale_localeUtils__WEBPACK_IMPORTED_MODULE_4__[/* isLocaleToDisplayDidomi */ "b"])() || hasAcceptedCookies();
};



/***/ }),

/***/ "kjCq":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("yhbn");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "km0D":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");
var isCallable = __webpack_require__("ANQd");
var isPrototypeOf = __webpack_require__("VXxY");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "knRJ":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    basePullAt = __webpack_require__("A0C2");

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),

/***/ "l6h7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var defineGlobalProperty = __webpack_require__("9vpE");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "lPgN":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("MaE1");
var hasOwn = __webpack_require__("/GgU");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineProperty = __webpack_require__("87KK").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "lZ21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOMMODATION_COMFORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORRESPONDANCE_ROOM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROOM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VILLETA_ROOM_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORRESPONDENCE_CABIN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CABIN_TYPE; });
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);




/**
 * @see src/components/utils/icon/icons.js l40
 */
var ACCOMMODATION_COMFORT_ORDER = ['000017', // club
'000048', // club seaside view
'000022', // superior
'000061', // superior
'000018', // deluxe
'000039', // deluxe zen
'000047', // deluxe seaside view
'000056', // Deluxe Exclusive
'000019', // suite
'000020', // suite 5 tridents
'000024', // chalet
'000038', // villa
'000040' // oasis family
];
var SINGLE_ROOM = 'simpleRoom';
var SEPARATE_ROOMS = 'separatedRooms';
var CONNECTING_ROOMS = 'simpleRooms';
var SEPARATE_ROOMS_3 = 'separatedRooms3';
var CORRESPONDANCE_ROOM_TYPE = {
  SINGLE_ROOM: SINGLE_ROOM,
  SEPARATE_ROOMS: SEPARATE_ROOMS,
  CONNECTING_ROOMS: CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS
};
var CORRESPONDENCE_CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins'
};
var ROOM_TYPE = {
  SINGLE_ROOM: SINGLE_ROOM,
  SEPARATE_ROOMS: SEPARATE_ROOMS,
  CONNECTING_ROOMS: CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS_3
};
var CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins3'
};
var VILLETA_ROOM_REGEX = new RegExp(/^(B2|B2\+|B2T)+$/);


/***/ }),

/***/ "ldqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_TRANSPORT_STATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchTransportStations; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("WGoB");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rJ95");







var FETCH_TRANSPORT_STATIONS = 'FETCH_TRANSPORT_STATIONS';

var formatTransportStationsNames = function formatTransportStationsNames(node) {
  return node.map(function (transport) {
    return {
      value: transport.id,
      label: transport.label,
      name: Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_4__[/* getTravelSectionSummary */ "c"])({
        travelSection: transport
      })
    };
  });
};

var transportStationFragment = "\n    fragment transportStation on TransportStationType {\n      id\n      label\n      city_id\n      type\n      is_main_city_station\n    }";

function fetchTransportStationsQuery(cityId, appContext) {
  var query = "{\n      transportStations(cityId: \"".concat(cityId, "\"){\n        airports {\n          ...transportStation\n        }\n        trainStations {\n          ...transportStation\n        }\n        ports {\n          ...transportStation\n        }\n      }\n    }\n    ").concat(transportStationFragment);
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* CITIES_GET_TRANSPORT_STATIONS */ "b"]
  }).then(function (_ref) {
    var _ref$transportStation = _ref.transportStations,
        airports = _ref$transportStation.airports,
        trainStations = _ref$transportStation.trainStations,
        ports = _ref$transportStation.ports;
    return {
      airports: formatTransportStationsNames(airports),
      trainStations: formatTransportStationsNames(trainStations),
      ports: formatTransportStationsNames(ports)
    };
  });
}

function fetchTransportStations(cityId, appContext) {
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(FETCH_TRANSPORT_STATIONS, cityId));
    return fetchTransportStationsQuery(cityId, appContext).then(function (response) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["resolve"])(FETCH_TRANSPORT_STATIONS), response));
      return response;
    })["catch"](function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_2__["reject"])(FETCH_TRANSPORT_STATIONS)));
      throw error;
    });
  };
}



/***/ }),

/***/ "m9Sl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ENTRY_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UNSET_ENTRY_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return entryRouteReducer; });
var SET_ENTRY_ROUTE = 'SET_ENTRY_ROUTE';
var UNSET_ENTRY_ROUTE = 'UNSET_ENTRY_ROUTE';
var initialState = '';
var entryRouteReducer = function entryRouteReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_ENTRY_ROUTE:
      return action.payload;

    case UNSET_ENTRY_ROUTE:
      return initialState;

    default:
      return state;
  }
};

/***/ }),

/***/ "mbB6":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIteratee = __webpack_require__("S3pA"),
    baseMap = __webpack_require__("bFjY"),
    isArray = __webpack_require__("wxYD");

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ "mmil":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("8+jV");
var uid = __webpack_require__("rvZv");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "mu8A":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var hasOwn = __webpack_require__("/GgU");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "mwRp":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("E+Ue");
var aCallable = __webpack_require__("eGzU");
var NATIVE_BIND = __webpack_require__("vCWs");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "nHh7":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var hasOwn = __webpack_require__("/GgU");
var toString = __webpack_require__("vnfA");
var shared = __webpack_require__("8+jV");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("6qX7");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "nJrx":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var shared = __webpack_require__("8+jV");
var hasOwn = __webpack_require__("/GgU");
var uid = __webpack_require__("rvZv");
var NATIVE_SYMBOL = __webpack_require__("1s2Y");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "naLQ":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    createWrap = __webpack_require__("P+cI"),
    getHolder = __webpack_require__("4mQY"),
    replaceHolders = __webpack_require__("AeOa");

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),

/***/ "nnO8":
/***/ (function(module, exports) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("aPQG");
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("igjW");











function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var ErrorBoundaryComponent = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(ErrorBoundaryComponent, _React$Component);

  var _super = _createSuper(ErrorBoundaryComponent);

  function ErrorBoundaryComponent(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, ErrorBoundaryComponent);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(ErrorBoundaryComponent, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_12__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          router = _this$props.router,
          children = _this$props.children;

      if (this.state.hasError) {
        if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_13__[/* isStrictlyProductionEnv */ "f"])()) {
          var locale = router.query.locale;
          router.replace({
            pathname: '/500',
            query: Boolean(locale) && {
              locale: locale
            }
          });
          this.setState({
            hasError: false
          });
        }

        return null;
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundaryComponent;
}(react__WEBPACK_IMPORTED_MODULE_10___default.a.Component);

var ErrorBoundary = Object(next_router__WEBPACK_IMPORTED_MODULE_11__["withRouter"])(ErrorBoundaryComponent);

/***/ }),

/***/ "oL6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ERROR_MESSAGES */
/* unused harmony export buildTransportKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areAnyTimeSlotIdsPresent; });
/* unused harmony export getAccommodationComfortIndex */
/* unused harmony export getAdultsCount */
/* unused harmony export getPackage */
/* unused harmony export getCurrency */
/* unused harmony export getRONPackage */
/* unused harmony export getKidsCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFormattedArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFormattedDepartureDate; });
/* unused harmony export hasAllInclusive */
/* unused harmony export hasChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasChildcare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTotalPriceFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMainHouseholdAttendee; });
/* unused harmony export hasTransport */
/* unused harmony export isTransportATrain */
/* unused harmony export isCharterFlight */
/* unused harmony export isDateAfterOptionRange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isOptionAllowed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isRecommendedTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return saveRecommendedTransport; });
/* unused harmony export getArrivalDate */
/* unused harmony export getTripArrival */
/* unused harmony export getTripDeparture */
/* unused harmony export hasAccomodation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareAccommodationsByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return compareProposalsByComfort; });
/* unused harmony export getNbParticipants */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hasErroredProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return hasFetchProposalsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getResolvedProposals; });
/* unused harmony export getSelectedProposal */
/* unused harmony export getSelectedProposalById */
/* unused harmony export getStockWarning */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTotalValue; });
/* unused harmony export getFormatedPrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFormatedPriceByLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPriceDiff; });
/* unused harmony export hasTransportOrTransferSelected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDefaultProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isPremiumAccommodation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isExclusiveCollectionRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isExclusiveCollectionSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getQuickSearchErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isExpiredDepartureDate; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("LqLs");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("CzFL");
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_snakeCase__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var lodash_nth__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("Hz96");
/* harmony import */ var lodash_nth__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_nth__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("6R5o");
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _client_local_storage_api__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("1RIK");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("ldK3");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("kiXb");
/* harmony import */ var _accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("lZ21");
/* harmony import */ var _booking_process_constants__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("XpIN");
/* harmony import */ var _label_labelUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("WGoB");
/* harmony import */ var _currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("wz9x");
/* harmony import */ var _client_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("z8xc");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("tI+f");































var OPTIONS_DAYS_RANGE = 29;
var DEFAULT_STOCK_WARNING_LIMIT = 2;
var TWO_WEEKS_IN_MS = 14 * 24 * 3600 * 1000;

function getAccommodationComfortIndex(accommodation) {
  return _accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_25__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(accommodation, 'categoryId'));
}

function compareProposalsByComfort(proposal1, proposal2) {
  var proposal1Index = getAccommodationComfortIndex(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal1, 'accommodations[0]'));
  var proposal2Index = getAccommodationComfortIndex(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal2, 'accommodations[0]')); // if we have not sorted the accommodation we don't change the order returned by the api

  if (proposal1Index === -1 || proposal2Index === -1) {
    return 0;
  }

  return proposal1Index - proposal2Index;
}

function compareAccommodationsByComfort(accommodation1, accommodation2) {
  return getAccommodationComfortIndex(accommodation1) - getAccommodationComfortIndex(accommodation2);
}

function areAnyTimeSlotIdsPresent(attendees, targetIds) {
  var targetSet = new Set(targetIds);
  return attendees.some(function (attendee) {
    return attendee.schedules.some(function (schedule) {
      return schedule.timeSlots.some(function (slot) {
        return targetSet.has(slot.id);
      });
    });
  });
}

function isCharterFlight(cancellationPolicy) {
  return [_booking_process_constants__WEBPACK_IMPORTED_MODULE_26__[/* LEGAL_INFO_THEO_ID */ "e"], _booking_process_constants__WEBPACK_IMPORTED_MODULE_26__[/* LEGAL_INFO_WEBTHEO_ID */ "f"]].includes(cancellationPolicy);
}

function isDateAfterOptionRange(date) {
  return date && date.isValid() && date.diff(moment__WEBPACK_IMPORTED_MODULE_21___default()(), 'days') >= OPTIONS_DAYS_RANGE;
}

function isOptionAllowed(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'optionAvailable');
}

function getAdultsCount(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'attendees.adults.length', 1);
}

function getCurrency(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'price.currency');
}

function getKidsCount(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'attendees.children.length', 0);
}

function getTotalPriceFormatted(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'price.total.formattedValue');
}

function getArrivalDate(proposal) {
  return Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_23__[/* momentFromApiDate */ "j"])(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'arrivalDate'));
}

function getTripDeparture(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports.inbound.travelSections[0].departure.label', '');
}

function getTripArrival(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports.outbound.travelSections[0].departure.label', '');
}

function hasChildren(proposal) {
  return getKidsCount(proposal) > 0;
}

function hasChildcare(proposal) {
  return proposal.additionalServices.childcares.length > 0;
}

function hasAllInclusive(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'packageId') === _constants__WEBPACK_IMPORTED_MODULE_30__[/* PACKAGE_ALL_INCLUSIVE */ "f"];
}

function getFormattedDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD MMMM YYYY';
  return Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_23__[/* momentFromApiDate */ "j"])(date).format(dateFormat);
}

function getFormattedArrivalDate(proposal, dateFormat) {
  return getFormattedDate(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'arrivalDate'), dateFormat);
}

function getFormattedDepartureDate(proposal, dateFormat) {
  return getFormattedDate(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'departureDate'), dateFormat);
}

function getRONPackage(proposal) {
  var packages = lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'packages') || [];
  return lodash_find__WEBPACK_IMPORTED_MODULE_19___default()(packages, function (pkg) {
    return pkg.id === _constants__WEBPACK_IMPORTED_MODULE_30__[/* PACKAGE_ROOM_ONLY */ "h"];
  });
}

function getPackage(proposal, packageId) {
  var packages = lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'packages') || [];
  return lodash_find__WEBPACK_IMPORTED_MODULE_19___default()(packages, function (pkg) {
    return (pkg === null || pkg === void 0 ? void 0 : pkg.id) === packageId;
  }) || {};
}

function hasTransport(proposal) {
  return !!lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports');
}

function hasTransfer(proposal) {
  return hasTransport(proposal) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17___default()(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'additionalServices.transfers'));
}

function hasTransportOrTransferSelected(proposal) {
  return hasTransport(proposal) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_17___default()((proposal.additionalServices.transfers || []).filter(function (transfer) {
    return transfer.pricingInfo.isFullyRented;
  }));
}

function isTransportATrain(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports.inbound.travelSections[0].transport.type') === 'TRAIN' && lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'transports.outbound.travelSections[0].transport.type') === 'TRAIN';
}

function hasAccomodation(proposal) {
  return !!lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'accommodations.length');
}

function getResolvedProposals(proposals) {
  return proposals.filter(function (p) {
    return !p.errorCode;
  });
}

function hasErroredProposals(proposals) {
  return proposals.some(function (p) {
    return p.errorCode;
  });
}

function hasFetchProposalsFailed(_ref) {
  var _proposals$, _proposals$$price;

  var errors = _ref.errors,
      proposals = _ref.proposals;
  return errors && errors.length > 0 || hasErroredProposals(proposals) || !proposals || proposals.length === 0 || ((_proposals$ = proposals[0]) === null || _proposals$ === void 0 ? void 0 : (_proposals$$price = _proposals$.price) === null || _proposals$$price === void 0 ? void 0 : _proposals$$price.gap) >= _constants__WEBPACK_IMPORTED_MODULE_30__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "i"];
}

function getSelectedProposal(proposals, selectedProposalIndex) {
  return lodash_nth__WEBPACK_IMPORTED_MODULE_18___default()(proposals, selectedProposalIndex);
}

function getSelectedProposalById(proposals, selectedProposalId) {
  return proposals.find(function (proposal) {
    return proposal.id === selectedProposalId;
  }) || proposals[0];
}

function getStockWarning(i18n, remainingStock) {
  return {
    showStockWarning: remainingStock <= lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(i18n, 'stockWarningLimit', DEFAULT_STOCK_WARNING_LIMIT),
    stockWarning: "".concat(remainingStock, " ").concat(Object(_label_labelUtils__WEBPACK_IMPORTED_MODULE_27__[/* pluralizeLabel */ "d"])(lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(i18n, 'room', ''), lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(i18n, 'rooms', ''), remainingStock))
  };
}

function getNbParticipants(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'attendees.list.length', 0);
}

function getTotalValue(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'price.total.value', 0);
}

function getFormatedPrice(formatedPrice, amount) {
  if (amount === 0) {
    return "".concat(formatedPrice);
  }

  return amount > 0 ? "+".concat(formatedPrice) : "-".concat(formatedPrice);
}

function getFormatedPriceByLocale(price, locale, currency) {
  return getFormatedPrice(Object(_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_28__[/* formatAmountForLocale */ "b"])(Math.abs(price), locale, currency), price);
}

function getPriceDiff(proposalPrice, selectedProposalPrice, locale, currency) {
  var diffPrice = proposalPrice - selectedProposalPrice;
  return diffPrice === 0 ? null : getFormatedPriceByLocale(diffPrice, locale, currency);
}

var getDefaultProposal = function getDefaultProposal(proposals, resort) {
  /**
   * There is a random corner case that make selectedProposal as undefined
   * It should be the default one (mainly the first one).
   * Maybe proposals array is empty at some point...
   * Unable to reproduce the bug... See BookingEngine.container
   */
  var firstProposal = proposals[0] || {};

  if (resort && resort.id === _constants__WEBPACK_IMPORTED_MODULE_30__[/* CEFALU_RESORT */ "a"]) {
    var deluxeProposal = proposals.find(function (proposal) {
      return lodash_get__WEBPACK_IMPORTED_MODULE_20___default()(proposal, 'accommodations[0].comfortType') === _constants__WEBPACK_IMPORTED_MODULE_30__[/* DELUXE_COMFORT */ "e"];
    });
    return deluxeProposal ? deluxeProposal : firstProposal;
  }

  return firstProposal;
};

var isPremiumAccommodation = function isPremiumAccommodation(accommodation) {
  return !!(accommodation.comfortId && [_constants__WEBPACK_IMPORTED_MODULE_30__[/* COMFORT_TYPE_SUITE */ "c"], _constants__WEBPACK_IMPORTED_MODULE_30__[/* COMFORT_TYPE_CHALET */ "b"], _constants__WEBPACK_IMPORTED_MODULE_30__[/* COMFORT_TYPE_VILLA */ "d"]].includes(accommodation.comfortId));
};

var isExclusiveCollectionRoom = function isExclusiveCollectionRoom(accommodation, product) {
  return accommodation.exclusiveCollection || Number(product === null || product === void 0 ? void 0 : product.comfort) >= 5;
};

var isExclusiveCollectionSpace = function isExclusiveCollectionSpace(accommodation, product) {
  return accommodation.exclusiveCollection && (product === null || product === void 0 ? void 0 : product.comfort) === 4;
};

function buildTransportDetailKey(transportDetail) {
  return transportDetail.travelSections.map(function (section) {
    var _section$transport, _section$transport2, _section$transport2$c, _section$departure, _section$departure2, _section$departure3, _section$arrival, _section$arrival2, _section$arrival3;

    var transportClass = _client_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_29__[/* TRANSPORT_CLASS_TO_I18N */ "f"][(_section$transport = section.transport) === null || _section$transport === void 0 ? void 0 : _section$transport["class"]];
    var company = "".concat(transportClass).concat(((_section$transport2 = section.transport) === null || _section$transport2 === void 0 ? void 0 : (_section$transport2$c = _section$transport2.companyOperator) === null || _section$transport2$c === void 0 ? void 0 : _section$transport2$c.id) || '');
    return "".concat((_section$departure = section.departure) === null || _section$departure === void 0 ? void 0 : _section$departure.id).concat((_section$departure2 = section.departure) === null || _section$departure2 === void 0 ? void 0 : _section$departure2.date).concat((_section$departure3 = section.departure) === null || _section$departure3 === void 0 ? void 0 : _section$departure3.time, "-").concat((_section$arrival = section.arrival) === null || _section$arrival === void 0 ? void 0 : _section$arrival.id).concat((_section$arrival2 = section.arrival) === null || _section$arrival2 === void 0 ? void 0 : _section$arrival2.date).concat((_section$arrival3 = section.arrival) === null || _section$arrival3 === void 0 ? void 0 : _section$arrival3.time, "-").concat(company);
  }).join(':');
}

var buildTransportKey = function buildTransportKey(transport) {
  return "".concat(buildTransportDetailKey(transport.inbound), "/").concat(buildTransportDetailKey(transport.outbound));
};

var isRecommendedTransport = function isRecommendedTransport(transport, proposalId) {
  if (!transport || !transport.inbound || !transport.outbound) {
    return false;
  }

  return buildTransportKey(transport) === Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_22__[/* getFromLocalStorage */ "a"])("recommendedTransport-".concat(proposalId));
};

var saveRecommendedTransport = function saveRecommendedTransport(transport, proposalId) {
  var localStorageKey = "recommendedTransport-".concat(proposalId);

  if (!Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_22__[/* getFromLocalStorage */ "a"])(localStorageKey)) {
    Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_22__[/* setInLocalStorage */ "c"])(localStorageKey, buildTransportKey(transport), {
      ttl: TWO_WEEKS_IN_MS
    });
  }
};

var getMainHouseholdAttendee = function getMainHouseholdAttendee(proposal, householdId) {
  var customerId = proposal.households[householdId].attendees[0].customerId;
  return proposal.attendees.list.find(function (attendee) {
    return attendee.customerId === customerId;
  });
};

var ERROR_MESSAGES = {
  RESORT_NOT_AVAILABLE: 'productsComparison.resortNotAvailable',
  NOT_ON_SALE_FOR_THE_PERIOD: 'booking.accommodation.errorMessages.calendar.resortNotOnSale',
  INVALID_PRODUCT_ID: 'booking.accommodation.errorMessages.calendar.resortNotOnSale',
  NO_TRANSPORT: 'booking.accommodation.errorMessages.noTransport',
  NO_ACCOMMODATION: 'booking.accommodation.errorMessages.noAccommodation',
  UNAVAILABLE_FOR_BIRTHDATES: 'booking.accommodation.errorMessages.ageIncorrectOrUnauthorized',
  INVALID_BOOKING_CRITERIA: 'booking.accommodation.errorMessages.invalidBookingCriteria',
  NO_PROPOSAL: 'booking.accommodation.errorMessages.noProposalAvailable',
  TECHNICAL_ERROR: 'booking.accommodation.errorMessages.technicalError',
  INVALID_VOUCHER_CODE: 'booking.accommodation.errorMessages.technicalError',
  AUTHORIZATION_ERROR: 'productsComparison.unknownAttendee'
};
var QUICK_SEARCH_ERROR_MESSAGES = {
  INVALID_PRODUCT_ID: 'booking.partners.errorMessages.invalidResort',
  NO_ACCOMMODATION: 'booking.partners.errorMessages.noAccommodation',
  NOT_ON_SALE_FOR_THE_PERIOD: 'booking.partners.errorMessages.resortNotOnSale',
  NO_TRANSPORT: 'booking.partners.errorMessages.noTransport',
  TOO_MANY_ATTENDEES: 'booking.partners.errorMessages.attendees',
  UNAUTHORIZED_SALES_NETWORK: 'booking.partners.errorMessages.salesNetwork',
  UNAVAILABLE_FOR_BIRTHDATES: 'booking.partners.errorMessages.ageIncorrectOrUnauthorized',
  NO_PROPOSAL: 'booking.partners.errorMessages.noProposalAvailable',
  INVALID_BOOKING_CRITERIA: 'booking.partners.errorMessages.invalidBookingCriteria',
  FIELD_EMPTY: 'booking.partners.errorMessages.emptyField',
  INVALID_RESORT_ARRIVAL_DATE: 'booking.partners.errorMessages.invalidArrivalDate',
  UNKNOWN_DEPARTURE_CITY: 'booking.partners.errorMessages.invalidDepartureCity',
  TECHNICAL_ERROR: 'booking.partners.errorMessages.technicalError'
};
var QUICK_SEARCH_ERROR_LABELS = Object.keys(QUICK_SEARCH_ERROR_MESSAGES);

var toUpperSnakeCase = function toUpperSnakeCase(errorCode) {
  return lodash_snakeCase__WEBPACK_IMPORTED_MODULE_16___default()(errorCode).toUpperCase();
};

var getQuickSearchErrorMessage = function getQuickSearchErrorMessage(errorCode) {
  var errorLabel = toUpperSnakeCase(errorCode);
  return QUICK_SEARCH_ERROR_LABELS.includes(errorLabel) ? Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])(QUICK_SEARCH_ERROR_MESSAGES[errorLabel]) : Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.partners.errorMessages.defaultErrorMessage');
};

var isExpiredDepartureDate = function isExpiredDepartureDate(router) {
  return moment__WEBPACK_IMPORTED_MODULE_21___default()(router.query.departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_21___default()(new Date()), 'day');
};



/***/ }),

/***/ "oa0l":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "p9RO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onCheckboxChange; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("lKOy");
/* harmony import */ var lodash_difference__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_difference__WEBPACK_IMPORTED_MODULE_3__);




var CLUBMED = 'CLUBMED';
var PARTNERS = 'PARTNERS';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var FORYOUCLUB = 'FORYOUCLUB';
function onCheckboxChange(checkbox, setFieldValue) {
  var _fields;

  var fields = (_fields = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_fields, CLUBMED, {
    checked: [CLUBMED],
    unchecked: [CLUBMED, PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_fields, PARTNERS, {
    checked: [CLUBMED, PARTNERS],
    unchecked: [PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_fields, FOSUN_PARTNERS, {
    checked: [FOSUN_PARTNERS],
    unchecked: [FOSUN_PARTNERS]
  }), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_fields, FORYOUCLUB, {
    checked: [FORYOUCLUB],
    unchecked: [FORYOUCLUB]
  }), _fields);

  if (checkbox.checked) {
    lodash_difference__WEBPACK_IMPORTED_MODULE_3___default()(fields[checkbox.name].checked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, true);
    });
  } else {
    lodash_difference__WEBPACK_IMPORTED_MODULE_3___default()(fields[checkbox.name].unchecked, [checkbox.name]).map(function (id) {
      return setFieldValue(id, false);
    });
  }
}

/***/ }),

/***/ "pP7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BOOKING_ENGINE_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookingEngineI18n; });
/* harmony import */ var _views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9LZ4");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


var SET_CMS = 'SET_CMS';
var setCms = function setCms(config, legalInformations) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_CMS, {
    config: config,
    legalInformations: legalInformations
  });
};
var GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
var getBookingEngineI18n = function getBookingEngineI18n(appContext) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(GET_BOOKING_ENGINE_I18N, {}, {
      promise: Object(_views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__[/* fetchBookingEngineI18nQuery */ "a"])(appContext)
    }));
  };
};

/***/ }),

/***/ "pfAP":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var isObject = __webpack_require__("1YFU");
var isSymbol = __webpack_require__("km0D");
var getMethod = __webpack_require__("Uey1");
var ordinaryToPrimitive = __webpack_require__("ZoVA");
var wellKnownSymbol = __webpack_require__("nJrx");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "qPLk":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "qXr/":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "qd7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIGNOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return signout; });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rJ95");



var SIGNOUT = 'SIGNOUT';

function cleanCookies() {
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_1__[/* USER_INFO */ "e"]);
}

function signout() {
  cleanCookies();
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"])(SIGNOUT);
}

/***/ }),

/***/ "qqpj":
/***/ (function(module, exports, __webpack_require__) {

var baseToNumber = __webpack_require__("t/wz"),
    baseToString = __webpack_require__("JcJ6");

/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function(value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = baseToString(value);
        other = baseToString(other);
      } else {
        value = baseToNumber(value);
        other = baseToNumber(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

module.exports = createMathOperation;


/***/ }),

/***/ "qs2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("LTtw");
var DESCRIPTORS = __webpack_require__("uGjT");
var global = __webpack_require__("HnW7");
var uncurryThis = __webpack_require__("kZDm");
var hasOwn = __webpack_require__("/GgU");
var isCallable = __webpack_require__("ANQd");
var isPrototypeOf = __webpack_require__("VXxY");
var toString = __webpack_require__("vnfA");
var defineBuiltInAccessor = __webpack_require__("yYuE");
var copyConstructorProperties = __webpack_require__("sfoL");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "rAD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_QUICKLOGIN_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_QUICKLOGIN_INFOS; });
var UPDATE_QUICKLOGIN_INFOS = 'UPDATE_QUICKLOGIN_INFOS';
var RESET_QUICKLOGIN_INFOS = 'RESET_QUICKLOGIN_INFOS';

/***/ }),

/***/ "rcxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE_BE_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGE_BE_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_BE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGE_BE_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_BE_SERVICES_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_BE_PARTICIPANTS; });
/* unused harmony export PAGE_BE_BANKING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBookingEngineUri; });
/* unused harmony export getBookingCriteriaOffsetSell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBookingCriteriaDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkIsDepartureDateAvailaible; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("U2CP");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("PIvV");
/* harmony import */ var _proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("oL6k");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");












function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var PAGE_BE_ACCOMMODATION = 'accommodation';
var PAGE_BE_TRANSPORT = 'transport';
var PAGE_BE_SERVICES = 'services';
var PAGE_BE_ACTIVITIES = 'activities';
var PAGE_BE_SERVICES_ALL_INCLUSIVE = 'allInclusive';
var PAGE_BE_PARTICIPANTS = 'participants';
var PAGE_BE_BANKING = 'banking';
function getBookingEngineUri() {
  var _getDefaultProposal;

  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PAGE_BE_ACCOMMODATION;
  var proposals = arguments.length > 1 ? arguments[1] : undefined;
  var resort = arguments.length > 2 ? arguments[2] : undefined;
  var selectedProposalId = arguments.length > 3 ? arguments[3] : undefined;
  var otherQueryParameters = arguments.length > 4 ? arguments[4] : undefined;
  var proposalIds = proposals.map(function (proposal) {
    return proposal.id;
  });

  var _selectedProposalId = selectedProposalId || ((_getDefaultProposal = Object(_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_14__[/* getDefaultProposal */ "d"])(proposals, resort)) === null || _getDefaultProposal === void 0 ? void 0 : _getDefaultProposal.id);

  var queryParams = _objectSpread(_objectSpread({}, otherQueryParameters), {}, {
    proposalIds: proposalIds,
    selectedProposalId: _selectedProposalId,
    coderesort: resort === null || resort === void 0 ? void 0 : resort.id
  });

  return _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_12__[/* buildUrl */ "a"]('booking', {
    page: page
  }, queryParams);
}
var getBookingCriteriaOffsetSell = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee(productId, appContext) {
    var getQuery, query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getQuery = function getQuery() {
              return "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                    offsetSell\n                  }\n            }");
            };

            query = getQuery();
            return _context.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* CRITERIA_OFFSETSELL */ "h"]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBookingCriteriaOffsetSell(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getBookingCriteriaDepartureCities = /*#__PURE__*/function () {
  var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee2(productId, appContext) {
    var query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                      departureCities {\n                        value\n                        name\n                      }\n                  }\n            }");
            return _context2.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* CRITERIA_DEPARTURE_CITIES */ "g"]
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getBookingCriteriaDepartureCities(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}(); // check if the departureDate comes after today plus the offsetSell (in days), which is defined by the API

var checkIsDepartureDateAvailaible = function checkIsDepartureDateAvailaible(departureDate, offsetSell) {
  return moment__WEBPACK_IMPORTED_MODULE_11___default()(departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_11___default()().add(offsetSell, 'd'), 'day');
};

/***/ }),

/***/ "rvZv":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "sCYz":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var getBuiltIn = __webpack_require__("x90g");
var wellKnownSymbol = __webpack_require__("nJrx");
var defineBuiltIn = __webpack_require__("Swp0");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return MAX_PAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MAX_PAX_SELLER; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHILDCARE_CRITERIA_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHILDCARE_FILTER_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return KIDS_NUMBER_MAX_SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SEASON_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return TOP_COUNTRIES_FACET_LIST_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FLIGHT_DURATION_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SORT_BY_PRICE_QUERY_PARAM; });
/* unused harmony export PRODUCTS_TO_COMPARE_QUERY_PARAM */
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CUSTOM_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GROUP_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHILDCARE_FILTER_FACET_OPTION_0_TO_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHILDCARE_FILTER_FACET_OPTION_2_TO_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHILDCARE_FILTER_FACET_OPTION_4_TO_10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHILDCARE_FILTER_FACET_OPTION_11_TO_17; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHILDCARE_FILTER_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHILDCARE_FILTER_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHILDCARE_FILTER_FACET_AVERAGE_MONTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FLIGHT_DURATION_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FLIGHT_DURATION_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FLIGHT_DURATION_FACET_AS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SEASON_FACET_FIRST_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SEASON_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SEASON_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SEASON_FACET_QUERY_PARAM_FR_TO_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SEASON_FACET_QUERY_PARAM_EN_TO_FR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TYPES_OF_STAY_FACET_BADGE_ICON_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return TYPES_OF_STAY_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return TYPES_OF_STAY_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var MAX_PAX = 6;
var MAX_PAX_SELLER = 8;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_CRITERIA_FACET_ID = 'facette_childcare_age_in_month';
var CHILDCARE_FILTER_FACET_ID = 'facette_childcare_age_in_month_list';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var KIDS_NUMBER_MAX_SELLER = 7;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var SEASON_FACET_ID = 'seasons_ns';
var TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
var TYPES_OF_STAY_FACET_ID = 'facette_types';
var FLIGHT_DURATION_FACET_ID = 'facette_flight_duration';
var QUERY_QUERY_PARAM = 'search';
var SORT_BY_PRICE_QUERY_PARAM = 'sortByPrice';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, CHILDCARE_FILTER_FACET_ID, COUNTRIES_FACET_ID, DESTINATIONS_FACET_ID, SEASON_FACET_ID, TYPES_OF_STAY_FACET_ID];
var CUSTOM_FACETS_IDS = [FLIGHT_DURATION_FACET_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  trackingPrefixLabel: 'childcare'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  trackingPrefixLabel: 'season'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}];
var GROUP_STRING = 'group::';
var CHILDCARE_FILTER_FACET_OPTION_0_TO_2 = "".concat(GROUP_STRING, "from_0_to_2");
var CHILDCARE_FILTER_FACET_OPTION_2_TO_3 = "".concat(GROUP_STRING, "from_2_to_3");
var CHILDCARE_FILTER_FACET_OPTION_4_TO_10 = "".concat(GROUP_STRING, "from_4_to_10");
var CHILDCARE_FILTER_FACET_OPTION_11_TO_17 = "".concat(GROUP_STRING, "from_11_to_17");
var CHILDCARE_FILTER_FACET_LABELS_PREFIX = 'faceting.filters.childcare.label_';
var CHILDCARE_FILTER_FACET_LABELS = {
  from_0_to_2: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "babyClub"),
  from_2_to_3: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "miniClub"),
  from_4_to_10: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "petitClub"),
  from_11_to_17: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "teenClub")
};
var CHILDCARE_FILTER_FACET_AVERAGE_MONTHS = {
  from_0_to_2: 12,
  from_2_to_3: 30,
  from_4_to_10: 84,
  from_11_to_17: 168
};
var FLIGHT_DURATION_FACET_LABELS_PREFIX = 'faceting.filters.flightDuration.label_';
var FLIGHT_DURATION_FACET_LABELS = {
  '2h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "2h"),
  '4h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "4h"),
  '8h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h"),
  '8hmore': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h_more")
};
var FLIGHT_DURATION_FACET_AS_LIST = {
  id: FLIGHT_DURATION_FACET_ID,
  name: FLIGHT_DURATION_FACET_ID,
  list: [{
    label: '2h',
    value: '2h',
    count: -1
  }, {
    label: '4h',
    value: '4h',
    count: -1
  }, {
    label: '8h',
    value: '8h',
    count: -1
  }, {
    label: '8hmore',
    value: '8hmore',
    count: -1
  }]
};
var SEASON_FACET_FIRST_OPTION = 'SOLEIL';
var SEASON_FACET_LABELS_PREFIX = 'faceting.filters.season.label_';
var SEASON_FACET_LABELS = {
  NEIGE: "".concat(SEASON_FACET_LABELS_PREFIX, "snow"),
  SOLEIL: "".concat(SEASON_FACET_LABELS_PREFIX, "sun")
};
var SEASON_FACET_QUERY_PARAM_FR_TO_EN = {
  NEIGE: 'SNOW',
  SOLEIL: 'SUN'
};
var SEASON_FACET_QUERY_PARAM_EN_TO_FR = {
  SNOW: 'NEIGE',
  SUN: 'SOLEIL'
};
var NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES = ['CRUISE', 'JOYVIEW', 'TOUR'];
var TYPES_OF_STAY_FACET_BADGE_ICON_PROPS = {
  3: {
    className: 'rounded-4 size-40',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT3
  },
  4: {
    className: 'rounded-4 size-40',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT4
  },
  5: {
    className: 'rounded-4 size-40 bg-ultramarine border-ultramarine text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].DIAMOND
  },
  6: {
    className: 'rounded-4 size-40 bg-ultramarine border-ultramarine text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT6
  },
  CRUISE: {
    className: 'rounded-4 size-40 bg-sienna border-sienna text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].CRUISE
  },
  JOYVIEW: {
    className: 'rounded-4 size-40 bg-blueWave border-blueWave text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT_JOYVIEW
  },
  TOUR: {
    className: 'rounded-4 size-40 bg-sienna border-sienna text-white',
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TOUR
  }
};
var TYPES_OF_STAY_FACET_LABELS_PREFIX = 'faceting.filters.typesOfStay.label_';
var TYPES_OF_STAY_FACET_LABELS = {
  3: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "3_tridents"),
  4: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "4_tridents"),
  5: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "exclusive_collection"),
  6: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "villa"),
  CRUISE: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "cruise"),
  JOYVIEW: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "joyview"),
  TOUR: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "tour")
};
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.filters.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.filters.where.countriesTitle'
  }],
  titleLabel: 'faceting.filters.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  titleLabel: 'faceting.filters.activities.title'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  dataLabel: 'childcare',
  facetLists: [{
    deep: false,
    id: CHILDCARE_FILTER_FACET_ID,
    facetLabels: CHILDCARE_FILTER_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.childcare.title',
  trackingPrefixLabel: 'childcare'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: TYPES_OF_STAY_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  dataLabel: 'flightDuration',
  facetLists: [{
    deep: false,
    id: FLIGHT_DURATION_FACET_ID,
    facetLabels: FLIGHT_DURATION_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.flightDuration.title',
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  capitalizeLabels: true,
  dataLabel: 'season',
  facetLists: [{
    deep: false,
    id: SEASON_FACET_ID,
    facetLabels: SEASON_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.season.title',
  trackingPrefixLabel: 'season'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "sfoL":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("/GgU");
var ownKeys = __webpack_require__("1m4l");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "sjzV":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW");

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ "t/wz":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("a88S");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  return +value;
}

module.exports = baseToNumber;


/***/ }),

/***/ "tI+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PACKAGE_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PACKAGE_ROOM_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CEFALU_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELUXE_COMFORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PACKAGE_FOOD_AND_BEVERAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMFORT_TYPE_SUITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMFORT_TYPE_CHALET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMFORT_TYPE_VILLA; });
var PACKAGE_ALL_INCLUSIVE = 'PAI';
var PACKAGE_ROOM_ONLY = 'RON';
var PACKAGE_FOOD_AND_BEVERAGE = 'FFB';
var CEFALU_RESORT = 'CFAC';
var DELUXE_COMFORT = 'Deluxe';
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var COMFORT_TYPE_SUITE = 'typeoflodging_comfort_type_suite';
var COMFORT_TYPE_CHALET = 'typeoflodging_comfort_type_chalet';
var COMFORT_TYPE_VILLA = 'typeoflodging_comfort_type_villa';


/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return camelToSnakeCase; });
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("0fIf");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}

var camelToSnakeCase = function camelToSnakeCase(str) {
  return str ? str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  }) : '';
};



/***/ }),

/***/ "u9tP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAuthenticationMiddleware; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("m0zD");
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_logger__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6jSF");



function createAuthenticationMiddleware() {
  return function () {
    return function (next) {
      return function (action) {
        try {
          var _action$meta; // Works only on rejected optimistic actions, with a redirect_uri in payload's meta
          // $FlowFixMe


          var redirectUri = (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.redirect_uri;

          if (!!redirectUri && _utils_ple_utils__WEBPACK_IMPORTED_MODULE_2__[/* hasAuthResponseError */ "l"](action.payload)) {
            _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["windowWrapper"].setLocation(redirectUri);
          }
        } catch (e) {
          _logger__WEBPACK_IMPORTED_MODULE_1___default.a.warn(e);
        }

        return next(action);
      };
    };
  };
}

/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uGjT":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "uL19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCustomerSearchResult; });
/* unused harmony export filterProposalBySamePackage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdditionalTransportsError; });
/* unused harmony export getAllChildcaresByProductInfoId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCityTransportsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getIsLoadingAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getFilteredAccommodationsAlternativesByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getIsLoadingFilteredAccommodationsAlternativesByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getIsLoadingAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdditionalAccommodationsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdditionalAccommodationsPmrChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdditionalAccommodationsError; });
/* unused harmony export getFilteredAdditionalAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getFilteredAdditionalAccommodationsSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdditionalTransports; });
/* unused harmony export getSearchCriteriaTransports */
/* unused harmony export getSearchCriteriaTransportsInbound */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getSelectedProposalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCurrentResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getPaymentProviders; });
/* unused harmony export getProposalsWithMappedAttendees */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCurrentProposal; });
/* unused harmony export getCurrentTotalPrice */
/* unused harmony export getProposalHasAnyEquipmentForRent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getDetailedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getConnectedUserInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return proposalsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getInsurancesStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getStreetViews; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("1IsZ");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("oL6k");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("apzf");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Jsmy");
/* harmony import */ var _attendees_attendees_selector__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("eZ08");




















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}







var bookingSelector = function bookingSelector(_ref) {
  var booking = _ref.booking;
  return booking || {};
};

var additionalTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref2) {
  var additionalTransports = _ref2.additionalTransports;
  return additionalTransports || {};
});
var getCityTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref3) {
  var additionalTransports = _ref3.additionalTransports;
  return additionalTransports.transports.cityTransports || {};
});
var getPaymentProviders = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref4) {
  var paymentProviders = _ref4.paymentProviders;
  return paymentProviders;
});
var getInsurancesStore = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref5) {
  var insurance = _ref5.insurance;
  return insurance;
});
var getSearchCriteriaTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref6) {
  var searchCriteria = _ref6.searchCriteria;
  return searchCriteria;
});
var getSearchCriteriaTransportsInbound = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref7) {
  var searchCriteria = _ref7.searchCriteria;
  return searchCriteria && searchCriteria[0];
});
var getAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref8) {
  var transports = _ref8.transports;
  return transports;
});
var getAdditionalTransportsError = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref9) {
  var error = _ref9.error;
  return error;
});
var getIsLoadingAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref10) {
  var isLoading = _ref10.isLoading;
  return isLoading;
});
var additionalAccommodationsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref11) {
  var additionalAccommodations = _ref11.additionalAccommodations;
  return additionalAccommodations || {};
});
var getIsLoadingAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref12) {
  var isLoading = _ref12.isLoading;
  return isLoading;
});
var getIsLoadingFilteredAccommodationsAlternativesByComfort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref13) {
  var isLoadingFilteredAccommodationsAlternativesByComfort = _ref13.isLoadingFilteredAccommodationsAlternativesByComfort;
  return isLoadingFilteredAccommodationsAlternativesByComfort;
});
var getAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref14) {
  var accommodationsSets = _ref14.accommodationsSets;
  return accommodationsSets;
});
var getAdditionalAccommodationsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref15) {
  var filters = _ref15.filters;
  return filters;
});
var getAdditionalAccommodationsPmrChecked = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref16) {
  var isPmrChecked = _ref16.isPmrChecked;
  return isPmrChecked;
});
var getAdditionalAccommodationsError = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref17) {
  var error = _ref17.error;
  return error;
});
var getFilteredAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref18) {
  var filteredAccommodations = _ref18.filteredAccommodations;
  return filteredAccommodations;
});
var getFilteredAdditionalAccommodationsSets = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getFilteredAdditionalAccommodations, getAdditionalAccommodations, function (filteredAccommodations, additionalAccommodations) {
  return filteredAccommodations && filteredAccommodations.length > 0 ? filteredAccommodations : additionalAccommodations;
});
var getFilteredAccommodationsAlternativesByComfort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref19) {
  var filteredAccommodationsAlternativesByComfort = _ref19.filteredAccommodationsAlternativesByComfort;
  return filteredAccommodationsAlternativesByComfort;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref20) {
  var proposals = _ref20.proposals;
  return proposals || [];
});
var getCurrentResort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref21) {
  var resort = _ref21.resort;
  return resort;
});

var findAttendeeByNeolid = function findAttendeeByNeolid(attendees, neolid) {
  return attendees.find(function (attendee) {
    return attendee.neolid === neolid;
  });
};

var getSelectedProposalId = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref22) {
  var selectedProposalId = _ref22.selectedProposalId;
  return selectedProposalId;
});
/**
 * It should be getSelectedProposal but there is a selector getSelectedProposal
 * witch get the proposal from paymentInfoSelector
 * I do not know why...
 */

var getCurrentProposal = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref23) {
  var proposals = _ref23.proposals,
      selectedProposalId = _ref23.selectedProposalId;
  return (
    /**
     * return the selected proposal if found,
     * if not (for any reason) the default proposal for keeping the return shape value consistent
     */
    proposals.find(function (proposal) {
      return proposal.id === selectedProposalId;
    }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* getDefaultProposal */ "d"])(proposals)
  );
});
var getAllChildcaresByProductInfoId = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (state, productInfoId) {
  return productInfoId;
}, function (_ref24, productInfoId) {
  var additionalServices = _ref24.additionalServices;
  return additionalServices.childcares.filter(function (_ref25) {
    var id = _ref25.pricingInfo.id;
    return id === productInfoId;
  });
});
var getCurrentTotalPrice = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (proposal) {
  return proposal.price.total.value;
});

var filterProposalBySamePackage = function filterProposalBySamePackage(proposals, selectedProposal, resort) {
  var errorsProposals = proposals.filter(function (proposal) {
    return proposal.errorCode;
  });

  if (errorsProposals.length) {
    return errorsProposals;
  } // todo add the urban oasis condition once the feature is merged and ofc remove this comment 🤷‍ (Souhail)


  return (resort === null || resort === void 0 ? void 0 : resort.isJoyview) || (resort === null || resort === void 0 ? void 0 : resort.isUrbanOasis) ? proposals.filter(function (item) {
    var _item$accommodations = item.accommodations,
        accommodations = _item$accommodations === void 0 ? [] : _item$accommodations,
        packageId = item.packageId;
    return accommodations.length && packageId === selectedProposal.packageId;
  }) : proposals.filter(function (item) {
    var _item$accommodations2 = item.accommodations,
        accommodations = _item$accommodations2 === void 0 ? [] : _item$accommodations2;
    return accommodations.length;
  });
};

var getProposals = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(proposalsSelector, getCurrentProposal, getCurrentResort, filterProposalBySamePackage);
var getProposalsWithMappedAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getProposals, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__[/* tripInformationSelector */ "d"], function (proposals, tripInformation) {
  if (!proposals) {
    return proposals;
  }

  return proposals.map(function (proposal) {
    return _objectSpread(_objectSpread({}, proposal), {}, {
      attendees: _objectSpread(_objectSpread({}, proposal.attendees), {}, {
        list: proposal.attendees.list.map(function (attendee) {
          // if there is a birthdate it's a children otherwise it's an adult
          var attendeeData = attendee.birthdate ? findAttendeeByNeolid(tripInformation.kids, attendee.customerId) : findAttendeeByNeolid(tripInformation.adults, attendee.customerId);

          if (!attendeeData) {
            return attendee;
          }

          return _objectSpread(_objectSpread({}, attendee), {}, {
            firstName: attendeeData.firstName,
            lastName: attendeeData.lastName
          });
        })
      })
    });
  });
});
var getProposalHasAnyEquipmentForRent = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref26) {
  var rentalEquipments = _ref26.rentalEquipments;
  return rentalEquipments.hasAnyEquipmentForRent;
});
var getConnectedUserInfoSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_21__[/* userInfoSelector */ "a"], function (connectedUserInfo) {
  return connectedUserInfo.isQuickLoggedIn ? {} : lodash_omit__WEBPACK_IMPORTED_MODULE_18___default()(_objectSpread(_objectSpread({}, connectedUserInfo), {}, {
    birthdate: connectedUserInfo.dateOfBirth,
    neolid: connectedUserInfo.neolaneId,
    // harmonize the neolid between user and seller
    mobile: connectedUserInfo.mobilePhoneNumber
  }), ['dateOfBirth', 'GMNumber', 'homePhoneNumber', 'isProspect', 'neolaneId', 'unicodeCivility', 'expirationDate', 'mobilePhoneNumber']);
});
var getStreetViews = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref27) {
  var streetViews = _ref27.streetViews;
  return streetViews;
});
var getSuggestions = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref28) {
  var suggestions = _ref28.suggestions;
  return suggestions;
});
var getCustomerSearchResult = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (booking) {
  return booking.customerSearch;
});
var getReservedServicesByAttendee = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (state) {
  return Object(_attendees_attendees_selector__WEBPACK_IMPORTED_MODULE_23__[/* selectAttendeesWithInfosByHouseholds */ "c"])(state).attendees;
}, function (_ref29, attendeesWithInfos) {
  var additionalServices = _ref29.additionalServices; // defensive code if store is not available (ex: confirmation page)

  if (!additionalServices || !attendeesWithInfos) {
    return [];
  }

  var attendeesWithServiceRented = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(additionalServices.activities), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(additionalServices.rentals)).reduce(function (acc, service) {
    var pricingInfo = service.pricingInfo,
        productInfo = service.productInfo;
    pricingInfo.attendees.forEach(function (attendee) {
      var product = {
        price: attendee.rentedAmount.value,
        services: [service]
      };

      if (attendee.rentedAmount.value > 0) {
        if (!acc[attendee.id]) {
          acc[attendee.id] = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])({}, productInfo.id, _objectSpread({}, product));
        } else if (!acc[attendee.id][productInfo.id]) {
          acc[attendee.id][productInfo.id] = _objectSpread({}, product);
        } else {
          acc[attendee.id][productInfo.id].services.push(service);
        }
      }
    });
    return acc;
  }, {});
  return Object.entries(attendeesWithServiceRented).reduce(function (reservedServicesByAttendee, _ref30) {
    var _ref31 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_ref30, 2),
        id = _ref31[0],
        rentedServices = _ref31[1];

    var childIndex = attendeesWithInfos.children.findIndex(function (attendee) {
      return attendee.id === id;
    });

    if (childIndex > -1) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.children[childIndex]), {}, {
        id: id,
        index: childIndex + 1,
        isAdult: false,
        // $FlowFixMe 🤷‍️
        rentedServices: Object.values(rentedServices)
      })]);
    }

    var adultIndex = attendeesWithInfos.adults.findIndex(function (attendee) {
      return attendee.id === id;
    });
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.adults[adultIndex]), {}, {
      id: id,
      index: adultIndex + 1,
      isAdult: true,
      // $FlowFixMe 🤷‍️
      rentedServices: Object.values(rentedServices)
    })]);
  }, []).sort(function (a, b) {
    if (a.isAdult && !b.isAdult) {
      return -1;
    }

    if (!a.isAdult && b.isAdult) {
      return 1;
    }

    return a.index - b.index;
  });
});

var getDetailedAttendees = function getDetailedAttendees(_ref32) {
  var booking = _ref32.booking;
  return booking.attendees;
};



/***/ }),

/***/ "uUTq":
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__("X+YX"),
    baseRest = __webpack_require__("R3TX"),
    isArrayLikeObject = __webpack_require__("Ndl3");

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),

/***/ "uXT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "NavigationMemberAccess", function() { return /* binding */ NavigationMemberAccess_NavigationMemberAccess; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/utils/graphql-client/cacheFront.js
var cacheFront = __webpack_require__("ESA2");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 2 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/member-sign-in/MemberSignIn.jsx



var __jsx = react_default.a.createElement;













var MemberSignIn_MemberSignIn = function MemberSignIn(_ref) {
  var hasFacebookConnect = _ref.hasFacebookConnect,
      hasQuickLogin = _ref.hasQuickLogin,
      hasWechatConnect = _ref.hasWechatConnect;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return __jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-col-reverse lg:flex-row', {
      'lg:min-w-320': !hasQuickLogin,
      'lg:min-w-[580px]': hasQuickLogin
    }),
    "data-testid": "signInContent"
  }, __jsx("div", null, __jsx(Title["a" /* Title */], {
    className: "mb-10",
    iconColor: colors["a" /* COLORS */].SIENNA,
    iconName: icons["a" /* ICONS */].ICON_45,
    iconSize: "1.875rem",
    theme: "title-brand-n3"
  }, Object(i18n["h" /* t */])('account.authentication.yourAccount.title')), __jsx("p", {
    className: "mb-20 text-12 leading-tight text-black"
  }, Object(i18n["h" /* t */])('account.authentication.yourAccount.text')), __jsx("div", {
    className: "mb-20 flex gap-10"
  }, __jsx(Button["a" /* Button */], {
    "data-testid": "member-nav-signIn",
    isExternalLink: true,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_signIn'
      });
    },
    size: "large",
    url: ple_utils["f" /* buildSigninUrl */]({
      locale: locale
    })
  }, Object(i18n["h" /* t */])('account.authentication.signin')), hasFacebookConnect && __jsx(Button["a" /* Button */], {
    className: "min-w-50 leading-0",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].ULTRAMARINE,
    colorBorder: colors["a" /* COLORS */].ULTRAMARINE,
    "data-testid": "MemberSignIn-facebook",
    isExternalLink: true,
    isSquare: true,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_incentive_FB_connect'
      });
    },
    size: "large",
    url: ple_utils["d" /* buildFacebookConnectUrl */]({
      locale: locale
    })
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].FACEBOOK,
    width: "1.5rem"
  }), __jsx("span", {
    className: "sr-only"
  }, "Club Med - Facebook")), hasWechatConnect && __jsx(Button["a" /* Button */], {
    className: "min-w-50 leading-0",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].ULTRAMARINE,
    colorBorder: colors["a" /* COLORS */].ULTRAMARINE,
    "data-testid": "MemberSignIn-wechat",
    isExternalLink: true,
    isSquare: true,
    onClick: function onClick() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_incentive_wechat_connect'
      });
    },
    size: "large",
    url: ple_utils["j" /* buildWechatConnectUrl */]({
      locale: locale
    })
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WECHAT,
    width: "1.5rem"
  }), __jsx("span", {
    className: "sr-only"
  }, "Club Med - Wechat"))), __jsx("div", {
    className: "flex gap-10 font-sans text-12 leading-tight text-black"
  }, __jsx("p", null, Object(i18n["h" /* t */])('account.authentication.newToClubMed')), __jsx("a", {
    className: "font-bold text-sienna underline hocus:text-sienna-active",
    "data-testid": "member-nav-createAccount",
    href: ple_utils["h" /* buildSignupUrl */]({
      locale: locale
    }),
    onClick: function onClick() {
      return trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_createAccount'
      });
    },
    rel: "nofollow"
  }, Object(i18n["h" /* t */])('account.authentication.createAccountLinkLabel')))), hasQuickLogin && __jsx("div", {
    className: "mb-20 border-b-1 border-sand pb-20 lg:mb-0 lg:ms-20 lg:border-0 lg:border-s-1 lg:pb-0 lg:ps-20"
  }, __jsx(Title["a" /* Title */], {
    className: "mb-10",
    iconColor: colors["a" /* COLORS */].SIENNA,
    iconName: icons["a" /* ICONS */].DOCUMENT_COLORED,
    iconSize: "1.875rem",
    theme: "title-brand-n3"
  }, Object(i18n["h" /* t */])('account.authentication.quickLogin.title')), __jsx("p", {
    className: "mb-20 text-12 leading-tight text-black"
  }, Object(i18n["h" /* t */])('account.authentication.quickLogin.text')), __jsx("ul", {
    className: "mb-20 text-12 leading-tight"
  }, Array(10).fill().map(function (_, i) {
    return Object(i18n["h" /* t */])("account.authentication.quickLogin.keyPoint.".concat(i), {}, '');
  }).filter(Boolean).map(function (key) {
    return __jsx("li", {
      key: key,
      className: "mb-10 flex items-start gap-10"
    }, __jsx(Icon["a" /* Icon */], {
      className: "shrink-0 text-green",
      name: icons["a" /* ICONS */].CHECK,
      width: "1rem"
    }), key);
  })), __jsx(Button["a" /* Button */], {
    className: "w-full",
    color: colors["a" /* COLORS */].BLACK,
    colorBg: colors["a" /* COLORS */].SAFFRON,
    colorBorder: colors["a" /* COLORS */].SAFFRON,
    "data-testid": "member-nav-quickLogin",
    isExternalLink: true,
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_quickLogin'
      });
    },
    size: "large",
    url: ple_utils["f" /* buildSigninUrl */]({
      provider: 'bookingGM',
      locale: locale
    })
  }, Object(i18n["h" /* t */])('account.authentication.quickLogin.cta'))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/member-nav/member-sign-in/useExtendedConnect.js
var useExtendedConnect = __webpack_require__("4tGX");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/member-sign-in/MemberSignIn.container.jsx
var MemberSignIn_container_jsx = react_default.a.createElement;





var MemberSignIn_container_MemberSignInContainer = function MemberSignInContainer() {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useExtendedConnect = Object(useExtendedConnect["a" /* useExtendedConnect */])(),
      isFacebookConnectAvailable = _useExtendedConnect.isFacebookConnectAvailable,
      isWechatConnectAvailable = _useExtendedConnect.isWechatConnectAvailable;

  return MemberSignIn_container_jsx(MemberSignIn_MemberSignIn, {
    hasFacebookConnect: isFacebookConnectAvailable,
    hasQuickLogin: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('navigationBar.hasQuickLogin'),
    hasWechatConnect: isWechatConnectAvailable
  });
};
// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/local-storage-api/index.js
var local_storage_api = __webpack_require__("1RIK");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorage.constants.js
var sessionStorage_constants = __webpack_require__("4paF");

// EXTERNAL MODULE: ./src/client/components/utils/booking/useSearchBookings.js + 1 modules
var useSearchBookings = __webpack_require__("QMQE");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/client/store/user-info/actions/signout.js
var signout = __webpack_require__("qd7E");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/logged-nav/LoggedNav.jsx


var LoggedNav_jsx = react_default.a.createElement;




















var LoggedNav_formatWelcomeMessage = function formatWelcomeMessage(template, firstName, lastName) {
  return Object(dist["messageFormat"])(template).format({
    firstname: firstName || '',
    lastname: lastName || ''
  });
};

var LoggedNav_LoggedNav = function LoggedNav(_ref) {
  var closeMemberPanel = _ref.closeMemberPanel,
      userInfo = _ref.userInfo;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isGsa = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa');
  var signoutUrl = ple_utils["g" /* buildSignoutUrl */]({
    shouldRedirectToOidc: isGsa,
    locale: appContext.locale
  });

  var _useSearchBookings = Object(useSearchBookings["a" /* useSearchBookings */])(),
      favorites = _useSearchBookings.favorites,
      prebookings = _useSearchBookings.prebookings;

  var items = [{
    icon: icons["a" /* ICONS */].NOTEBOOK,
    label: Object(i18n["h" /* t */])('account.authenticated.dashboard'),
    onClick: function onClick() {
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_dashboard'
      });
    },
    url: Object(routeBuilder["b" /* urlPattern */])('account')
  }, {
    icon: icons["a" /* ICONS */].DETAILS,
    label: Object(i18n["h" /* t */])('account.authenticated.myTrips'),
    onClick: function onClick() {
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_myTrips'
      });
    },
    url: Object(routeBuilder["b" /* urlPattern */])('stays')
  }, {
    icon: icons["a" /* ICONS */].STAR_HOLLOW,
    label: Object(i18n["h" /* t */])('customerAccount.dashboard.travelPlans.title'),
    onClick: function onClick() {
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_travelplans'
      });
    },
    url: Object(routeBuilder["b" /* urlPattern */])('searches'),
    disabled: !(prebookings === null || prebookings === void 0 ? void 0 : prebookings.length) && !(favorites === null || favorites === void 0 ? void 0 : favorites.length)
  }, {
    icon: icons["a" /* ICONS */].PEOPLE,
    label: Object(i18n["h" /* t */])('account.authenticated.myProfile'),
    onClick: function onClick() {
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_myProfile'
      });
    },
    url: Object(routeBuilder["b" /* urlPattern */])('profile')
  }, {
    icon: icons["a" /* ICONS */].BAR,
    label: Object(i18n["h" /* t */])('account.authenticated.greatMembers'),
    onClick: function onClick() {
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_greatMembersProgram'
      });
    },
    url: Object(routeBuilder["b" /* urlPattern */])('greatMembers')
  }, {
    icon: icons["a" /* ICONS */].DISCONNECTION,
    isExternalLink: true,
    label: Object(i18n["h" /* t */])('account.authentication.signout'),
    onClick: function onClick() {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_logout'
      });
      Object(cacheFront["a" /* clearAllCacheFront */])();
      Object(signout["b" /* default */])();
      closeMemberPanel && closeMemberPanel();
      Object(sessionStorageApi["c" /* removeFromSessionStorage */])(sessionStorage_constants["c" /* KEY_CA_VOUCHER_TOASTER */]);
      Object(local_storage_api["b" /* remove */])(constants["e" /* CA_TRACKING */]);
    },
    url: signoutUrl
  }];
  var itemClasses = 'flex items-center font-bold leading-tight text-black text-16 p-10 air360-replay-ignore';
  return LoggedNav_jsx(react["Fragment"], null, LoggedNav_jsx("div", {
    "data-cs-mask": true,
    className: itemClasses
  }, LoggedNav_formatWelcomeMessage(Object(i18n["h" /* t */])('account.authenticated.greeting'), userInfo.firstName, userInfo.lastName)), LoggedNav_jsx("nav", null, items.filter(function (_ref2) {
    var _ref2$disabled = _ref2.disabled,
        disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
    return !disabled;
  }).map(function (_ref3) {
    var icon = _ref3.icon,
        isExternalLink = _ref3.isExternalLink,
        label = _ref3.label,
        onClick = _ref3.onClick,
        url = _ref3.url;
    return LoggedNav_jsx(DynamicLink["a" /* default */], {
      className: Object(classnames_utils["a" /* classnames */])(itemClasses, 'border-t-1 transition-color hocus:text-black-active'),
      isExternalLink: isExternalLink,
      key: url,
      queryParamsToIgnore: ['coderesort', 'hasSaveOption', 'selectedProposalId', 'proposalIds', 'optionIds'],
      onClick: onClick,
      url: url
    }, icon && LoggedNav_jsx(Icon["a" /* Icon */], {
      className: "me-10",
      name: icon,
      width: "1.25rem"
    }), label);
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/quicklogged-nav/QuickLoggedNav.jsx




var QuickLoggedNav_jsx = react_default.a.createElement;














var QuickLoggedNav_QuickLoggedNav = function QuickLoggedNav(_ref) {
  var bookingId = _ref.bookingId,
      closeMemberPanel = _ref.closeMemberPanel,
      stayId = _ref.stayId;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isGsa = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa');
  var signoutUrl = ple_utils["g" /* buildSignoutUrl */]({
    shouldRedirectToOidc: isGsa,
    locale: appContext.locale
  });
  var items = [{
    dataTestId: 'member-nav-quickdashboard-dashboard',
    icon: icons["a" /* ICONS */].NOTEBOOK,
    label: Object(i18n["h" /* t */])('account.authenticated.dashboard'),
    onClick: function onClick() {
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_dashboard'
      });
    },
    url: Object(routeBuilder["b" /* urlPattern */])('account')
  }, {
    dataTestId: 'member-nav-quickdashboard-details',
    hide: !bookingId || !stayId,
    icon: icons["a" /* ICONS */].DETAILS,
    label: Object(i18n["h" /* t */])('account.authenticated.quickLogin.details'),
    onClick: function onClick() {
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_bookingDetails'
      });
    },
    url: Object(routeBuilder["a" /* buildUrl */])('bookings', {
      bookingId: bookingId,
      stayId: stayId
    })
  }, {
    dataTestId: 'member-nav-quickdashboard-stepup',
    description: Object(i18n["h" /* t */])('account.authenticated.quickLogin.signinDescription'),
    icon: icons["a" /* ICONS */].CONNECT,
    isExternalLink: true,
    label: Object(i18n["h" /* t */])('account.authenticated.quickLogin.signin'),
    onClick: function onClick() {
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_stepUp'
      });
      Object(cacheFront["a" /* clearAllCacheFront */])();
    },
    url: Object(routeBuilder["b" /* urlPattern */])('stepup')
  }, {
    dataTestId: 'member-nav-quickdashboard-Signout',
    icon: icons["a" /* ICONS */].DISCONNECTION,
    isExternalLink: true,
    label: Object(i18n["h" /* t */])('account.authenticated.quickLogin.signout'),
    onClick: function onClick() {
      Object(cacheFront["a" /* clearAllCacheFront */])();
      Object(signout["b" /* default */])();
      closeMemberPanel && closeMemberPanel();
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_CA_NAV, {
        detail_click: 'memberSpace_logout'
      });
    },
    url: signoutUrl
  }];
  return QuickLoggedNav_jsx("nav", null, items.filter(function (i) {
    return !i.hide;
  }).map(function (_ref2, index) {
    var dataTestId = _ref2.dataTestId,
        description = _ref2.description,
        icon = _ref2.icon,
        isExternalLink = _ref2.isExternalLink,
        label = _ref2.label,
        onClick = _ref2.onClick,
        target = _ref2.target,
        url = _ref2.url;
    return QuickLoggedNav_jsx("div", {
      className: Object(classnames_utils["a" /* classnames */])('p-10', {
        'border-t-1': index > 0
      }),
      key: url
    }, description && QuickLoggedNav_jsx("p", {
      className: "text-10 text-black"
    }, description), QuickLoggedNav_jsx(DynamicLink["a" /* default */], {
      className: "flex items-center gap-10 text-16 font-bold leading-tight text-black transition-color hocus:text-sienna",
      "data-testid": dataTestId,
      isExternalLink: isExternalLink,
      queryParamsToIgnore: ['coderesort', 'hasSaveOption', 'selectedProposalId', 'proposalIds', 'optionIds'],
      onClick: onClick,
      target: target,
      url: url
    }, icon && QuickLoggedNav_jsx(Icon["a" /* Icon */], {
      name: icon,
      width: "1.25rem"
    }), label));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/quicklogged-nav/QuickLoggedNav.container.js




function mapStateToProps(state) {
  return {
    bookingId: get_default()(state, 'memberSpace.quickLogin.bookingId'),
    stayId: get_default()(state, 'memberSpace.quickLogin.stayId')
  };
}

var QuickLoggedNavContainer = Object(es["c" /* connect */])(mapStateToProps)(QuickLoggedNav_QuickLoggedNav);
// CONCATENATED MODULE: ./src/client/components/widgets/member-nav/MemberNav.jsx
var MemberNav_jsx = react_default.a.createElement;





var MemberNav_MemberNav = function MemberNav(_ref) {
  var closeMemberPanel = _ref.closeMemberPanel,
      userInfo = _ref.userInfo;

  var _useRouter = Object(router["useRouter"])(),
      cxoNeolid = _useRouter.query.cxo_neolid;

  if (userInfo.isQuickLoggedIn) {
    return MemberNav_jsx(QuickLoggedNavContainer, {
      closeMemberPanel: closeMemberPanel
    });
  }

  if (userInfo.isLoggedIn || cxoNeolid) {
    return MemberNav_jsx(LoggedNav_LoggedNav, {
      closeMemberPanel: closeMemberPanel,
      userInfo: userInfo
    });
  }

  return MemberNav_jsx(MemberSignIn_container_MemberSignInContainer, null);
};
// EXTERNAL MODULE: ./src/utils/string/stringUtils.js
var stringUtils = __webpack_require__("E8Xq");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation/member-access/NavigationMemberAccess.jsx

var NavigationMemberAccess_jsx = react_default.a.createElement;





var NavigationMemberAccess_getUserInfo = function getUserInfo() {
  var _userInfo$unicodeFirs, _userInfo$firstName, _userInfo$unicodeLast, _userInfo$lastName;

  var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    firstName: ((_userInfo$unicodeFirs = userInfo.unicodeFirstName) === null || _userInfo$unicodeFirs === void 0 ? void 0 : _userInfo$unicodeFirs.trim()) || Object(stringUtils["c" /* capitalizeWordFirstCaracter */])((_userInfo$firstName = userInfo.firstName) === null || _userInfo$firstName === void 0 ? void 0 : _userInfo$firstName.trim()),
    isLoggedIn: !!userInfo.isLoggedIn,
    isQuickLoggedIn: !!userInfo.isQuickLoggedIn,
    lastName: ((_userInfo$unicodeLast = userInfo.unicodeLastName) === null || _userInfo$unicodeLast === void 0 ? void 0 : _userInfo$unicodeLast.trim()) || Object(stringUtils["c" /* capitalizeWordFirstCaracter */])((_userInfo$lastName = userInfo.lastName) === null || _userInfo$lastName === void 0 ? void 0 : _userInfo$lastName.trim())
  };
};

var NavigationMemberAccess_NavigationMemberAccess = function NavigationMemberAccess(_ref) {
  var closeMemberPanel = _ref.closeMemberPanel,
      userInfo = _ref.userInfo;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var userInfos = NavigationMemberAccess_getUserInfo(userInfo);
  return NavigationMemberAccess_jsx(MemberNav_MemberNav, {
    closeMemberPanel: closeMemberPanel,
    userInfo: userInfos
  });
};

/***/ }),

/***/ "ubam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROFILE_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notifyProfileChanged; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("fYnN");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("H6pA");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("rJ95");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





var PROFILE_CHANGED = 'PLE_PROFILE_CHANGED';

function refreshCookie(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      unicodeFirstName = _ref.unicodeFirstName,
      unicodeLastName = _ref.unicodeLastName;
  var info = js_cookie__WEBPACK_IMPORTED_MODULE_8___default.a.get(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_10__[/* USER_INFO */ "e"]);
  var actualState = info ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_9__["oidc"].fromUriEncodedState(info) : {};
  js_cookie__WEBPACK_IMPORTED_MODULE_8___default.a.set(_utils_ple_utils_cookies__WEBPACK_IMPORTED_MODULE_10__[/* USER_INFO */ "e"], _clubmed_utils__WEBPACK_IMPORTED_MODULE_9__["oidc"].toUriEncodedState(_objectSpread(_objectSpread({}, actualState), {}, {
    firstName: firstName,
    lastName: lastName,
    unicodeFirstName: unicodeFirstName,
    unicodeLastName: unicodeLastName
  })));
}

function notifyProfileChanged(newProfile) {
  refreshCookie(newProfile);
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_11__[/* default */ "b"])(PROFILE_CHANGED, newProfile);
}

/***/ }),

/***/ "ulNE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var flattenIntoArray = __webpack_require__("42ly");
var toObject = __webpack_require__("N9G2");
var toLength = __webpack_require__("tJVe");
var toInteger = __webpack_require__("i7Kn");
var arraySpeciesCreate = __webpack_require__("aoZ+");

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});


/***/ }),

/***/ "unIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DATA_SCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_SCORE_SESSION_STORAGE_KEY; });
var SET_DATA_SCORE = 'SET_DATA_SCORE';
var DATA_SCORE_SESSION_STORAGE_KEY = 'cmLeadScore';


/***/ }),

/***/ "urw/":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("7St7");

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');


/***/ }),

/***/ "v315":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ rootReducer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/session-storage-api/sessionStorageApi.js
var sessionStorageApi = __webpack_require__("9NGo");

// EXTERNAL MODULE: ./src/client/store/lead-info/constants.js
var constants = __webpack_require__("unIT");

// CONCATENATED MODULE: ./src/client/store/lead-info/leadInfo.reducer.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var initialState = {
  score: parseFloat(Object(sessionStorageApi["b" /* getFromSessionStorage */])(constants["a" /* DATA_SCORE_SESSION_STORAGE_KEY */])) || 0
};

var leadInfo_reducer_leadInfosReducer = function leadInfosReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  if (type === constants["b" /* SET_DATA_SCORE */]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      score: payload.score
    });
  }

  return state;
};


// EXTERNAL MODULE: /opt/webapp/node_modules/redux-optimist-promise/build/index.js
var build = __webpack_require__("b0q8");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/client/store/streetViews/constants.js
var streetViews_constants = __webpack_require__("Xvk6");

// CONCATENATED MODULE: ./src/client/store/streetViews/streetViews.reducer.js



var streetViews_reducer_initialState = [];
function streetViewsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : streetViews_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case proposals_constants["v" /* PREPARE_BE */]:
    case Object(build["resolve"])(streetViews_constants["a" /* FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID */]):
      {
        var _action$payload;

        return (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.streetViews) || [];
      }

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/customer-search/customerSearch.reducer.js
var SET_CUSTOMER_SEARCH_RESULT = 'SET_CUSTOMER_SEARCH_RESULT';
var UNSET_CUSTOMER_SEARCH_RESULT = 'UNSET_CUSTOMER_SEARCH_RESULT';
var customerSearch_reducer_initialState = {};
var customerSearch = function customerSearch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : customerSearch_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_CUSTOMER_SEARCH_RESULT:
      return action.payload;

    case UNSET_CUSTOMER_SEARCH_RESULT:
      return customerSearch_reducer_initialState;

    default:
      return state;
  }
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.flat.js
var es_array_flat = __webpack_require__("ulNE");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.unscopables.flat.js
var es_array_unscopables_flat = __webpack_require__("urw/");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/constants.js
var store_constants = __webpack_require__("cvSI");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/has.js
var has = __webpack_require__("1mr4");
var has_default = /*#__PURE__*/__webpack_require__.n(has);

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.reducer.utils.js















function proposals_reducer_utils_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function proposals_reducer_utils_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? proposals_reducer_utils_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : proposals_reducer_utils_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function getTransportsWithTransfer(proposal) {
  return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.transports), {}, {
    inbound: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, get_default()(proposal, 'transports.inbound')), {}, {
      transferIncluded: true
    }),
    outbound: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, get_default()(proposal, 'transports.outbound')), {}, {
      transferIncluded: true
    })
  });
}

function setTransferIncludedInProposal(proposal) {
  return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), has_default()(proposal, 'transports.inbound') && has_default()(proposal, 'transports.outbound') ? {
    transports: getTransportsWithTransfer(proposal)
  } : null);
}

function updateProposal(proposalId, state, updateFn) {
  var indexToUpdate = state.findIndex(function (p) {
    return get_default()(p, 'id') === proposalId;
  });
  return indexToUpdate !== -1 ? state.map(function (proposal, index) {
    return index === indexToUpdate ? updateFn(proposal) : proposal;
  }) : state;
}

function updateTransfers(state, proposalFields) {
  if (isEmpty_default()(proposalFields)) {
    return state;
  }

  var updateFn = function updateFn(proposal) {
    var currentProposal = proposalFields.find(function (_ref) {
      var id = _ref.id;
      return id === get_default()(proposal, 'id');
    }) || {};
    var price = currentProposal.price,
        availableTransfers = currentProposal.availableTransfers,
        paymentSchedule = currentProposal.paymentSchedule,
        selectedTransfers = currentProposal.selectedTransfers;
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      price: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.price), price),
      paymentSchedule: paymentSchedule,
      availableTransfers: availableTransfers || proposal.availableTransfers,
      selectedTransfers: selectedTransfers || proposal.selectedTransfers
    });
  };

  return state.map(updateFn);
}

function updateTransportError(state, proposalId, error) {
  var updateFn = function updateFn(proposal) {
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      transports: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.transports), {}, {
        error: error
      })
    });
  }; // $FlowFixMe


  return updateProposal(proposalId, state, updateFn);
}

function updateAttendees(state, proposalFields) {
  if (!proposalFields) {
    return state;
  }

  var price = proposalFields.price,
      attendees = proposalFields.attendees,
      attendeesPrice = proposalFields.attendeesPrice,
      households = proposalFields.households;

  var updateFn = function updateFn(proposal) {
    return proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal), {}, {
      price: price,
      attendees: proposals_reducer_utils_objectSpread(proposals_reducer_utils_objectSpread({}, proposal.attendees), {}, {
        list: attendees.list
      }),
      households: households,
      attendeesPrice: attendeesPrice
    });
  }; // $FlowFixMe


  return updateProposal(proposalFields.id, state, updateFn);
}


// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.reducer.js



















function proposals_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function proposals_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? proposals_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : proposals_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var proposals_reducer_initialState = [];
function proposalsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : proposals_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case proposals_constants["v" /* PREPARE_BE */]:
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
      {
        var proposals = get_default()(action, 'payload.proposals.proposals', []).map(setTransferIncludedInProposal).sort(proposalUtils["c" /* compareProposalsByComfort */]);

        var errors = get_default()(action, 'payload.proposals.errors', []);

        proposals.forEach(function (proposal) {
          if (proposal.transports) {
            Object(proposalUtils["x" /* saveRecommendedTransport */])(proposal.transports, proposal.id);
          }
        });
        return [].concat(Object(toConsumableArray["a" /* default */])(proposals), Object(toConsumableArray["a" /* default */])(errors));
      }

    case Object(build["resolve"])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
      {
        var selectedProposalId = get_default()(action, 'meta.payload.selectedProposalId');

        return state.map(function (proposal) {
          if (proposal.id !== selectedProposalId) {
            return proposal;
          }

          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
            households: proposal.households.map(function (household, index) {
              return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, household), {}, {
                paymentSchedule: action.payload.proposal.households[index].paymentSchedule
              });
            })
          });
        });
      }

    case Object(build["reject"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
      {
        // $FlowFixMe
        return [{
          errorCode: 500
        }];
      }

    case proposals_constants["G" /* SET_PROPOSALS */]:
      return get_default()(action, 'payload.proposals');

    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
      return action.payload.addAccommodation || state;

    case Object(build["resolve"])(proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]):
      {
        var updatedProposal = action.payload.addAccommodation[0];
        return state.map(function (proposal) {
          if (proposal.id === updatedProposal.id) {
            return updatedProposal;
          }

          return proposal;
        });
      }

    case proposals_constants["J" /* UPDATE_ATTENDEES */]:
      return updateAttendees(state, get_default()(action, 'payload.proposal'));

    case proposals_constants["m" /* FETCH_PROPOSALS */]:
    case proposals_constants["h" /* CLEAR_PROPOSALS */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["p" /* UPDATE_TRIP_DATE_CRITERIA */]:
      return proposals_reducer_initialState;

    case Object(build["resolve"])(proposals_constants["e" /* ADD_TRANSFER_TO_PROPOSALS */]):
      {
        var transfersAdded = get_default()(action, 'payload', []).map(function (item) {
          return get_default()(item, 'addTransfer');
        }).flat();

        return updateTransfers(state, transfersAdded);
      }

    case Object(build["resolve"])(proposals_constants["B" /* REMOVE_TRANSFER_FROM_PROPOSALS */]):
      {
        var transfersRemoved = get_default()(action, 'payload', []).map(function (item) {
          return get_default()(item, 'removeTransfer');
        }).flat();

        return updateTransfers(state, transfersRemoved);
      }

    case Object(build["resolve"])(proposals_constants["f" /* ADD_TRANSPORT */]):
      {
        if (!action.payload.addTransport) {
          return state;
        }

        return action.payload.addTransport.map(function (proposal) {
          return setTransferIncludedInProposal(proposal);
        });
      }

    case Object(build["reject"])(proposals_constants["f" /* ADD_TRANSPORT */]):
      var transportExpiredError = get_default()(action, 'payload.errors', []).find(function (error) {
        return get_default()(error, 'statusCode') === 400;
      });

      var proposalId = get_default()(action, 'meta.payload.proposalId');

      var errorInfo = pick_default()(transportExpiredError, ['statusCode', 'message']);

      return transportExpiredError ? updateTransportError(state, proposalId, errorInfo) : state;

    case Object(build["resolve"])(proposals_constants["F" /* SET_PROMO_CODE */]):
    case Object(build["resolve"])(proposals_constants["A" /* REMOVE_PROMO_CODE */]):
      return state.map(function (proposal) {
        if (proposal.id === get_default()(action, 'payload.promoCodeProposal.id')) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
            price: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal.price), {}, {
              aggregateDiscount: get_default()(action, 'payload.promoCodeProposal.price.aggregateDiscount'),
              aggregateDiscountPromoCode: get_default()(action, 'payload.promoCodeProposal.price.aggregateDiscountPromoCode'),
              promoCode: get_default()(action, 'payload.promoCodeProposal.price.promoCode'),
              discounts: get_default()(action, 'payload.promoCodeProposal.price.discounts'),
              total: get_default()(action, 'payload.promoCodeProposal.price.total')
            }),
            paymentSchedule: get_default()(action, 'payload.promoCodeProposal.paymentSchedule'),
            attendeesPrice: get_default()(action, 'payload.promoCodeProposal.attendeesPrice')
          });
        }

        return proposal;
      });

    case proposals_constants["K" /* UPDATE_INSURANCES */]:
      var proposalFields = get_default()(action, 'payload.modifyInsurances.proposal');

      if (!proposalFields) {
        return state;
      }

      return updateProposal(proposalFields.id, state, function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          price: proposalFields.price,
          paymentSchedule: proposalFields.paymentSchedule,
          attendeesPrice: proposalFields.attendeesPrice
        });
      });

    case proposals_constants["i" /* DELETE_INSURANCES */]:
      var proposalDeleteInsurances = get_default()(action, 'payload.deleteInsurances.proposal');

      if (!proposalDeleteInsurances) {
        return state;
      }

      return updateProposal(proposalDeleteInsurances.id, state, function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          price: proposalDeleteInsurances.price,
          paymentSchedule: proposalDeleteInsurances.paymentSchedule,
          attendeesPrice: proposalDeleteInsurances.attendeesPrice
        });
      });

    case proposals_constants["E" /* SAVE_DONATION_TO_PROPOSALS */]:
      return state.map(function (proposal) {
        return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), {}, {
          price: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal.price), {}, {
            donation: action.payload
          }),
          households: proposal.households.map(function (household) {
            var _household$paymentSch;

            var formatAmount = function formatAmount(amount) {
              return Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(amount + action.payload.value, proposal.originalLocale || '', proposal.price.currency, {
                precision: 2
              });
            };

            return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, household), {}, {
              paymentSchedule: household.paymentSchedule ? proposals_reducer_objectSpread(proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, household.paymentSchedule), ((_household$paymentSch = household.paymentSchedule) === null || _household$paymentSch === void 0 ? void 0 : _household$paymentSch.depositAmount) ? {
                depositAmount: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, household.paymentSchedule.depositAmount), {}, {
                  formattedValue: formatAmount(household.paymentSchedule.depositAmount.value)
                })
              } : {}), {}, {
                total: proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, household.paymentSchedule.total), {}, {
                  formattedValue: formatAmount(household.paymentSchedule.total.value)
                })
              }) : household.paymentSchedule
            });
          })
        });
      });

    case Object(build["resolve"])(proposals_constants["d" /* ADD_SERVICE */]):
    case Object(build["resolve"])(proposals_constants["L" /* UPDATE_SERVICES */]):
    case Object(build["resolve"])(proposals_constants["j" /* DELETE_SERVICE */]):
      {
        // $FlowFixMe
        var data = Object.values(action.payload)[0];
        return state.map(function (proposal) {
          var proposalData = data.find(function (_ref) {
            var id = _ref.id;
            return id === proposal.id;
          });

          if (proposalData) {
            return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), proposalData);
          }

          return proposal;
        });
      }

    case Object(build["resolve"])(proposals_constants["H" /* SWITCH_PROPOSALS_OFFERS */]):
      return state.map(function (proposal) {
        var proposalData = action.payload.proposals.find(function (_ref2) {
          var id = _ref2.id;
          return id === proposal.id;
        });

        if (proposalData) {
          return proposals_reducer_objectSpread(proposals_reducer_objectSpread({}, proposal), proposalData);
        }

        return proposals_reducer_objectSpread({}, proposal);
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/proposals/insurance/insurance.reducer.js









function insurance_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function insurance_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? insurance_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : insurance_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var insurance_reducer_initialState = {};
var insurance_reducer_insuranceReducer = function insuranceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : insurance_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case proposals_constants["q" /* INIT_INSURANCES */]:
      return payload;

    case proposals_constants["r" /* INSURANCE_ADDED */]:
      return insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, payload, insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state[payload]), {}, {
        isDeleted: false,
        isAdded: true
      })));

    case proposals_constants["s" /* INSURANCE_DELETED */]:
      return insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, payload, insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state[payload]), {}, {
        isAdded: false,
        isDeleted: true
      })));

    case proposals_constants["I" /* TOGGLE_TERMS */]:
      return insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state), {}, Object(defineProperty["a" /* default */])({}, payload, insurance_reducer_objectSpread(insurance_reducer_objectSpread({}, state[payload]), {}, {
        // $FlowFixMe
        termsChecked: !(state[payload] && state[payload].termsChecked)
      })));

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/booking/resort/resort.reducer.js






var resort_reducer_initialState = null;
function resortReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : resort_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
      {
        return get_default()(action, 'payload.proposals.resort', null);
      }

    case proposals_constants["v" /* PREPARE_BE */]:
      return get_default()(action, 'payload.resort', null);

    case proposals_constants["m" /* FETCH_PROPOSALS */]:
    case proposals_constants["h" /* CLEAR_PROPOSALS */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["p" /* UPDATE_TRIP_DATE_CRITERIA */]:
      return resort_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// CONCATENATED MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalIdReducer.reducer.js


var selectedProposalIdReducer_reducer_initialState = null;

function selectedProposalIdReducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedProposalIdReducer_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["v" /* PREPARE_BE */]:
    case selectedProposalId_action["b" /* SELECT_PROPOSAL */]:
      return action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.proposalId;

    case selectedProposalId_action["a" /* CLEAR_SELECTED_PROPOSAL */]:
      return selectedProposalIdReducer_reducer_initialState;

    default:
      return state;
  }
}


// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// CONCATENATED MODULE: ./src/client/store/booking/best-proposal-id/bestProposalId.reducer.js











var bestProposalId_reducer_initialState = null;
function bestProposalIdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bestProposalId_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
      {
        var proposals = Object(toConsumableArray["a" /* default */])(get_default()(action, 'payload.proposals.proposals', [])).sort(proposalUtils["c" /* compareProposalsByComfort */]);

        return get_default()(proposals, '[0].id', null);
      }

    case proposals_constants["G" /* SET_PROPOSALS */]:
      {
        return get_default()(action, 'payload.proposals[0].id', null);
      }

    case Object(build["reject"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]):
    case proposals_constants["h" /* CLEAR_PROPOSALS */]:
    case duration_constants["c" /* TRIP_INFORMATION_SET_DURATION */]:
    case departure_city_constants["b" /* TRIP_INFORMATION_SET_DEPARTURE_CITY */]:
    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
    case store_constants["p" /* UPDATE_TRIP_DATE_CRITERIA */]:
      {
        return bestProposalId_reducer_initialState;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.action.js + 1 modules
var additionalAccommodations_action = __webpack_require__("06Jt");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-loading/isLoading.reducer.js



var isLoading_reducer_initialState = false;

function isLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isLoading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return true;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var isLoading_reducer = (isLoadingReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/accommodations-sets/accommodationsSets.reducer.js










function accommodationsSets_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function accommodationsSets_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? accommodationsSets_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : accommodationsSets_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var accommodationsSets_reducer_initialState = [];

function accommodationsSetsReducer() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : accommodationsSets_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return accommodationsSets_reducer_initialState;

    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return ((action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.additionalAccommodations) || []
      /**
       * Sometimes we get a corner case from API responses where arrangement accommodation does not match any of resort accommodations
       * In this case we could get and accommodationsSet with empty accommodations field... It makes no sense to display it to the user
       * See https://github.com/ClubMediterranee/cm-b2c/issues/14959
       */
      ).filter(function (additionalAccommodationSet) {
        return additionalAccommodationSet.accommodations && additionalAccommodationSet.accommodations.length > 0;
      }).map(function (accommodation, index) {
        return accommodationsSets_reducer_objectSpread(accommodationsSets_reducer_objectSpread({}, accommodation), {}, {
          accommodationSetNumber: index + 1
        });
      });

    default:
      return state;
  }
}

/* harmony default export */ var accommodationsSets_reducer = (accommodationsSetsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/error/error.reducer.js



var error_reducer_initialState = null;

function additionalAccommodationsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return error_reducer_initialState;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      var error = get_default()(action, 'payload.errors[0]', {});

      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR',
        errorCode: get_default()(action, 'payload.errors[0].errorCode')
      };

    default:
      return state;
  }
}

/* harmony default export */ var error_reducer = (additionalAccommodationsErrorReducer);
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: ./src/client/components/widgets/additional-accommodations/AdditionalAccommodationsUtils.js
var AdditionalAccommodationsUtils = __webpack_require__("CwJu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("WNMA");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/findLast.js
var findLast = __webpack_require__("GFPz");
var findLast_default = /*#__PURE__*/__webpack_require__.n(findLast);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/slice.js
var slice = __webpack_require__("+n+S");
var slice_default = /*#__PURE__*/__webpack_require__.n(slice);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/take.js
var take = __webpack_require__("W1ge");
var take_default = /*#__PURE__*/__webpack_require__.n(take);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/find.js
var find = __webpack_require__("6R5o");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/intersectionBy.js
var intersectionBy = __webpack_require__("wyfB");
var intersectionBy_default = /*#__PURE__*/__webpack_require__.n(intersectionBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/groupBy.js
var groupBy = __webpack_require__("Rj53");
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: ./src/utils/accommodation/accommodation.constants.js
var accommodation_constants = __webpack_require__("lZ21");

// CONCATENATED MODULE: ./src/client/store/filters/filtersHelper.js



























function filtersHelper_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function filtersHelper_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? filtersHelper_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : filtersHelper_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var defaultMatch = function defaultMatch(a, b) {
  return a === b;
};

function _getMatcher(filter) {
  return filter.match || defaultMatch;
}

function _matchFilter(data) {
  return function (filter) {
    var dataValue = get_default()(data, filter.path);

    var filterValue = filter.value;
    return _getMatcher(filter)(dataValue, filterValue);
  };
}

function _toggleFilter(filters) {
  return function (toggledFilter) {
    return filters.map(function (filter) {
      var shouldToggleFilter = filter.path === toggledFilter.path && filter.value === toggledFilter.value;
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        selected: shouldToggleFilter ? !filter.selected : filter.selected
      });
    });
  };
}

function _filterDataSet(dataSet, filters) {
  var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };
  var activeFilters = filters.filter(function (f) {
    return condition(f) === true;
  });
  return dataSet.filter(function (data) {
    var match = _matchFilter(data);

    return isEmpty_default()(activeFilters) || activeFilters.some(function (activeFilter) {
      return match(activeFilter);
    });
  });
}

function _removeUnusedFilters(filters) {
  return filters.map(function (filter) {
    return filter.selected === true && filter.matchedOccurrences === 0 ? filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
      selected: false
    }) : filter;
  });
}

function filterDataSetWithSelectedAndMatchedFilters(dataSet, filters) {
  return _filterDataSet(dataSet, filters, function (filter) {
    return filter.selected && get_default()(filter, 'matchedOccurrences', 0) > 0;
  });
}

function getDataSetIfFilterWasSelected(dataSet, filter) {
  return _filterDataSet(dataSet, [filter]);
}

function getFiltersWithMatchedOccurrences(dataSet) {
  return function (filters) {
    // First, we group all filters by their path
    var filtersByCategory = groupBy_default()(filters, 'category');

    return filters.map(function (filter) {
      // Then, for every filter, we get all data objects matching all active filters in all other categories
      var matchedResultsInOtherCategories = Object.keys(filtersByCategory).filter(function (category) {
        return category !== filter.category;
      }).map(function (filterKey) {
        return filterDataSetWithSelectedAndMatchedFilters(dataSet, get_default()(filtersByCategory, filterKey));
      }); // Then, we activate the current filter (whether its current activation state) and get all data objects matching only this filter

      var matchedResultsForCurrentFilter = getDataSetIfFilterWasSelected(dataSet, filter);
      var matchResults = intersectionBy_default()(matchedResultsForCurrentFilter, matchedResultsForCurrentFilter, 'id') || []; // Finally, The intersection gives us the list of results matching all our active filters
      // prettier-ignore

      var matchedOccurrences = ( // $FlowFixMe
      intersectionBy_default.a.apply(void 0, Object(toConsumableArray["a" /* default */])(matchedResultsInOtherCategories).concat([matchResults, 'id'])) || []).length;
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        matchedOccurrences: matchedOccurrences
      });
    });
  };
}

function _activateFilter(filters, valuesToActivate) {
  return filters.map(function (filter) {
    var matchedOccurrences = get_default()(filter, 'matchedOccurrences', 0);

    if (matchedOccurrences > 0 && valuesToActivate.includes(filter.value)) {
      return filtersHelper_objectSpread(filtersHelper_objectSpread({}, filter), {}, {
        selected: true
      });
    }

    return filter;
  });
}

function getPreselectedFilters(filters, selectedProposal) {
  var accommodationFilters = filters.filter(function (f) {
    return f.category === 'accommodations' && get_default()(f, 'matchedOccurrences', 0) > 0;
  }); // categoryId is the comfort level of the room, used as value for comfort filters

  var selectedProposalComfort = get_default()(selectedProposal, 'accommodations[0].categoryId');

  var selectedProposalComfortOrder = accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */].indexOf(selectedProposalComfort); // at first, activate filters equal to selected proposal comfort level
  // and those with higher comfort level

  var higherComfortCodes = slice_default()(accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */], selectedProposalComfortOrder);

  var filtersToActivate = higherComfortCodes.filter(function (code) {
    return find_default()(accommodationFilters, {
      value: code
    });
  }); // if no equal or higher comfort level filter found,
  // activate the one below the selected proposal comfort level

  if (filtersToActivate.length === 0) {
    var lowerComfortCodes = take_default()(accommodation_constants["a" /* ACCOMMODATION_COMFORT_ORDER */], selectedProposalComfortOrder); // use findLast to start from the end of the array
    // and get the highest comfort level possible


    var codeToActivate = findLast_default()(lowerComfortCodes, function (code) {
      return find_default()(accommodationFilters, {
        value: code
      });
    });

    codeToActivate && filtersToActivate.push(codeToActivate);
  }

  switch (selectedProposalComfort) {
    // if selected proposal comfort level is club, club seaside view
    // or superior (default state), do not activate any filter
    case '000017': // club

    case '000048': // club seaside view

    case '000061':
      // superior
      return filters;

    default:
      return _activateFilter(filters, filtersToActivate);
  }
}

function updateFilters(dataSet) {
  return function (filters) {
    var updateMatchOccurrences = getFiltersWithMatchedOccurrences(dataSet);
    var updatedOccurrencesFilters = updateMatchOccurrences(filters);
    return _removeUnusedFilters(updatedOccurrencesFilters);
  };
}

function toggleFilter(dataSet) {
  return function (filters, toggledFilter) {
    var updatedToggleFilters = _toggleFilter(filters)(toggledFilter);

    return updateFilters(dataSet)(updatedToggleFilters);
  };
}

function filterDataSet(dataSet, filters) {
  if (!filters) {
    return dataSet;
  }

  var filtersByCategory = groupBy_default()(filters, 'category');

  return Object.keys(filtersByCategory) // $FlowFixMe
  .reduce(function (filteredResults, category) {
    return filterDataSetWithSelectedAndMatchedFilters(filteredResults, filtersByCategory[category]);
  }, dataSet);
}


// EXTERNAL MODULE: ./src/client/store/booking/additional-accommodations/filters/filterUtils.js + 1 modules
var filterUtils = __webpack_require__("KxdP");

// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filters/filters.reducer.js







var filters_reducer_initialState = null;
function filtersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filters_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = get_default()(action, 'payload.additionalAccommodations') || [];
  var reducedMobilityVisibility = get_default()(action, 'payload.reducedMobilityVisibility') || false;
  var proposal = get_default()(action, 'payload.selectedProposal') || null; // remove initial accommodation (related to selected proposal) from additional accommodations

  var filteredAdditionalAccommodations = (proposal && additionalAccommodations.length ? Object(AdditionalAccommodationsUtils["a" /* filterAccommodations */])(proposal, additionalAccommodations) : additionalAccommodations).filter(function (data) {
    return reducedMobilityVisibility ? true : data.accommodations.every(function (accomodation) {
      return !accomodation.reducedMobilityAccess;
    });
  });
  var getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(filteredAdditionalAccommodations);

  var removeNoMatchedOccurencesConfigurationFilters = function removeNoMatchedOccurencesConfigurationFilters(filters) {
    return filters === null || filters === void 0 ? void 0 : filters.filter(function (filter) {
      var shouldKeepFilter = filter.category !== 'configuration' || filter.category === 'configuration' && !!filter.matchedOccurrences;
      return shouldKeepFilter;
    });
  };

  switch (action.type) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return filters_reducer_initialState;

    case additionalAccommodations_action["b" /* CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS */]:
      {
        var _action$payload = action.payload,
            product = _action$payload.product,
            selectedProposal = _action$payload.selectedProposal,
            shouldPreselectFilters = _action$payload.shouldPreselectFilters;
        var filters = Object(filterUtils["a" /* createFilters */])(filteredAdditionalAccommodations, product);
        var filtersWithOccurences = getFiltersWithOccurrences(filters);
        var cleanedFilters = removeNoMatchedOccurencesConfigurationFilters(filtersWithOccurences);
        return cleanedFilters && shouldPreselectFilters ? getPreselectedFilters(cleanedFilters, selectedProposal) : cleanedFilters;
      }

    case additionalAccommodations_action["i" /* UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS */]:
      return updateFilters(filteredAdditionalAccommodations)(state || []);

    case additionalAccommodations_action["e" /* TOGGLE_ACCOMMODATIONS_FILTER */]:
      var filter = action.payload.filter;
      return toggleFilter(filteredAdditionalAccommodations)(state || [], filter);

    case additionalAccommodations_action["f" /* TOGGLE_EXTRA_FEATURES */]:
      {
        var accommodationsSets = action.payload.accommodationsSets;
        return Object(filterUtils["c" /* handleReducedMobilityFilter */])(accommodationsSets, reducedMobilityVisibility, state);
      }

    case additionalAccommodations_action["h" /* UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY */]:
      var category = action.payload.category;
      var updatedFilters = Object(filterUtils["d" /* unselectCategory */])(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-data-fetched/isDataFetched.reducer.js


var isDataFetched_reducer_initialState = false;
function isDataFetched() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isDataFetched_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
      return false;

    case Object(build["reject"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
    case Object(build["resolve"])(additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]):
      return true;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-pmr-checked/isPmrChecked.reducer.js

var isPmrChecked_reducer_initialState = false;
function isPmrChecked() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isPmrChecked_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case additionalAccommodations_action["g" /* TOGGLE_PMR_CHECKBOX */]:
      return action.payload.isChecked;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filtered-accommodations/filteredAccommodations.reducer.js



var filteredAccommodations_reducer_initialState = null;

function filteredAccommodationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filteredAccommodations_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = get_default()(action, 'payload.additionalAccommodations') || [];
  var filters = get_default()(action, 'payload.filters') || [];

  switch (get_default()(action, 'type')) {
    case additionalAccommodations_action["a" /* CLEAR_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return filteredAccommodations_reducer_initialState;

    case additionalAccommodations_action["j" /* UPDATE_FILTERED_ACCOMMODATIONS_RESULTS */]:
      return filterDataSet(additionalAccommodations, filters);

    default:
      return state;
  }
}

/* harmony default export */ var filteredAccommodations_reducer = (filteredAccommodationsReducer);
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/accommodation-room/infos/AccommodationRoomInfos.utils.js
var AccommodationRoomInfos_utils = __webpack_require__("OsvN");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/store/filteredAccommodationsByComfort/filteredAccommodationsByComforHelper.js















function filteredAccommodationsByComforHelper_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function filteredAccommodationsByComforHelper_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? filteredAccommodationsByComforHelper_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : filteredAccommodationsByComforHelper_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





function allAccommodationsHaveTheSameCategory(accommodationSet) {
  var accommodations = accommodationSet.accommodations;
  var firstAccommodationCategory = accommodations[0].categoryId;
  return accommodations.every(function (_ref) {
    var currentCategoryId = _ref.categoryId;
    return currentCategoryId === firstAccommodationCategory;
  });
} //check if it already has the caregoryId


function getCategoryIndex(categorizedAccommodationsArray, currentCategoryId) {
  return categorizedAccommodationsArray.findIndex(function (_ref2) {
    var categoryId = _ref2.categoryId;
    return currentCategoryId === categoryId;
  });
} //if not ie == -1


function addNewComfortToArray(categorizedAccommodationsArray, accommodationSet) {
  var firstAccommodation = accommodationSet.accommodations[0];
  var viewsAvailable = [];
  var outsideFacilitiesAvailable = [];
  var roomTypesAvailable = [];
  var accommodations = accommodationSet.accommodations;
  var noView = {
    id: AccommodationRoomInfos_utils["e" /* NO_VIEW_ICON_ID */],
    label: Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noViewLabel')
  };
  var no_outside_facility = {
    id: AccommodationRoomInfos_utils["d" /* NO_OUTSIDE_FACILITY_ICON_ID */],
    label: Object(i18n["h" /* t */])('booking.accommodation.roomFinder.noFacilitiesLabel')
  };
  accommodations.forEach(function (_ref3) {
    var view = _ref3.view,
        outsideFacilities = _ref3.outsideFacilities,
        roomType = _ref3.roomType;
    viewsAvailable.push(view || noView);
    outsideFacilitiesAvailable.push((outsideFacilities === null || outsideFacilities === void 0 ? void 0 : outsideFacilities[0]) || no_outside_facility); //array that always contain one element

    roomType && roomTypesAvailable.push({
      id: roomType
    });
  });
  var id = firstAccommodation.id,
      categoryId = firstAccommodation.categoryId;
  categorizedAccommodationsArray.push({
    id: id,
    categoryId: categoryId,
    availableFilters: {
      view: viewsAvailable ? uniqBy_default()(viewsAvailable, 'id').map(function (view) {
        return filteredAccommodationsByComforHelper_objectSpread(filteredAccommodationsByComforHelper_objectSpread({}, view), {}, {
          firstAlternativeId: accommodationSet.id,
          icon: icons["a" /* ICONS */][get_default()(view, 'id')] || icons["a" /* ICONS */].TRIDENT
        });
      }) : [],
      //HERE
      outsideFacilities: outsideFacilitiesAvailable ? uniqBy_default()(outsideFacilitiesAvailable, 'id').map(function (outsideFacility) {
        return filteredAccommodationsByComforHelper_objectSpread(filteredAccommodationsByComforHelper_objectSpread({}, outsideFacility), {}, {
          firstAlternativeId: accommodationSet.id,
          icon: icons["a" /* ICONS */][get_default()(outsideFacility, 'id')] || icons["a" /* ICONS */].TRIDENT
        });
      }) : [],
      roomType: roomTypesAvailable ? uniqBy_default()(roomTypesAvailable, 'id').map(function (roomType) {
        return filteredAccommodationsByComforHelper_objectSpread(filteredAccommodationsByComforHelper_objectSpread({}, roomType), {}, {
          firstAlternativeId: accommodationSet.id,
          icon: icons["a" /* ICONS */][get_default()(roomType, 'id')] || icons["a" /* ICONS */].TRIDENT
        });
      }) : []
    }
  });
}

function getFiltersAndAlternativesByComfort(accommodationSets) {
  var categorizedAccommodationsArray = []; //Remove the accommodationSets with different comfort categories (ie : deluxe + superieur)

  var filteredAccommodationSets = accommodationSets.filter(function (accommodationSet) {
    return allAccommodationsHaveTheSameCategory(accommodationSet);
  });
  filteredAccommodationSets.map(function (accommodationSet) {
    var categoryId = accommodationSet.accommodations[0].categoryId;
    var categoryIndex = getCategoryIndex(categorizedAccommodationsArray, categoryId);
    var categoryNotListed = categoryIndex === -1;

    if (categoryNotListed) {
      addNewComfortToArray(categorizedAccommodationsArray, accommodationSet);
    } else {
      accommodationSet.accommodations.forEach(function (_ref4) {
        var view = _ref4.view,
            outsideFacilities = _ref4.outsideFacilities,
            roomType = _ref4.roomType; //check if the views are NOT already listed in the available filters => we add them

        if (view && !categorizedAccommodationsArray[categoryIndex].availableFilters.view.some(function (_ref5) {
          var id = _ref5.id;
          return id === view.id;
        })) {
          categorizedAccommodationsArray[categoryIndex].availableFilters.view.push(filteredAccommodationsByComforHelper_objectSpread(filteredAccommodationsByComforHelper_objectSpread({}, view), {}, {
            firstAlternativeId: accommodationSet.id,
            icon: icons["a" /* ICONS */][get_default()(view, 'id')] || icons["a" /* ICONS */].TRIDENT
          }));
        }

        if (outsideFacilities.length > 0 && !categorizedAccommodationsArray[categoryIndex].availableFilters.outsideFacilities.some(function (_ref6) {
          var id = _ref6.id;
          return id === outsideFacilities[0].id;
        })) {
          categorizedAccommodationsArray[categoryIndex].availableFilters.outsideFacilities.push(filteredAccommodationsByComforHelper_objectSpread(filteredAccommodationsByComforHelper_objectSpread({}, outsideFacilities[0]), {}, {
            firstAlternativeId: accommodationSet.id,
            icon: icons["a" /* ICONS */][get_default()(outsideFacilities[0], 'id')] || icons["a" /* ICONS */].TRIDENT
          }));
        }

        if (roomType && !categorizedAccommodationsArray[categoryIndex].availableFilters.roomType === roomType.id) {
          categorizedAccommodationsArray[categoryIndex].availableFilters.roomType.push(filteredAccommodationsByComforHelper_objectSpread(filteredAccommodationsByComforHelper_objectSpread({}, roomType), {}, {
            firstAlternativeId: accommodationSet.id,
            icon: icons["a" /* ICONS */][get_default()(roomType, 'id')] || icons["a" /* ICONS */].TRIDENT
          }));
        }
      });
    }
  });
  return categorizedAccommodationsArray;
}


// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/filtered-accommodations-alternatives-by-comfort/filteredAccommodationsAlternativesByComfort.reducer.js



var filteredAccommodationsAlternativesByComfort_reducer_initialState = null;

function filteredAccommodationsAlternativesByComfortReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filteredAccommodationsAlternativesByComfort_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var additionalAccommodations = get_default()(action, 'payload.additionalAccommodations') || [];

  switch (get_default()(action, 'type')) {
    case additionalAccommodations_action["d" /* GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT */]:
      return getFiltersAndAlternativesByComfort(additionalAccommodations);

    default:
      return state;
  }
}

/* harmony default export */ var filteredAccommodationsAlternativesByComfort_reducer = (filteredAccommodationsAlternativesByComfortReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/is-loading/isLoadingFilteredAccommodationsAlternativesByComfort.reducer.js




function isLoadingFilteredAccommodationsAlternativesByComfort() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
      return true;

    case Object(build["reject"])(additionalAccommodations_action["d" /* GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT */]):
    case Object(build["resolve"])(additionalAccommodations_action["d" /* GET_ALTERNATIVES_ACCOMMODATIONS_BY_COMFORT */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var isLoadingFilteredAccommodationsAlternativesByComfort_reducer = (isLoadingFilteredAccommodationsAlternativesByComfort);
// CONCATENATED MODULE: ./src/client/store/booking/additional-accommodations/additionalAccommodations.reducer.js










var additionalAccommodations_reducer_additionalAccommodations = Object(redux["c" /* combineReducers */])({
  error: error_reducer,
  isLoading: isLoading_reducer,
  accommodationsSets: accommodationsSets_reducer,
  filters: filtersReducer,
  filteredAccommodations: filteredAccommodations_reducer,
  isLoadingFilteredAccommodationsAlternativesByComfort: isLoadingFilteredAccommodationsAlternativesByComfort_reducer,
  filteredAccommodationsAlternativesByComfort: filteredAccommodationsAlternativesByComfort_reducer,
  isDataFetched: isDataFetched,
  isPmrChecked: isPmrChecked
});
// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/is-loading/isLoading.reducer.js




var is_loading_isLoading_reducer_initialState = false;

function isLoading_reducer_isLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : is_loading_isLoading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case additionalTransports_action["a" /* FETCH_ADDITIONAL_TRANSPORTS */]:
    case proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]:
      return true;

    case Object(build["resolve"])(additionalTransports_action["a" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case Object(build["reject"])(additionalTransports_action["a" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["reject"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
      return false;

    default:
      return state;
  }
}

/* harmony default export */ var is_loading_isLoading_reducer = (isLoading_reducer_isLoadingReducer);
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./src/client/store/booking/transport-stations/transportStations.action.js
var transportStations_action = __webpack_require__("ldqU");

// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/transports/transports.reducer.js










function transports_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function transports_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? transports_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : transports_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var sortPath = 'price.value';
var transports_reducer_initialState = {
  alternativeTransports: [],
  selectedTransport: undefined,
  selectedTransportId: null,
  cityTransports: {
    loading: false,
    cityId: null,
    data: {
      airports: [],
      trainStations: [],
      ports: []
    }
  }
};

function transportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : transports_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case Object(build["resolve"])(additionalTransports_action["a" /* FETCH_ADDITIONAL_TRANSPORTS */]):
      var _action$payload = action.payload,
          additionalTransports = _action$payload.additionalTransports,
          selectedTransport = _action$payload.selectedTransport;
      var alternativeTransports = sortBy_default()(additionalTransports || [], sortPath).map(function (transport, index) {
        return transports_reducer_objectSpread(transports_reducer_objectSpread({}, transport), {}, {
          transportNumber: index + 1
        });
      });
      return transports_reducer_objectSpread(transports_reducer_objectSpread({}, state), {}, {
        selectedTransport: selectedTransport,
        proposalTransport: selectedTransport,
        alternativeTransports: alternativeTransports,
        selectedTransportId: null
      });

    case transportStations_action["a" /* FETCH_TRANSPORT_STATIONS */]:
      return transports_reducer_objectSpread(transports_reducer_objectSpread({}, state), {}, {
        cityTransports: transports_reducer_objectSpread(transports_reducer_objectSpread({}, state.cityTransports), {}, {
          loading: true,
          cityId: action.payload
        })
      });

    case Object(build["resolve"])(transportStations_action["a" /* FETCH_TRANSPORT_STATIONS */]):
      return transports_reducer_objectSpread(transports_reducer_objectSpread({}, state), {}, {
        cityTransports: transports_reducer_objectSpread(transports_reducer_objectSpread({}, state.cityTransports), {}, {
          data: action.payload
        })
      });

    case Object(build["reject"])(transportStations_action["a" /* FETCH_TRANSPORT_STATIONS */]):
      return transports_reducer_objectSpread(transports_reducer_objectSpread({}, state), {}, {
        cityTransports: transports_reducer_objectSpread({}, state.cityTransports)
      });

    default:
      return state;
  }
}

/* harmony default export */ var transports_reducer = (transportsReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/error/error.reducer.js




var error_error_reducer_initialState = null;

function additionalTransportsErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : error_error_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case additionalTransports_action["a" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return error_error_reducer_initialState;

    case Object(build["reject"])(additionalTransports_action["a" /* FETCH_ADDITIONAL_TRANSPORTS */]):
    case Object(build["reject"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
      var error = get_default()(action, 'payload.errors[0]', {});

      return {
        statusCode: error.statusCode || 500,
        message: error.message || 'UNKNOWN ERROR'
      };

    default:
      return state;
  }
}

/* harmony default export */ var error_error_reducer = (additionalTransportsErrorReducer);
// CONCATENATED MODULE: ./src/client/store/booking/additional-transports/additionalTransports.reducer.js




/* harmony default export */ var additionalTransports_reducer = (Object(redux["c" /* combineReducers */])({
  error: error_error_reducer,
  isLoading: is_loading_isLoading_reducer,
  transports: transports_reducer
}));
// CONCATENATED MODULE: ./src/client/store/booking/payment-providers/paymentProviders.reducer.js



var paymentProviders_reducer_initialState = [];

function paymentProvidersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : paymentProviders_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
      return get_default()(action, 'payload.paymentProviders', paymentProviders_reducer_initialState);

    default:
      return state;
  }
}

/* harmony default export */ var paymentProviders_reducer = (paymentProvidersReducer);
// CONCATENATED MODULE: ./src/client/store/booking/booking-engine-entry/bookingEngineEntry.reducer.js

var bookingEngineEntry_reducer_initialState = null;
function bookingEngineEntry() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bookingEngineEntry_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["m" /* FETCH_PROPOSALS */]:
      {
        return action.payload.bookingEngineEntry;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/remove.js
var remove = __webpack_require__("knRJ");
var remove_default = /*#__PURE__*/__webpack_require__.n(remove);

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/store/booking/attendees/attendees.selector.js
var attendees_selector = __webpack_require__("eZ08");

// CONCATENATED MODULE: ./src/client/store/booking/attendees/attendees.reducer.js













function attendees_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function attendees_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? attendees_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : attendees_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}









var attendees_reducer_initialState = {
  isMultiHouseHold: false,
  attendeesByHouseHolds: [],
  numberOfHouseHolds: 0,
  kidsAttendees: [],
  adultsAttendees: []
};

function shuffleKidsThatWillBeAdult(adults, children, arrivalDate) {
  if (arrivalDate) {
    var otherChildren = children ? Object(toConsumableArray["a" /* default */])(children) : [];

    var kidsThatWillBeAdults = remove_default()(otherChildren, function (kid) {
      return moment_default()(arrivalDate).diff(moment_default()(kid.birthdate || (kid === null || kid === void 0 ? void 0 : kid.dateOfBirth)), 'years') >= 18;
    });

    var actualAdultsAttendees = adults === null || adults === void 0 ? void 0 : adults.concat(kidsThatWillBeAdults.map(function (newAdult) {
      return attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, newAdult), {}, {
        address: {}
      });
    }) || []);
    return {
      shuffledAdults: actualAdultsAttendees || [],
      shuffledChildren: otherChildren
    };
  }

  return {
    shuffledAdults: adults || [],
    shuffledChildren: children || []
  };
}

function attendeesReducer() {
  var _action$payload4;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : attendees_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case adults_constants["d" /* SET_ATTENDEES */]:
    case proposals_constants["v" /* PREPARE_BE */]:
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
      {
        var _proposals$proposals;

        var _action$payload = action.payload,
            adultsAttendees = _action$payload.adultsAttendees,
            kidsAttendees = _action$payload.kidsAttendees,
            selectedProposal = _action$payload.selectedProposal,
            proposals = _action$payload.proposals;
        var defaultProposal = selectedProposal || (proposals === null || proposals === void 0 ? void 0 : (_proposals$proposals = proposals.proposals) === null || _proposals$proposals === void 0 ? void 0 : _proposals$proposals[0]);

        var _shuffleKidsThatWillB = shuffleKidsThatWillBeAdult(state.adultsAttendees.concat(adultsAttendees || []), state.kidsAttendees.concat(kidsAttendees || []), defaultProposal === null || defaultProposal === void 0 ? void 0 : defaultProposal.arrivalDate),
            shuffledAdults = _shuffleKidsThatWillB.shuffledAdults,
            shuffledChildren = _shuffleKidsThatWillB.shuffledChildren;

        var _attendeesByHouseHolds = Object(attendees_selector["b" /* formatHouseholds */])(defaultProposal);

        return attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, state), {}, {
          adultsAttendees: shuffledAdults,
          kidsAttendees: shuffledChildren,
          isMultiHouseHold: _attendeesByHouseHolds.length > 1,
          attendeesByHouseHolds: _attendeesByHouseHolds,
          numberOfHouseHolds: _attendeesByHouseHolds.length
        });
      }

    case proposals_constants["J" /* UPDATE_ATTENDEES */]:
      {
        var _action$payload2, _action$payload3;

        var _attendeesByHouseHolds2 = Object(attendees_selector["b" /* formatHouseholds */])( // $FlowFixMe we dont need the missing fields in this case
        action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.proposal, action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.attendees);

        return attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, state), {}, {
          isMultiHouseHold: _attendeesByHouseHolds2.length > 1,
          attendeesByHouseHolds: _attendeesByHouseHolds2,
          numberOfHouseHolds: _attendeesByHouseHolds2.length
        });
      }

    case proposals_constants["l" /* EDIT_HOUSEHOLDS */]:
      var attendeesByHouseHolds = ((_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.households) || state.attendeesByHouseHolds;
      return attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, state), {}, {
        attendeesByHouseHolds: attendeesByHouseHolds,
        numberOfHouseHolds: attendeesByHouseHolds.length
      });

    case SET_CUSTOMER_SEARCH_RESULT:
      try {
        if (!action.payload.data) {
          return attendees_reducer_objectSpread({}, state);
        }

        var _action$payload5 = action.payload,
            _action$payload5$data = _action$payload5.data,
            searchedAdults = _action$payload5$data.adults,
            searchedChildren = _action$payload5$data.children,
            _action$payload5$sear = _action$payload5.searchedHouseholdIndex,
            searchedHouseholdIndex = _action$payload5$sear === void 0 ? 0 : _action$payload5$sear;

        var currentHouseholds = Object(toConsumableArray["a" /* default */])(state.attendeesByHouseHolds);

        var currentHousehold = currentHouseholds[searchedHouseholdIndex];
        currentHouseholds[searchedHouseholdIndex] = attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, currentHousehold), {}, {
          adults: currentHousehold.adults.map(function (adult, index) {
            var _searchedAdults$index;

            return attendees_reducer_objectSpread(attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, adult), searchedAdults[index]), {}, {
              customerId: (_searchedAdults$index = searchedAdults[index]) === null || _searchedAdults$index === void 0 ? void 0 : _searchedAdults$index.id,
              neolid: '',
              id: adult.id || Object(ContactInfoUtils["a" /* createId */])(index, 'A')
            });
          }),
          children: currentHousehold.children.map(function (child, index) {
            var _searchedChildren$ind;

            return attendees_reducer_objectSpread(attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, child), searchedChildren[index]), {}, {
              customerId: (_searchedChildren$ind = searchedChildren[index]) === null || _searchedChildren$ind === void 0 ? void 0 : _searchedChildren$ind.id,
              neolid: '',
              id: child.id || Object(ContactInfoUtils["a" /* createId */])(index, 'A')
            });
          })
        });
        return attendees_reducer_objectSpread(attendees_reducer_objectSpread({}, state), {}, {
          attendeesByHouseHolds: currentHouseholds,
          numberOfHouseHolds: currentHouseholds.length
        });
      } catch (error) {
        logger["default"].error(error);
        return attendees_reducer_objectSpread({}, state);
      }

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/booking/suggestions/suggestions.reducer.js










function suggestions_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function suggestions_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? suggestions_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : suggestions_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var suggestions_reducer_initialState = {
  dates: [],
  durations: [],
  resorts: []
};
function suggestionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : suggestions_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
      {
        var dates = get_default()(action, 'payload.proposals.dateSuggestion', []);

        var durations = get_default()(action, 'payload.proposals.durationSuggestions', []);

        var resorts = get_default()(action, 'payload.proposals.suggestions', []);

        return suggestions_reducer_objectSpread(suggestions_reducer_objectSpread({}, state), {}, {
          dates: dates,
          resorts: resorts,
          durations: durations
        });
      }

    case proposals_constants["h" /* CLEAR_PROPOSALS */]:
      return suggestions_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/booking/entry-route/entryRoute.reducer.js
var entryRoute_reducer = __webpack_require__("m9Sl");

// EXTERNAL MODULE: ./src/client/store/booking/option-validity/optionValidity.reducer.js
var optionValidity_reducer = __webpack_require__("O7yO");

// EXTERNAL MODULE: ./src/client/store/booking/travel-companion/travel-companion.reducer.js
var travel_companion_reducer = __webpack_require__("dGyR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/is-proposal-loading.reducer.js


var is_proposal_loading_reducer_initialState = true;
var is_proposal_loading_reducer_isProposalLoadingReducer = function isProposalLoadingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : is_proposal_loading_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]:
    case proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]:
      return true;

    case Object(build["resolve"])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["reject"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["reject"])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case proposals_constants["t" /* IS_BOOKING */]:
      return false;

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/booking/booking.reducer.js


















var booking = Object(redux["c" /* combineReducers */])({
  additionalAccommodations: additionalAccommodations_reducer_additionalAccommodations,
  additionalTransports: additionalTransports_reducer,
  attendees: attendeesReducer,
  bestProposalId: bestProposalIdReducer,
  bookingEngineEntry: bookingEngineEntry,
  customerSearch: customerSearch,
  entryRoute: entryRoute_reducer["c" /* entryRouteReducer */],
  insurance: insurance_reducer_insuranceReducer,
  paymentProviders: paymentProviders_reducer,
  proposals: proposalsReducer,
  resort: resortReducer,
  selectedProposalId: selectedProposalIdReducer,
  isProposalLoading: is_proposal_loading_reducer_isProposalLoadingReducer,
  streetViews: streetViewsReducer,
  suggestions: suggestionsReducer,
  optionValidityDuration: optionValidity_reducer["c" /* optionValidityReducer */],
  travelCompanion: travel_companion_reducer["e" /* travelCompanionReducer */]
});
// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// CONCATENATED MODULE: ./src/client/store/utils/createReducer.js
function createReducer(initialState) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var handler = action && action.type && handlers ? handlers[action.type] : undefined; // if no action was provided, return the actual state

    if (!handler) {
      return state;
    }

    state = handler(state, action);
    return state;
  };
}

/* harmony default export */ var utils_createReducer = (createReducer);
// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.reducer.js










var _createReducer;

function calendar_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function calendar_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? calendar_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : calendar_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var calendar_reducer_initialState = {
  blockInputDepartureDate: true,
  bookableDateLastRequestId: -1,
  bookableDates: {},
  bookableDatesCriteria: {},
  byDays: {},
  calendar: {},
  calendarCriteria: {},
  departureCity: null,
  initialDuration: null,
  isLoading: true,
  isPriceCalendarSelection: false,
  errorResponse: {},
  selectedMonth: Object(calendar_helper["c" /* getDefaultSelectedMonth */])(),
  lastRequestId: -1,
  productId: null,
  tripPrice: {},
  tripPriceLastRequestId: -1,
  tripPriceIsLoading: false
};
var calendarReducer = utils_createReducer(calendar_reducer_initialState, (_createReducer = {}, Object(defineProperty["a" /* default */])(_createReducer, store_constants["m" /* SYNC_WITH_LOCATION */], function (state, action) {
  var _action$payload$locat = action.payload.location.queryParams,
      queryParams = _action$payload$locat === void 0 ? {} : _action$payload$locat;

  if (!queryParams[uri_constants["g" /* QUERY_DEPARTURE_DATE */]]) {
    return state;
  }

  var selectedMonth = Object(calendar_helper["c" /* getDefaultSelectedMonth */])(queryParams[uri_constants["g" /* QUERY_DEPARTURE_DATE */]] || state.selectedMonth, uri_constants["f" /* QUERY_DATE_FORMAT */]);
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["h" /* FETCH_CALENDAR */], function (state, action) {
  var _action$payload, _action$payload2;

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: {},
    // $FlowFixMe
    calendarCriteria: action.payload.options || {},
    // $FlowFixMe
    departureCity: action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.departureCity,
    isLoading: true,
    lastRequestId: get_default()(action, 'optimist.id', -1),
    // $FlowFixMe
    productId: action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.productId
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["h" /* FETCH_CALENDAR */]), function (state, action) {
  var _action$optimist = action.optimist;
  _action$optimist = _action$optimist === void 0 ? {} : _action$optimist;
  var _action$optimist$id = _action$optimist.id,
      id = _action$optimist$id === void 0 ? -1 : _action$optimist$id,
      calendar = action.payload.calendar; // If there is another request in progress

  if (id !== state.lastRequestId || !calendar) {
    return state;
  }

  var selectedMonth = state.selectedMonth;
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    byDays: Object(calendar_helper["d" /* getPricesByDays */])(calendar),
    calendar: calendar,
    selectedMonth: Object(calendar_helper["e" /* getSelectedMonth */])(calendar, selectedMonth),
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["h" /* FETCH_CALENDAR */]), function (state, action) {
  var errors = action.payload.errors || '';
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    byDays: {},
    errorResponse: {
      errors: errors
    },
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["f" /* FETCH_BOOKABLE_DATES */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    // $FlowFixMe
    bookableDatesCriteria: action.payload.options || {},
    bookableDatesLoading: true,
    bookableDateLastRequestId: get_default()(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["f" /* FETCH_BOOKABLE_DATES */]), function (state, action) {
  var _action$optimist2 = action.optimist;
  _action$optimist2 = _action$optimist2 === void 0 ? {} : _action$optimist2;
  var _action$optimist2$id = _action$optimist2.id,
      id = _action$optimist2$id === void 0 ? -1 : _action$optimist2$id,
      bookableDates = action.payload.bookableDates;

  if (id !== state.bookableDateLastRequestId || !bookableDates) {
    return state;
  }

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: bookableDates,
    bookableDatesLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["f" /* FETCH_BOOKABLE_DATES */]), function (state, action) {
  var errors = action.payload.errors || '';
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    bookableDates: {},
    errorResponse: {
      errors: errors
    },
    bookableDatesLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["a" /* CALENDAR_CHANGE_MONTH */], function (state, action) {
  var selectedMonth = action.payload.selectedMonth || calendar_helper["a" /* INITIAL_MONTH */];
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["e" /* CLEAR_CALENDAR */], function () {
  return calendar_reducer_initialState;
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["o" /* TRIP_INFORMATION_SET_DEPARTURE_DATE */], function (state, action) {
  if (!action.payload.departureDate) {
    return state;
  }

  var selectedMonth = Object(calendar_helper["c" /* getDefaultSelectedMonth */])(action.payload.departureDate);
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    selectedMonth: selectedMonth
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["b" /* CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    blockInputDepartureDate: action.payload.blockInputDepartureDate
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["c" /* CALENDAR_SET_INITIAL_DURATION */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    initialDuration: action.payload.duration
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["d" /* CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    isPriceCalendarSelection: action.payload.isPriceCalendarSelection
  });
}), Object(defineProperty["a" /* default */])(_createReducer, store_constants["j" /* FETCH_CALENDAR_TRIP_PRICE */], function (state, action) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPriceIsLoading: true,
    tripPriceLastRequestId: get_default()(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["resolve"])(store_constants["j" /* FETCH_CALENDAR_TRIP_PRICE */]), function (state, action) {
  var _action$optimist3 = action.optimist;
  _action$optimist3 = _action$optimist3 === void 0 ? {} : _action$optimist3;
  var _action$optimist3$id = _action$optimist3.id,
      id = _action$optimist3$id === void 0 ? -1 : _action$optimist3$id,
      _action$payload3 = action.payload;
  _action$payload3 = _action$payload3 === void 0 ? {} : _action$payload3;
  var tripPrice = _action$payload3.price;

  if (id !== state.tripPriceLastRequestId) {
    return state;
  }

  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPrice: tripPrice,
    tripPriceIsLoading: false
  });
}), Object(defineProperty["a" /* default */])(_createReducer, Object(build["reject"])(store_constants["j" /* FETCH_CALENDAR_TRIP_PRICE */]), function (state) {
  return calendar_reducer_objectSpread(calendar_reducer_objectSpread({}, state), {}, {
    tripPrice: {},
    tripPriceIsLoading: false
  });
}), _createReducer));
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/merge.js
var merge = __webpack_require__("H8sf");
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// CONCATENATED MODULE: ./src/client/store/cms/cms.reducer.js











function cms_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function cms_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? cms_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cms_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var cms_reducer_initialState = {};
function cmsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cms_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case Object(build["resolve"])(cms_actions["a" /* GET_BOOKING_ENGINE_I18N */]):
    case cms_actions["b" /* SET_CMS */]:
      {
        var data = merge_default()({}, state, cms_reducer_objectSpread(cms_reducer_objectSpread(cms_reducer_objectSpread({}, get_default()(action, 'payload.config', {})), get_default()(action, 'payload.legalInformations', {})), {}, {
          paymentProviders: get_default()(action, 'payload.paymentProviders', {})
        }));

        Object(i18n["a" /* addTranslationKeys */])(data);
        return data;
      }

    default:
      return state;
  }
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__("gqY9");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__("HUPx");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isUndefined.js
var isUndefined = __webpack_require__("CZlo");
var isUndefined_default = /*#__PURE__*/__webpack_require__.n(isUndefined);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/includes.js
var includes = __webpack_require__("qYhz");
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);

// EXTERNAL MODULE: ./node_modules/entities/index.js
var entities = __webpack_require__("4oK2");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/client/store/faceting/constants.js
var store_faceting_constants = __webpack_require__("9QcM");

// CONCATENATED MODULE: ./src/client/store/faceting/faceting.reducer.js


































var faceting_reducer_createReducer;

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function faceting_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function faceting_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? faceting_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : faceting_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}









var IGNORED_FILTERS_IDS = [faceting_constants["O" /* PRODUCT_FACET_ID */], faceting_constants["u" /* DEPARTURE_DATE_MAX_FACET_ID */], faceting_constants["I" /* LOCALE_FACET_ID */], faceting_constants["m" /* COUNTRIES_FACET_ID */]];

function catalogFacetItemToState(item) {
  return {
    label: item.i18n,
    value: item.filter,
    count: item.freq
  };
} // Pertimm will always send `interpretation_explanation.interpretations` dates
// in the format 'DD/MM/YYYY', for any locale


var PERTIMM_INTERPRETATION_DATE_FORMAT = 'DD/MM/YYYY';
var PERTIMM_DEPARTURE_MIN_DATE = 'departure_date_min';
var PERTIMM_DEPARTURE_MAX_DATE = 'departure_date_max';
/**
 * Takes the Pertimm catalog of facets and restructure it before storage in redux store.
 */

function catalogToState() {
  var catalogs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeFacets = arguments.length > 1 ? arguments[1] : undefined;
  var completeCountriesFacetAsTree = arguments.length > 2 ? arguments[2] : undefined;
  var facetingTopCountries = arguments.length > 3 ? arguments[3] : undefined;
  var catalogIdsAsList = [faceting_constants["d" /* CHILDCARE_CRITERIA_FACET_ID */], faceting_constants["f" /* CHILDCARE_FILTER_FACET_ID */], faceting_constants["m" /* COUNTRIES_FACET_ID */], faceting_constants["r" /* DEPARTURE_CITY_FACET_ID */], faceting_constants["x" /* DURATION_FACET */], faceting_constants["R" /* SEASON_FACET_ID */], faceting_constants["Z" /* TYPES_OF_STAY_FACET_ID */]];
  var catalogIdsAsTree = [faceting_constants["a" /* ACTIVITIES_FACET_ID */], faceting_constants["w" /* DESTINATIONS_FACET_ID */]];
  var facetsAsList = catalogs.filter(function (catalog) {
    return catalogIdsAsList.includes(catalog.id);
  }).map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        list = _ref.list;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: list.map(catalogFacetItemToState)
    };
  });
  facetsAsList.push(faceting_constants["B" /* FLIGHT_DURATION_FACET_AS_LIST */]);
  var facetsAsTree = catalogs.filter(function (catalog) {
    return catalogIdsAsTree.includes(catalog.id);
  }).map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        tree = _ref2.tree;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: tree.map(function (list) {
        return faceting_reducer_objectSpread(faceting_reducer_objectSpread({
          id: list.name
        }, catalogFacetItemToState(list)), {}, {
          list: list.tree.map(catalogFacetItemToState)
        });
      })
    };
  });

  var _facetsAsList$filter = facetsAsList.filter(function (_ref3) {
    var id = _ref3.id;
    return id === faceting_constants["m" /* COUNTRIES_FACET_ID */];
  }),
      _facetsAsList$filter2 = Object(slicedToArray["a" /* default */])(_facetsAsList$filter, 1),
      countriesFacetAsList = _facetsAsList$filter2[0];

  var _facetsAsTree$filter = facetsAsTree.filter(function (_ref4) {
    var id = _ref4.id;
    return id === faceting_constants["w" /* DESTINATIONS_FACET_ID */];
  }),
      _facetsAsTree$filter2 = Object(slicedToArray["a" /* default */])(_facetsAsTree$filter, 1),
      destinationsFacetAsTree = _facetsAsTree$filter2[0];

  var topCountriesFacetAsList = getTopCountriesFacetList(facetingTopCountries, countriesFacetAsList);
  var countriesFacetAsTree = countriesFacetAsList && destinationsFacetAsTree ? getCountriesFacetAsTree(activeFacets, completeCountriesFacetAsTree, countriesFacetAsList, destinationsFacetAsTree, topCountriesFacetAsList) : null;
  return [].concat(Object(toConsumableArray["a" /* default */])(facetsAsList.map(function (facet) {
    return facet.id === faceting_constants["m" /* COUNTRIES_FACET_ID */] ? countriesFacetAsTree : facet;
  }).filter(Boolean)), Object(toConsumableArray["a" /* default */])(facetsAsTree));
}

function filtersToActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filters.reduce(function (acc, filter) {
    var categoryId = filter.id;

    if (faceting_constants["y" /* FILTERABLE_FACETS_IDS */].includes(categoryId)) {
      return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, categoryId, faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, acc[categoryId]), {}, Object(defineProperty["a" /* default */])({}, filter.value, true))));
    }

    return acc;
  }, {});
}

function sanitizeFilters(filters) {
  return filters.filter(function (filter) {
    return !includes_default()(IGNORED_FILTERS_IDS, get_default()(filter, 'id'));
  });
}

function sanitizeLabel(label) {
  return label ? label.toLowerCase().replace(/\s+/g, '') : '';
}

function sanitizeValue(value) {
  return value ? value.toUpperCase().replace(/\s+/g, '') : '';
}

function removeDuplicateCountries(countryList) {
  var countryLabels = {};
  return countryList.reduce(function (result, country) {
    var label = sanitizeLabel(country.label);

    if (!countryLabels[label]) {
      countryLabels[label] = faceting_reducer_objectSpread({}, country);
      result.push(countryLabels[label]);
    }

    return result;
  }, []);
}

function trimLabel(label) {
  return label ? label.trim() : '';
}

function filtersToState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return sanitizeFilters(filters).map(function (filter) {
    return {
      id: get_default()(filter, 'id'),
      name: get_default()(filter, 'value'),
      label: get_default()(filter, 'value_i18n'),
      selected: true
    };
  });
}

function getCountriesFacetAsTree(activeFacets, completeCountriesFacetAsTree, countriesFacetAsList, destinationsFacetAsTree, topCountriesFacetAsList) {
  var destinationsActiveFacets = activeFacets[faceting_constants["w" /* DESTINATIONS_FACET_ID */]];
  var initialValueForCountriesFacetAsTree = completeCountriesFacetAsTree && completeCountriesFacetAsTree.list.length >= destinationsFacetAsTree.list.length ? completeCountriesFacetAsTree : faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, destinationsFacetAsTree), {}, {
    id: faceting_constants["m" /* COUNTRIES_FACET_ID */]
  });
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, initialValueForCountriesFacetAsTree), {}, {
    list: [topCountriesFacetAsList].concat(Object(toConsumableArray["a" /* default */])(initialValueForCountriesFacetAsTree.list.map(function (region) {
      var _destinationsFacetAsT, _completeCountriesFac;

      var regionLabel = region.label,
          value = region.value; // Retrieve updated data for the current region in destinationsFacetAsTree

      var destinationsFacetRegion = destinationsFacetAsTree === null || destinationsFacetAsTree === void 0 ? void 0 : (_destinationsFacetAsT = destinationsFacetAsTree.list) === null || _destinationsFacetAsT === void 0 ? void 0 : _destinationsFacetAsT.find(function (_ref5) {
        var regionLabelFromTree = _ref5.label;
        return sanitizeLabel(regionLabel) === sanitizeLabel(regionLabelFromTree);
      }); // Check if there are region filters selected, if there are but the current region is not in the active filters, remove it

      if (destinationsActiveFacets && !destinationsActiveFacets[value]) {
        return null;
      } // Retrieve stored data for the current region in completeCountriesFacetRegion


      var completeCountriesFacetRegion = completeCountriesFacetAsTree === null || completeCountriesFacetAsTree === void 0 ? void 0 : (_completeCountriesFac = completeCountriesFacetAsTree.list) === null || _completeCountriesFac === void 0 ? void 0 : _completeCountriesFac.find(function (_ref6) {
        var regionLabelFromTree = _ref6.label;
        return sanitizeLabel(regionLabel) === sanitizeLabel(regionLabelFromTree);
      });
      var completeCountriesFacetRegionList = (completeCountriesFacetRegion === null || completeCountriesFacetRegion === void 0 ? void 0 : completeCountriesFacetRegion.list) || [];
      var destinationsFacetRegionList = (destinationsFacetRegion === null || destinationsFacetRegion === void 0 ? void 0 : destinationsFacetRegion.list) || []; // Keep stored data if it's country list is bigger than the updated data

      var list = completeCountriesFacetRegionList.length > destinationsFacetRegionList.length ? completeCountriesFacetRegionList : destinationsFacetRegionList;
      return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, region), {}, {
        label: trimLabel(regionLabel),
        list: removeDuplicateCountries(list.map(function (country) {
          var countryLabel = country.label; // Retrieve updated data for the current country in countriesFacetAsList

          var countriesFacetCountry = countriesFacetAsList.list.find(function (_ref7) {
            var countryLabelFromList = _ref7.label;
            return sanitizeLabel(countryLabel) === sanitizeLabel(countryLabelFromList);
          }); // Update current country's data if it is in countriesFacetAsList, otherwise remove it

          return countriesFacetCountry ? faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, country), {}, {
            count: countriesFacetCountry.count,
            label: trimLabel(countriesFacetCountry.label),
            value: countriesFacetCountry.value
          }) : null;
        }).filter(Boolean))
      });
    }).filter(Boolean).filter(function (_ref8) {
      var id = _ref8.id;
      return id !== faceting_constants["X" /* TOP_COUNTRIES_FACET_LIST_ID */];
    }))).filter(Boolean).filter(function (_ref9) {
      var list = _ref9.list;
      return list && list.length > 0;
    })
  });
}

function getTopCountriesFacetList(facetingTopCountries, countriesFacetAsList) {
  var topCountries = facetingTopCountries.enabled ? facetingTopCountries.items.map(function (_ref10) {
    var id = _ref10.id;
    return id;
  }) : [];
  var topCountriesList = countriesFacetAsList && countriesFacetAsList.list ? topCountries.map(function (countryCode) {
    return countriesFacetAsList.list.find(function (_ref11) {
      var value = _ref11.value;
      return sanitizeValue(value) === countryCode;
    });
  }).filter(Boolean) : [];
  return topCountriesList.length > 0 ? {
    count: topCountriesList.reduce(function (result, country) {
      return country && country.count ? result + parseInt(country.count, 10) : result;
    }, 0).toString(),
    id: faceting_constants["X" /* TOP_COUNTRIES_FACET_LIST_ID */],
    label: trimLabel(facetingTopCountries.title),
    list: removeDuplicateCountries(topCountriesList.map(function (country) {
      return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, country), {}, {
        label: trimLabel(country.label)
      });
    })),
    value: facetingTopCountries.title
  } : null;
}

function getTotalLabelsCount(facet) {
  return facet.list.reduce(function (result, facetList) {
    return facetList && facetList.list ? result + facetList.list.length : result;
  }, 0);
}

function parseBanners() {
  var banners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  try {
    return banners.map(function (banner) {
      return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, banner), {}, {
        content: JSON.parse(banner.content)
      });
    });
  } catch (e) {
    return [];
  }
}

function removeUnselectedFiltersFromActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeFacetsState = arguments.length > 1 ? arguments[1] : undefined;

  var activeFacets = faceting_reducer_objectSpread({}, activeFacetsState);

  var newActiveFacets = {};

  if (filters.length) {
    var _loop = function _loop(categoryId) {
      if (activeFacets.hasOwnProperty(categoryId)) {
        var categoryIdFilter = Object(toConsumableArray["a" /* default */])(filters).filter(function (_ref12) {
          var id = _ref12.id;
          return id === categoryId;
        });

        if (categoryIdFilter.length) {
          newActiveFacets[categoryId] = {};

          var _loop2 = function _loop2(categoryName) {
            if (activeFacets[categoryId].hasOwnProperty(categoryName) && // $FlowFixMe
            categoryIdFilter.some(function (_ref13) {
              var name = _ref13.name,
                  id = _ref13.id;
              return name === categoryName && id === categoryId;
            })) {
              newActiveFacets[categoryId][categoryName] = activeFacets[categoryId][categoryName];
            }
          };

          for (var categoryName in activeFacets[categoryId]) {
            _loop2(categoryName);
          }
        }
      }
    };

    for (var categoryId in activeFacets) {
      _loop(categoryId);
    }
  }

  return newActiveFacets;
}

var faceting_reducer_initialState = {
  // Special pertimm marchandising rules with pre-parameterized criteria
  // such as `minDate` / `maxDate` for some user queries such as `noel`.
  pertimmInterpretations: {},
  products: [],
  recommandedProducts: [],
  facets: [],
  activeCustomFacets: {},
  activeFacets: {},
  childcareAvailabilities: [],
  customFilters: [],
  filters: [],
  completeCountriesFacetAsTree: null,
  query: {
    label: ''
  },
  redirection: null,
  scrollToResults: false,
  isLoading: true,
  isPriceLoading: true,
  isLoadingChildcareAvailabilities: false,
  isSearchEnabled: false,
  isSelectionModeEnabled: false,
  kidsValidationState: [],
  joyviewOffsetSell: -1,
  productsBeforeActiveCustomFacetsFiltering: null,
  productsFilteredWithActiveCustomFacets: null,
  resortOffsetSell: -1,
  orderByPrice: '',
  productsSelectedForComparison: [],
  prices: [],
  noResults: false,
  lastRequestId: -1,
  lastRecommandedRequestId: -1,
  isDateRequired: false,
  searchFilterList: []
};
var facetingReducer = utils_createReducer(faceting_reducer_initialState, (faceting_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["i" /* FACETING_RESET_REDIRECTION */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    redirection: null
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["j" /* FACETING_RESET_SEARCH */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    products: [],
    productsBeforeActiveCustomFacetsFiltering: null,
    productsFilteredWithActiveCustomFacets: null,
    prices: [],
    childcareAvailabilities: [],
    redirection: null,
    scrollToResults: false,
    isLoading: true,
    isPriceLoading: true,
    noResults: false,
    searchIsEnabled: false
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["d" /* FACETING_LOAD_OFFSET_SELL_REQUEST */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    joyviewOffsetSell: -1,
    resortOffsetSell: -1
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["d" /* FACETING_LOAD_OFFSET_SELL_REQUEST */]), function (state, action) {
  var locale = action.payload.locale;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    joyviewOffsetSell: (locale === null || locale === void 0 ? void 0 : locale.joyviewOffsetSell) || -1,
    resortOffsetSell: (locale === null || locale === void 0 ? void 0 : locale.resortOffsetSell) || -1
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["d" /* FACETING_LOAD_OFFSET_SELL_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    joyviewOffsetSell: -1,
    resortOffsetSell: -1
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["e" /* FACETING_LOAD_PRODUCTS_REQUEST */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    isPriceLoading: true,
    lastRecommandedRequestId: get_default()(action, 'optimist.id', -1),
    recommandedProducts: [],
    noResults: true,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["e" /* FACETING_LOAD_PRODUCTS_REQUEST */]), function (state, action) {
  var _action$optimist, _action$payload; // If there is another request in progress


  if ((action === null || action === void 0 ? void 0 : (_action$optimist = action.optimist) === null || _action$optimist === void 0 ? void 0 : _action$optimist.id) !== state.lastRecommandedRequestId) {
    return state;
  }

  var _ref14 = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {},
      resorts = _ref14.resorts;

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    recommandedProducts: resorts,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["e" /* FACETING_LOAD_PRODUCTS_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isPriceLoading: false,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["k" /* FACETING_SEARCH_REQUEST */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    isPriceLoading: true,
    lastRequestId: get_default()(action, 'optimist.id', -1),
    noResults: false,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["k" /* FACETING_SEARCH_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (get_default()(action, 'optimist.id') !== state.lastRequestId) {
    return state;
  }

  var products = action.payload.search.products;

  var productsSelectedForComparison = get_default()(state, 'productsSelectedForComparison', []).filter(function (selectedProductId) {
    return products.some(function (product) {
      return product.id === selectedProductId;
    });
  });

  var pertimmInterpretations = get_default()(action.payload, 'interpretation_explanation.interpretations', []).reduce(function (acc, interpretation) {
    if (interpretation.filter_name === PERTIMM_DEPARTURE_MIN_DATE) {
      acc.minDate = Object(dateUtils["e" /* getTimestamp */])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    if (interpretation.filter_name === PERTIMM_DEPARTURE_MAX_DATE) {
      acc.maxDate = Object(dateUtils["e" /* getTimestamp */])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    return acc;
  }, {});

  var activeFacets = filtersToActiveFacetsState(action.payload.filters);
  var facetingTopCountries = action.payload.facetingTopCountries;
  var facets = !isEmpty_default()(action.payload.catalogs) ? catalogToState(action.payload.catalogs, activeFacets, state.completeCountriesFacetAsTree, facetingTopCountries) : state.facets || [];

  var _facets$filter = facets.filter(function (catalog) {
    return faceting_constants["m" /* COUNTRIES_FACET_ID */] === catalog.id;
  }),
      _facets$filter2 = Object(slicedToArray["a" /* default */])(_facets$filter, 1),
      countriesFacetAsTree = _facets$filter2[0];

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeFacets: activeFacets,
    banners: parseBanners(action.payload.banners),
    // We need to store the complete country list because pertimm doesn't return all of them once a filter is selected
    completeCountriesFacetAsTree: !state.completeCountriesFacetAsTree || countriesFacetAsTree && getTotalLabelsCount(countriesFacetAsTree) > getTotalLabelsCount(state.completeCountriesFacetAsTree) ? countriesFacetAsTree : state.completeCountriesFacetAsTree,
    // If the catalog of facets is empty (e.g. "no results"), keep the previous state
    facets: facets,
    filters: filtersToState(action.payload.filters),
    isLoading: false,
    noResults: !action.payload.redirection && products.length === 0,
    pertimmInterpretations: pertimmInterpretations,
    products: products,
    productsBeforeActiveCustomFacetsFiltering: null,
    productsFilteredWithActiveCustomFacets: null,
    productsSelectedForComparison: productsSelectedForComparison,
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.query), {}, {
      label: Object(entities["decodeHTML"])(action.payload.query)
    }),
    redirection: action.payload.redirection
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["k" /* FACETING_SEARCH_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    isPriceLoading: false,
    noResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["t" /* FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    productsFilteredWithActiveCustomFacets: action.payload.productsFilteredWithActiveCustomFacets
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["s" /* FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    productsBeforeActiveCustomFacetsFiltering: action.payload.productsBeforeActiveCustomFacetsFiltering
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["f" /* FACETING_PRICES_REQUEST */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: true,
    prices: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["f" /* FACETING_PRICES_REQUEST */]), function (state, action) {
  var _action$payload2;

  var _ref15 = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {},
      resorts = _ref15.resorts;

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: resorts,
    scrollToResults: false
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["f" /* FACETING_PRICES_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: [],
    scrollToResults: true
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: true,
    childcareAvailabilities: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["resolve"])(store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */]), function (state, action) {
  var childcareSearch = action.payload.childcareSearch;
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: childcareSearch
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, Object(build["reject"])(store_faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */]), function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["l" /* FACETING_SET_CUSTOM_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    customFilters: action.payload.customFilters
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["m" /* FACETING_SET_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    filters: action.payload.filters
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["v" /* FACETING_SET_SEARCH_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    searchFilterList: action.payload.searchFilterList
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["n" /* FACETING_SET_INITIAL_PRICES */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    prices: action.payload.initialProductPrices
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["p" /* FACETING_SET_IS_SEARCH_ENABLED */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isSearchEnabled: action.payload.isSearchEnabled
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["q" /* FACETING_SET_KIDS_VALIDATION_STATE */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    kidsValidationState: action.payload.kidsValidationState
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["u" /* FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isSelectionModeEnabled: action.payload.enable,
    productsSelectedForComparison: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["z" /* FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON */], function (state, action) {
  var productsCurrentlySelected = get_default()(state, 'productsSelectedForComparison');

  var productToBeToggled = get_default()(action, 'payload.productId', null);

  if (!productToBeToggled) {
    return state;
  }

  if (includes_default()(productsCurrentlySelected, productToBeToggled)) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      productsSelectedForComparison: productsCurrentlySelected.filter(function (p) {
        return p !== productToBeToggled;
      })
    });
  }

  if (productsCurrentlySelected.length < faceting_constants["J" /* MAX_NUMBER_OF_SELECTED_PRODUCTS */]) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      productsSelectedForComparison: [].concat(Object(toConsumableArray["a" /* default */])(productsCurrentlySelected), [productToBeToggled])
    });
  }

  return state;
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_constants["m" /* SYNC_WITH_LOCATION */], function (state, action) {
  var _action$payload3 = action.payload;
  _action$payload3 = _action$payload3 === void 0 ? {} : _action$payload3;
  var queryParams = _action$payload3.location.queryParams;
  var orderByPrice = ['asc', 'desc'].includes(queryParams[faceting_constants["W" /* SORT_BY_PRICE_QUERY_PARAM */]]) ? queryParams[faceting_constants["W" /* SORT_BY_PRICE_QUERY_PARAM */]] : '';

  if (!queryParams[faceting_constants["P" /* QUERY_QUERY_PARAM */]]) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      activeCustomFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeCustomFacets), Object(facetingUtils["f" /* getActiveFacetsFromQueryParams */])(queryParams, facetingUtils["a" /* customFacetsQueryParamMapping */])),
      activeFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeFacets), Object(facetingUtils["f" /* getActiveFacetsFromQueryParams */])(queryParams, facetingUtils["b" /* facetsQueryParamMapping */])),
      orderByPrice: orderByPrice
    });
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeCustomFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeCustomFacets), Object(facetingUtils["f" /* getActiveFacetsFromQueryParams */])(queryParams, facetingUtils["a" /* customFacetsQueryParamMapping */])),
    activeFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeFacets), Object(facetingUtils["f" /* getActiveFacetsFromQueryParams */])(queryParams, facetingUtils["b" /* facetsQueryParamMapping */])),
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.query), {}, {
      label: queryParams[faceting_constants["P" /* QUERY_QUERY_PARAM */]]
    }),
    orderByPrice: orderByPrice
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["w" /* FACETING_SET_SEARCH_QUERY */], function (state, _ref16) {
  var value = _ref16.payload.value;

  if (isUndefined_default()(value)) {
    return state;
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    query: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, value), {}, {
      label: Object(entities["decodeHTML"])(value.label)
    })
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["c" /* FACETING_CLEAR_FACETS */], function (state, action) {
  var categoryId = action.payload.categoryId;

  if (faceting_constants["n" /* CUSTOM_FACETS_IDS */].includes(categoryId)) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      activeCustomFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeCustomFacets), {}, Object(defineProperty["a" /* default */])({}, categoryId, {}))
    });
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeFacets), {}, Object(defineProperty["a" /* default */])({}, categoryId, {}))
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["b" /* FACETING_CLEAR_ALL */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeCustomFacets: {},
    activeFacets: {}
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["x" /* FACETING_TOGGLE_FACET_SELECTED */], function (state, action) {
  var facet = action.payload;
  var categoryId = facet.categoryId;
  var isCustomFacetId = faceting_constants["n" /* CUSTOM_FACETS_IDS */].includes(categoryId);
  var categoryActiveFacets = isCustomFacetId ? state.activeCustomFacets[categoryId] : state.activeFacets[categoryId];
  var newState;

  if (facet.isSelected) {
    newState = faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, categoryActiveFacets), {}, Object(defineProperty["a" /* default */])({}, facet.value, facet.isSelected));
  } else {
    var _facet$value = facet.value,
        _ = categoryActiveFacets[_facet$value],
        rest = Object(objectWithoutProperties["a" /* default */])(categoryActiveFacets, [_facet$value].map(_toPropertyKey)); // eslint-disable-line


    newState = rest;
  }

  if (isCustomFacetId) {
    return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
      activeCustomFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeCustomFacets), {}, Object(defineProperty["a" /* default */])({}, categoryId, faceting_reducer_objectSpread({}, newState)))
    });
  }

  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeFacets: faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state.activeFacets), {}, Object(defineProperty["a" /* default */])({}, categoryId, faceting_reducer_objectSpread({}, newState)))
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["o" /* FACETING_SET_IS_DATE_REQUIRED */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    isDateRequired: action.payload.isDateRequired
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["r" /* FACETING_SET_ORDER_BY_PRICE */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    orderByPrice: action.payload.orderByPrice
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["A" /* FACETING_UPDATE_CUSTOM_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    customFilters: action.payload.customFilters,
    activeCustomFacets: removeUnselectedFiltersFromActiveFacetsState( // $FlowFixMe
    action.payload.customFilters, state.activeCustomFacets)
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["B" /* FACETING_UPDATE_FILTERS */], function (state, action) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    filters: action.payload.filters,
    activeFacets: removeUnselectedFiltersFromActiveFacetsState( // $FlowFixMe
    action.payload.filters, state.activeFacets)
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["g" /* FACETING_RESET_CUSTOM_FILTERS */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeCustomFacets: {},
    customFilters: []
  });
}), Object(defineProperty["a" /* default */])(faceting_reducer_createReducer, store_faceting_constants["h" /* FACETING_RESET_FILTERS */], function (state) {
  return faceting_reducer_objectSpread(faceting_reducer_objectSpread({}, state), {}, {
    activeFacets: {},
    filters: [],
    query: {
      label: ''
    }
  });
}), faceting_reducer_createReducer));

// CONCATENATED MODULE: ./src/client/store/faceting-trip-information/facetingTripInformation.reducer.js






var facetingTripInformation_reducer_initialState = {
  departureCities: []
};
var facetingTripInformation = utils_createReducer(facetingTripInformation_reducer_initialState, Object(defineProperty["a" /* default */])({}, Object(build["resolve"])(store_faceting_constants["k" /* FACETING_SEARCH_REQUEST */]), function (state, action) {
  return {
    departureCities: Object(facetingUtils["h" /* getDepartureCities */])(get_default()(action, 'payload.catalogs', []))
  };
}));
/* harmony default export */ var facetingTripInformation_reducer = (facetingTripInformation);
// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// CONCATENATED MODULE: ./src/client/store/global-loader/label/label.reducer.js




var label_reducer_initialState = '';

function LabelReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : label_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case globalLoader_action["b" /* START_LOADING */]:
    case proposals_constants["a" /* ADD_ACCOMMODATION */]:
    case proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]:
    case proposals_constants["f" /* ADD_TRANSPORT */]:
    case proposals_constants["m" /* FETCH_PROPOSALS */]:
    case proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]:
      return get_default()(action, 'payload.globalLoaderLabel', null);

    case globalLoader_action["a" /* END_LOADING */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["reject"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]):
    case Object(build["reject"])(proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]):
    case Object(build["resolve"])(proposals_constants["f" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["f" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
      return label_reducer_initialState;

    default:
      return state;
  }
}

/* harmony default export */ var label_reducer = (LabelReducer);
// CONCATENATED MODULE: ./src/client/store/global-loader/navigation/navigation.reducer.js

var navigation_reducer_initialState = false;
var navigation_reducer_isNavigation = function isNavigation() {
  var _action$payload;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigation_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case globalLoader_action["b" /* START_LOADING */]:
      return !!(action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.isNavigation);

    case globalLoader_action["a" /* END_LOADING */]:
      return navigation_reducer_initialState;

    default:
      return state;
  }
};
// CONCATENATED MODULE: ./src/client/store/global-loader/should-display/shouldDisplay.reducer.js




var shouldDisplay_reducer_initialState = false;

function ShouldDisplayReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDisplay_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case globalLoader_action["b" /* START_LOADING */]:
    case proposals_constants["a" /* ADD_ACCOMMODATION */]:
    case proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]:
    case proposals_constants["f" /* ADD_TRANSPORT */]:
    case proposals_constants["m" /* FETCH_PROPOSALS */]:
    case proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]:
    case proposals_constants["C" /* SAVE_CUSTOMER_PROPOSAL */]:
    case proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]:
    case proposals_constants["l" /* EDIT_HOUSEHOLDS */]:
      return true;

    case globalLoader_action["a" /* END_LOADING */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["reject"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]):
    case Object(build["reject"])(proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]):
    case Object(build["resolve"])(proposals_constants["f" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["f" /* ADD_TRANSPORT */]):
    case Object(build["reject"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["reject"])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */]):
    case Object(build["resolve"])(proposals_constants["C" /* SAVE_CUSTOMER_PROPOSAL */]):
    case Object(build["reject"])(proposals_constants["C" /* SAVE_CUSTOMER_PROPOSAL */]):
    case Object(build["resolve"])(proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case Object(build["reject"])(proposals_constants["z" /* PROPOSAL_REFRESH */]):
    case Object(build["resolve"])(proposals_constants["l" /* EDIT_HOUSEHOLDS */]):
      return false;

    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
      return get_default()(action, 'payload.proposals.errors') ? false : state;

    default:
      return state;
  }
}

/* harmony default export */ var shouldDisplay_reducer = (ShouldDisplayReducer);
// CONCATENATED MODULE: ./src/client/store/global-loader/globalLoader.reducer.js




/* harmony default export */ var globalLoader_reducer = (Object(redux["c" /* combineReducers */])({
  isNavigation: navigation_reducer_isNavigation,
  label: label_reducer,
  shouldDisplay: shouldDisplay_reducer
}));
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// CONCATENATED MODULE: ./src/client/components/widgets/cart/cart.reducer.js















function cart_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function cart_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? cart_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cart_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';
var cart_reducer_initialState = {
  data: {},
  errorResponse: {},
  editingBookingId: ''
};
var cart_reducer_cartReducer = function cartReducer() {
  var _state$data, _state$data$bookingsC, _action$payload$addSe, _action$payload$remov, _action$payload$addSe2, _action$payload$remov2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cart_reducer_initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cartBookings = (_state$data = state.data) === null || _state$data === void 0 ? void 0 : (_state$data$bookingsC = _state$data.bookingsCart) === null || _state$data$bookingsC === void 0 ? void 0 : _state$data$bookingsC.cartBookings;

  switch (action.type) {
    case FETCH_BOOKING_CART:
      return cart_reducer_objectSpread({}, state);

    case Object(build["resolve"])(FETCH_BOOKING_CART):
      return cart_reducer_objectSpread(cart_reducer_objectSpread({}, state), {}, {
        data: get_default()(action, 'payload', {}),
        errorResponse: {}
      });

    case Object(build["reject"])(FETCH_BOOKING_CART):
      return cart_reducer_objectSpread(cart_reducer_objectSpread({}, state), {}, {
        errorResponse: {
          errors: action.payload.errors
        }
      });

    case UPDATE_BOOKING_CART:
      return cart_reducer_objectSpread(cart_reducer_objectSpread({}, state), {}, {
        editingBookingId: action.payload.bookingId
      });

    case Object(build["resolve"])(UPDATE_BOOKING_CART):
      var bookingToUpdateIndex = cartBookings.findIndex(function (booking) {
        return booking.bookingId === state.editingBookingId;
      });
      var updatedCartBookings = [].concat(Object(toConsumableArray["a" /* default */])(cartBookings.slice(0, bookingToUpdateIndex)), [cart_reducer_objectSpread(cart_reducer_objectSpread({}, (_action$payload$addSe = action.payload.addServiceCart) === null || _action$payload$addSe === void 0 ? void 0 : _action$payload$addSe.cart), (_action$payload$remov = action.payload.removeServiceCart) === null || _action$payload$remov === void 0 ? void 0 : _action$payload$remov.cart)], Object(toConsumableArray["a" /* default */])(cartBookings.slice(bookingToUpdateIndex + 1)));
      return cart_reducer_objectSpread(cart_reducer_objectSpread({}, state), {}, {
        data: cart_reducer_objectSpread(cart_reducer_objectSpread({}, state.data), {}, {
          bookingsCart: cart_reducer_objectSpread(cart_reducer_objectSpread({}, state.data.bookingsCart), {}, {
            amount: {
              total: cart_reducer_objectSpread(cart_reducer_objectSpread(cart_reducer_objectSpread({}, state.data.bookingsCart.amount.total), (_action$payload$addSe2 = action.payload.addServiceCart) === null || _action$payload$addSe2 === void 0 ? void 0 : _action$payload$addSe2.totalAmount), (_action$payload$remov2 = action.payload.removeServiceCart) === null || _action$payload$remov2 === void 0 ? void 0 : _action$payload$remov2.totalAmount)
            },
            isEmpty: updatedCartBookings.every(function (cart) {
              return cart.isEmpty;
            }),
            cartBookings: updatedCartBookings
          })
        })
      });

    case Object(build["reject"])(UPDATE_BOOKING_CART):
      return cart_reducer_objectSpread(cart_reducer_objectSpread({}, state), {}, {
        errorResponse: {
          errors: action.payload.errors
        }
      });

    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/client/store/member-space/quick-login/quickLogin.constants.js
var quickLogin_constants = __webpack_require__("rAD9");

// CONCATENATED MODULE: ./src/client/store/member-space/quick-login/quickLogin.reducer.js



var quickLogin_reducer_createReducer;



var quickLogin_reducer_initialState = {
  bookingId: null,
  stayId: null
};
var quickLogin = utils_createReducer(quickLogin_reducer_initialState, (quickLogin_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(quickLogin_reducer_createReducer, quickLogin_constants["b" /* UPDATE_QUICKLOGIN_INFOS */], function (state, _ref) {
  var payload = _ref.payload;
  return {
    bookingId: get_default()(payload, 'bookingId') || null,
    stayId: get_default()(payload, 'stayId') || null
  };
}), Object(defineProperty["a" /* default */])(quickLogin_reducer_createReducer, quickLogin_constants["a" /* RESET_QUICKLOGIN_INFOS */], function () {
  return quickLogin_reducer_initialState;
}), quickLogin_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/member-space/memberSpace.reducer.js



var memberSpace = Object(redux["c" /* combineReducers */])({
  quickLogin: quickLogin,
  cart: cart_reducer_cartReducer
});
// CONCATENATED MODULE: ./src/client/store/search/query/searchQuery.reducer.js









/* eslint-disable new-cap */

function searchQuery_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function searchQuery_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? searchQuery_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : searchQuery_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var searchQuery_reducer_initialState = {
  keywords: ''
};
var searchQueryReducer = utils_createReducer(searchQuery_reducer_initialState, Object(defineProperty["a" /* default */])({}, store_constants["l" /* SEARCH_SET_KEYWORDS */], function (state, action) {
  return searchQuery_reducer_objectSpread(searchQuery_reducer_objectSpread({}, state), {}, {
    keywords: get_default()(action, 'payload.keywords')
  });
}));
// CONCATENATED MODULE: ./src/client/store/search/search.reducer.js


var searchReducer = Object(redux["c" /* combineReducers */])({
  query: searchQueryReducer
});
// CONCATENATED MODULE: ./src/client/store/seller/neolidsReducer.js
var neolidsReducer_initialState = [];
var neolidsReducer = function neolidsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : neolidsReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined; // there is just a switch with a default case because data is initialized in src/client/store/getInitialReduxState.client.js
  // and is never changed after that (data come from query params)

  switch (action.type) {
    default:
      return state;
  }
};
// EXTERNAL MODULE: ./src/client/store/seller/sellerInfoReducer.js
var sellerInfoReducer = __webpack_require__("+2AQ");

// CONCATENATED MODULE: ./src/client/store/seller/sellerReducer.js



/* harmony default export */ var sellerReducer = (Object(redux["c" /* combineReducers */])({
  neolids: neolidsReducer,
  sellerInfo: sellerInfoReducer["b" /* sellerInfoReducer */]
}));
// EXTERNAL MODULE: ./src/client/store/user-info/actions/signout.js
var signout = __webpack_require__("qd7E");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.reducer.js





var departureCity_reducer_initialState = null;

function departureCityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : departureCity_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case store_constants["m" /* SYNC_WITH_LOCATION */]:
      var _ref = action || {},
          _ref$payload = _ref.payload;

      _ref$payload = _ref$payload === void 0 ? {} : _ref$payload;
      var queryParams = _ref$payload.location.queryParams; // in cases where params is not in the url, we should just keep the state as it is.

      return queryParams[uri_constants["m" /* QUERY_TRANSPORT */]] ? queryParams[uri_constants["m" /* QUERY_TRANSPORT */]] : state;

    case departure_city_constants["b" /* TRIP_INFORMATION_SET_DEPARTURE_CITY */]:
      return get_default()(action, 'payload.value', departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */]);

    case signout["a" /* SIGNOUT */]:
      return departureCity_reducer_initialState;

    default:
      return state;
  }
}

/* harmony default export */ var departureCity_reducer = (departureCityReducer);
// CONCATENATED MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.reducer.js




var departureDate_reducer_initialState = null;

function departureDateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : departureDate_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case store_constants["m" /* SYNC_WITH_LOCATION */]:
      // in cases where params is not in the url, we should just keep the state as it is.
      return payload.location.queryParams[uri_constants["g" /* QUERY_DEPARTURE_DATE */]] ? Object(dateUtils["e" /* getTimestamp */])(payload.location.queryParams[uri_constants["g" /* QUERY_DEPARTURE_DATE */]], uri_constants["f" /* QUERY_DATE_FORMAT */]) : state;

    case store_constants["o" /* TRIP_INFORMATION_SET_DEPARTURE_DATE */]:
      return get_default()(payload, 'departureDate');

    default:
      return state;
  }
}

/* harmony default export */ var departureDate_reducer = (departureDateReducer);
// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/duration/duration.reducer.js




/* eslint-disable no-duplicate-imports */








var duration_reducer_initialState = null;
function tripDurationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : duration_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case store_constants["m" /* SYNC_WITH_LOCATION */]:
      {
        var _ref2 = payload,
            queryParams = _ref2.location.queryParams;

        if (queryParams[uri_constants["h" /* QUERY_DURATION */]]) {
          return parseInt(queryParams[uri_constants["h" /* QUERY_DURATION */]], 10);
        }

        return state ? state : duration_constants["a" /* DEFAULT_NO_DURATION */];
      }

    case duration_constants["c" /* TRIP_INFORMATION_SET_DURATION */]:
      var _ref3 = payload,
          value = _ref3.value;

      if (value === duration_constants["a" /* DEFAULT_NO_DURATION */]) {
        return null;
      }

      return Number(value) || state;

    case Object(build["resolve"])(store_faceting_constants["k" /* FACETING_SEARCH_REQUEST */]):
      var _ref4 = payload,
          search = _ref4.search;
      var products = search ? search.products : [];
      var durationQueryParam = Object(uriUtils["k" /* getSpecificQueryParam */])(uri_constants["h" /* QUERY_DURATION */]);
      var defaultDuration = durationQueryParam ? Number(durationQueryParam) : state;

      var durationFromPrice = get_default()(products, '0.price.termsAndConditions.duration');

      return durationFromPrice ? Number(durationFromPrice) : defaultDuration;

    case signout["a" /* SIGNOUT */]:
      return duration_reducer_initialState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.constants.js
var flexibility_constants = __webpack_require__("45Yg");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.reducer.js

var flexibility_reducer_initialState = null;
function flexibilityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : flexibility_reducer_initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case flexibility_constants["a" /* TRIP_INFORMATION_SET_FLEXIBILITY */]:
      return payload.value;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-criteria/tripCriteria.reducer.js





/* harmony default export */ var tripCriteria_reducer = (Object(redux["c" /* combineReducers */])({
  departureCity: departureCity_reducer,
  departureDate: departureDate_reducer,
  duration: tripDurationReducer,
  flexibility: flexibilityReducer
}));
// CONCATENATED MODULE: ./src/client/store/trip-date-criteria/tripDateCriteria.reducer.js





var tripDateCriteria_reducer_createReducer;







var tripDateCriteria_reducer_initialState = {
  departureDate: null,
  arrivalDate: null
};
/* harmony default export */ var tripDateCriteria_reducer = (utils_createReducer(tripDateCriteria_reducer_initialState, (tripDateCriteria_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, store_constants["m" /* SYNC_WITH_LOCATION */], function (state, _ref) {
  var payload = _ref.payload;

  if (!payload.location.queryParams[uri_constants["g" /* QUERY_DEPARTURE_DATE */]]) {
    return state;
  }

  var formattedDate = Object(dateUtils["a" /* formatDate */])('YYYYMMDD')(payload.location.queryParams[uri_constants["g" /* QUERY_DEPARTURE_DATE */]], uri_constants["f" /* QUERY_DATE_FORMAT */]);
  return {
    arrivalDate: Number(formattedDate),
    departureDate: Number(formattedDate)
  };
}), Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]), function (state, action) {
  var _get2 = get_default()(action, 'payload.proposals.proposals', [tripDateCriteria_reducer_initialState]),
      _get3 = Object(slicedToArray["a" /* default */])(_get2, 1),
      proposal = _get3[0];

  if (proposal) {
    var arrivalDate = proposal.arrivalDate,
        departureDate = proposal.departureDate;
    return {
      arrivalDate: Number(arrivalDate),
      departureDate: Number(departureDate)
    };
  }

  return state;
}), Object(defineProperty["a" /* default */])(tripDateCriteria_reducer_createReducer, store_constants["p" /* UPDATE_TRIP_DATE_CRITERIA */], function (state, action) {
  var day = get_default()(action, 'payload.day', {});

  var departureDate = Number(get_default()(day, 'id')) || null;
  var arrivalDate = Number(get_default()(day, 'arrivalDate', departureDate)) || null;
  return {
    departureDate: departureDate,
    arrivalDate: arrivalDate
  };
}), tripDateCriteria_reducer_createReducer)));
// EXTERNAL MODULE: ./src/client/store/price-remote/constants.js
var price_remote_constants = __webpack_require__("GZgf");

// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.reducer.js










var priceOfStay_reducer_createReducer;

function priceOfStay_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function priceOfStay_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? priceOfStay_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : priceOfStay_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var priceOfStay_reducer_initialState = {
  data: null,
  error: null,
  isLoading: true,
  lastRequestId: -1,
  priceOfStayArgs: {}
};
var priceOfStayReducer = utils_createReducer(priceOfStay_reducer_initialState, (priceOfStay_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */], function (state, action) {
  var _action$payload;

  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    data: null,
    lastRequestId: get_default()(action, 'optimist.id', -1),
    priceOfStayArgs: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.args
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, Object(build["resolve"])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (get_default()(action, 'optimist.id', -1) !== state.lastRequestId) {
    return state;
  }

  var priceOfStay = action.payload.priceOfStay;

  if (priceOfStay && priceOfStay.errors) {
    return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
      isLoading: false,
      data: null,
      error: priceOfStay.errors
    });
  }

  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    data: priceOfStay,
    error: null
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, Object(build["reject"])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */]), function (state) {
  return priceOfStay_reducer_objectSpread(priceOfStay_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), Object(defineProperty["a" /* default */])(priceOfStay_reducer_createReducer, price_remote_constants["d" /* RESET_PRICE_OF_STAY */], function () {
  return priceOfStay_reducer_initialState;
}), priceOfStay_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.reducer.js










var allInclusiveServices_reducer_createReducer;

function allInclusiveServices_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function allInclusiveServices_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? allInclusiveServices_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : allInclusiveServices_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var allInclusiveServices_reducer_initialState = {
  isLoading: true,
  data: [],
  lastRequestId: -1
};
var allInclusiveServicesReducer = utils_createReducer(allInclusiveServices_reducer_initialState, (allInclusiveServices_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */], function (state, action) {
  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    lastRequestId: get_default()(action, 'optimist.id', -1)
  });
}), Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, Object(build["resolve"])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */]), function (state, action) {
  // If there is another request in progress
  if (get_default()(action, 'optimist.id', -1) !== state.lastRequestId) {
    return state;
  }

  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    data: action.payload.allInclusiveServices
  });
}), Object(defineProperty["a" /* default */])(allInclusiveServices_reducer_createReducer, Object(build["reject"])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */]), function (state) {
  return allInclusiveServices_reducer_objectSpread(allInclusiveServices_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), allInclusiveServices_reducer_createReducer));
// CONCATENATED MODULE: ./src/client/store/price-remote/priceRemote.reducer.js



var priceRemoteReducer = Object(redux["c" /* combineReducers */])({
  allInclusiveServices: allInclusiveServicesReducer,
  priceOfStay: priceOfStayReducer
});
// EXTERNAL MODULE: ./src/client/store/priceTicket/constants.js
var priceTicket_constants = __webpack_require__("0OJc");

// CONCATENATED MODULE: ./src/client/store/priceTicket/priceTicket.reducer.js










var priceTicket_reducer_createReducer;

function priceTicket_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function priceTicket_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? priceTicket_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : priceTicket_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var priceTicket_reducer_initialState = {
  isLoading: true,
  productArgs: '',
  price: {}
};
/* harmony default export */ var priceTicket_reducer = (utils_createReducer(priceTicket_reducer_initialState, (priceTicket_reducer_createReducer = {}, Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, priceTicket_constants["b" /* PRICE_TICKET_REQUEST */], function (state, action) {
  var _action$payload;

  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: true,
    productArgs: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.productArgs
  });
}), Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, Object(build["resolve"])(priceTicket_constants["b" /* PRICE_TICKET_REQUEST */]), function (state, action) {
  var price = get_default()(action, 'payload.price') || {};
  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: false,
    price: price
  });
}), Object(defineProperty["a" /* default */])(priceTicket_reducer_createReducer, Object(build["reject"])(priceTicket_constants["b" /* PRICE_TICKET_REQUEST */]), function (state) {
  return priceTicket_reducer_objectSpread(priceTicket_reducer_objectSpread({}, state), {}, {
    isLoading: false
  });
}), priceTicket_reducer_createReducer)));
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.is-finite.js
var es_number_is_finite = __webpack_require__("+E13");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/BookingAttendeesProfile.fragment.js
var BookingAttendeesProfile_fragment = __webpack_require__("SQLw");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.queries.js



function travelerProfilesQuery(_ref) {
  var adults = _ref.adults,
      kids = _ref.kids;
  return "\n    {\n      ".concat(Object(BookingEngine_query["b" /* getAttendeesData */])({
    adultsAttendeesIds: adults,
    kidsAttendeesIds: kids
  }), "\n    }\n    ").concat(adults && adults[0] || kids && kids[0] ? BookingAttendeesProfile_fragment["a" /* default */] : '', "\n  ");
}
// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.action.js








var FETCH_PREBOOKING_TRAVELERS = 'FETCH_PREBOOKING_TRAVELERS';
function fetchPrebookingTravelers(params, appContext) {
  return function (dispatch) {
    if (!params.adults || params.adults.length === 0) {
      return Promise.reject();
    }

    var query = travelerProfilesQuery(params);
    var promise = graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["U" /* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS */]
    })["catch"](function (error) {
      if (error.errors && error.errors.some(function (e) {
        return e.statusCode === 401;
      })) {
        Object(sellerUtils["e" /* handle401GraphqlErrorSeller */])(error, appContext);
      }

      return {};
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(FETCH_PREBOOKING_TRAVELERS, params, {
      optimist: true,
      promise: promise
    }));
  };
}
// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/trip-information/kids/kids.reducer.js















/* eslint-disable flowtype/no-weak-types */

function kids_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function kids_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? kids_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : kids_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}








var kids_reducer_initialState = [];

function updateKid(state, action) {
  var _get2 = get_default()(action, 'payload'),
      index = _get2.index,
      valuesToUpdate = _get2.valuesToUpdate;

  if (!Number.isFinite(index)) {
    return state;
  }

  var kidsState = state || [];
  return Array(index >= kidsState.length ? index + 1 : kidsState.length).fill(kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])).map(function (defaultKid, i) {
    if (i !== index) {
      return kidsState[i] ? kidsState[i] : kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
    }

    return kids_reducer_objectSpread(kids_reducer_objectSpread({}, kids_reducer_objectSpread({}, kidsState[i] ? kidsState[i] : defaultKid)), valuesToUpdate);
  });
}

var kids_reducer_updateKids = function updateKids(state, _ref) {
  var payload = _ref.payload;

  if (!payload.kidsAttendees) {
    return state.map(function (kid) {
      return {
        birthdate: kid.birthdate,
        neolid: kid.neolid,
        childcareIncluded: kid.childcareIncluded,
        mainContactId: undefined
      };
    });
  }

  return state.map(function (kid, index) {
    var _get3 = get_default()(payload, "kidsAttendees[".concat(index, "]"), {}),
        birthdate = _get3.birthdate,
        restAttendeeData = Object(objectWithoutProperties["a" /* default */])(_get3, ["birthdate"]);

    return kids_reducer_objectSpread(kids_reducer_objectSpread({}, restAttendeeData), {}, {
      birthdate: kid.birthdate,
      neolid: kid.neolid,
      childcareIncluded: kid.childcareIncluded,
      mainContactId: undefined
    });
  });
};

function kidsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : kids_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case kids_constants["e" /* TRIP_INFORMATION_UPDATE_KID */]:
      return updateKid(state, action);

    case kids_constants["c" /* TRIP_INFORMATION_SET_KIDS */]:
      {
        var kids = get_default()(action, 'payload.kids') || [];
        return kids.map(function (kid) {
          return kid || kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
        });
      }

    case kids_constants["d" /* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */]:
      {
        var _kids = get_default()(action, 'payload.kids') || [];

        return _kids.map(function (kid, index) {
          return kid ? kids_reducer_objectSpread(kids_reducer_objectSpread(kids_reducer_objectSpread({}, state[index]), kid), {}, {
            birthdate: typeof kid.birthdate === 'string' ? Object(apiDate["e" /* apiDateToTimestamp */])(kid.birthdate) : kid.birthdate,
            neolid: kid.neolid || get_default()(state[index], 'neolid'),
            mainContactId: kid.neolid ? undefined : kid.mainContactId
          }) : kids_reducer_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */]);
        });
      }

    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(FETCH_PREBOOKING_TRAVELERS):
    case adults_constants["d" /* SET_ATTENDEES */]:
      return kids_reducer_updateKids(state, action);

    case proposals_constants["J" /* UPDATE_ATTENDEES */]:
      {
        if (!action.payload.attendees) {
          return state;
        }

        return state.map(function (kid) {
          var updatedKid = action.payload.attendees.find(function (_ref2) {
            var id = _ref2.id;
            return id === kid.id;
          }) || {};
          return kids_reducer_objectSpread(kids_reducer_objectSpread({}, kid), {}, {
            neolid: updatedKid.customerId,
            gmNumber: updatedKid.gmNumber
          });
        });
      }

    case kids_constants["b" /* TRIP_INFORMATION_RESET_KIDS */]:
      return kids_reducer_initialState;

    case signout["a" /* SIGNOUT */]:
      return kids_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-information/adults/adults.reducer.js
















function adults_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function adults_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? adults_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : adults_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}







var adults_reducer_initialState = [];

function updateAdult(state, action) {
  var _get2 = get_default()(action, 'payload'),
      index = _get2.index,
      valuesToUpdate = _get2.valuesToUpdate;

  if (!Number.isFinite(index)) {
    return state;
  }

  var adults = state || [];
  return Array(index >= adults.length ? index + 1 : adults.length).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    if (i !== index) {
      return adults[i] ? adults[i] : adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */]);
    }

    return adults_reducer_objectSpread(adults_reducer_objectSpread({}, adults_reducer_objectSpread({}, adults[i] ? adults[i] : defaultAdult)), valuesToUpdate);
  });
}

function setAdultsNumber(state, action) {
  var adultsNumber = get_default()(action, 'payload.adultsNumber');

  if (adultsNumber === 0) {
    return [];
  }

  if (!Number.isFinite(adultsNumber)) {
    return state;
  }

  var adults = state || [];
  return Array(adultsNumber).fill(adults_reducer_objectSpread({}, adults_constants["b" /* DEFAULT_ADULT_VALUE */])).map(function (defaultAdult, i) {
    return adults_reducer_objectSpread({}, adults[i] ? adults[i] : defaultAdult);
  });
}

var adults_reducer_setAdults = function setAdults(state, _ref) {
  var payload = _ref.payload;

  if (!payload.adultsAttendees) {
    return state.map(function (adult) {
      return {
        neolid: adult.neolid
      };
    });
  }

  return payload.adultsAttendees.map(function (_ref2, index) {
    var _state$index;

    var birthdate = _ref2.birthdate,
        dateOfBirth = _ref2.dateOfBirth,
        homePhoneNumber = _ref2.homePhoneNumber,
        mobilePhoneNumber = _ref2.mobilePhoneNumber,
        restAttendeeData = Object(objectWithoutProperties["a" /* default */])(_ref2, ["birthdate", "dateOfBirth", "homePhoneNumber", "mobilePhoneNumber"]);

    var birth = birthdate || dateOfBirth;
    return adults_reducer_objectSpread(adults_reducer_objectSpread({}, restAttendeeData), {}, {
      birthdate: birth ? Object(apiDate["e" /* apiDateToTimestamp */])(birth) : null,
      phoneNumber: mobilePhoneNumber || homePhoneNumber,
      neolid: state === null || state === void 0 ? void 0 : (_state$index = state[index]) === null || _state$index === void 0 ? void 0 : _state$index.neolid
    });
  });
};

function adultsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : adults_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (get_default()(action, 'type')) {
    case adults_constants["f" /* TRIP_INFORMATION_UPDATE_ADULT */]:
      return updateAdult(state, action);

    case adults_constants["e" /* TRIP_INFORMATION_SET_ADULTS_NUMBER */]:
      return setAdultsNumber(state, action);

    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(FETCH_PREBOOKING_TRAVELERS):
    case adults_constants["d" /* SET_ATTENDEES */]:
      return adults_reducer_setAdults(state, action);

    case proposals_constants["J" /* UPDATE_ATTENDEES */]:
      {
        if (!action.payload.attendees) {
          return state;
        }

        return state.map(function (adult) {
          var updatedAdult = action.payload.attendees.find(function (_ref3) {
            var id = _ref3.id;
            return id === adult.id;
          }) || {};
          return adults_reducer_objectSpread(adults_reducer_objectSpread({}, adult), {}, {
            neolid: updatedAdult.customerId,
            gmNumber: updatedAdult.gmNumber,
            mainContactId: undefined
          });
        });
      }

    case adults_constants["c" /* SET_ADULTS */]:
      return action.payload.map(function (adult, index) {
        return adults_reducer_objectSpread(adults_reducer_objectSpread(adults_reducer_objectSpread({}, state[index]), adult), {}, {
          mainContactId: adult.neolid ? undefined : adult.mainContactId,
          neolid: adult.neolid || get_default()(state[index], 'neolid')
        }, adult.address ? {
          address: adults_reducer_objectSpread(adults_reducer_objectSpread({}, get_default()(state[index], 'address')), adult.address)
        } : null);
      });

    case signout["a" /* SIGNOUT */]:
      return adults_reducer_initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/client/store/trip-information/tripInformation.reducer.js



/* harmony default export */ var tripInformation_reducer = (Object(redux["c" /* combineReducers */])({
  kids: kidsReducer,
  adults: adultsReducer
}));
// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/widgets/cart/cart.actions.js
var cart_actions = __webpack_require__("zhg9");

// EXTERNAL MODULE: ./src/client/components/widgets/popin-newsletter/PopinNewsletter.jsx
var PopinNewsletter = __webpack_require__("Qosd");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/store/toast/toast.actions.js
var toast_actions = __webpack_require__("7Z8V");

// CONCATENATED MODULE: ./src/client/store/toast/toast.reducer.js










function toast_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function toast_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? toast_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : toast_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}











var toast_reducer_initialState = {
  color: colors["a" /* COLORS */].BLUE_WAVE,
  icon: icons["a" /* ICONS */].CHECK_OUTLINE,
  label: '',
  shouldDisplay: false
};
var toast_reducer_toast = function toast() {
  var _action$payload, _action$payload2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toast_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case toast_actions["b" /* OPEN_TOAST */]:
    case Object(build["resolve"])(proposals_constants["a" /* ADD_ACCOMMODATION */]):
    case Object(build["resolve"])(proposals_constants["c" /* ADD_ACCOMMODATION_FROM_ALTERNATIVES */]):
    case Object(build["resolve"])(proposals_constants["f" /* ADD_TRANSPORT */]):
      return {
        className: Object(classnames_utils["a" /* classnames */])('mt-navigation', get_default()(action, 'payload.className', '')),
        color: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.color) || colors["a" /* COLORS */].BLUE_WAVE,
        icon: icons["a" /* ICONS */].CHECK_OUTLINE,
        label: get_default()(action, 'payload.toastLabel') || get_default()(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: true,
        style: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.style
      };

    case proposals_constants["k" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */]:
    case PopinNewsletter["a" /* NEWSLETTER_SUBSCRIPTION_VALIDATION */]:
      return {
        className: 'mt-navigation',
        color: colors["a" /* COLORS */].BLUE_WAVE,
        icon: icons["a" /* ICONS */].CHECK_OUTLINE,
        label: get_default()(action, 'payload.toastLabel') || get_default()(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: true
      };

    case Object(build["resolve"])(proposals_constants["d" /* ADD_SERVICE */]):
    case Object(build["resolve"])(proposals_constants["L" /* UPDATE_SERVICES */]):
    case Object(build["resolve"])(proposals_constants["j" /* DELETE_SERVICE */]):
    case Object(build["resolve"])(cart_actions["a" /* UPDATE_BOOKING_CART */]):
    case 'PICK_YOUR_ROOM_AGENCY_SUCCESS':
      return {
        className: 'mt-navigation',
        color: colors["a" /* COLORS */].BLUE_WAVE,
        icon: icons["a" /* ICONS */].CHECK_OUTLINE,
        label: get_default()(action, 'payload.toastLabel') || get_default()(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: !!(get_default()(action, 'payload.toastLabel') || get_default()(action, 'meta.payload.toastLabel'))
      };

    case 'PICK_YOUR_ROOM_AGENCY':
      return {
        className: 'mt-navigation',
        color: colors["a" /* COLORS */].BLUE_WAVE,
        icon: icons["a" /* ICONS */].CROSS_OUTLINE,
        label: get_default()(action, 'payload.toastLabel') || get_default()(action, 'meta.payload.toastLabel') || '',
        shouldDisplay: !!get_default()(action, 'payload.toastLabel')
      };

    case 'PAYMENT_BUTTON_ERROR':
    case proposals_constants["b" /* ADD_ACCOMMODATION_ERROR */]:
      return {
        className: 'mt-navigation',
        color: colors["a" /* COLORS */].RED,
        icon: icons["a" /* ICONS */].CROSS_OUTLINE,
        label: action.payload.toastLabel,
        shouldDisplay: !!action.payload.toastLabel
      };

    case proposals_constants["L" /* UPDATE_SERVICES */]:
    case proposals_constants["j" /* DELETE_SERVICE */]:
      return toast_reducer_objectSpread(toast_reducer_objectSpread({}, state), {}, {
        className: 'mt-navigation',
        shouldDisplay: false
      });

    case toast_actions["a" /* CLOSE_TOAST */]:
    case additionalAccommodations_action["c" /* FETCH_ADDITIONAL_ACCOMMODATIONS */]:
    case additionalTransports_action["a" /* FETCH_ADDITIONAL_TRANSPORTS */]:
      return toast_reducer_objectSpread(toast_reducer_objectSpread({}, state), {}, {
        className: 'mt-navigation',
        shouldDisplay: false
      });

    default:
      return state;
  }
};
// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isNil.js
var isNil = __webpack_require__("2Lg3");
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);

// EXTERNAL MODULE: ./src/client/store/user-info/actions/notifyProfileChanged.js
var notifyProfileChanged = __webpack_require__("ubam");

// CONCATENATED MODULE: ./src/client/store/user-info/reducers/userInfoReducer.js












function userInfoReducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function userInfoReducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? userInfoReducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : userInfoReducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var MAIN_CONTACT_INDEX = 0; // $FlowFixMe known flow bug. Faultly rejects empty object.

var userInfoReducer_initialState = {};
function userInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userInfoReducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case signout["a" /* SIGNOUT */]:
      return userInfoReducer_initialState;

    case notifyProfileChanged["a" /* PROFILE_CHANGED */]:
      return userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, state), action.payload);

    case adults_constants["d" /* SET_ATTENDEES */]:
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
      var profile = action.payload.profile; // If profile is null, it means that the user is not logged or its token is not valid
      // and existing userInfo and no profile seems weird, but the token being short lived, it can
      // happen
      // address is nullable

      if (profile) {
        return userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, state), profile);
      }

      return state;

    case adults_constants["f" /* TRIP_INFORMATION_UPDATE_ADULT */]:
      if (isEmpty_default()(state)) {
        return state;
      }

      var _action$payload = action.payload,
          index = _action$payload.index,
          valuesToUpdate = _action$payload.valuesToUpdate;

      var updatedDateOfBirth = get_default()(valuesToUpdate, 'birthdate');

      var optinEmail = get_default()(valuesToUpdate, 'optinEmail');

      var optinSms = get_default()(valuesToUpdate, 'optinSms');

      var optinMail = get_default()(valuesToUpdate, 'optinMail');

      var optinPhone = get_default()(valuesToUpdate, 'optinPhone');

      var optinClubmedPlus = get_default()(valuesToUpdate, 'optinClubmedPlus');

      if (index !== MAIN_CONTACT_INDEX) {
        return state;
      }

      var newState = state;

      if (updatedDateOfBirth) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          updatedDateOfBirth: updatedDateOfBirth
        });
      }

      if (!isNil_default()(optinEmail)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinEmail: optinEmail
        });
      }

      if (!isNil_default()(optinSms)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinSms: optinSms
        });
      }

      if (!isNil_default()(optinMail)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinMail: optinMail
        });
      }

      if (!isNil_default()(optinPhone)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinPhone: optinPhone
        });
      }

      if (!isNil_default()(optinClubmedPlus)) {
        newState = userInfoReducer_objectSpread(userInfoReducer_objectSpread({}, newState), {}, {
          optinClubmedPlus: optinClubmedPlus
        });
      }

      return newState;

    default:
      return state;
  }
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// CONCATENATED MODULE: ./src/client/store/validation-schema/constants.js
var UPDATE_VALIDATION_SCHEMA = 'UPDATE_VALIDATION_SCHEMA';
// EXTERNAL MODULE: ./src/client/store/validation-schema/validationSchema.selectors.js
var validationSchema_selectors = __webpack_require__("PwcU");

// CONCATENATED MODULE: ./src/client/store/validation-schema/validationSchema.reducer.js














var _initialState;

function validationSchema_reducer_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function validationSchema_reducer_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? validationSchema_reducer_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : validationSchema_reducer_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}





var validationSchema_reducer_initialState = (_initialState = {
  address: []
}, Object(defineProperty["a" /* default */])(_initialState, validationSchema_selectors["a" /* ATTENDEES_ROLES */].MAIN, []), Object(defineProperty["a" /* default */])(_initialState, validationSchema_selectors["a" /* ATTENDEES_ROLES */].OTHER_ADULT, []), Object(defineProperty["a" /* default */])(_initialState, validationSchema_selectors["a" /* ATTENDEES_ROLES */].KID, []), _initialState);

var validationMapper = function validationMapper(validation) {
  return validationSchema_reducer_objectSpread(validationSchema_reducer_objectSpread({}, validation), {}, {
    validators: validation.validators.map(function (validator) {
      return validator.name === 'pattern' ? {
        name: 'pattern',
        value: new RegExp(validator.value)
      } : validator;
    })
  });
};

var validationSchema_reducer_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : validationSchema_reducer_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Object(build["resolve"])(proposals_constants["m" /* FETCH_PROPOSALS */]):
    case Object(build["resolve"])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */]):
    case Object(build["resolve"])(proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */]):
    case UPDATE_VALIDATION_SCHEMA:
      {
        var _action$payload;

        var validationSchema = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.validationSchema;

        if (!validationSchema) {
          return state;
        }

        var newState = validationSchema_reducer_objectSpread({}, validationSchema_reducer_initialState);

        validationSchema.forEach(function (validationSchemaItem) {
          var _validationSchemaItem, _validationSchemaItem2;

          newState[validationSchemaItem.name] = (validationSchemaItem === null || validationSchemaItem === void 0 ? void 0 : (_validationSchemaItem = validationSchemaItem.fields) === null || _validationSchemaItem === void 0 ? void 0 : (_validationSchemaItem2 = _validationSchemaItem.map(validationMapper)) === null || _validationSchemaItem2 === void 0 ? void 0 : _validationSchemaItem2.filter(function (_ref) {
            var type = _ref.type;
            return type === 'string';
          })) || [];
        });
        return newState;
      }

    default:
      return state;
  }
};

/* harmony default export */ var validationSchema_reducer = (validationSchema_reducer_reducer);
// CONCATENATED MODULE: ./src/client/store/rootReducer.js



















var rootReducer = Object(redux["c" /* combineReducers */])({
  booking: booking,
  calendar: calendarReducer,
  cms: cmsReducer,
  faceting: facetingReducer,
  facetingTripInformation: facetingTripInformation_reducer,
  globalLoader: globalLoader_reducer,
  memberSpace: memberSpace,
  priceRemote: priceRemoteReducer,
  priceTicket: priceTicket_reducer,
  search: searchReducer,
  seller: sellerReducer,
  tripDateCriteria: tripDateCriteria_reducer,
  tripInformation: tripInformation_reducer,
  userInfo: userInfoReducer,
  leadInfos: leadInfo_reducer_leadInfosReducer,
  tripCriteria: tripCriteria_reducer,
  toast: toast_reducer_toast,
  validationSchema: validationSchema_reducer
});

/***/ }),

/***/ "vCWs":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "vnfA":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "vuE1":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("XTsI");
__webpack_require__("nHh7");
__webpack_require__("hU7e");
__webpack_require__("xVUo");
__webpack_require__("cdJH");


/***/ }),

/***/ "wKkN":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var uncurryThis = __webpack_require__("kZDm");
var hiddenKeys = __webpack_require__("qXr/");
var isObject = __webpack_require__("1YFU");
var hasOwn = __webpack_require__("/GgU");
var defineProperty = __webpack_require__("87KK").f;
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternalModule = __webpack_require__("Ed3r");
var isExtensible = __webpack_require__("YF+p");
var uid = __webpack_require__("rvZv");
var FREEZING = __webpack_require__("+pJz");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("yH/f");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__);

var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "waz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ToastContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__["createContext"]({
  ref: null
});

/***/ }),

/***/ "we+H":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("vCWs");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "whR3":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("c72w"),
    copyObject = __webpack_require__("LtXa"),
    createAssigner = __webpack_require__("wpQC"),
    isArrayLike = __webpack_require__("9y2L"),
    isPrototype = __webpack_require__("CbIe"),
    keys = __webpack_require__("BlJA");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "wxLG":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "wyfB":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseIntersection = __webpack_require__("1sLo"),
    baseIteratee = __webpack_require__("S3pA"),
    baseRest = __webpack_require__("R3TX"),
    castArrayLikeObject = __webpack_require__("VZDm"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = baseRest(function(arrays) {
  var iteratee = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  if (iteratee === last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, baseIteratee(iteratee, 2))
    : [];
});

module.exports = intersectionBy;


/***/ }),

/***/ "x90g":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "xS1b":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "xVJP":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "xVUo":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var apply = __webpack_require__("KXRF");
var call = __webpack_require__("we+H");
var uncurryThis = __webpack_require__("kZDm");
var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var isSymbol = __webpack_require__("km0D");
var arraySlice = __webpack_require__("gp/v");
var getReplacerFunction = __webpack_require__("NEd/");
var NATIVE_SYMBOL = __webpack_require__("1s2Y");

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "xe/R":
/***/ (function(module, exports) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ "yAUU":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "yUod":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("we+H");
var anObject = __webpack_require__("ep/x");
var getMethod = __webpack_require__("Uey1");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "yYuE":
/***/ (function(module, exports, __webpack_require__) {

var makeBuiltIn = __webpack_require__("OoaE");
var defineProperty = __webpack_require__("87KK");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "ycRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BOOKING_PAYMENT_STATUS_VALIDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOKING_PAYMENT_STATUS_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BOOKING_PAYMENT_STATUS_UPGRADE_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOKING_PAYMENT_STATUS_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BOOKING_PAYMENT_STATUS_SERVICES_IN_OPTION; });
var BOOKING_PAYMENT_STATUS_VALIDATED = 'VALIDATED';
var BOOKING_PAYMENT_STATUS_OPTION = 'OPTION';
var BOOKING_PAYMENT_STATUS_PACKAGE_UPGRADE = 'PACKAGE_UPGRADE';
var BOOKING_PAYMENT_STATUS_ADDITIONAL_SERVICE = 'ADDITIONAL_SERVICE';
var BOOKING_PAYMENT_STATUS_PICK_YOUR_ROOM = 'PICK_YOUR_ROOM';
var BOOKING_PAYMENT_STATUS_UPGRADE_ROOM = 'UPGRADE_ROOM';
var BOOKING_PAYMENT_STATUS_CART = 'CART';
var BOOKING_PAYMENT_STATUS_SERVICES_IN_OPTION = 'SERVICES_IN_OPTION';


/***/ }),

/***/ "ydRd":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("kZDm");
var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var classof = __webpack_require__("3LIW");
var getBuiltIn = __webpack_require__("x90g");
var inspectSource = __webpack_require__("/ExG");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "yhbn":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("gIGD");
var isConstructor = __webpack_require__("ydRd");
var isObject = __webpack_require__("1YFU");
var wellKnownSymbol = __webpack_require__("nJrx");

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ "yvHl":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("/GgU");
var isCallable = __webpack_require__("ANQd");
var toObject = __webpack_require__("A+R+");
var sharedKey = __webpack_require__("mmil");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "z+NW":
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__("gAMm"),
    func = convert('uniqBy', __webpack_require__("yjkv"));

func.placeholder = __webpack_require__("VDAD");
module.exports = func;


/***/ }),

/***/ "z7Vv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLANE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLIGHT_CLASS_AVAILABLE_TO_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRAIN_CLASS_AVAILABLE_TO_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRANSPORT_CLASS_TO_I18N; });
/* unused harmony export SNCF_ID */
/* unused harmony export getFindSectionTransportTypeFn */
/* unused harmony export getClassLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return formatDate; });
/* unused harmony export getWayLabel */
/* unused harmony export formatConnectionLabel */
/* unused harmony export getStep */
/* unused harmony export hasPlane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasOnlyPlanes; });
/* unused harmony export hasOnlyTrain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isTransportTrain; });
/* unused harmony export isTransportPlaneTicket */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTransportIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCompanyOperators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCompanyOperatorsName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTransportClasses; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Jhhs");
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("jLkM");
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("yjkv");
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("WGoB");






















var BOAT = 'BOAT';
var PLANE = 'PLANE';
var TRAIN = 'TRAIN';
var FLIGHT_CLASS_AVAILABLE_TO_SEARCH = ['PLANE_ECONOMY', 'PLANE_ECONOMY_PLUS', 'PLANE_BUSINESS', 'PLANE_PREMIUM', 'PLANE_FIRST'];
var TRAIN_CLASS_AVAILABLE_TO_SEARCH = ['TRAIN_SECOND', 'TRAIN_FIRST'];
var TRANSPORT_CLASS_TO_I18N = {
  '1CL': 'firstClassLabel',
  '2CL': 'secondClassLabel',
  BUS: 'businessClassLabel',
  DIB: 'emeraldClassLabel',
  DIV: 'economyClassLabel',
  ECO: 'economyClassLabel',
  'EC+': 'alizeeClassLabel',
  FIR: 'firstClassLabel',
  PLANE_BUSINESS: 'businessClassLabel',
  PLANE_ECONOMY: 'economyClassLabel',
  PLANE_ECONOMY_PLUS: 'alizeeClassLabel',
  PLANE_FIRST: 'firstClassLabel',
  PLANE_PREMIUM: 'premiumClassLabel',
  PRC: 'premiumClassLabel',
  PRE: 'premiumClassLabel',
  TRAIN_FIRST: 'firstClassLabel',
  TRAIN_SECOND: 'secondClassLabel'
};
var SNCF_ID = 'SNC';

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__[/* momentFromApiDate */ "j"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__[/* momentFromApiDate */ "j"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }

  return null;
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__[/* momentFromApiTime */ "l"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function formatDate(date, format) {
  return Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_21__[/* capitalizeName */ "a"])(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_20__[/* momentFromApiDate */ "j"])(date).format(format || Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('common.verboseDateFormatTechnicalID')));
}

function getWayLabel(i18n, way) {
  if (way === 'INBOUND') {
    var _i18n$common, _i18n$common$transpor;

    return i18n === null || i18n === void 0 ? void 0 : (_i18n$common = i18n.common) === null || _i18n$common === void 0 ? void 0 : (_i18n$common$transpor = _i18n$common.transport) === null || _i18n$common$transpor === void 0 ? void 0 : _i18n$common$transpor.inboundLabel;
  }

  if (way === 'OUTBOUND') {
    var _i18n$common2, _i18n$common2$transpo;

    return i18n === null || i18n === void 0 ? void 0 : (_i18n$common2 = i18n.common) === null || _i18n$common2 === void 0 ? void 0 : (_i18n$common2$transpo = _i18n$common2.transport) === null || _i18n$common2$transpo === void 0 ? void 0 : _i18n$common2$transpo.outboundLabel;
  }

  return null;
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_16___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_16___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_17__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var _i18n$common3, _i18n$common3$transpo;

  var _ref = (i18n === null || i18n === void 0 ? void 0 : i18n.common) || {},
      timeFormat = _ref.timeFormat;

  var transportConnectionLabel = i18n === null || i18n === void 0 ? void 0 : (_i18n$common3 = i18n.common) === null || _i18n$common3 === void 0 ? void 0 : (_i18n$common3$transpo = _i18n$common3.transport) === null || _i18n$common3$transpo === void 0 ? void 0 : _i18n$common3$transpo.connection;
  return function (step) {
    var connectionDuration = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'connectionDurationInMin');

    var stopOverDuration = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'stopDurationInMin');

    var information = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_14___default()(stopOverDuration) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_14___default()(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'transport.reference'),
      type: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'transport.type'),
      information: information,
      operator: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'transport.companyOperator.label'),
      operatorId: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'transport.companyOperator.id'),
      operatorLogo: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'transport.companyOperator.logo'),
      start: {
        label: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'departure.airportLabel'),
        time: formatTime(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'departure.time'), timeFormat),
        date: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'departure.date')
      },
      end: {
        label: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'arrival.airportLabel'),
        time: formatTime(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'arrival.time'), timeFormat),
        date: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'arrival.date')
      },
      technicalStops: lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(step, 'technicalStops')
    };
  };
}

function hasOnlyBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(section, 'transport.type') === BOAT;
  });
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(section, 'transport.type') === BOAT;
  });
}

function hasPlane(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(section, 'transport.type') === PLANE;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(travelSections) {
  return !(hasTrain(travelSections) || hasBoat(travelSections));
}

function isTransportTrain(inbound, outbound) {
  return hasOnlyTrain(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(inbound, 'travelSections')) && hasOnlyTrain(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(outbound, 'travelSections'));
}

function isTransportPlaneTicket(inbound, outbound) {
  return hasOnlyPlanes(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(inbound, 'travelSections')) && hasOnlyPlanes(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(outbound, 'travelSections'));
}

function getTransportIcon(inbound, outbound) {
  var isTrain = hasTrain(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(inbound, 'travelSections')) && hasTrain(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(outbound, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasOnlyBoat(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(inbound, 'travelSections')) && hasOnlyBoat(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(outbound, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_14___default()(travelSections) ? (travelSections || []).some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(section, 'arrival.time') || lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inbound, outbound) {
  return tripHasSchedules(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(inbound, 'travelSections')) || tripHasSchedules(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(outbound, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var numberMinutes = Number(minutes);

  if (numberMinutes < 60) {
    return "".concat(numberMinutes).concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('options.countdownLabels.min'));
  }

  if (numberMinutes % 60 === 0) {
    return "".concat(numberMinutes / 60).concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('options.countdownLabels.hours'));
  }

  var time = [Math.floor(numberMinutes / 60), Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('options.countdownLabels.hours'), "".concat(isRTL ? '-' : ''), (numberMinutes % 60).toString().padStart(2, '0'), Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('options.countdownLabels.min')];
  return time.join('');
}

function getCompanyOperators() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var companyOperators = travelSections.reduce(function (companies, section) {
    var _section$transport, _section$transport$co, _section$transport2, _section$transport2$c;

    if ((section === null || section === void 0 ? void 0 : (_section$transport = section.transport) === null || _section$transport === void 0 ? void 0 : (_section$transport$co = _section$transport.companyOperator) === null || _section$transport$co === void 0 ? void 0 : _section$transport$co.id) && (section === null || section === void 0 ? void 0 : (_section$transport2 = section.transport) === null || _section$transport2 === void 0 ? void 0 : (_section$transport2$c = _section$transport2.companyOperator) === null || _section$transport2$c === void 0 ? void 0 : _section$transport2$c.label)) {
      companies.push(section.transport.companyOperator);
    }

    return companies;
  }, []);
  return lodash_uniqBy__WEBPACK_IMPORTED_MODULE_13___default()(companyOperators, 'id');
}

function getCompanyOperatorsName() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var companyOperators = getCompanyOperators(travelSections);
  return lodash_uniqBy__WEBPACK_IMPORTED_MODULE_13___default()(companyOperators, 'id').map(function (company) {
    return Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_21__[/* capitalizeName */ "a"])(company.label);
  });
}

function getTransportClasses() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allClasses = travelSections.map(function (section) {
    var _section$transport3;

    return section === null || section === void 0 ? void 0 : (_section$transport3 = section.transport) === null || _section$transport3 === void 0 ? void 0 : _section$transport3["class"];
  }).filter(Boolean);
  return lodash_uniq__WEBPACK_IMPORTED_MODULE_12___default()(allClasses);
}

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref2) {
    var type = _ref2.transport.type;
    return type === transportType;
  };
};
var getClassLabel = function getClassLabel(_ref3) {
  var transportType = _ref3.transportType,
      travelSections = _ref3.travelSections,
      inboundCriteria = _ref3.inboundCriteria;

  var transportClass = (inboundCriteria === null || inboundCriteria === void 0 ? void 0 : inboundCriteria.flightClass) || lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(transportType ? travelSections.find(getFindSectionTransportTypeFn(transportType)) : travelSections[0], 'transport.class');

  if (!TRANSPORT_CLASS_TO_I18N[transportClass]) {
    return null;
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])("common.transport.transportClass.".concat(TRANSPORT_CLASS_TO_I18N[transportClass]));
};


/***/ }),

/***/ "zSnQ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toIndexedObject = __webpack_require__("dNjr");
var nativeGetOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var DESCRIPTORS = __webpack_require__("uGjT");

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "zcYo":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "zhg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_BOOKING_CART; });
/* unused harmony export getBookingsCartQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookingsCart; });
/* unused harmony export removeService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateBookingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateBookingCartSequencially; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _store_utils_createAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Nhxn");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__);












var FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
var UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';

var bookingCartQuery = function bookingCartQuery(appContext) {
  return "\n  bookingId\n  attendees {\n    id\n    firstname\n    lastname\n    birthday\n    unicodeFirstname\n    unicodeLastname\n    type\n  }\n  stayServices {\n    stayIndex\n    childcares {\n      id\n      productId\n      type\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n      attendees {\n        id\n        schedules {\n          price {\n            value\n          }\n          startDate\n          endDate\n        }\n      }\n    }\n    transfers {\n      id\n      productId\n      type\n      label\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n    }\n    insurance {\n      id\n      productId\n      type\n      label\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n    }\n    whiteLabelServices {\n      id\n      productId\n      type\n      serviceInfo {\n        subtype\n        label\n      }\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n    }\n    rentals {\n      id\n      productId\n      type\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n      attendees {\n        id\n        schedules {\n          price {\n            value\n          }\n          startDate\n          endDate\n        }\n      }\n    }\n    activities {\n      id\n      productId\n      type\n      schedules {\n        startDate\n        endDate\n        attendees {\n          id\n          price\n        }\n      }\n    }\n    pickRoom {\n      id\n      type\n      accommodations {\n        id\n        rooms {\n          id\n        }\n      }\n    }\n  }\n  price {\n    total {\n        formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__["getBookingPrecision"])(appContext.locale), ")\n        value\n        currency\n    }\n    currency\n    detail {\n      service\n      amount\n    }\n  }\n  isEmpty\n  hasServicesInOption");
};

var cartQuery = function cartQuery(appContext) {
  return "\n  amount {\n    total {\n      value\n      currency\n      formattedValue(precision: ".concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__["getBookingPrecision"])(appContext.locale), ")\n    }\n  }\n  isEmpty\n  cartBookings {\n    ").concat(bookingCartQuery(appContext), "\n  }");
};

var getBookingsCartQuery = function getBookingsCartQuery(appContext, bookingIds) {
  var gqlBookingIds = bookingIds.map(function (id) {
    return "\"".concat(id, "\"");
  });
  return "\n    query {\n      bookingsCart(bookingIds : [".concat(gqlBookingIds.toString(), "]) {\n        ").concat(cartQuery(appContext), "\n      }\n    }\n  ");
};
var fetchBookingsCart = function fetchBookingsCart(bookingIds, context) {
  return function (dispatch) {
    return dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(FETCH_BOOKING_CART, {}, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runNoCacheQuery(getBookingsCartQuery(context, bookingIds), context, {
        requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_GET_BOOKINGS_CART */ "j"]
      })
    }));
  };
};

var addService = function addService(_ref) {
  var context = _ref.context,
      id = _ref.id,
      bookingId = _ref.bookingId,
      amountToUpdate = _ref.amountToUpdate,
      schedules = _ref.schedules,
      accommodations = _ref.accommodations,
      serviceName = _ref.serviceName,
      stayIndex = _ref.stayIndex;
  return "mutation {\n  addServiceCart(\n    bookingId : \"".concat(bookingId, "\",\n    amount: ").concat(amountToUpdate, ",\n    serviceCart: {\n      id: \"").concat(id, "\",\n      stay_index: ").concat(stayIndex || 0, ",\n      ").concat(schedules ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_10__[/* attributesToString */ "a"])({
    schedules: schedules
  }) : '', "\n      ").concat(accommodations ? Object(_utils_graphql_client_graphqlClient_utils__WEBPACK_IMPORTED_MODULE_10__[/* attributesToString */ "a"])({
    accommodations: accommodations
  }) : '', "\n    }\n    serviceName: \"").concat(serviceName, "\") {\n      cart {\n        ").concat(bookingCartQuery(context), "\n      }\n      totalAmount {\n        value\n        currency\n        formattedValue(precision: ").concat(Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_11__["getBookingPrecision"])(context.locale), ")\n      }\n    }\n  }");
};

var removeService = function removeService(appContext, id, bookingId, amountToUpdate) {
  return "mutation {\n    removeServiceCart(\n      bookingId : \"".concat(bookingId, "\",\n      amount: ").concat(amountToUpdate, ",\n      itemId: \"").concat(id, "\")\n      {\n        cart {\n          ").concat(bookingCartQuery(appContext), "\n        }\n        totalAmount {\n          value\n          currency\n          formattedValue\n        }\n      }\n  }");
};
var updateBookingCart = function updateBookingCart(_ref2) {
  var context = _ref2.context,
      id = _ref2.id,
      bookingId = _ref2.bookingId,
      schedules = _ref2.schedules,
      accommodations = _ref2.accommodations,
      serviceName = _ref2.serviceName,
      action = _ref2.action,
      successMsg = _ref2.successMsg,
      stayIndex = _ref2.stayIndex;
  return function (dispatch, getState) {
    var _getState, _getState$memberSpace, _getState$memberSpace2, _getState$memberSpace3, _bookingsCart$amount, _bookingsCart$amount$;

    var bookingsCart = ((_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$memberSpace = _getState.memberSpace) === null || _getState$memberSpace === void 0 ? void 0 : (_getState$memberSpace2 = _getState$memberSpace.cart) === null || _getState$memberSpace2 === void 0 ? void 0 : (_getState$memberSpace3 = _getState$memberSpace2.data) === null || _getState$memberSpace3 === void 0 ? void 0 : _getState$memberSpace3.bookingsCart) || {};
    var totalAmount = ((_bookingsCart$amount = bookingsCart.amount) === null || _bookingsCart$amount === void 0 ? void 0 : (_bookingsCart$amount$ = _bookingsCart$amount.total) === null || _bookingsCart$amount$ === void 0 ? void 0 : _bookingsCart$amount$.value) || 0;
    var bookingPrice = bookingsCart === null || bookingsCart === void 0 ? void 0 : bookingsCart.cartBookings.find(function (cartBooking) {
      return cartBooking.bookingId === bookingId;
    }).price.total.value;
    var amountToUpdate = totalAmount - bookingPrice;
    dispatch(Object(_store_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(UPDATE_BOOKING_CART, {
      id: id,
      bookingId: bookingId,
      toastLabel: successMsg
    }, {
      optimist: true,
      promise: _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
        context: context,
        id: id,
        bookingId: bookingId,
        amountToUpdate: amountToUpdate,
        schedules: schedules,
        accommodations: accommodations,
        serviceName: serviceName,
        stayIndex: stayIndex
      }) : removeService(context, id, bookingId, amountToUpdate), context, {
        requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "K"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "I"]
      })
    }));
  };
};
var updateBookingCartSequencially = function updateBookingCartSequencially(params, cartState) {
  var _cartState$amount, _cartState$amount$tot, _cartState$cartBookin, _cartState$cartBookin2, _cartState$cartBookin3;

  if (params.length === 0) {
    return Promise.resolve();
  }

  var _params$ = params[0],
      context = _params$.context,
      id = _params$.id,
      bookingId = _params$.bookingId,
      schedules = _params$.schedules,
      accommodations = _params$.accommodations,
      serviceName = _params$.serviceName,
      action = _params$.action,
      stayIndex = _params$.stayIndex;
  var totalAmount = (cartState === null || cartState === void 0 ? void 0 : (_cartState$amount = cartState.amount) === null || _cartState$amount === void 0 ? void 0 : (_cartState$amount$tot = _cartState$amount.total) === null || _cartState$amount$tot === void 0 ? void 0 : _cartState$amount$tot.value) || 0;
  var bookingPrice = (cartState === null || cartState === void 0 ? void 0 : (_cartState$cartBookin = cartState.cartBookings.find(function (cartBooking) {
    return cartBooking.bookingId === bookingId;
  })) === null || _cartState$cartBookin === void 0 ? void 0 : (_cartState$cartBookin2 = _cartState$cartBookin.price) === null || _cartState$cartBookin2 === void 0 ? void 0 : (_cartState$cartBookin3 = _cartState$cartBookin2.total) === null || _cartState$cartBookin3 === void 0 ? void 0 : _cartState$cartBookin3.value) || 0;
  var amountToUpdate = totalAmount - bookingPrice;
  var promise = _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runNoCacheQuery(action === 'update' ? addService({
    context: context,
    id: id,
    bookingId: bookingId,
    amountToUpdate: amountToUpdate,
    schedules: schedules,
    accommodations: accommodations,
    serviceName: serviceName,
    stayIndex: stayIndex
  }) : removeService(context, id, bookingId, amountToUpdate), context, {
    requestName: action === 'update' ? _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART */ "K"] : _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM */ "I"]
  });
  return promise.then(function () {
    return updateBookingCartSequencially(params.slice(1));
  });
};
/* export const updateBookingCartAll = (params: Array<updateCartParams>, cartState: BookingsCart) => {
  return Promise.all(
    params.map(({ id, bookingId, schedules, accommodations, serviceName, context, action }) =>
      graphQLClient.runNoCacheQuery(
        action === 'update'
          ? addService({ id, bookingId, 0, schedules, accommodations, serviceName })
          : removeService(id, bookingId, 0),
        context,
        {
          requestName:
            action === 'update'
              ? CUSTOMER_ACCOUNT_UPDATE_BOOKING_CART
              : CUSTOMER_ACCOUNT_REMOVE_BOOKING_CART_ITEM,
        },
      ),
    ),
  );
}; */

/***/ })

},[[11,3,4,1,6,82,0,5,7,8,9,11,10,14,22,24,41,40]]]);